/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Currency: { input: any; output: any; }
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string, without a time component.
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: any; output: any; }
  /**
   * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library. The Decimal appears in a JSON
   * response as a string to preserve precision.
   */
  Decimal: { input: any; output: any; }
  /**
   * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
   * character sequences. The Json type is most often used to represent a free-form
   * human-readable json string.
   */
  Json: { input: any; output: any; }
  NonNegativeInteger: { input: any; output: any; }
  UUID: { input: any; output: any; }
  /** Represents an uploaded file. */
  Upload: { input: any; output: any; }
};

export type AcceptBuybackInput = {
  itemId: Scalars['ID']['input'];
};

export type AcceptBuybackPayload = {
  __typename?: 'AcceptBuybackPayload';
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** A code that grants access to a part of the app */
export type AccessCode = {
  __typename?: 'AccessCode';
  /** The access level granted */
  accessLevel: AccessLevel;
  /** The access code */
  code: Scalars['String']['output'];
  /** The live stream ID */
  liveStreamId?: Maybe<Scalars['UUID']['output']>;
};

export enum AccessLevel {
  /** Full access to sign up and use the app */
  Full = 'FULL',
  /** Access to view a single live stream */
  ViewLiveStream = 'VIEW_LIVE_STREAM'
}

/** Parameters for creating a new account */
export type AccountCreateInput = {
  /** The email address of the user */
  email: Scalars['String']['input'];
  /** Invitation code */
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  /** The password for the user */
  password: Scalars['String']['input'];
  /** The username for the user */
  username: Scalars['String']['input'];
};

export type AccountCreatePayload = {
  __typename?: 'AccountCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CreatedUser>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type AccountDeletePayload = {
  __typename?: 'AccountDeletePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<DeletedUser>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Account funds balance information */
export type AccountFundsBalance = {
  __typename?: 'AccountFundsBalance';
  balance: MoneyAmount;
  isSupported: Scalars['Boolean']['output'];
};

/** Parameters for changing the current user's email */
export type AccountUpdateEmailInput = {
  /** The user's current password */
  currentPassword: Scalars['String']['input'];
  /** The user's new email */
  newEmail: Scalars['String']['input'];
};

/** Parameters for changing the current user's account */
export type AccountUpdateInput = {
  /** The color to be used for the user's avatar */
  avatarColor?: InputMaybe<AvatarColor>;
  /** The image url to be used for the user's avatar */
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  /** The biography of the user */
  biography?: InputMaybe<Scalars['String']['input']>;
  /**
   * True in order to confirm user. Confirmed time will be set as of query execution.
   * False will be ignored.
   * If user is already confirmed, an error will be returned.
   */
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID for the user's selected payment method to be used with live auctions */
  defaultPaymentMethodId?: InputMaybe<Scalars['UUID']['input']>;
  /** The ID for the user's selected shipping address to be used with live auctions */
  defaultShippingAddressId?: InputMaybe<Scalars['UUID']['input']>;
  /** True if the user is subscribed to the mailing list */
  mailingListSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if the user is over 18 years of age */
  over18?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the user has completed registration or not */
  registrationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's username. Requirements: 3-25 characters in length, only alphanumeric characters */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type AccountUpdatePayload = {
  __typename?: 'AccountUpdatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<UpdatedUser>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type AcknowledgeEventInput = {
  /** The type of entity */
  entity: Entity;
  /** The unique UUID of an entity */
  entityId: Scalars['UUID']['input'];
  /** The type of event */
  event: Event;
};

export type AcknowledgeEventPayload = {
  __typename?: 'AcknowledgeEventPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<AcknowledgeEventResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The response from acknowledgeEvent mutation */
export type AcknowledgeEventResponse = {
  __typename?: 'AcknowledgeEventResponse';
  status: Scalars['String']['output'];
};

/** Parameters for acknowledging a receipt */
export type AcknowledgeReceiptInput = {
  /** The UUID of an entity (i.e giveaway, auction) */
  entityId: Scalars['UUID']['input'];
  /** The entity type */
  type: ReceiptType;
};

/** The type of response to serve for apply acknowledgeReceipt mutation */
export type AcknowledgeReceiptResponse = {
  __typename?: 'AcknowledgeReceiptResponse';
  /** Denotes the succces or failure of a mutation */
  status: Scalars['String']['output'];
};

export type AcknowledgeReceiptResponsePayload = {
  __typename?: 'AcknowledgeReceiptResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<AcknowledgeReceiptResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Input for adding items to a checklist */
export type AddItemsToChecklistInput = {
  /** ID of the checklist/repack */
  checklistId: Scalars['UUID']['input'];
  /** List of items to include */
  items: Array<RepackItemInput>;
  /** Which pool to add items to */
  poolType?: InputMaybe<ChecklistPoolType>;
};

/** An address for shipping or billing purposes */
export type Address = {
  __typename?: 'Address';
  /** The recipient's city */
  city: Scalars['String']['output'];
  /** The recipient's company name. Optional. */
  company?: Maybe<Scalars['String']['output']>;
  /** The recipient's country. Optional, defaults to USA. */
  country?: Maybe<Scalars['String']['output']>;
  /** The unique ID for this address */
  id: Scalars['UUID']['output'];
  /** The first line of the street address */
  line1: Scalars['String']['output'];
  /** The second line of the street address. Optional. */
  line2?: Maybe<Scalars['String']['output']>;
  /** The recipient's full name */
  name: Scalars['String']['output'];
  /** The recipient's phone number. Optional */
  phone?: Maybe<Scalars['String']['output']>;
  /** The recipient's postal code */
  postalCode: Scalars['String']['output'];
  /** The recipient's state */
  state: Scalars['String']['output'];
};

export type AddressChangePayload = {
  __typename?: 'AddressChangePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Address>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type AddressChangePayloadV2 = {
  __typename?: 'AddressChangePayloadV2';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<AddressV2>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for adding an address to the current user */
export type AddressCreateInput = {
  /** The recipient's city */
  city: Scalars['String']['input'];
  /** The recipient's company name. Optional. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's country. Optional, defaults to USA. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The first line of the street address */
  line1: Scalars['String']['input'];
  /** The second line of the street address. Optional. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's full name */
  name: Scalars['String']['input'];
  /** The recipient's phone number. Optional */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's postal code */
  postalCode: Scalars['String']['input'];
  /** The recipient's state */
  state: Scalars['String']['input'];
};

/** Parameters for adding an address to the current user */
export type AddressCreateInputV2 = {
  /** The recipient's city */
  city: Scalars['String']['input'];
  /** The recipient's company name. Optional. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's country. Optional, defaults to USA. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The first line of the street address */
  line1: Scalars['String']['input'];
  /** The second line of the street address. Optional. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's full name */
  name: Scalars['String']['input'];
  /** The recipient's phone number. Optional */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's postal code */
  postalCode: Scalars['String']['input'];
  /** The recipient's state. Required for US addresses. */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Parameters for deleting an address belonging to the current user */
export type AddressDeleteInput = {
  /** The unique ID for this address */
  id: Scalars['UUID']['input'];
};

/** Parameters for changing an address belonging to the current user */
export type AddressUpdateInput = {
  /** The recipient's city */
  city: Scalars['String']['input'];
  /** The recipient's company name. Optional. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's country. Optional, defaults to USA. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID for this address */
  id: Scalars['UUID']['input'];
  /** The first line of the street address */
  line1: Scalars['String']['input'];
  /** The second line of the street address. Optional. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's full name */
  name: Scalars['String']['input'];
  /** The recipient's phone number. Optional */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's postal code */
  postalCode: Scalars['String']['input'];
  /** The recipient's state */
  state: Scalars['String']['input'];
};

/** Parameters for changing an address belonging to the current user */
export type AddressUpdateInputV2 = {
  /** The recipient's city */
  city: Scalars['String']['input'];
  /** The recipient's company name. Optional. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's country. Optional, defaults to USA. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** The unique ID for this address */
  id: Scalars['UUID']['input'];
  /** The first line of the street address */
  line1: Scalars['String']['input'];
  /** The second line of the street address. Optional. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's full name */
  name: Scalars['String']['input'];
  /** The recipient's phone number. Optional */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The recipient's postal code */
  postalCode: Scalars['String']['input'];
  /** The recipient's state. Required for US addresses. */
  state?: InputMaybe<Scalars['String']['input']>;
};

/** An address for shipping or billing purposes. V2 supports non-US addresses since state is nullable */
export type AddressV2 = {
  __typename?: 'AddressV2';
  /** The recipient's city */
  city: Scalars['String']['output'];
  /** The recipient's company name. Optional. */
  company?: Maybe<Scalars['String']['output']>;
  /** The recipient's country. Optional, defaults to USA. */
  country?: Maybe<Scalars['String']['output']>;
  /** The address's country */
  countryV2: Country;
  /** The unique ID for this address */
  id: Scalars['UUID']['output'];
  /** The first line of the street address */
  line1: Scalars['String']['output'];
  /** The second line of the street address. Optional. */
  line2?: Maybe<Scalars['String']['output']>;
  /** The recipient's full name */
  name: Scalars['String']['output'];
  /** The recipient's phone number. Optional */
  phone?: Maybe<Scalars['String']['output']>;
  /** The recipient's postal code */
  postalCode: Scalars['String']['output'];
  /** The recipient's state. Required for US addresses. */
  state?: Maybe<Scalars['String']['output']>;
};

export enum AdminRole {
  /** Manage user account details and status */
  CustomerExperience = 'CUSTOMER_EXPERIENCE',
  /** Manage feature flags and on-call tooling */
  Engineering = 'ENGINEERING',
  /** Manage growth campaigns and programs */
  Growth = 'GROWTH',
  /** Manage Instant Rips */
  InstantRipsOperations = 'INSTANT_RIPS_OPERATIONS',
  /** Manage live streams and breaks */
  SellerOperations = 'SELLER_OPERATIONS',
  /** System Administrator */
  SystemAdministrator = 'SYSTEM_ADMINISTRATOR'
}

/** Input object for assigning a spot */
export type AssignSpotInput = {
  breakSpotId: Scalars['UUID']['input'];
  targetUsername: Scalars['String']['input'];
};

export type AssignSpotPayload = {
  __typename?: 'AssignSpotPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<AssignSpotResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type AssignSpotResponse = {
  __typename?: 'AssignSpotResponse';
  breakSpot?: Maybe<BreakSpot>;
};

/** Parameters for assigning staffers to a live stream */
export type AssignStaffersToLiveStreamInput = {
  /** The ID of the live stream */
  id: Scalars['ID']['input'];
  /** The IDs of the staffers to assign */
  stafferIds: Array<Scalars['ID']['input']>;
};

export type AssignStaffersToLiveStreamPayload = {
  __typename?: 'AssignStaffersToLiveStreamPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveStreamResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for applying a shop-scoped auction ban */
export type AuctionBanInput = {
  liveStreamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type AuctionBanPayload = {
  __typename?: 'AuctionBanPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<AuctionBanResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type AuctionBanResult = {
  __typename?: 'AuctionBanResult';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AuctionFailInput = {
  breakId: Scalars['UUID']['input'];
};

export type AuctionFailPayload = {
  __typename?: 'AuctionFailPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<AuctionFailResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type AuctionFailResponse = {
  __typename?: 'AuctionFailResponse';
  breakSpotAuction?: Maybe<BreakSpotAuction>;
};

export type AuctionStartedPayload = {
  __typename?: 'AuctionStartedPayload';
  /** The BreakSpotAuction that was started */
  breakSpotAuction: BreakSpotAuction;
  breakSpotAuctionId: Scalars['UUID']['output'];
  breakSpotId: Scalars['UUID']['output'];
  timestamp: Scalars['DateTime']['output'];
};

/** Types of authentication factors supported by the system */
export enum AuthFactorType {
  /** Auth using email and FanID auth code */
  Fanid = 'FANID',
  /** Auth using email and password */
  Password = 'PASSWORD'
}

/** Parameters for initiating authentication with FanID */
export type AuthParams = {
  __typename?: 'AuthParams';
  clientId: Scalars['String']['output'];
  nonce: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
  responseType: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

/** Information about the just authenticated user */
export type AuthUser = {
  __typename?: 'AuthUser';
  /** Whether the user has accepted chat guidelines or not */
  acceptedGuidelines: Scalars['Boolean']['output'];
  /** True if the user has admin privileges */
  admin: Scalars['Boolean']['output'];
  /** The color to be used for the user's avatar */
  avatarColor?: Maybe<AvatarColor>;
  /** The image url to be used for the user's avatar */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The biography of the user */
  biography?: Maybe<Scalars['String']['output']>;
  /**
   * A timestamp indicating when this user was confirmed.
   * Null if the user has not been confirmed.
   */
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user's email address */
  email: Scalars['String']['output'];
  /** The user's unique ID */
  id: Scalars['UUID']['output'];
  /** A timestamp indicating when this user was created */
  insertedAt: Scalars['DateTime']['output'];
  /** True if the user is subscribed to the mailing list */
  mailingListSubscription: Scalars['Boolean']['output'];
  /** True if the user has enabled notifications */
  notificationsEnabled: Scalars['Boolean']['output'];
  /** Whether the user has completed registration or not */
  registrationComplete: Scalars['Boolean']['output'];
  /** A timestamp indicating when this user was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The user's username */
  username?: Maybe<Scalars['String']['output']>;
};

export type AuthenticateInput = {
  /** The client ID of the application making the request */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Unique Device identifier */
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  /**
   * Factor used to authenticate the user.
   * May be a password or an authentication code from a third party service.
   */
  factor: Scalars['String']['input'];
  /** Invitation code. */
  invitationCode?: InputMaybe<Scalars['String']['input']>;
  /** The promo code the user can use to sign up with */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** A referral code if the user signup is from a referral */
  referralCode?: InputMaybe<Scalars['String']['input']>;
  /** Unique SEON identifier for fraud detection */
  seonIdentifier?: InputMaybe<Scalars['String']['input']>;
  /**
   * The type of authentication to attempt. (Optional)
   * If not provided, this defaults to FANID
   */
  type?: InputMaybe<AuthFactorType>;
  /** How to identify the user. Typically email or username. */
  userKey: Scalars['String']['input'];
};

export type AuthenticateResult = {
  __typename?: 'AuthenticateResult';
  /** The action that was taken to authenticate the user */
  action: CollectAuthenticateAction;
  /** The promo code the user used to sign up with */
  promoCode?: Maybe<Scalars['String']['output']>;
  tokens: TokenPair;
  user: AuthUser;
};

/** An avatar for a shop or channel */
export type Avatar = {
  __typename?: 'Avatar';
  /** The type of the avatar */
  avatarType: AvatarType;
  /** The ID of the channel if the avatar refers to a channel */
  channelId?: Maybe<Scalars['ID']['output']>;
  /** The description to be shown in the avatar */
  description?: Maybe<Scalars['String']['output']>;
  /** The name to be shown in the avatar */
  displayName: Scalars['String']['output'];
  /** The follower count for the shop or channel */
  followerCount?: Maybe<Scalars['Int']['output']>;
  /** The ID of the avatar */
  id: Scalars['UUID']['output'];
  /** Whether the current user is following the channel, shop or user represented in the avatar */
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  /** The URL of the avatar logo */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the shop if the avatar refers to a shop */
  shopId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the channel if the avatar refers to a user */
  userId?: Maybe<Scalars['ID']['output']>;
};

/** The color to be used for the user's avatar background */
export enum AvatarColor {
  /** Avatar color: Brown (RGB values {0, 0, 0}) */
  Black = 'BLACK',
  /** Avatar color: Blue (RGB values {0, 64, 221}) */
  Blue = 'BLUE',
  /** Avatar color: Green (RGB values {36, 138, 61}) */
  Green = 'GREEN',
  /** Avatar color: Pink (RGB values {211, 15, 69}) */
  Pink = 'PINK',
  /** Avatar color: Red (RGB values {215, 0, 21}) */
  Red = 'RED',
  /** Avatar color: Yellow (RGB values {178, 80, 0}) */
  Yellow = 'YELLOW'
}

export type AvatarConnection = {
  __typename?: 'AvatarConnection';
  edges?: Maybe<Array<Maybe<AvatarEdge>>>;
  pageInfo: PageInfo;
};

export type AvatarEdge = {
  __typename?: 'AvatarEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Avatar>;
};

export enum AvatarType {
  Channel = 'CHANNEL',
  Shop = 'SHOP',
  User = 'USER'
}

export type Badge = {
  __typename?: 'Badge';
  /** Unique identifier for the badge */
  id: Scalars['UUID']['output'];
  /** Full URL to the badge image */
  imageUrl: Scalars['String']['output'];
  /** Name of the badge */
  name: BadgeName;
  /** Display priority for ordering badges (lower = more important) */
  priority: Scalars['Int']['output'];
  /** Whether this badge is only available to sellers/staffers */
  sellerOnly: Scalars['Boolean']['output'];
};

export enum BadgeName {
  /** FBG VIP badge */
  FbgVip = 'FBG_VIP',
  /** First Time Customer badge */
  FirstTimeCustomer = 'FIRST_TIME_CUSTOMER',
  /** Instant Rips Chase badge */
  InstantRipsChase = 'INSTANT_RIPS_CHASE',
  /** Instant Rips Grail badge */
  InstantRipsGrail = 'INSTANT_RIPS_GRAIL',
  /** VIP badge for special users */
  Vip = 'VIP'
}

/** Ban status for a user */
export type BanStatus = {
  __typename?: 'BanStatus';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  isActive: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a fractional percentage value using basis points
 * (1 basis point = 0.01%). Provides both a human-readable display
 * and an exact integer value for safe calculations, similar to how
 * the Money type represents currency in cents.
 */
export type BasisPoints = {
  __typename?: 'BasisPoints';
  /** The display value of the basis points, e.g. 6.25% */
  display: Scalars['String']['output'];
  /** The value of the basis points, e.g. 625 */
  value: Scalars['Int']['output'];
};

export type BatchFollowShopCreatePayload = {
  __typename?: 'BatchFollowShopCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<BatchFollowShopCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the batchFollowShopCreate mutation */
export type BatchFollowShopCreateResponse = {
  __typename?: 'BatchFollowShopCreateResponse';
  /** The shop that is being followed */
  shops: Array<Shop>;
  /** The user that is following the shop */
  user: UpdatedUser;
};

/** Parameters for bidding on an auction */
export type BidInput = {
  /** The amount of the bid in cents */
  bidInCents: Scalars['Int']['input'];
  /** The unique ID for this auction */
  id: Scalars['UUID']['input'];
  /** The maximum bid amount in cents */
  maxBidInCents?: InputMaybe<Scalars['Int']['input']>;
  /** Unique device identifier (SEON fingerprint) */
  seonIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type BidPayload = {
  __typename?: 'BidPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<BreakSlotAuction>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type BidV2Payload = {
  __typename?: 'BidV2Payload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<BreakSpotAuction>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** A big moment captured from a live recording */
export type BigMoment = {
  __typename?: 'BigMoment';
  /** The end time of the moment in the stream */
  endTime: Scalars['Int']['output'];
  /** The big moment's unique ID */
  id: Scalars['UUID']['output'];
  /** The URL of the media file */
  livestreamUrl: Scalars['String']['output'];
  /** The CloudFront URL for accessing the moment */
  primaryUrl: Scalars['String']['output'];
  /** The sport category this moment belongs to */
  sportCategory?: Maybe<Scalars['String']['output']>;
  /** The start time of the moment in the stream */
  startTime: Scalars['Int']['output'];
  /** Text to display on the thumbnail */
  thumbnailText?: Maybe<Scalars['String']['output']>;
  /** The URL of the moment's thumbnail image */
  thumbnailUrl: Scalars['String']['output'];
  /** The title of the big moment */
  title: Scalars['String']['output'];
  /** The S3 object key for the transcript file */
  transcriptObjectKey?: Maybe<Scalars['String']['output']>;
  /** The type of big moment */
  type: Scalars['String']['output'];
};

/** A break event */
export type Break = {
  __typename?: 'Break';
  /**
   * The break's items (spots and sub-breaks). Returns a union type that clients
   * can query using inline fragments:
   *
   *   breakItems {
   *     __typename
   *     ... on BreakSpot { id label priceInCents }
   *     ... on Break { id title status }
   *   }
   *
   * Note: Spots that have been converted to sub-breaks are excluded to avoid
   * duplication. Sub-breaks represent a way to split parent spots into
   * additional break opportunities.
   */
  breakItems: Array<BreakSpotOrBreak>;
  /** Claimed, available, and total counts for this break's break items */
  breakItemsCounts: BreakItemsCounts;
  breakMechanicThreshold?: Maybe<MoneyAmount>;
  /**
   * The break's minimum bid in cents for the break mechanic type
   * @deprecated Use `break_mechanic_threshold` instead
   */
  breakMechanicThresholdInCents?: Maybe<Scalars['Int']['output']>;
  breakMechanicThresholdLocal?: Maybe<MoneyAmount>;
  /** The mechanic type of the break */
  breakMechanicType?: Maybe<BreakMechanicType>;
  /** The break's products */
  breakProducts: Array<BreakProducts>;
  /** The break's slots */
  breakSlots: Array<BreakSlot>;
  /**
   * Claimed, available, and total counts for this break's break slots
   * @deprecated This field is deprecated, use `break_spots_counts` instead
   */
  breakSlotsCounts?: Maybe<BreakSlotsCounts>;
  /** The break's spots */
  breakSpots: Array<BreakSpot>;
  /** Claimed, available, and total counts for this break's break slots */
  breakSpotsCounts?: Maybe<BreakSpotsCounts>;
  /** The template used for the break */
  breakTemplate?: Maybe<BreakTemplate>;
  /** List of cards from the break */
  cards?: Maybe<Array<Maybe<Card>>>;
  /** The break's currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** The current instant rip break spot that is either showing a pack or has revealed a card */
  currentInstantRipBreakSpot?: Maybe<CurrentInstantRipSpot>;
  /** The break's description */
  description?: Maybe<Scalars['String']['output']>;
  /** If the break is auction, this field indicates whether extended bidding is enabled */
  extendedBiddingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The GMV amount with currency
   * @deprecated This field is deprecated.
   */
  gmvDisplay?: Maybe<MoneyAmount>;
  /** The break's unique ID */
  id: Scalars['UUID']['output'];
  /** The date the break was created */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether all spots in the break and its sub-breaks are sold or converted to sub-breaks */
  isSold?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The vault items opened in a repack
   * @deprecated This object is deprecated.
   */
  items?: Maybe<GetVaultItemsResponse>;
  /** A list of leagues associated with the break */
  leagues: Array<League>;
  /** The live stream the break belongs to */
  liveStream?: Maybe<LiveStream>;
  /**
   * The lowest price of the break's spots.
   *
   * For AUCTION breaks, returns the minimum bid amount set on the break.
   * For SET_PRICE breaks, returns the lowest price of the break's spots.
   * Can be NULL if no price is set.
   */
  lowestBreakSpotPrice?: Maybe<MoneyAmount>;
  minimumBid?: Maybe<MoneyAmount>;
  /**
   * The break's minimum bid in cents
   * @deprecated Use `minimum_bid` instead
   */
  minimumBidInCents?: Maybe<Scalars['Int']['output']>;
  minimumBidLocal?: Maybe<MoneyAmount>;
  /** The number of unique buyers in the break */
  numBuyers?: Maybe<Scalars['Int']['output']>;
  /** The number of unique products in the break */
  numUnqiueProducts?: Maybe<Scalars['Int']['output']>;
  /**
   * An Odyssey Repack Status, set only if the product is of type digital
   * @deprecated This object is deprecated.
   */
  odysseyStatus?: Maybe<BreakOdysseyStatus>;
  /** The break's parent break */
  parentBreak?: Maybe<Break>;
  /** The break's parent break spots */
  parentBreakSpots?: Maybe<Array<Maybe<BreakSpot>>>;
  price?: Maybe<MoneyAmount>;
  /**
   * The break's price in cents. This only applies to random set price.
   * @deprecated Use `price` instead
   */
  priceInCents?: Maybe<Scalars['Int']['output']>;
  priceLocal?: Maybe<MoneyAmount>;
  /** The break's pricing type */
  pricingType: BreakPricingType;
  /**
   * deprecated: The break's products
   * @deprecated This field is deprecated
   */
  products: Array<Product>;
  /**
   * Whether the break is purchasable
   * @deprecated This field is deprecated. Please use `purchasable` on spot instead.
   */
  purchasable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * DEPRECATED: Use `purchasable` instead.
   * @deprecated This field is deprecated. Please use `purchasable` instead.
   */
  purchaseable?: Maybe<Scalars['Boolean']['output']>;
  /** The date the break was randomized */
  randomizedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The Net revenue amount with currency
   * @deprecated This field is deprecated
   */
  revenue?: Maybe<MoneyAmount>;
  /** The break's root break */
  rootBreak?: Maybe<Break>;
  /** The break's selection type */
  selectionType: BreakSelectionType;
  shippingProfile?: Maybe<ShippingProfile>;
  /** The shipping profile id */
  shippingProfileId?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the break started ripping */
  startRippingAt?: Maybe<Scalars['DateTime']['output']>;
  /** The break's status */
  status: BreakStatus;
  /** The break's title */
  title?: Maybe<Scalars['String']['output']>;
  /** The break's type */
  type?: Maybe<BreakType>;
};


/** A break event */
export type BreakBreakSlotsArgs = {
  filter?: InputMaybe<BreakSlotFilter>;
};


/** A break event */
export type BreakBreakSpotsArgs = {
  filter?: InputMaybe<BreakSpotFilter>;
};

export type BreakGame = {
  __typename?: 'BreakGame';
  /** Annotations for the break game */
  annotations: Scalars['Json']['output'];
  /** Break game break status */
  break: Break;
  /** Break game end time */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Break game type */
  gameType: BreakGameType;
  /**
   * The title of the giveaway reward
   * @deprecated use generic reward_title field instead
   */
  giveawayTitle?: Maybe<Scalars['String']['output']>;
  /** Break game's ID */
  id: Scalars['UUID']['output'];
  /** The reward title */
  rewardTitle?: Maybe<Scalars['String']['output']>;
  /** Break game reward type */
  rewardType: BreakGameRewardType;
  /** Break game status (is game active or completed) */
  status: BreakGameStatusType;
};

export type BreakGameAddTimeInput = {
  /** The break game id */
  breakGameId: Scalars['UUID']['input'];
  /** Game duration to add in seconds */
  secondsToAdd?: InputMaybe<Scalars['Int']['input']>;
};

export type BreakGameCreateInput = {
  /** The break id */
  breakId: Scalars['UUID']['input'];
  /** The duration of the game (seconds) */
  gameDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The type of the game */
  gameType: BreakGameType;
  /** The reward title */
  rewardTitle?: InputMaybe<Scalars['String']['input']>;
  /** The type of the game reward */
  rewardType?: InputMaybe<BreakGameRewardType>;
};

export type BreakGameEndGameInput = {
  /** The break game id */
  breakGameId: Scalars['UUID']['input'];
};

export type BreakGameLaunchGiveawayInput = {
  /** The break game id */
  breakGameId: Scalars['UUID']['input'];
};

export type BreakGameLaunchRewardInput = {
  /** The break game id */
  breakGameId: Scalars['UUID']['input'];
};

export type BreakGameResponse = {
  __typename?: 'BreakGameResponse';
  breakGame?: Maybe<BreakGame>;
};

export type BreakGameResponsePayload = {
  __typename?: 'BreakGameResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<BreakGameResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export enum BreakGameRewardType {
  Custom = 'CUSTOM',
  Giveaway = 'GIVEAWAY'
}

export enum BreakGameStatusType {
  /** Game in progress */
  Active = 'ACTIVE',
  /** Game completed, awaiting seller action before processing to reward */
  AwaitingAction = 'AWAITING_ACTION',
  /** Game ended, all spots were sold, reward is completed */
  Completed = 'COMPLETED',
  /** Game ended, unclaimed spots left */
  Failed = 'FAILED',
  /** Game completed, reward is in progress */
  RewardActive = 'REWARD_ACTIVE'
}

export enum BreakGameType {
  FillTheBoard = 'FILL_THE_BOARD',
  WhiteElephant = 'WHITE_ELEPHANT'
}

/** The break input object */
export type BreakInput = {
  /** The break's break mechanic threshold in cents */
  breakMechanicThresholdInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The break's break mechanic type */
  breakMechanicType?: InputMaybe<BreakMechanicType>;
  /** The break's break products */
  breakProductsConfig?: InputMaybe<Array<InputMaybe<BreakProductsInput>>>;
  /** The break's spots and the corresponding pricing. This list is only needed for PYT set price. */
  breakSpots?: InputMaybe<Array<InputMaybe<BreakSpotInput>>>;
  /** The break template ID of the break */
  breakTemplateId: Scalars['UUID']['input'];
  /** If the break is auction, this field enables extended bidding */
  extendedBiddingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the break is auction, this field sets the extended bidding refill threshold in seconds */
  extendedBiddingRefillThresholdInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates this is a child break */
  isChild?: InputMaybe<Scalars['Boolean']['input']>;
  /** The live stream ID of the break */
  liveStreamId: Scalars['UUID']['input'];
  /** If the break is auction, this field sets the minimum bid amount */
  minimumBidAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The break's pricing type */
  pricingType: BreakPricingType;
  /** The price for random set price break */
  randomSetPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The break's selection type */
  selectionType: BreakSelectionType;
  /** The unique identifier of a shipping profile ID belonging to the shop to be used with a given break */
  shippingProfileId?: InputMaybe<Scalars['UUID']['input']>;
  /** The shop ID the break belongs to */
  shopId?: InputMaybe<Scalars['UUID']['input']>;
  /** The title of the break */
  title: Scalars['String']['input'];
};

/** Count of the break items */
export type BreakItemsCounts = {
  __typename?: 'BreakItemsCounts';
  /** Number of break items available */
  available?: Maybe<Scalars['Int']['output']>;
  /** Number of break items claimed */
  claimed?: Maybe<Scalars['Int']['output']>;
  /** Total number of break items */
  total?: Maybe<Scalars['Int']['output']>;
};

/** The type of break mechanic */
export enum BreakMechanicType {
  /** Pick 2, Choose 1 */
  Pick_2Choose_1 = 'PICK_2_CHOOSE_1',
  /** Stash or Pass */
  StashOrPass = 'STASH_OR_PASS'
}

/** The Odyssey repack status of a break */
export enum BreakOdysseyStatus {
  /** The Odyssey box has been opened */
  BoxOpened = 'BOX_OPENED',
  /** The Odyssey repack is ready */
  Ready = 'READY',
  /** The Odyssey repack has been ripped */
  RepackRevealed = 'REPACK_REVEALED',
  /** The Odyssey break has been revealed */
  Revealed = 'REVEALED',
  /**
   * The Odyssey break has been revealed and a new pack is upcoming
   * @deprecated Upcoming is deprecated and will be removed in a future release.
   */
  Upcoming = 'UPCOMING'
}

/** A purchase order for a break slot */
export type BreakOrder = {
  __typename?: 'BreakOrder';
  /** The amount of the order purchased using account funds */
  accountFundsAppliedAsPaymentMethod?: Maybe<MoneyAmount>;
  /** The purchase price of the break slot */
  amountInCents: Scalars['Int']['output'];
  /** The amount of the order paid via payment method */
  amountPaidViaPaymentMethod?: Maybe<MoneyAmount>;
  /** The purchase price value of the break slot */
  amountValue: MoneyAmount;
  /** The amount of the order purchased using wallet credit */
  appliedRewardsBalanceAsPaymentMethod?: Maybe<MoneyAmount>;
  /** The break that the order is purchased from */
  break: Break;
  /**
   * The break slot purchased
   * @deprecated This field is being replaced by breakSlot
   */
  breakSlot: BreakSlot;
  /**
   * The list of break slots purchased
   * @deprecated This field is being replaced by breakSpots
   */
  breakSlots: Array<BreakSlot>;
  /** The list of break spots purchased */
  breakSpots: Array<BreakSlot>;
  /** The shipment service provider */
  carrierProvider?: Maybe<Scalars['String']['output']>;
  /**
   * The destination shop's country
   * @deprecated Use destination_country_v2 instead
   */
  destinationCountry?: Maybe<Scalars['String']['output']>;
  /** The destination shop's country */
  destinationCountryV2?: Maybe<Country>;
  /** The discount value amount */
  discountValue?: Maybe<MoneyAmount>;
  /** The discount value amount for display */
  discountValueDisplay?: Maybe<Scalars['String']['output']>;
  /** The discount value amount in cents */
  discountValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The amount of the order purchased using fancash credit */
  fancashCreditAppliedAsPaymentMethod?: Maybe<MoneyAmount>;
  /** The unique id for this order */
  id: Scalars['UUID']['output'];
  /** A timestamp indicating when this order was created */
  insertedAt: Scalars['DateTime']['output'];
  /** Whether the order is first time purchase */
  isFirstOrder?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this order is for a giveaway */
  isGiveaway?: Maybe<Scalars['Boolean']['output']>;
  /** The user friendly code for break order */
  orderCode: Scalars['String']['output'];
  /**
   * The payment method used to pay for this order
   * @deprecated This field is deprecated. Use paymentMethodV2 instead.
   */
  paymentMethod: PaymentMethod;
  /** The payment method used to pay for this order */
  paymentMethodV2: PaymentMethodV2;
  /** The product value amount */
  productValue?: Maybe<MoneyAmount>;
  /** The product value amount for display */
  productValueDisplay?: Maybe<Scalars['String']['output']>;
  /** The product value amount in cents */
  productValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Promotional code */
  promoCode?: Maybe<Scalars['String']['output']>;
  /** The purchase quantity of the break slot */
  quantity: Scalars['Int']['output'];
  /** The amount of the order purchased using wallet credit */
  rewardsAmount: MoneyAmount;
  /** The shipment service level */
  serviceLevel?: Maybe<Scalars['String']['output']>;
  /**
   * The shipping address used to fulfill this order
   * @deprecated Use shippingAddressV2 instead
   */
  shippingAddress: Address;
  /** The shipping address used to fulfill this order */
  shippingAddressV2: AddressV2;
  /** The cost of shipping for the break spot */
  shippingValue?: Maybe<MoneyAmount>;
  /** The cost of shipping for the break spot for display */
  shippingValueDisplay?: Maybe<Scalars['String']['output']>;
  /** The cost of shipping for the break spot in cents */
  shippingValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The order status */
  status?: Maybe<Scalars['String']['output']>;
  /** The client secret for the stripe payment intent */
  stripePaymentIntentClientSecret?: Maybe<Scalars['String']['output']>;
  /** The status of the stripe payment intent */
  stripePaymentIntentStatus?: Maybe<Scalars['String']['output']>;
  /** The subtotal value amount */
  subTotalValue?: Maybe<MoneyAmount>;
  /** The subtotal value amount for display */
  subTotalValueDisplay?: Maybe<Scalars['String']['output']>;
  /** The subtotal value amount in cents */
  subTotalValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The shipment tracking sub status */
  substatusCode?: Maybe<Scalars['String']['output']>;
  /** The tax charge for the break spot */
  totalChargeValue?: Maybe<MoneyAmount>;
  /** The tax charge for the break spot for display */
  totalChargeValueDisplay?: Maybe<Scalars['String']['output']>;
  /** The tax charge for the break spot in cents */
  totalChargeValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The total amount for the break order */
  totalOrderAmount?: Maybe<MoneyAmount>;
  /** The total sales tax amount */
  totalSalesTax?: Maybe<MoneyAmount>;
  /** The total sales tax amount for display */
  totalSalesTaxDisplay?: Maybe<Scalars['String']['output']>;
  /** The total sales tax amount in cents */
  totalSalesTaxInCents?: Maybe<Scalars['Int']['output']>;
  /** The shipment tracking number */
  trackingNumber?: Maybe<Scalars['String']['output']>;
  /** The shipment tracking status */
  trackingStatus?: Maybe<Scalars['String']['output']>;
  /** The tracking provider url */
  trackingUrlProvider?: Maybe<Scalars['String']['output']>;
};

export type BreakOrderConnection = {
  __typename?: 'BreakOrderConnection';
  count: Scalars['Int']['output'];
  edges?: Maybe<Array<Maybe<BreakOrderEdge>>>;
  pageInfo: PageInfo;
};

export type BreakOrderEdge = {
  __typename?: 'BreakOrderEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<BreakOrder>;
};

/** The response from purchasing a slot in a break */
export type BreakOrderResponse = {
  __typename?: 'BreakOrderResponse';
  /** Messages about the successful break order purchase */
  messages?: Maybe<Array<Maybe<Message>>>;
  order: BreakOrder;
};

/** Describes how slots in a break are priced */
export enum BreakPricingType {
  /** Break's slots use auction pricing */
  Auction = 'AUCTION',
  /** Break's slots use fixed pricing */
  SetPrice = 'SET_PRICE'
}

/** The products associated with the break */
export type BreakProducts = {
  __typename?: 'BreakProducts';
  /** The break info */
  break: Break;
  /** The product's cost in cents */
  costInCents?: Maybe<Scalars['Int']['output']>;
  /** The product info */
  product: Product;
  /** The quantity of the product associated with the break */
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type BreakProductsInput = {
  /** The cost of the product in cents */
  costInCents: Scalars['Int']['input'];
  /** The product ID */
  productId: Scalars['UUID']['input'];
  /** The quantity of the product */
  quantity: Scalars['Int']['input'];
};

/** Describes how slots in a break are assigned */
export enum BreakSelectionType {
  /**
   * Break's slots are picked by the customer
   * @deprecated We are renaming this to :pick_your_spot, please use that instead
   */
  PickYourSlot = 'PICK_YOUR_SLOT',
  /** Break's spots are picked by the customer */
  PickYourSpot = 'PICK_YOUR_SPOT',
  /** Break's slots will be randomly assigned */
  Random = 'RANDOM'
}

/** A single slot in a break */
export type BreakSlot = {
  __typename?: 'BreakSlot';
  /** The break this slot belongs to */
  break: Break;
  /** The most recent break slot auction related to this slot */
  breakSlotAuction?: Maybe<BreakSlotAuction>;
  /** The break slot auctions related to this slot */
  breakSlotAuctions: Array<BreakSlotAuction>;
  /** The break template slot related to this slot */
  breakTemplateSlot: BreakTemplateSlot;
  /** The break slot's unique ID */
  id: Scalars['UUID']['output'];
  /** The break slot's label */
  label: Scalars['String']['output'];
  /** The break slot's label abbreviation (up to 3 letters) */
  labelAbbreviation: Scalars['String']['output'];
  /** The break template slot logo url */
  logoUrl?: Maybe<Scalars['String']['output']>;
  previousPrice?: Maybe<MoneyAmount>;
  /** The break spot's price before discount display */
  previousPriceDisplay?: Maybe<Scalars['String']['output']>;
  /** The break spot's price before discount in cents */
  previousPriceInCents?: Maybe<Scalars['Int']['output']>;
  previousPriceLocal?: Maybe<MoneyAmount>;
  price?: Maybe<MoneyAmount>;
  /** The break spot's price discount percentage */
  priceDiscountPercentage?: Maybe<Scalars['Int']['output']>;
  priceDisplay?: Maybe<Scalars['String']['output']>;
  /** The template slot's price in cents */
  priceInCents?: Maybe<Scalars['Int']['output']>;
  priceLocal?: Maybe<MoneyAmount>;
  /** Whether this spot is available for purchase */
  purchasable: Scalars['Boolean']['output'];
  rawPrice?: Maybe<MoneyAmount>;
  /** The template slot's raw price display */
  rawPriceDisplay?: Maybe<Scalars['String']['output']>;
  /** The template slot's raw price in cents */
  rawPriceInCents?: Maybe<Scalars['Int']['output']>;
  rawPriceLocal?: Maybe<MoneyAmount>;
  /** The template slot's number */
  slotNumber: Scalars['Int']['output'];
  user?: Maybe<BreakUser>;
};


/** A single slot in a break */
export type BreakSlotBreakSlotAuctionsArgs = {
  status?: InputMaybe<BreakSlotAuctionStatus>;
};

/** An auction to sell off a single break slot */
export type BreakSlotAuction = {
  __typename?: 'BreakSlotAuction';
  /** The break associated with the break slot auction */
  break: Break;
  /** The break slot auctions's break mechanic picked spots, if any */
  breakMechanicPickedSpots?: Maybe<Array<Maybe<BreakSpot>>>;
  /** The break slot auctions's break mechanic revealed spots, if any */
  breakMechanicRevealedSpots?: Maybe<Array<BreakSpot>>;
  /** The break slot auctions's break mechanic threshold in cents, if any */
  breakMechanicThresholdInCents?: Maybe<Scalars['Int']['output']>;
  /** The break slot auctions's break mechanic type, if any */
  breakMechanicType?: Maybe<BreakMechanicType>;
  /**
   * The break slot associated with the break slot auction
   * @deprecated This field is being replaced by breakSpot
   */
  breakSlot: BreakSlot;
  /** The break spot associated with the break spot auction */
  breakSpot: BreakSlot;
  /** The break slot auction's ending time */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The break slot auction's failure reason */
  failureReason?: Maybe<BreakSlotAuctionFailureReason>;
  /** The break slot auction's current high bid in cents */
  highBidInCents?: Maybe<Scalars['Int']['output']>;
  /** The user that is the current high bidder */
  highBidder?: Maybe<BreakUser>;
  /** Whether the high bidder was preauthorized */
  highBidderPreauthed?: Maybe<Scalars['Boolean']['output']>;
  /** The break slot auction's unique ID */
  id: Scalars['UUID']['output'];
  /** The break slot auction's initial duration in seconds */
  initialDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  /** The break slot auction's minimum bid in cents */
  minimumBidInCents?: Maybe<Scalars['Int']['output']>;
  /** The break slot auction's refill threshold in seconds */
  refillThresholdInSeconds?: Maybe<Scalars['Int']['output']>;
  /** The break slot auction's current status */
  status?: Maybe<BreakSlotAuctionStatus>;
  /** The timestamp of the last update to the break slot auction */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The failure reason of a break slot auction */
export enum BreakSlotAuctionFailureReason {
  /** No valid bids were made */
  NoBids = 'NO_BIDS',
  /** Failed to create order when auction ended */
  OrderFailure = 'ORDER_FAILURE',
  /** Failed to capture payment when auction ended */
  PaymentFailure = 'PAYMENT_FAILURE'
}

/** The status of a break slot auction */
export enum BreakSlotAuctionStatus {
  /** Break slot auction is active */
  Active = 'ACTIVE',
  /** Break slot auction is completed */
  Complete = 'COMPLETE',
  /** Break slot auction has failed */
  Failed = 'FAILED',
  /** Break spot auction is waiting for payment 3DS verification */
  PaymentPending = 'PAYMENT_PENDING',
  /** Break slot auction is waiting for selection */
  SelectionPending = 'SELECTION_PENDING',
  /** A random break spot has been assigned */
  SpotAssigned = 'SPOT_ASSIGNED'
}

export enum BreakSlotAvailability {
  /** Break slots that are still available */
  Available = 'AVAILABLE',
  /** Break slots that have been claimed */
  Claimed = 'CLAIMED'
}

export type BreakSlotFilter = {
  /** Filter break slots by availability. Ignored when owned filter is supplied. */
  availability?: InputMaybe<BreakSlotAvailability>;
};

/** Info on break slots in a break */
export type BreakSlotsCounts = {
  __typename?: 'BreakSlotsCounts';
  /** Number of break slots available */
  available?: Maybe<Scalars['Int']['output']>;
  /** Number of break slots claimed */
  claimed?: Maybe<Scalars['Int']['output']>;
  /** Total number of break slots */
  total?: Maybe<Scalars['Int']['output']>;
};

/** A single spot in a break */
export type BreakSpot = {
  __typename?: 'BreakSpot';
  /** The break this spot belongs to */
  break: Break;
  /** The most recent break spot auction related to this spot */
  breakSpotAuction?: Maybe<BreakSpotAuction>;
  /** The break spot auctions related to this spot */
  breakSpotAuctions: Array<BreakSpotAuction>;
  /** The break template spot related to this spot */
  breakTemplateSpot: BreakTemplateSpot;
  /** The break spot's digital rip status */
  digitalRipStatus?: Maybe<DigitalRipStatus>;
  /** The break spot's unique ID */
  id: Scalars['UUID']['output'];
  /** The vault items opened in a repack */
  items?: Maybe<GetVaultItemsResponse>;
  /** The break spot's label */
  label: Scalars['String']['output'];
  /** The break spot's label abbreviation (up to 3 letters) */
  labelAbbreviation: Scalars['String']['output'];
  leagues: Array<League>;
  /** The break template slot logo url */
  logoUrl?: Maybe<Scalars['String']['output']>;
  previousPrice?: Maybe<MoneyAmount>;
  /** The break spot's price before discount in cents */
  previousPriceInCents?: Maybe<Scalars['Int']['output']>;
  previousPriceLocal?: Maybe<MoneyAmount>;
  price?: Maybe<MoneyAmount>;
  /** The break spot's price discount percentage */
  priceDiscountPercentage?: Maybe<Scalars['Int']['output']>;
  priceDisplay?: Maybe<Scalars['String']['output']>;
  /**
   * The template spot's price in cents
   * @deprecated Use price instead
   */
  priceInCents?: Maybe<Scalars['Int']['output']>;
  priceLocal?: Maybe<MoneyAmount>;
  pricingType: BreakPricingType;
  /** Whether this spot is available for purchase */
  purchasable: Scalars['Boolean']['output'];
  rawPrice?: Maybe<MoneyAmount>;
  /**
   * The template spot's raw price display
   * @deprecated Use rawPrice instead
   */
  rawPriceDisplay?: Maybe<Scalars['String']['output']>;
  /**
   * The template spot's raw price in cents
   * @deprecated Use rawPrice instead
   */
  rawPriceInCents?: Maybe<Scalars['Int']['output']>;
  rawPriceLocal?: Maybe<MoneyAmount>;
  /** The template spot's number */
  spotNumber: Scalars['Int']['output'];
  user?: Maybe<BreakUser>;
};


/** A single spot in a break */
export type BreakSpotBreakSpotAuctionsArgs = {
  status?: InputMaybe<BreakSpotAuctionStatus>;
};

/** An auction to sell off a single break spot */
export type BreakSpotAuction = {
  __typename?: 'BreakSpotAuction';
  /** The break associated with the break spot auction */
  break: Break;
  /** The ID of the break this auction belongs to */
  breakId: Scalars['UUID']['output'];
  /** The break spot auctions's break mechanic expiration, if any */
  breakMechanicExpiration?: Maybe<Scalars['DateTime']['output']>;
  /** The break spot auctions's break mechanic picked spots, if any */
  breakMechanicPickedSpots?: Maybe<Array<Maybe<BreakSpot>>>;
  /** The break spot auctions's break mechanic revealed spots, if any */
  breakMechanicRevealedSpots?: Maybe<Array<Maybe<BreakSpot>>>;
  /** The break spot auctions's break mechanic threshold */
  breakMechanicThreshold?: Maybe<MoneyAmount>;
  /**
   * The break spot auctions's break mechanic threshold in cents, if any
   * @deprecated Use breakMechanicThreshold instead
   */
  breakMechanicThresholdInCents?: Maybe<Scalars['Int']['output']>;
  breakMechanicThresholdLocal?: Maybe<MoneyAmount>;
  /** The break spot auctions's break mechanic type, if any */
  breakMechanicType?: Maybe<BreakMechanicType>;
  /** The break spot associated with the break spot auction */
  breakSpot: BreakSpot;
  /** The break spot auction's currency */
  currency?: Maybe<Scalars['String']['output']>;
  /** Whether users can outbid themselves */
  disallowOutbiddingSelf?: Maybe<Scalars['Boolean']['output']>;
  /** The break spot auction's ending time */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The break spot auction's failure reason */
  failureReason?: Maybe<BreakSpotAuctionFailureReason>;
  /** The break spot auction's current high bid */
  highBid?: Maybe<MoneyAmount>;
  /**
   * The break spot auction's current high bid in cents
   * @deprecated Use highBid instead
   */
  highBidInCents?: Maybe<Scalars['Int']['output']>;
  highBidLocal?: Maybe<MoneyAmount>;
  /** The user that is the current high bidder */
  highBidder?: Maybe<BreakUser>;
  /** Whether the high bidder was preauthorized */
  highBidderPreauthed?: Maybe<Scalars['Boolean']['output']>;
  /** The break slot auction's unique ID */
  id: Scalars['UUID']['output'];
  /** The break spot auction's initial duration in seconds */
  initialDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  /** The break spot auction's minimum bid */
  minimumBid?: Maybe<MoneyAmount>;
  /**
   * The break spot auction's minimum bid in cents
   * @deprecated Use minimumBid instead
   */
  minimumBidInCents?: Maybe<Scalars['Int']['output']>;
  minimumBidLocal?: Maybe<MoneyAmount>;
  nextBid?: Maybe<MoneyAmount>;
  /**
   * The break spot auction's next bid in cents
   * @deprecated Use nextBid instead
   */
  nextBidInCents?: Maybe<Scalars['Int']['output']>;
  nextBidLocal?: Maybe<MoneyAmount>;
  /**
   * Unique ID for each publish event on this auction. Every publish operation
   * has the same publishId for all subscribers. This is meant to be used for
   * debugging purposes and has no other use.
   */
  publishId?: Maybe<Scalars['String']['output']>;
  /** The list of users whom seen the auction entity */
  readReceipts?: Maybe<Array<User>>;
  /** The break spot auction's refill threshold in seconds */
  refillThresholdInSeconds?: Maybe<Scalars['Int']['output']>;
  /** The break spot auction's starting time */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The break spot auction's current status */
  status?: Maybe<BreakSpotAuctionStatus>;
  /** Whether only trusted users can perform certain actions, such as place custom bids */
  trustedUsersOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The timestamp of the last update to the break spot auction */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The failure reason of a break spot auction */
export enum BreakSpotAuctionFailureReason {
  /** No valid bids were made */
  NoBids = 'NO_BIDS',
  /** Failed to create order when auction ended */
  OrderFailure = 'ORDER_FAILURE',
  /** Failed to capture payment when auction ended */
  PaymentFailure = 'PAYMENT_FAILURE',
  /** Spot was released */
  Released = 'RELEASED'
}

/** The status of a break spot auction */
export enum BreakSpotAuctionStatus {
  /** Break spot auction is active */
  Active = 'ACTIVE',
  /** Break spot auction is completed */
  Complete = 'COMPLETE',
  /** Break spot auction has failed */
  Failed = 'FAILED',
  /** Break spot auction is waiting for payment 3DS verification */
  PaymentPending = 'PAYMENT_PENDING',
  /** Break spot auction is waiting for selection */
  SelectionPending = 'SELECTION_PENDING',
  /** A random break spot has been assigned */
  SpotAssigned = 'SPOT_ASSIGNED'
}

/** The payload sent in a breakSpotChanged subscription */
export type BreakSpotChangedPayload = {
  __typename?: 'BreakSpotChangedPayload';
  /** The break that the break spot that changed belongs to. */
  break: Break;
  /**
   * The break slot that changed (e.g. purchased, refunded, discounted).
   *
   * This field is here for backwards compatibility and will be soon deprecated.
   */
  breakSlot: BreakSlot;
  /** The break spot* that changed (e.g. purchased, refunded, discounted). */
  breakSpot: BreakSpot;
};

export type BreakSpotFilter = {
  /** Filter break slots by availability. Ignored when owned filter is supplied. */
  availability?: InputMaybe<BreakSlotAvailability>;
};

/** The break spot input object */
export type BreakSpotInput = {
  breakTemplateSpotId: Scalars['UUID']['input'];
  priceInCents: Scalars['Int']['input'];
};

/** Union type representing either a break spot or a sub-break created from spots */
export type BreakSpotOrBreak = Break | BreakSpot;

/** Info on break spots in a break */
export type BreakSpotsCounts = {
  __typename?: 'BreakSpotsCounts';
  /** Number of break spots available */
  available?: Maybe<Scalars['Int']['output']>;
  /** Number of break spots claimed */
  claimed?: Maybe<Scalars['Int']['output']>;
  /** Total number of break spots */
  total?: Maybe<Scalars['Int']['output']>;
};

/** The status of a break */
export enum BreakStatus {
  /** The break has been finished */
  Complete = 'COMPLETE',
  /** The break is selling spots */
  InProgress = 'IN_PROGRESS',
  /** The break has been created and is ready to start */
  Ready = 'READY',
  /** The break is opening product */
  Ripping = 'RIPPING'
}

/** A template that can be used to configure a break */
export type BreakTemplate = {
  __typename?: 'BreakTemplate';
  /** List of slots that belong to this template */
  breakTemplateSlots: Array<BreakTemplateSlot>;
  /** List of spots that belong to this template */
  breakTemplateSpots: Array<BreakTemplateSpot>;
  /** List of breaks that use this template */
  breaks: Array<Break>;
  /** The break template's unique ID */
  id: Scalars['UUID']['output'];
  /** The break template's label */
  label: Scalars['String']['output'];
  /** Paginated list of spots that belong to this template */
  paginatedBreakTemplateSpots?: Maybe<BreakTemplateSpotConnection>;
  /** The shop this break template belongs to, nil if universal template */
  shop?: Maybe<Shop>;
};


/** A template that can be used to configure a break */
export type BreakTemplatePaginatedBreakTemplateSpotsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The template configuration for a single break slot */
export type BreakTemplateSlot = {
  __typename?: 'BreakTemplateSlot';
  /** The break slots related to this template slot */
  breakSlots: Array<BreakSlot>;
  /** The break template this slot belongs to */
  breakTemplate: BreakTemplate;
  /** The break template slot's unique ID */
  id: Scalars['UUID']['output'];
  /** The break template slot's label */
  label: Scalars['String']['output'];
  /** The break template slot logo url */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The break template slot's number */
  slotNumber: Scalars['Int']['output'];
};

/** The template configuration for a single break spot */
export type BreakTemplateSpot = {
  __typename?: 'BreakTemplateSpot';
  /** The break spots related to this template spot */
  breakSpots: Array<BreakSpot>;
  /** The break template this spot belongs to */
  breakTemplate: BreakTemplate;
  /** The break template spot's unique ID */
  id: Scalars['UUID']['output'];
  /** The break template spot's label */
  label: Scalars['String']['output'];
  /** The break template slot logo url */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The break template spot's number */
  spotNumber: Scalars['Int']['output'];
};

export type BreakTemplateSpotConnection = {
  __typename?: 'BreakTemplateSpotConnection';
  edges?: Maybe<Array<Maybe<BreakTemplateSpotEdge>>>;
  pageInfo: PageInfo;
};

export type BreakTemplateSpotCreateInput = {
  /** Label of the spot */
  label: Scalars['String']['input'];
};

export type BreakTemplateSpotEdge = {
  __typename?: 'BreakTemplateSpotEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<BreakTemplateSpot>;
};

export type BreakTemplateSpotUpdateInput = {
  /** The break template spot's unique ID */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Label of the spot */
  label: Scalars['String']['input'];
};

export enum BreakType {
  Group = 'GROUP',
  Personal = 'PERSONAL'
}

/** A user participating in a break */
export type BreakUser = {
  __typename?: 'BreakUser';
  /** The image url to be used for the user's avatar */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The break user's id */
  id: Scalars['UUID']['output'];
  /** The break user's username */
  username: Scalars['String']['output'];
};

/** Information about the user's breaking profile */
export type BreakingProfile = {
  __typename?: 'BreakingProfile';
  /** Whether the user has accepted chat guidelines or not */
  acceptedGuidelines: Scalars['Boolean']['output'];
  /** The user's selected payment method to be used with live auctions */
  auctionPaymentMethod?: Maybe<PaymentMethod>;
  /** The user's selected shipping address to be used with live auctions */
  auctionShippingAddress?: Maybe<Address>;
  /** The color to be used for the user's avatar */
  avatarColor?: Maybe<AvatarColor>;
  /** The image url to be used for the user's avatar */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** A token for accessing chat */
  chatToken: Scalars['String']['output'];
  /** Whether the user has completed registration or not */
  registrationComplete: Scalars['Boolean']['output'];
  /** The user's username */
  username: Scalars['String']['output'];
};

export type BreakingProfileChangePayload = {
  __typename?: 'BreakingProfileChangePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<BreakingProfile>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for changing breaking profile belonging to the current user */
export type BreakingProfileUpdateInput = {
  /** The color to be used for the user's avatar */
  avatarColor?: InputMaybe<AvatarColor>;
  /** The image url to be used for the user's avatar */
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  /** Whether the user has completed registration or not */
  registrationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The user's username. Requirements: 3-25 characters in length, only alphanumeric characters */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** A candidate for the leader board. */
export type Candidate = {
  __typename?: 'Candidate';
  /** The number of times the promotion code has been redeemed. */
  redeemCount?: Maybe<Scalars['Int']['output']>;
  /** The shop */
  shop: Shop;
};

export type CaptureSubscriptionListInput = {
  eventData: Scalars['String']['input'];
  eventTitle: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

export type CaptureSubscriptionListPayload = {
  __typename?: 'CaptureSubscriptionListPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CaptureSubscriptionListResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The response from captureSubscriptionList mutation */
export type CaptureSubscriptionListResponse = {
  __typename?: 'CaptureSubscriptionListResponse';
  status: Scalars['String']['output'];
};

/** A card */
export type Card = {
  __typename?: 'Card';
  /** The full name of the athlete of the card */
  athleteName?: Maybe<Scalars['String']['output']>;
  /** The card average listing price across platforms, in cents value */
  avgPriceInCents?: Maybe<Scalars['Int']['output']>;
  /** The card average listing price across platforms, in display format */
  avgPriceInCentsDisplay?: Maybe<Scalars['String']['output']>;
  /** The name of brand series of the card */
  brandSeries?: Maybe<Scalars['String']['output']>;
  /**
   * The first name of the player in the card
   * @deprecated Deprecated: first_name is deprecated
   */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The grade of the card */
  grade?: Maybe<Scalars['Float']['output']>;
  /** The grader of the card */
  grader?: Maybe<Scalars['String']['output']>;
  /** The ID of the card */
  id: Scalars['UUID']['output'];
  /** The back side image of the card */
  imageBackUrl?: Maybe<Scalars['String']['output']>;
  /** The front side image of the card */
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** string of metadata returned by RCI */
  insertedAt: Scalars['DateTime']['output'];
  /**
   * The last name of the player in the card
   * @deprecated Deprecated: last_name is deprecated
   */
  lastName?: Maybe<Scalars['String']['output']>;
  /** string of metadata returned by RCI */
  metadata?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the card
   * @deprecated Deprecated: name is deprecated
   */
  name?: Maybe<Scalars['String']['output']>;
  /** Team name of the athlete */
  team?: Maybe<Scalars['String']['output']>;
  /** The title of the card */
  title?: Maybe<Scalars['String']['output']>;
  /** The USER ID of the card */
  userId: Scalars['UUID']['output'];
};

export type CardAttachedPayload = {
  __typename?: 'CardAttachedPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CardAttachedResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the cardAttach mutation */
export type CardAttachedResponse = {
  __typename?: 'CardAttachedResponse';
  cards?: Maybe<Array<Maybe<Card>>>;
};

/** Full card catalog item with detailed metadata */
export type CardCatalogItem = {
  __typename?: 'CardCatalogItem';
  /** The card brand */
  brand?: Maybe<Scalars['String']['output']>;
  /** The card number */
  cardNumber?: Maybe<Scalars['String']['output']>;
  /** The category ID */
  categoryId?: Maybe<Scalars['UUID']['output']>;
  /** Category tags */
  categoryTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Grading information (when available) */
  gradingInfo?: Maybe<GradingInfo>;
  /** Grading status (e.g., GRADED, UNGRADED, UNKNOWN) */
  gradingStatus?: Maybe<Scalars['String']['output']>;
  /** The unique identifier (uses card_uuid from API) */
  id: Scalars['UUID']['output'];
  /** The card variant images */
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Timestamp when the item was inserted */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The card manufacturer */
  manufacturer?: Maybe<Scalars['String']['output']>;
  /** The parallel variation */
  parallel?: Maybe<Scalars['String']['output']>;
  /** The product uuid from card catalog */
  productId?: Maybe<Scalars['UUID']['output']>;
  /** The card product name */
  productName?: Maybe<Scalars['String']['output']>;
  /** The card set name */
  setName?: Maybe<Scalars['String']['output']>;
  /** The card subject (player/person) */
  subjectName?: Maybe<Scalars['String']['output']>;
  /** The team name */
  teamName?: Maybe<Scalars['String']['output']>;
  /** The card title (product name) */
  title?: Maybe<Scalars['String']['output']>;
  /** The card type (e.g., Checklist, Base) */
  type?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the item was last updated */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The variant uuid from card catalog */
  variantId: Scalars['UUID']['output'];
  /** The card year */
  year?: Maybe<Scalars['String']['output']>;
};

/** Card catalog item search result */
export type CardCatalogItemSearchResult = {
  __typename?: 'CardCatalogItemSearchResult';
  /** The card variant images */
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The product uuid from card catalog */
  productId: Scalars['UUID']['output'];
  /** The card title (aka product_name) */
  title?: Maybe<Scalars['String']['output']>;
  /** The variant uuid from card catalog */
  variantId: Scalars['UUID']['output'];
};

export type CardCatalogSearchInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
};

export type CardConnection = {
  __typename?: 'CardConnection';
  edges?: Maybe<Array<Maybe<CardEdge>>>;
  pageInfo: PageInfo;
};

export type CardCreateInput = {
  /** The break id to which this card should be attached */
  breakId?: InputMaybe<Scalars['UUID']['input']>;
  /** The base64 encoded content of the front side of the card */
  content: Scalars['String']['input'];
  /** The base64 encoded content of the back side of the card */
  contentBack?: InputMaybe<Scalars['String']['input']>;
  /** The file type of the card. We only accept png, jpg, or jpeg */
  fileType: Scalars['String']['input'];
  /** Whether the card should be attached to the currently authenticated user */
  isForUser?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response from the cardCreate mutation */
export type CardCreateResponse = {
  __typename?: 'CardCreateResponse';
  card: Card;
};

export type CardDeletePayload = {
  __typename?: 'CardDeletePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CardDeleteResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CardDeleteResponse = {
  __typename?: 'CardDeleteResponse';
  cards?: Maybe<Array<Maybe<Card>>>;
};

export type CardEdge = {
  __typename?: 'CardEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Card>;
};

export enum CardOrientation {
  /** Horizontal orientation */
  Horizontal = 'HORIZONTAL',
  /** Rotated 0 degrees */
  Rotated_0 = 'ROTATED_0',
  /** Rotated 90 degrees */
  Rotated_90 = 'ROTATED_90',
  /** Rotated 180 degrees */
  Rotated_180 = 'ROTATED_180',
  /** Rotated -90 degrees */
  RotatedNeg_90 = 'ROTATED_NEG_90',
  /** Vertical orientation */
  Vertical = 'VERTICAL'
}

export type CardPayload = {
  __typename?: 'CardPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CardCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CardRotatedPayload = {
  __typename?: 'CardRotatedPayload';
  flip: Scalars['Boolean']['output'];
  orientation: Scalars['String']['output'];
  zoom: Scalars['Boolean']['output'];
};

/** The key to use when sorting live streams */
export enum CardSortKey {
  /** Sort by the athlete name of the card */
  AthleteName = 'ATHLETE_NAME',
  /** Sort by the created time of the card */
  InsertedAt = 'INSERTED_AT',
  /** Sort by the title of the card */
  Title = 'TITLE'
}

/** Card step in instant rip flow */
export type CardStep = {
  __typename?: 'CardStep';
  /** The current item */
  currentItem: InstantRipCurrentItem;
  /** The instant rip pack status */
  digitalRipStatus: CardStepStatus;
  nextItemId?: Maybe<Scalars['UUID']['output']>;
};

export enum CardStepStatus {
  /** Card is revealed */
  CardRevealed = 'CARD_REVEALED'
}

export type CardSwipedPayload = {
  __typename?: 'CardSwipedPayload';
  index: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
};

export type CardUpdateInput = {
  /** The athlete name of the card */
  athleteName?: InputMaybe<Scalars['String']['input']>;
  /** The average price in cents of the card */
  avgPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The brand series of the card */
  brandSeries?: InputMaybe<Scalars['String']['input']>;
  /** The grade of the card */
  grade?: InputMaybe<Scalars['Float']['input']>;
  /** The grader of the card */
  grader?: InputMaybe<Scalars['String']['input']>;
  /** The team of the card */
  team?: InputMaybe<Scalars['String']['input']>;
  /** The title of the card */
  title: Scalars['String']['input'];
};

export type CardUpdatePayload = {
  __typename?: 'CardUpdatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CardUpdateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response for card update mutation */
export type CardUpdateResponse = {
  __typename?: 'CardUpdateResponse';
  card: Card;
};

/** Carrier-specific information */
export type Carrier = {
  __typename?: 'Carrier';
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
};

export type CategoryHierarchyItem = {
  __typename?: 'CategoryHierarchyItem';
  categories: Array<HierarchyCategoryItem>;
  categoryType: Scalars['String']['output'];
};

/** Parameters for celebrating a live stream */
export type CelebrateLiveStreamInput = {
  /** The ID of the object we want to update */
  id: Scalars['ID']['input'];
  /** The type of celebration we want to start */
  type: CelebrationType;
};

export type CelebrateLiveStreamPayload = {
  __typename?: 'CelebrateLiveStreamPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveStreamResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Live stream celebration stype */
export enum CelebrationType {
  Confetti = 'CONFETTI',
  Fire = 'FIRE',
  ToTheMoon = 'TO_THE_MOON'
}

/** Input object for changing break status */
export type ChangeBreakStatusInput = {
  breakId: Scalars['UUID']['input'];
  newStatus: BreakStatus;
};

export type ChangeBreakStatusPayload = {
  __typename?: 'ChangeBreakStatusPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ChangeBreakStatusResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type ChangeBreakStatusResponse = {
  __typename?: 'ChangeBreakStatusResponse';
  break?: Maybe<Break>;
};

export type ChangeDataPrivacySettingsPayload = {
  __typename?: 'ChangeDataPrivacySettingsPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ChangeDataPrivacySettingsResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the changeDataPrivacySettings mutation */
export type ChangeDataPrivacySettingsResponse = {
  __typename?: 'ChangeDataPrivacySettingsResponse';
  /** The user's data privacy settings */
  dataPrivacySettings: DataPrivacySettings;
};

export type ChangeStafferSettingsPayload = {
  __typename?: 'ChangeStafferSettingsPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ChangeStafferSettingsResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the changeSettings mutation */
export type ChangeStafferSettingsResponse = {
  __typename?: 'ChangeStafferSettingsResponse';
  /** The user who has updated their settings */
  user: CurrentUser;
};

/** A collection of related live streams belonging to a single shop */
export type Channel = {
  __typename?: 'Channel';
  /** Paginated list of live streams from the channel which contain all live and upcoming live streams */
  availableLiveStreams?: Maybe<LiveStreamConnection>;
  /**
   * Paginated list of live streams from the channel which contain all completed live streams which
   * include video-on-demand replays.
   * @deprecated This query was used to list streams with replays, not completed ones.
   * Therefore, use the `liveStreamsWithReplays` instead
   */
  completedLiveStreams?: Maybe<LiveStreamConnection>;
  /** The total number of users who follow a channel */
  followerCount: Scalars['Int']['output'];
  /** The users who follow a channel */
  followers: Array<PublicUser>;
  /** The channel's unique ID */
  id: Scalars['UUID']['output'];
  /** Whether the current user is following the channel */
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  /** The channel's live streams */
  liveStreams?: Maybe<LiveStreamConnection>;
  /**
   * Paginated list of live streams from the channel which contain all live streams which
   * include video-on-demand replays.
   */
  liveStreamsWithReplays?: Maybe<LiveStreamConnection>;
  /** The logo url of channel types */
  logoUrl: Scalars['String']['output'];
  /** The channel's Mux Live Stream ID */
  muxLiveStreamId?: Maybe<Scalars['String']['output']>;
  /** The channel's name */
  name: Scalars['String']['output'];
  /** The channel's playback ID */
  playbackId: Scalars['String']['output'];
  /** The shop the channel belongs to */
  shop: Shop;
  /** A paginated list of the users who follow a channel */
  subscribers?: Maybe<PublicUserConnection>;
  /** The channel's webrtc playback ID */
  webrtcPlaybackUrl?: Maybe<Scalars['String']['output']>;
};


/** A collection of related live streams belonging to a single shop */
export type ChannelAvailableLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


/** A collection of related live streams belonging to a single shop */
export type ChannelCompletedLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


/** A collection of related live streams belonging to a single shop */
export type ChannelLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
  startsAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startsBefore?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<LiveStreamStatus>;
};


/** A collection of related live streams belonging to a single shop */
export type ChannelLiveStreamsWithReplaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


/** A collection of related live streams belonging to a single shop */
export type ChannelSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A section with channels */
export type ChannelsSection = {
  __typename?: 'ChannelsSection';
  allItems?: Maybe<Array<Avatar>>;
  items?: Maybe<Array<Avatar>>;
  sectionType: SearchSectionType;
};

/** Carry cost statistics for a checklist */
export type ChecklistCarryCostStats = {
  __typename?: 'ChecklistCarryCostStats';
  avgCarryCost?: Maybe<Scalars['Int']['output']>;
};

/** Category breakdown item */
export type ChecklistCategoryBreakdownItem = {
  __typename?: 'ChecklistCategoryBreakdownItem';
  cardCount: Scalars['Int']['output'];
  categoryName: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

/** Comprehensive statistics for a checklist */
export type ChecklistComprehensiveStats = {
  __typename?: 'ChecklistComprehensiveStats';
  autoPercentage?: Maybe<Scalars['Float']['output']>;
  carryCostStats?: Maybe<ChecklistCarryCostStats>;
  categoryBreakdown: Array<ChecklistCategoryBreakdownItem>;
  playerConcentration: ChecklistPlayerConcentration;
  qualityStats: ChecklistQualityStats;
  titleDuplicates: Array<ChecklistTitleDuplicateItem>;
  typeBreakdown?: Maybe<ChecklistTypeBreakdown>;
  valueStats?: Maybe<ChecklistValueStats>;
};

/** Player concentration statistics */
export type ChecklistPlayerConcentration = {
  __typename?: 'ChecklistPlayerConcentration';
  playersOverThreshold: Array<Scalars['String']['output']>;
  thresholdPercentage: Scalars['Float']['output'];
};

/** The checklist pool item from a checklist for a vault item */
export type ChecklistPoolItem = {
  __typename?: 'ChecklistPoolItem';
  type: RepackItemType;
};

export enum ChecklistPoolType {
  /** Add items to draft pool */
  Draft = 'DRAFT',
  /** Add items to reserve pool with vault transfer */
  Reserve = 'RESERVE'
}

/** Quality statistics for a checklist */
export type ChecklistQualityStats = {
  __typename?: 'ChecklistQualityStats';
  cardsUnderGrade7: Scalars['Int']['output'];
  cardsWithSerial: Scalars['Int']['output'];
  gradedPercentage: Scalars['Float']['output'];
  totalCards: Scalars['Int']['output'];
};

/** Title duplicate item */
export type ChecklistTitleDuplicateItem = {
  __typename?: 'ChecklistTitleDuplicateItem';
  count: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  title: Scalars['String']['output'];
};

/** Type breakdown statistics for a checklist */
export type ChecklistTypeBreakdown = {
  __typename?: 'ChecklistTypeBreakdown';
  base?: Maybe<ChecklistTypeStats>;
  chase?: Maybe<ChecklistTypeStats>;
  grail?: Maybe<ChecklistTypeStats>;
};

/** Statistics for a specific card type */
export type ChecklistTypeStats = {
  __typename?: 'ChecklistTypeStats';
  avgValue?: Maybe<Scalars['Int']['output']>;
  ceilingValue?: Maybe<Scalars['Int']['output']>;
  count: Scalars['Int']['output'];
  floorValue?: Maybe<Scalars['Int']['output']>;
};

/** Value statistics for a checklist */
export type ChecklistValueStats = {
  __typename?: 'ChecklistValueStats';
  avgValue?: Maybe<Scalars['Int']['output']>;
  ceilingValue?: Maybe<Scalars['Int']['output']>;
  floorValue?: Maybe<Scalars['Int']['output']>;
};

/** The input parameter for querying checkout purchase spot breakdown */
export type CheckoutFixedSpotQueriesInput = {
  /** The amount of account funds to apply to the checkout by the user, in cents */
  appliedAccountFundsAmount?: InputMaybe<Scalars['Int']['input']>;
  /** It represent applied fancash balance applied at the time of checkout in cents by user */
  appliedFancashAmount?: InputMaybe<Scalars['Int']['input']>;
  /** If true, apply the user's account funds to the purchase */
  applyAccountFunds?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, apply the user's entire fancash balance to the purchase */
  applyFancashBalance?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, apply the user's entire reward balance to the purchase */
  applyRewardsBalance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique ID for this break */
  breakId: Scalars['UUID']['input'];
  /** The break spot id to be purchased */
  breakSpotIdList: Array<InputMaybe<Scalars['UUID']['input']>>;
  /** The promo code to be used for this purchase */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** Unique device identifier (SEON fingerprint) */
  seonIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The shipping address to be used for this purchase */
  shippingAddressId: Scalars['UUID']['input'];
};

export type CheckoutListingBreakdownPayload = {
  __typename?: 'CheckoutListingBreakdownPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CheckoutPurchaseListingBreakdown>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The checkout break down. This object should contain all the pricing information needed in the checkout box for purchase fixed price spot action */
export type CheckoutPurchaseFixedSpotBreakdown = {
  __typename?: 'CheckoutPurchaseFixedSpotBreakdown';
  /** The total amount without any discounts like promo code, credit applied */
  actualTotalAmount?: Maybe<MoneyAmount>;
  /** The total amount with discounts like promo code, credit applied */
  actualTotalAmountPostDiscount?: Maybe<MoneyAmount>;
  /** The amount due. The amount due is total charge - applied rewards balance */
  amountDue?: Maybe<MoneyAmount>;
  /** The amount of the order purchased using account funds */
  appliedAccountFundsBalanceAsPaymentMethod?: Maybe<MoneyAmount>;
  /** The amount of the order purchased using fancash credit */
  appliedFancashBalanceAsPaymentMethod?: Maybe<MoneyAmount>;
  /**
   * The amount of the order purchased using wallet credit
   * @deprecated Previously used for Employee Rewards related rewards. No longer populated with a value.
   */
  appliedRewardsBalanceAsPaymentMethod?: Maybe<MoneyAmount>;
  /** The discount value */
  discountValue?: Maybe<MoneyAmount>;
  /** The discount value for display */
  discountValueDisplay?: Maybe<Scalars['String']['output']>;
  /** The discount value in cents */
  discountValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Total produce cost */
  productValue?: Maybe<MoneyAmount>;
  /** Total product cost for display */
  productValueDisplay?: Maybe<Scalars['String']['output']>;
  /** Total produce cost in cents */
  productValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Promotional code */
  promoCode?: Maybe<Scalars['String']['output']>;
  /** Shipping cost */
  shippingValue?: Maybe<MoneyAmount>;
  /** Shipping cost for display */
  shippingValueDisplay?: Maybe<Scalars['String']['output']>;
  /** Shipping cost in cents */
  shippingValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The sub total of product cost * quantity */
  subTotalValue?: Maybe<MoneyAmount>;
  /** The sub total of product cost * quantity, for display */
  subTotalValueDisplay?: Maybe<Scalars['String']['output']>;
  /** The sub total of product cost * quantity, in cents */
  subTotalValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The tax line items */
  taxLines: Array<TaxLine>;
  totalAmount?: Maybe<MoneyAmount>;
  /** Total charge, combing product cost, shipping cost and tax */
  totalChargeValue?: Maybe<MoneyAmount>;
  /** Total charge, combing product cost, shipping cost and tax, for display */
  totalChargeValueDisplay?: Maybe<Scalars['String']['output']>;
  /** Total charge, combing product cost, shipping cost and tax, in cents */
  totalChargeValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Total charge, combing product cost, shipping cost and tax in user's currency */
  totalChargeValueLocal?: Maybe<MoneyAmount>;
  /** Total sales tax */
  totalSalesTax?: Maybe<Scalars['Float']['output']>;
  /** Total sales tax for display */
  totalSalesTaxDisplay?: Maybe<Scalars['String']['output']>;
  /** Total sales tax */
  totalSalesTaxValue?: Maybe<MoneyAmount>;
  /** Information about the available wallet balances and their contributions to the checkout */
  walletAmounts?: Maybe<WalletsAmounts>;
};

/** The checkout break down for purchasing a listing */
export type CheckoutPurchaseListingBreakdown = {
  __typename?: 'CheckoutPurchaseListingBreakdown';
  /** The total amount without any discounts like promo code, credit applied */
  actualTotalAmount?: Maybe<MoneyAmount>;
  /** The total amount with discounts like promo code, credit applied */
  actualTotalAmountPostDiscount?: Maybe<MoneyAmount>;
  /** The amount due. The amount due is total charge - applied rewards balance */
  amountDue?: Maybe<MoneyAmount>;
  /** The amount of the order purchased using account funds */
  appliedAccountFundsBalanceAsPaymentMethod?: Maybe<MoneyAmount>;
  /** The amount of the order purchased using fancash credit */
  appliedFancashBalanceAsPaymentMethod?: Maybe<MoneyAmount>;
  /**
   * The amount of the order purchased using wallet credit
   * @deprecated Previously used for Employee Rewards related rewards. No longer populated with a value.
   */
  appliedRewardsBalanceAsPaymentMethod?: Maybe<MoneyAmount>;
  /** The discount value */
  discountValue?: Maybe<MoneyAmount>;
  /** The discount value for display */
  discountValueDisplay?: Maybe<Scalars['String']['output']>;
  /** The discount value in cents */
  discountValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Total produce cost */
  productValue?: Maybe<MoneyAmount>;
  /** Total product cost for display */
  productValueDisplay?: Maybe<Scalars['String']['output']>;
  /** Total produce cost in cents */
  productValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Promotional code */
  promoCode?: Maybe<Scalars['String']['output']>;
  /** The quantity of the random slot to be purchased. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Shipping cost */
  shippingValue?: Maybe<MoneyAmount>;
  /** Shipping cost for display */
  shippingValueDisplay?: Maybe<Scalars['String']['output']>;
  /** Shipping cost in cents */
  shippingValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The sub total of product cost * quantity */
  subTotalValue?: Maybe<MoneyAmount>;
  /** The sub total of product cost * quantity, for display */
  subTotalValueDisplay?: Maybe<Scalars['String']['output']>;
  /** The sub total of product cost * quantity, in cents */
  subTotalValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The tax line items */
  taxLines: Array<TaxLine>;
  totalAmount?: Maybe<MoneyAmount>;
  /** Total charge, combing product cost, shipping cost and tax */
  totalChargeValue?: Maybe<MoneyAmount>;
  /** Total charge, combing product cost, shipping cost and tax, for display */
  totalChargeValueDisplay?: Maybe<Scalars['String']['output']>;
  /** Total charge, combing product cost, shipping cost and tax, in cents */
  totalChargeValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Total charge, combing product cost, shipping cost and tax in user's currency */
  totalChargeValueLocal?: Maybe<MoneyAmount>;
  /** Total sales tax */
  totalSalesTax?: Maybe<Scalars['Float']['output']>;
  /** Total sales tax for display */
  totalSalesTaxDisplay?: Maybe<Scalars['String']['output']>;
  /** Total sales tax */
  totalSalesTaxValue?: Maybe<MoneyAmount>;
  /** Information about the available wallet balances and their contributions to the checkout */
  walletAmounts?: Maybe<WalletsAmounts>;
};

/** The checkout break down. This object should contain all the pricing information needed in the checkout box for purchase random spot action */
export type CheckoutPurchaseRandomSpotBreakdown = {
  __typename?: 'CheckoutPurchaseRandomSpotBreakdown';
  /** The total amount without any discounts like promo code, credit applied */
  actualTotalAmount?: Maybe<MoneyAmount>;
  /** The total amount with discounts like promo code, credit applied */
  actualTotalAmountPostDiscount?: Maybe<MoneyAmount>;
  /** The amount due. The amount due is total charge - applied rewards balance */
  amountDue?: Maybe<MoneyAmount>;
  /** The amount of the order purchased using account funds */
  appliedAccountFundsBalanceAsPaymentMethod?: Maybe<MoneyAmount>;
  /** The amount of the order purchased using fancash credit */
  appliedFancashBalanceAsPaymentMethod?: Maybe<MoneyAmount>;
  /**
   * The amount of the order purchased using wallet credit
   * @deprecated Previously used for Employee Rewards related rewards. No longer populated with a value.
   */
  appliedRewardsBalanceAsPaymentMethod?: Maybe<MoneyAmount>;
  /** The discount value */
  discountValue?: Maybe<MoneyAmount>;
  /** The discount value for display */
  discountValueDisplay?: Maybe<Scalars['String']['output']>;
  /** The discount value in cents */
  discountValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Total produce cost */
  productValue?: Maybe<MoneyAmount>;
  /** Total product cost for display */
  productValueDisplay?: Maybe<Scalars['String']['output']>;
  /** Total produce cost in cents */
  productValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Promotional code */
  promoCode?: Maybe<Scalars['String']['output']>;
  /** The quantity of the random slot to be purchased. */
  quantity?: Maybe<Scalars['Int']['output']>;
  /** Shipping cost */
  shippingValue?: Maybe<MoneyAmount>;
  /** Shipping cost for display */
  shippingValueDisplay?: Maybe<Scalars['String']['output']>;
  /** Shipping cost in cents */
  shippingValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The sub total of product cost * quantity */
  subTotalValue?: Maybe<MoneyAmount>;
  /** The sub total of product cost * quantity, for display */
  subTotalValueDisplay?: Maybe<Scalars['String']['output']>;
  /** The sub total of product cost * quantity, in cents */
  subTotalValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The tax line items */
  taxLines: Array<TaxLine>;
  totalAmount?: Maybe<MoneyAmount>;
  /** Total charge, combing product cost, shipping cost and tax */
  totalChargeValue?: Maybe<MoneyAmount>;
  /** Total charge, combing product cost, shipping cost and tax, for display */
  totalChargeValueDisplay?: Maybe<Scalars['String']['output']>;
  /** Total charge, combing product cost, shipping cost and tax, in cents */
  totalChargeValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Total charge, combing product cost, shipping cost and tax in user's currency */
  totalChargeValueLocal?: Maybe<MoneyAmount>;
  /** Total sales tax */
  totalSalesTax?: Maybe<Scalars['Float']['output']>;
  /** Total sales tax for display */
  totalSalesTaxDisplay?: Maybe<Scalars['String']['output']>;
  /** Total sales tax */
  totalSalesTaxValue?: Maybe<MoneyAmount>;
  /** Information about the available wallet balances and their contributions to the checkout */
  walletAmounts?: Maybe<WalletsAmounts>;
};

export type CheckoutRandomSpotBreakdownPayload = {
  __typename?: 'CheckoutRandomSpotBreakdownPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CheckoutPurchaseRandomSpotBreakdown>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The input parameter for querying checkout purchase random slot breakdown */
export type CheckoutRandomSpotQueriesInput = {
  /** The amount of account funds to apply to the checkout by the user, in cents */
  appliedAccountFundsAmount?: InputMaybe<Scalars['Int']['input']>;
  /** It represent applied fancash balance applied at the time of checkout in cents by user */
  appliedFancashAmount?: InputMaybe<Scalars['Int']['input']>;
  /** If true, apply the user's account funds to the purchase */
  applyAccountFunds?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, apply the user's entire fancash balance to the purchase */
  applyFancashBalance?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, apply the user's entire reward balance to the purchase */
  applyRewardsBalance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique ID for this break */
  breakId: Scalars['UUID']['input'];
  /** The promo code to be used for this purchase */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** Quantity of the purchased product */
  quantity: Scalars['Int']['input'];
  /** Unique device identifier (SEON fingerprint) */
  seonIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The shipping address to be used for this purchase */
  shippingAddressId: Scalars['UUID']['input'];
};

export type CheckoutSpotBreakdownPayload = {
  __typename?: 'CheckoutSpotBreakdownPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CheckoutPurchaseFixedSpotBreakdown>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The type of a breakdown */
export enum CheckoutType {
  /** The fancash checkout */
  Fancash = 'FANCASH'
}

export type CodeResult = PromotionCode | RewardCode;

export type CodeStatus = {
  __typename?: 'CodeStatus';
  isRedeemed: Scalars['Boolean']['output'];
};

export enum CodeType {
  /** The code is a promotion code */
  Promotion = 'PROMOTION',
  /** The code is a reward code */
  Reward = 'REWARD'
}

export type CollectAcceptedOrDeclinedOffer = {
  __typename?: 'CollectAcceptedOrDeclinedOffer';
  offersForBuyer?: Maybe<Array<Maybe<CollectOfferData>>>;
  offersForSeller?: Maybe<Array<Maybe<CollectOfferData>>>;
};

export type CollectAccountFunds = {
  __typename?: 'CollectAccountFunds';
  availableForPayout?: Maybe<Money>;
  pendingUnderwriting?: Maybe<Money>;
  total?: Maybe<Money>;
  usableFunds?: Maybe<Money>;
};

export type CollectAccountingMarketplaceAuctionSale = {
  __typename?: 'CollectAccountingMarketplaceAuctionSale';
  /** The name of the auction. */
  auctionName: Scalars['String']['output'];
  /** The unique identifier for the auction sale. */
  id: Scalars['Int']['output'];
  /** Closed item in this auction sale. */
  itemClosed?: Maybe<CollectAccountingMarketplaceAuctionSaleItem>;
  /** Scheduled item for this auction sale. */
  itemScheduled?: Maybe<CollectAccountingMarketplaceAuctionSaleItem>;
  /** Items included in this auction sale. */
  items: CollectAccountingMarketplaceAuctionSaleItem;
  /** Live items in this auction sale. */
  itemsLive?: Maybe<CollectAccountingMarketplaceAuctionSaleItem>;
  /** Net amount for the seller from this auction sale. */
  netAmount: Money;
  /**
   * Date of payout to the seller for this auction sale.
   * @deprecated This field will be removed as the values are invalid
   */
  payoutDate: Scalars['DateTime']['output'];
};

export type CollectAccountingMarketplaceAuctionSaleConnection = {
  __typename?: 'CollectAccountingMarketplaceAuctionSaleConnection';
  edges: Array<CollectAccountingMarketplaceAuctionSaleEdge>;
  pageNumber: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CollectAccountingMarketplaceAuctionSaleEdge = {
  __typename?: 'CollectAccountingMarketplaceAuctionSaleEdge';
  node: CollectAccountingMarketplaceAuctionSale;
};

export type CollectAccountingMarketplaceAuctionSaleItem = {
  __typename?: 'CollectAccountingMarketplaceAuctionSaleItem';
  /** Total number of auction items sold */
  count: Scalars['Int']['output'];
  /** Net amount for the items */
  netAmount: Money;
};

export type CollectAccountingMarketplacePremierSale = {
  __typename?: 'CollectAccountingMarketplacePremierSale';
  /** The unique identifier for the premier sale. */
  id: Scalars['Int']['output'];
  /** The lot number of the premier sale. */
  lotNumber: Scalars['String']['output'];
  /** Date when the premier sale occurred. */
  saleDate: Scalars['DateTime']['output'];
  /** The sale price in cents. */
  salePrice?: Maybe<Scalars['Int']['output']>;
  /** Net amount for the seller from this premier sale. */
  sellerNetAmount: Money;
  /** The current status of the premier sale. */
  status?: Maybe<Scalars['String']['output']>;
  /** The title of the premier sale item. */
  title: Scalars['String']['output'];
};

export type CollectAccountingMarketplacePremierSaleConnection = {
  __typename?: 'CollectAccountingMarketplacePremierSaleConnection';
  edges: Array<CollectAccountingMarketplacePremierSaleEdge>;
  pageNumber: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CollectAccountingMarketplacePremierSaleEdge = {
  __typename?: 'CollectAccountingMarketplacePremierSaleEdge';
  node: CollectAccountingMarketplacePremierSale;
};

export type CollectAccountingMarketplaceRecentTransaction = {
  __typename?: 'CollectAccountingMarketplaceRecentTransaction';
  /** Date of the transaction. */
  date: Scalars['DateTime']['output'];
  /** Description of the transaction. */
  description: Scalars['String']['output'];
  /** The unique identifier for the recent transaction. */
  id: Scalars['String']['output'];
  /** Amount of the transaction. */
  saleAmount: Money;
  /** Date when the sale occurred. */
  saleDate: Scalars['DateTime']['output'];
};

export type CollectAccountingMarketplaceRecentTransactionConnection = {
  __typename?: 'CollectAccountingMarketplaceRecentTransactionConnection';
  edges: Array<CollectAccountingMarketplaceRecentTransactionEdge>;
  pageNumber: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CollectAccountingMarketplaceRecentTransactionEdge = {
  __typename?: 'CollectAccountingMarketplaceRecentTransactionEdge';
  node: CollectAccountingMarketplaceRecentTransaction;
};

export type CollectAccountingMarketplaceSummary = {
  __typename?: 'CollectAccountingMarketplaceSummary';
  /** Total account funds amount */
  accountFundsAmount: Money;
  /** Total available payout amount */
  availablePayoutAmount: Money;
  /** Total amount due */
  dueAmount: Money;
  /** Number of outstanding invoices */
  outstandingInvoicesCount: Scalars['Int']['output'];
  /** Total pending payout amount */
  pendingPayoutAmount: Money;
  updatedAt: Scalars['DateTime']['output'];
};

export type CollectActivityForgetRecentViewPayload = {
  __typename?: 'CollectActivityForgetRecentViewPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectActivityForgetRecentViewResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectActivityForgetRecentViewResponse = {
  __typename?: 'CollectActivityForgetRecentViewResponse';
  record: CollectRecentlyViewedItem;
};

export type CollectActivityTrackViewInput = {
  itemId: Scalars['String']['input'];
  itemType: CollectRecentlyViewedItemType;
};

export type CollectActivityTrackViewPayload = {
  __typename?: 'CollectActivityTrackViewPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectActivityTrackViewResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectActivityTrackViewResponse = {
  __typename?: 'CollectActivityTrackViewResponse';
  record: CollectRecentlyViewedItem;
};

export type CollectAddFixedPriceToSetlistPayload = {
  __typename?: 'CollectAddFixedPriceToSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectAddFixedPriceToSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectAddFixedPriceToSetlistResponse = {
  __typename?: 'CollectAddFixedPriceToSetlistResponse';
  fixedPrice: CollectListing;
};

export type CollectAddItemToSetlistPayload = {
  __typename?: 'CollectAddItemToSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectAddItemToSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectAddItemToSetlistResponse = {
  __typename?: 'CollectAddItemToSetlistResponse';
  item: CollectItem;
};

export type CollectAddPremierToSetlistPayload = {
  __typename?: 'CollectAddPremierToSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectAddPremierToSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectAddPremierToSetlistResponse = {
  __typename?: 'CollectAddPremierToSetlistResponse';
  premier: CollectListing;
};

export type CollectAddProductToSetlistPayload = {
  __typename?: 'CollectAddProductToSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectAddProductToSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectAddProductToSetlistResponse = {
  __typename?: 'CollectAddProductToSetlistResponse';
  product: CollectProduct;
};

export type CollectAddToCollectionPayload = {
  __typename?: 'CollectAddToCollectionPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectAddToCollectionResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectAddToCollectionResponse = {
  __typename?: 'CollectAddToCollectionResponse';
  item: CollectItem;
};

export type CollectAddVariantToSetlistPayload = {
  __typename?: 'CollectAddVariantToSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectAddVariantToSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectAddVariantToSetlistResponse = {
  __typename?: 'CollectAddVariantToSetlistResponse';
  variant: CollectVariant;
};

export type CollectAddVaultItemsToGroupPayload = {
  __typename?: 'CollectAddVaultItemsToGroupPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectVaultItemGroup>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectAddWeeklyToSetlistPayload = {
  __typename?: 'CollectAddWeeklyToSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectAddWeeklyToSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectAddWeeklyToSetlistResponse = {
  __typename?: 'CollectAddWeeklyToSetlistResponse';
  weekly: CollectListing;
};

/** Address representation for Collect application */
export type CollectAddress = {
  __typename?: 'CollectAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type CollectAddressCreateInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CollectAddressCreatePayload = {
  __typename?: 'CollectAddressCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectAddressCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectAddressCreateResponse = {
  __typename?: 'CollectAddressCreateResponse';
  id: Scalars['UUID']['output'];
};

export type CollectAddressValidateInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CollectAddressValidatePayload = {
  __typename?: 'CollectAddressValidatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectAddressValidateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectAddressValidateResponse = {
  __typename?: 'CollectAddressValidateResponse';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export enum CollectAlgoliaSearchIndexName {
  Listing = 'LISTING',
  ListingBestDeals = 'LISTING_BEST_DEALS',
  ListingBestValueDesc = 'LISTING_BEST_VALUE_DESC',
  ListingConfidenceValueGuidePrice = 'LISTING_CONFIDENCE_VALUE_GUIDE_PRICE',
  ListingFeatured = 'LISTING_FEATURED',
  ListingHighestPrice = 'LISTING_HIGHEST_PRICE',
  ListingLowestPrice = 'LISTING_LOWEST_PRICE',
  ListingRecentlyAdded = 'LISTING_RECENTLY_ADDED',
  ListingSoldAsc = 'LISTING_SOLD_ASC',
  ListingSoldDesc = 'LISTING_SOLD_DESC',
  ListingYearAsc = 'LISTING_YEAR_ASC',
  ListingYearDesc = 'LISTING_YEAR_DESC'
}

export type CollectAlgoliaSearchRequest = {
  indexName: CollectAlgoliaSearchIndexName;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type CollectAlgoliaSearchResponse = {
  __typename?: 'CollectAlgoliaSearchResponse';
  hits: Array<CollectAlgoliaSearchResponseHit>;
};

export type CollectAlgoliaSearchResponseHit = {
  __typename?: 'CollectAlgoliaSearchResponseHit';
  listingUuid: Scalars['UUID']['output'];
};

export enum CollectAlgoliaSearchStrategy {
  None = 'NONE',
  StopIfEnoughMatches = 'STOP_IF_ENOUGH_MATCHES'
}

export type CollectAlternatingShippingAddress = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CollectAuction = {
  /** The integer ID of the auction. this only applies to weekly auction */
  auctionIntegerId?: Maybe<Scalars['Int']['output']>;
  collectListingTimer: CollectListingTimer;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /** The integer ID of the auction schedule */
  integerId?: Maybe<Scalars['Int']['output']>;
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payoutDate?: Maybe<Scalars['Date']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: CollectAuctionStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type CollectAuctionAndListingsDelta = {
  __typename?: 'CollectAuctionAndListingsDelta';
  auction: CollectAuction;
  listingsDelta?: Maybe<Array<Maybe<CollectListingDelta>>>;
};

export enum CollectAuctionBidStatusFilter {
  /** Active auctions where user has bids */
  Active = 'ACTIVE',
  /** Ended auctions where user has bids */
  Ended = 'ENDED'
}

export type CollectAuctionConnection = {
  __typename?: 'CollectAuctionConnection';
  edges?: Maybe<Array<Maybe<CollectAuctionEdge>>>;
  pageInfo: PageInfo;
};

export type CollectAuctionEdge = {
  __typename?: 'CollectAuctionEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectAuction>;
};

export type CollectAuctionIdInput = {
  /** Auction ID */
  id: Scalars['UUID']['input'];
  /** Type of the auction (weekly or premier) */
  type: CollectAuctionType;
};

export type CollectAuctionIdListInput = {
  /** Auction ID */
  auctionIds: Array<InputMaybe<Scalars['UUID']['input']>>;
  /** Type of the auction (weekly or premier) */
  type: CollectAuctionType;
};

export enum CollectAuctionStatus {
  Closed = 'CLOSED',
  ExtendedBidding = 'EXTENDED_BIDDING',
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export enum CollectAuctionType {
  Premier = 'PREMIER',
  Weekly = 'WEEKLY'
}

export type CollectAuctionsForBidsPageInput = {
  /** Type of the auction (weekly or premier) */
  auctionType: CollectAuctionType;
  /** Filter auctions by bid status (active or ended) */
  status?: InputMaybe<CollectAuctionBidStatusFilter>;
};

export type CollectAuctionsForSellingPageInput = {
  /** Type of the auction (weekly or premier) */
  auctionType: CollectAuctionType;
  /** Filter auctions by listing status (preview, open, closed, sold, unsold) */
  status?: InputMaybe<CollectListingStatusFilter>;
};

/** The action that was taken to authenticate the user */
export enum CollectAuthenticateAction {
  /** User logged in */
  Login = 'LOGIN',
  /** User refreshed their token */
  Refresh = 'REFRESH',
  /** User was registered */
  Registration = 'REGISTRATION'
}

export type CollectBatchCancelListingsPayload = {
  __typename?: 'CollectBatchCancelListingsPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBatchCancelListingsResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/**
 * Result of a batch cancel is a list of payloads for each listing cancel.
 * Each entry in the payloads list is a Payload object.
 */
export type CollectBatchCancelListingsResponse = {
  __typename?: 'CollectBatchCancelListingsResponse';
  payloads: Array<CollectCancelListingPayload>;
};

export type CollectBatchCreateListingInput = {
  requests?: InputMaybe<Array<InputMaybe<CollectCreateListingInput>>>;
};

export type CollectBatchCreateListingPayload = {
  __typename?: 'CollectBatchCreateListingPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBatchCreateListingResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectBatchCreateListingResponse = {
  __typename?: 'CollectBatchCreateListingResponse';
  failedVaultItems?: Maybe<Array<Maybe<CollectVaultItem>>>;
  listings?: Maybe<Array<Maybe<CollectListing>>>;
};

export type CollectBatchCreateListingsV2Payload = {
  __typename?: 'CollectBatchCreateListingsV2Payload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBatchCreateListingsV2Response>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectBatchCreateListingsV2Response = {
  __typename?: 'CollectBatchCreateListingsV2Response';
  payloads: Array<CollectBatchCreateListingsV2ResponsePayload>;
};

export type CollectBatchCreateListingsV2ResponsePayload = {
  __typename?: 'CollectBatchCreateListingsV2ResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBatchCreateListingsV2ResponseResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** When listing was created, it's listing. When it was not created, it's vault_item */
export type CollectBatchCreateListingsV2ResponseResponse = {
  __typename?: 'CollectBatchCreateListingsV2ResponseResponse';
  listing?: Maybe<CollectListing>;
  vaultItem?: Maybe<CollectVaultItem>;
};

export type CollectBatchMakeOffersPayload = {
  __typename?: 'CollectBatchMakeOffersPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBatchMakeOffersResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectBatchMakeOffersResponse = {
  __typename?: 'CollectBatchMakeOffersResponse';
  payloads: Array<CollectBatchMakeOffersResponsePayload>;
};

export type CollectBatchMakeOffersResponsePayload = {
  __typename?: 'CollectBatchMakeOffersResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBatchMakeOffersResponseResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectBatchMakeOffersResponseResponse = {
  __typename?: 'CollectBatchMakeOffersResponseResponse';
  listing?: Maybe<CollectListing>;
  offer?: Maybe<CollectFixedPriceListingOfferWithHistoryInterface>;
};

/**
 * An update object for a specific listing which is used in batching update.
 * For weekly and premier listings updates all arguments other than `type`,
 * `id` and `marketplace_event_id` are ignored. Fixed price works with all args
 */
export type CollectBatchUpdateListingsInput = {
  allowOffers?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  listingPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  marketplaceEventId?: InputMaybe<Scalars['UUID']['input']>;
  marketplaceEventType?: InputMaybe<CollectMarketplaceEventType>;
  rejectPriceThresholdInCents?: InputMaybe<Scalars['Int']['input']>;
  type: CollectListingType;
};

export type CollectBatchUpdateListingsPayload = {
  __typename?: 'CollectBatchUpdateListingsPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBatchUpdateListingsResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/**
 * Result of a batch update is a list of payloads for each listing update.
 * Each entry in the payloads list is listing-type-specific Payload object.
 */
export type CollectBatchUpdateListingsResponse = {
  __typename?: 'CollectBatchUpdateListingsResponse';
  payloads: Array<CollectBatchUpdateListingsResponseUpdatePayload>;
};

export type CollectBatchUpdateListingsResponseUpdatePayload = CollectUpdateFixedPriceListingPayload | CollectUpdatePremierListingPayload | CollectUpdateWeeklyListingPayload;

/** The bid increment config for valid bids */
export type CollectBidIncrementConfig = {
  __typename?: 'CollectBidIncrementConfig';
  boundary?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type CollectBidPayload = {
  __typename?: 'CollectBidPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBidResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The response of a multi bid. */
export type CollectBidResponse = {
  __typename?: 'CollectBidResponse';
  bidResults?: Maybe<Array<Maybe<CollectBidResult>>>;
  isFirstBid?: Maybe<Scalars['Boolean']['output']>;
};

/** The result of a bid */
export type CollectBidResult = {
  __typename?: 'CollectBidResult';
  bidId?: Maybe<Scalars['UUID']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  isFirstBid: Scalars['Boolean']['output'];
  listing: CollectListing;
};

export enum CollectBidType {
  Outbid = 'OUTBID',
  Winning = 'WINNING'
}

/** It contains the information needed to place a bid on one listing */
export type CollectBigSingle = {
  listingId: Scalars['UUID']['input'];
  maxBid?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectBoAddToCartListingInput = {
  listingId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
};

export type CollectBoBatchUpdateTrackingInformationPayload = {
  __typename?: 'CollectBoBatchUpdateTrackingInformationPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBoBatchUpdateTrackingInformationResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectBoBatchUpdateTrackingInformationResponse = {
  __typename?: 'CollectBoBatchUpdateTrackingInformationResponse';
  results?: Maybe<Array<Maybe<CollectBoTrackingUpdateResult>>>;
};

export type CollectBoCart = {
  __typename?: 'CollectBoCart';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  items: Array<CollectBoCartItem>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CollectBoCartItem = {
  __typename?: 'CollectBoCartItem';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  listing?: Maybe<CollectListing>;
  quantity: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CollectBoCartPayload = {
  __typename?: 'CollectBoCartPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBoCart>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Either the draft order was built, or we failed validation */
export enum CollectBoCheckoutCreateIntentErrorCode {
  /** Why a specific listing could not be added to the create intent */
  QuantityExceedsAvailable = 'QUANTITY_EXCEEDS_AVAILABLE'
}

export type CollectBoCheckoutCreateIntentFailure = {
  __typename?: 'CollectBoCheckoutCreateIntentFailure';
  /**
   * Returned when any listing fails validation – there is no partial success
   * @deprecated Use errors_detailed instead
   */
  errors?: Maybe<Array<Maybe<CollectBoCheckoutCreateIntentListingError>>>;
  /** Detailed error information from TrogonRPCError */
  errorsDetailed: Array<TrogonRpcError>;
};

export type CollectBoCheckoutCreateIntentListingError = {
  __typename?: 'CollectBoCheckoutCreateIntentListingError';
  /** Quantity still in stock */
  availableQuantity: Scalars['Int']['output'];
  code: CollectBoCheckoutCreateIntentErrorCode;
  /** Listing that failed the validation */
  listingId: Scalars['UUID']['output'];
  /** Title of the listing that failed validation */
  listingTitle: Scalars['String']['output'];
  /** Human-readable text to surface in the UI */
  message: Scalars['String']['output'];
  /** Quantity the buyer asked for */
  requestedQuantity: Scalars['Int']['output'];
};

export enum CollectBoCheckoutDraftIntentErrorCode {
  /** Why a specific listing could not be added to the draft order */
  QuantityExceedsAvailable = 'QUANTITY_EXCEEDS_AVAILABLE'
}

export type CollectBoCheckoutDraftIntentFailure = {
  __typename?: 'CollectBoCheckoutDraftIntentFailure';
  /**
   * Returned when any listing fails validation – there is no partial success
   * @deprecated Use errors_detailed instead
   */
  errors?: Maybe<Array<Maybe<CollectBoCheckoutDraftIntentListingError>>>;
  /** Detailed error information from TrogonRPCError */
  errorsDetailed: Array<TrogonRpcError>;
};

export type CollectBoCheckoutDraftIntentListingError = {
  __typename?: 'CollectBoCheckoutDraftIntentListingError';
  /** Quantity still in stock */
  availableQuantity: Scalars['Int']['output'];
  code: CollectBoCheckoutDraftIntentErrorCode;
  /** Listing that failed the validation */
  listingId: Scalars['UUID']['output'];
  /** Title of the listing that failed validation */
  listingTitle: Scalars['String']['output'];
  /** Human-readable text to surface in the UI */
  message: Scalars['String']['output'];
  /** Quantity the buyer asked for */
  requestedQuantity: Scalars['Int']['output'];
};

export type CollectBoCheckoutListingConfirmIntentPayload = {
  __typename?: 'CollectBoCheckoutListingConfirmIntentPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBoCheckoutListingConfirmIntentResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectBoCheckoutListingConfirmIntentResponse = {
  __typename?: 'CollectBoCheckoutListingConfirmIntentResponse';
  order?: Maybe<CollectBoOrder>;
};

export type CollectBoCheckoutListingCreateDraftOrderResponse = {
  __typename?: 'CollectBoCheckoutListingCreateDraftOrderResponse';
  order?: Maybe<CollectBoOrder>;
  shippingOptions?: Maybe<Array<Maybe<CollectBoShippingFeeOptions>>>;
};

export type CollectBoCheckoutListingCreateIntentPayload = {
  __typename?: 'CollectBoCheckoutListingCreateIntentPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBoCheckoutListingCreateIntentResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectBoCheckoutListingCreateIntentResponse = {
  __typename?: 'CollectBoCheckoutListingCreateIntentResponse';
  order?: Maybe<CollectBoOrder>;
};

export type CollectBoCheckoutListingInput = {
  listingId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
};

export type CollectBoCheckoutOneShopInput = {
  /** Means the listings contained in this seller order. */
  listings?: InputMaybe<Array<InputMaybe<CollectBoCheckoutListingInput>>>;
  /** Means the promo codes applied to this order. */
  promoCodesToBeApplied?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The ID of the pre-validated shipping address for this seller order. */
  shipToAddressId?: InputMaybe<Scalars['String']['input']>;
  /** Means the shipping option id applied to this sellerorder. */
  shopConfigShippingFeeId?: InputMaybe<Scalars['String']['input']>;
  /** The shop id of the seller order. */
  shopId: Scalars['UUID']['input'];
};

export type CollectBoCheckoutV2ConfirmIntentPayload = {
  __typename?: 'CollectBoCheckoutV2ConfirmIntentPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectBoCheckoutV2ConfirmIntentResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectBoCheckoutV2ConfirmIntentResponse = {
  __typename?: 'CollectBoCheckoutV2ConfirmIntentResponse';
  /** If the confirm is successful, we generate invoice and client display invoice. */
  invoice?: Maybe<CollectBoInvoice>;
};

export type CollectBoCheckoutV2CreateIntentResponse = {
  __typename?: 'CollectBoCheckoutV2CreateIntentResponse';
  /** Client use this to interact with Stripe. */
  clientSecret?: Maybe<Scalars['String']['output']>;
  invoicePayment?: Maybe<CollectBoInvoicePayment>;
};

export enum CollectBoFulfilmentStatus {
  CollectBoFulfilmentStatusAwaitingFulfilment = 'COLLECT_BO_FULFILMENT_STATUS_AWAITING_FULFILMENT',
  CollectBoFulfilmentStatusFulfilled = 'COLLECT_BO_FULFILMENT_STATUS_FULFILLED',
  CollectBoFulfilmentStatusUnspecified = 'COLLECT_BO_FULFILMENT_STATUS_UNSPECIFIED'
}

export type CollectBoIntentSummary = {
  __typename?: 'CollectBoIntentSummary';
  /** Amount of the payment intent in cents */
  intentAmount?: Maybe<Money>;
  /**
   * Amount of the payment intent in cents
   * @deprecated Use intent_amount instead
   */
  intentAmountInCents?: Maybe<Money>;
  /** Sequential number for the payment intent */
  intentNumber?: Maybe<Scalars['Int']['output']>;
  /** Invoice remaining amount after this intent */
  invoiceRemainingAmountAfter?: Maybe<Money>;
  /** Invoice remaining amount before this intent */
  invoiceRemainingAmountBefore?: Maybe<Money>;
  /** Payment intent ID for tracking payment processing */
  paymentIntentId?: Maybe<Scalars['UUID']['output']>;
};

export type CollectBoInventory = {
  __typename?: 'CollectBoInventory';
  availableQuantity?: Maybe<Scalars['Int']['output']>;
  listingId?: Maybe<Scalars['UUID']['output']>;
};

export type CollectBoInvoice = {
  __typename?: 'CollectBoInvoice';
  billToUserTenantId?: Maybe<Scalars['UUID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditCardProcessingFee?: Maybe<Money>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<Maybe<CollectBoInvoiceDiscount>>>;
  dueAt?: Maybe<Scalars['DateTime']['output']>;
  externalInvoiceId?: Maybe<Scalars['String']['output']>;
  externalInvoiceSource?: Maybe<CollectBoInvoiceSource>;
  feeTotalShipping?: Maybe<Money>;
  feeTotalTax?: Maybe<Money>;
  id?: Maybe<Scalars['String']['output']>;
  /** List of payment intent summaries for this invoice */
  intentsSummaries?: Maybe<Array<Maybe<CollectBoIntentSummary>>>;
  /** User-friendly message about the invoice payment status */
  invoiceMessage?: Maybe<Scalars['String']['output']>;
  lineItems?: Maybe<Array<Maybe<CollectBoInvoiceLineItem>>>;
  orderTotalAmount?: Maybe<Money>;
  /** Original total amount in cents before any modifications */
  originalTotalAmountInCents?: Maybe<Money>;
  overallShippingStatus?: Maybe<CollectBoShippingStatus>;
  paidInFullAt?: Maybe<Scalars['DateTime']['output']>;
  payments?: Maybe<Array<Maybe<CollectBoInvoicePayment>>>;
  reason?: Maybe<Scalars['String']['output']>;
  recentPaymentMethod?: Maybe<CollectBoPaymentMethod>;
  status?: Maybe<CollectBoInvoiceStatus>;
  subTotal?: Maybe<Money>;
  /** Subtotal amount after discounts have been applied */
  subTotalAfterDiscounts?: Maybe<Money>;
  /** Total amount after all fees have been applied */
  totalAfterFees?: Maybe<Money>;
  totalDueDisplay?: Maybe<Money>;
  totalPaidDisplay?: Maybe<Money>;
  totalPaidViaPmInInitialIntent?: Maybe<Money>;
  totalRemainingDisplay?: Maybe<Money>;
  type?: Maybe<CollectBoInvoiceType>;
  wireInfo?: Maybe<CollectInvoiceWireInfo>;
};

export type CollectBoInvoiceDiscount = {
  __typename?: 'CollectBoInvoiceDiscount';
  /** The amount of the discount used. if the type is reward_balance, this will be the amount of the reward balance used. */
  amount?: Maybe<Money>;
  discountType?: Maybe<CollectBoInvoiceDiscountType>;
  invoiceDiscountId?: Maybe<Scalars['String']['output']>;
};

export enum CollectBoInvoiceDiscountType {
  CollectBoInvoiceDiscountTypePromoCode = 'COLLECT_BO_INVOICE_DISCOUNT_TYPE_PROMO_CODE',
  CollectBoInvoiceDiscountTypeRewardBalance = 'COLLECT_BO_INVOICE_DISCOUNT_TYPE_REWARD_BALANCE',
  CollectBoInvoiceDiscountTypeUnspecified = 'COLLECT_BO_INVOICE_DISCOUNT_TYPE_UNSPECIFIED'
}

export type CollectBoInvoiceLineItem = {
  __typename?: 'CollectBoInvoiceLineItem';
  /**
   * The combined price, in the currency's subunit, of all the items in the line item.
   * This includes any line-level discounts.
   */
  finalLinePriceInCents?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  lineItemType?: Maybe<Scalars['String']['output']>;
  listingId?: Maybe<Scalars['String']['output']>;
  listingName?: Maybe<Scalars['String']['output']>;
  /** The total price before any discounts or taxes (i.e. originalPriceInCents * quantity). */
  originalLinePrice?: Maybe<Money>;
  /** The per-item price before any discounts or taxes. */
  originalPrice?: Maybe<Money>;
  quantity?: Maybe<Scalars['Int']['output']>;
  selectedShopConfigShippingFee?: Maybe<CollectBoShippingFeeOptions>;
  sellerOrderId?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<CollectBoShipping>;
  shopId?: Maybe<Scalars['String']['output']>;
  shopName?: Maybe<Scalars['String']['output']>;
  shopSellerId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CollectBoInvoicePayment = {
  __typename?: 'CollectBoInvoicePayment';
  amountPaid?: Maybe<Money>;
  amountToBePaid?: Maybe<Money>;
  /**
   * Credit card fee percentage as a string
   * @deprecated Use processing_fee_percent instead
   */
  creditCardFeePercent?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  errorReason?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Sequential number for the payment intent */
  intentNumber?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['String']['output']>;
  /** Payment intent ID for tracking payment processing */
  paymentIntentId?: Maybe<Scalars['UUID']['output']>;
  paymentMethod?: Maybe<CollectBoPaymentMethod>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Processing fee amount for the payment */
  processingFee?: Maybe<Money>;
  /** Processing fee percentage as a string */
  processingFeePercent?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CollectBoPaymentStatus>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wireInfo?: Maybe<CollectInvoiceWireInfo>;
};

/** Either the create intent was successful, or we failed validation */
export type CollectBoInvoiceResponse = {
  __typename?: 'CollectBoInvoiceResponse';
  invoice?: Maybe<CollectBoInvoice>;
};

export enum CollectBoInvoiceSearchStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Due = 'DUE',
  InvoiceSearchStatusUnspecified = 'INVOICE_SEARCH_STATUS_UNSPECIFIED',
  Overdue = 'OVERDUE',
  Paid = 'PAID'
}

export enum CollectBoInvoiceSource {
  Bo = 'BO',
  Collect = 'COLLECT',
  InvoiceSourceUnspecified = 'INVOICE_SOURCE_UNSPECIFIED'
}

export enum CollectBoInvoiceStatus {
  InvoiceStatusBuyerDefaulted = 'INVOICE_STATUS_BUYER_DEFAULTED',
  InvoiceStatusCanceled = 'INVOICE_STATUS_CANCELED',
  InvoiceStatusFailed = 'INVOICE_STATUS_FAILED',
  InvoiceStatusNotPaid = 'INVOICE_STATUS_NOT_PAID',
  InvoiceStatusPaidInFull = 'INVOICE_STATUS_PAID_IN_FULL',
  InvoiceStatusPaidInPartial = 'INVOICE_STATUS_PAID_IN_PARTIAL',
  InvoiceStatusPendingPayment = 'INVOICE_STATUS_PENDING_PAYMENT',
  InvoiceStatusUnspecified = 'INVOICE_STATUS_UNSPECIFIED'
}

export type CollectBoInvoiceSummary = {
  __typename?: 'CollectBoInvoiceSummary';
  overdueInvoiceCount?: Maybe<Scalars['Int']['output']>;
  pendingInvoiceCount?: Maybe<Scalars['Int']['output']>;
};

export enum CollectBoInvoiceType {
  BuyNowPurchase = 'BUY_NOW_PURCHASE',
  CollectAuctionSale = 'COLLECT_AUCTION_SALE',
  CollectCapitalNote = 'COLLECT_CAPITAL_NOTE',
  CollectCashAdvance = 'COLLECT_CASH_ADVANCE',
  CollectDeferredCheckoutFees = 'COLLECT_DEFERRED_CHECKOUT_FEES',
  CollectDeferredVaultFees = 'COLLECT_DEFERRED_VAULT_FEES',
  CollectExtendedSale = 'COLLECT_EXTENDED_SALE',
  CollectGradingFees = 'COLLECT_GRADING_FEES',
  CollectInboundShippingLabel = 'COLLECT_INBOUND_SHIPPING_LABEL',
  CollectManual = 'COLLECT_MANUAL',
  CollectVaultFees = 'COLLECT_VAULT_FEES',
  CollectVaultItemFulfill = 'COLLECT_VAULT_ITEM_FULFILL',
  CollectVaultItemGrade = 'COLLECT_VAULT_ITEM_GRADE',
  CollectVaultItemMemberCheckout = 'COLLECT_VAULT_ITEM_MEMBER_CHECKOUT',
  CollectVaultItemMemberTransfer = 'COLLECT_VAULT_ITEM_MEMBER_TRANSFER',
  CollectVaultItemPickUpInPerson = 'COLLECT_VAULT_ITEM_PICK_UP_IN_PERSON',
  CollectVaultItemSendAuction = 'COLLECT_VAULT_ITEM_SEND_AUCTION',
  CollectVaultItemTradeShowCheckout = 'COLLECT_VAULT_ITEM_TRADE_SHOW_CHECKOUT',
  CollectVaultPortfolioLoan = 'COLLECT_VAULT_PORTFOLIO_LOAN',
  CollectVaultPortfolioLoanInterest = 'COLLECT_VAULT_PORTFOLIO_LOAN_INTEREST',
  CollectVaultSale = 'COLLECT_VAULT_SALE',
  InvoiceTypeUnspecified = 'INVOICE_TYPE_UNSPECIFIED',
  OfferPurchase = 'OFFER_PURCHASE'
}

/** Represents the relative pricing tier of a listing compared to the guide price */
export enum CollectBoListingDealTier {
  /** Fair deal */
  Fair = 'FAIR',
  /** Good deal */
  Good = 'GOOD',
  /** Great deal */
  Great = 'GREAT',
  /** Poor deal */
  Poor = 'POOR'
}

export enum CollectBoListingFilterStatus {
  ListingFilterStatusActive = 'LISTING_FILTER_STATUS_ACTIVE',
  ListingFilterStatusDelisted = 'LISTING_FILTER_STATUS_DELISTED',
  ListingFilterStatusSold = 'LISTING_FILTER_STATUS_SOLD',
  ListingFilterStatusSoldOut = 'LISTING_FILTER_STATUS_SOLD_OUT',
  ListingFilterStatusUnspecified = 'LISTING_FILTER_STATUS_UNSPECIFIED'
}

/** The guide price of a listing */
export type CollectBoListingGuidePrice = {
  __typename?: 'CollectBoListingGuidePrice';
  /** The amount of the guide price */
  amount: Money;
  /** The date when the guide price was last updated */
  updatedAt: Scalars['DateTime']['output'];
};

export type CollectBoListingsAvailableInventoryResponse = {
  __typename?: 'CollectBoListingsAvailableInventoryResponse';
  listings?: Maybe<Array<Maybe<CollectBoInventory>>>;
};

export type CollectBoListingsForSellingPageResponse = {
  __typename?: 'CollectBoListingsForSellingPageResponse';
  listings?: Maybe<Array<Maybe<CollectListing>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export enum CollectBoListingsForSellingPageSortDirection {
  /** Ascending */
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  /** Descending */
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  SortDirectionUnspecified = 'SORT_DIRECTION_UNSPECIFIED'
}

export enum CollectBoListingsForSellingPageSortField {
  /** The asking price of the listing */
  SortFieldAskingPrice = 'SORT_FIELD_ASKING_PRICE',
  /** When the listing was listed */
  SortFieldListedAt = 'SORT_FIELD_LISTED_AT',
  /** The product year of the listing */
  SortFieldProductYear = 'SORT_FIELD_PRODUCT_YEAR',
  /** When the listing was sold */
  SortFieldSaleDate = 'SORT_FIELD_SALE_DATE',
  /** The sale price of the listing */
  SortFieldSalePrice = 'SORT_FIELD_SALE_PRICE',
  SortFieldUnspecified = 'SORT_FIELD_UNSPECIFIED'
}

export type CollectBoMainOrder = {
  __typename?: 'CollectBoMainOrder';
  allowedPaymentMethods?: Maybe<Array<Maybe<CollectValidPaymentMethod>>>;
  buyerFanId?: Maybe<Scalars['String']['output']>;
  /** Means the total amount of money applied to this main order that comes from the wallet */
  chargeRemaining?: Maybe<Money>;
  /** This is the total order amount that customer needs to pay. */
  chargeTotal?: Maybe<Money>;
  /** Means the total amount of money applied to this main order that comes from the account funds */
  chargeUsedWithAccountFunds?: Maybe<Money>;
  /** Means the total amount of money applied to this main order that comes from the crypto */
  chargeUsedWithCrypto?: Maybe<Money>;
  /** Means the total amount of money applied to this main order that comes from the fancash */
  chargeUsedWithFancash?: Maybe<Money>;
  /** Means the total amount of money applied to this main order that comes from the reward balance */
  chargeUsedWithRewardBalance?: Maybe<Money>;
  /** Means the total amount of money applied to this main order that comes from the wallet */
  chargeUsedWithWallet?: Maybe<Money>;
  clientPlatform?: Maybe<Scalars['String']['output']>;
  /** The credit card processing fee display */
  creditCardProcessingFeeDisplay?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  disallowedPaymentMethods?: Maybe<Array<Maybe<CollectBoPaymentMethod>>>;
  /**
   * When displaying on the checkout page, this field means the total credit card processing fee. Client simply needs to take this value
   *     and dispaly, no additional calculation is needed.
   */
  feeTotalCreditCardProcessing?: Maybe<Money>;
  /** When displaying on the checkout page, this field means the total tax of the products */
  feeTotalProductSalesTax?: Maybe<Money>;
  /**
   * When displaying on the checkout page, this field means the total shipping cost among all the seller orders.
   *     each seller order may ship to a different address and thus have a different shipping cost.
   */
  feeTotalShipping?: Maybe<Money>;
  /** When displaying on the checkout page, this field means the total tax of the product and shipping */
  feeTotalTax?: Maybe<Money>;
  /** When displaying on the checkout page, this field means the total tax of the shipping */
  feeTotalTaxShipping?: Maybe<Money>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** List of payment intent summaries for this main order */
  intentsSummaries?: Maybe<Array<Maybe<CollectBoIntentSummary>>>;
  mainOrderId?: Maybe<Scalars['String']['output']>;
  manualOrderCreatedByUserId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  orderType?: Maybe<CollectBoOrderType>;
  /** Original total amount in cents before any modifications */
  originalTotalAmountInCents?: Maybe<Money>;
  payments?: Maybe<Array<Maybe<CollectBoInvoicePayment>>>;
  sellerOrders?: Maybe<Array<Maybe<CollectBoSellerorder>>>;
  /** Subtotal amount after discounts have been applied */
  subTotalAfterDiscounts?: Maybe<Money>;
  /** When displaying on the checkout page, this field means the total sale price of the products */
  subTotalProduct?: Maybe<Money>;
  /** The subtotal amount of the order, which is subtotal of all seller orders - reward */
  subtotalWithRewardsAppliedDisplay?: Maybe<Money>;
  /** Total amount after all fees have been applied */
  totalAfterFees?: Maybe<Money>;
  /** The total amount of the order, which is subtotal + tax + shipping - reward */
  totalDisplay?: Maybe<Money>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CollectBoMySellingListing = {
  __typename?: 'CollectBoMySellingListing';
  currency?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<CollectListing>;
  sellerNet?: Maybe<Money>;
  soldPriceMax?: Maybe<Money>;
  soldPriceMin?: Maybe<Money>;
  soldQuantity?: Maybe<Scalars['Int']['output']>;
};

export type CollectBoMySellingListingsResponse = {
  __typename?: 'CollectBoMySellingListingsResponse';
  listings?: Maybe<Array<Maybe<CollectBoMySellingListing>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export enum CollectBoMySellingListingsSortDirection {
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  SortDirectionUnspecified = 'SORT_DIRECTION_UNSPECIFIED'
}

export enum CollectBoMySellingListingsSortField {
  /** Date listed */
  SortFieldCreatedAt = 'SORT_FIELD_CREATED_AT',
  /** Listing price */
  SortFieldListingPrice = 'SORT_FIELD_LISTING_PRICE',
  /** Product year */
  SortFieldProductYear = 'SORT_FIELD_PRODUCT_YEAR',
  SortFieldUnspecified = 'SORT_FIELD_UNSPECIFIED'
}

export type CollectBoOrder = {
  __typename?: 'CollectBoOrder';
  buyerFanId?: Maybe<Scalars['String']['output']>;
  chargeRemainingInCents?: Maybe<Scalars['Int']['output']>;
  chargeTotal?: Maybe<Scalars['Int']['output']>;
  clientPlatform?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  feePlatformTakeInCents?: Maybe<Scalars['Int']['output']>;
  feeTotalCreditCardProcessingInCents?: Maybe<Scalars['Int']['output']>;
  feeTotalProductSalesTaxInCents?: Maybe<Scalars['Int']['output']>;
  feeTotalShippingInCents?: Maybe<Scalars['Int']['output']>;
  feeTotalTaxInCents?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  orderItems?: Maybe<Array<Maybe<CollectBoOrderItem>>>;
  orderPayments?: Maybe<Array<Maybe<CollectBoOrderPayment>>>;
  orderType?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<CollectBoOrderStatus>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  shopConfigShippingFee?: Maybe<CollectBoShippingFeeOptions>;
  shopId?: Maybe<Scalars['String']['output']>;
  subTotalProductInCents?: Maybe<Scalars['Int']['output']>;
  taxId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CollectBoOrderItem = {
  __typename?: 'CollectBoOrderItem';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  feeShippingInCents?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  listing?: Maybe<CollectListing>;
  listingId?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  productValueInCents?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  referenceCode?: Maybe<Scalars['String']['output']>;
  shipToAddress?: Maybe<CollectShippingAddress>;
  taxCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CollectBoOrderPayment = {
  __typename?: 'CollectBoOrderPayment';
  clientPlatform?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['String']['output']>;
  paymentAmountInCents?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<CollectBoPaymentStatus>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum CollectBoOrderStatus {
  CollectBoOrderStatusNoPaymentRequired = 'COLLECT_BO_ORDER_STATUS_NO_PAYMENT_REQUIRED',
  CollectBoOrderStatusPaymentFailed = 'COLLECT_BO_ORDER_STATUS_PAYMENT_FAILED',
  CollectBoOrderStatusPaymentSucceededFull = 'COLLECT_BO_ORDER_STATUS_PAYMENT_SUCCEEDED_FULL',
  CollectBoOrderStatusPaymentSucceededPartial = 'COLLECT_BO_ORDER_STATUS_PAYMENT_SUCCEEDED_PARTIAL',
  CollectBoOrderStatusPending = 'COLLECT_BO_ORDER_STATUS_PENDING',
  CollectBoOrderStatusRefundedFull = 'COLLECT_BO_ORDER_STATUS_REFUNDED_FULL',
  CollectBoOrderStatusUnspecified = 'COLLECT_BO_ORDER_STATUS_UNSPECIFIED'
}

export enum CollectBoOrderType {
  OrderTypeManual = 'ORDER_TYPE_MANUAL',
  OrderTypePurchase = 'ORDER_TYPE_PURCHASE',
  OrderTypeUnknown = 'ORDER_TYPE_UNKNOWN'
}

export type CollectBoOrdersBySellerResponse = {
  __typename?: 'CollectBoOrdersBySellerResponse';
  pageNumber?: Maybe<Scalars['Int']['output']>;
  soldRecords?: Maybe<Array<Maybe<CollectBoSellerSoldRecord>>>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export enum CollectBoOrdersSortDirection {
  SortDirectionAsc = 'SORT_DIRECTION_ASC',
  SortDirectionDesc = 'SORT_DIRECTION_DESC',
  SortDirectionUnspecified = 'SORT_DIRECTION_UNSPECIFIED'
}

export enum CollectBoOrdersSortField {
  /** Listing price */
  SortFieldListingPrice = 'SORT_FIELD_LISTING_PRICE',
  /** Product year */
  SortFieldProductYear = 'SORT_FIELD_PRODUCT_YEAR',
  /** Date sold */
  SortFieldSoldAt = 'SORT_FIELD_SOLD_AT',
  SortFieldUnspecified = 'SORT_FIELD_UNSPECIFIED',
  /** Date updated */
  SortFieldUpdatedAt = 'SORT_FIELD_UPDATED_AT'
}

export enum CollectBoPaymentMethod {
  AccountFunds = 'ACCOUNT_FUNDS',
  AccountFundsManual = 'ACCOUNT_FUNDS_MANUAL',
  AchTransfer = 'ACH_TRANSFER',
  AchTransferManual = 'ACH_TRANSFER_MANUAL',
  ApplePay = 'APPLE_PAY',
  Check = 'CHECK',
  Consignment = 'CONSIGNMENT',
  CreditCard = 'CREDIT_CARD',
  CreditCardManual = 'CREDIT_CARD_MANUAL',
  Crypto = 'CRYPTO',
  CryptoManual = 'CRYPTO_MANUAL',
  Ebay = 'EBAY',
  Fancash = 'FANCASH',
  GooglePay = 'GOOGLE_PAY',
  IntercompanyPayment = 'INTERCOMPANY_PAYMENT',
  InvoiceRecentPaymentMethodUnspecified = 'INVOICE_RECENT_PAYMENT_METHOD_UNSPECIFIED',
  MoneyOrder = 'MONEY_ORDER',
  PaidByFanaticsCollect = 'PAID_BY_FANATICS_COLLECT',
  PaidByPwcc = 'PAID_BY_PWCC',
  Paypal = 'PAYPAL',
  PaypalManual = 'PAYPAL_MANUAL',
  RewardBalance = 'REWARD_BALANCE',
  Wallet = 'WALLET',
  WireTransfer = 'WIRE_TRANSFER'
}

export enum CollectBoPaymentStatus {
  CollectBoPaymentStatusCancelled = 'COLLECT_BO_PAYMENT_STATUS_CANCELLED',
  CollectBoPaymentStatusFailed = 'COLLECT_BO_PAYMENT_STATUS_FAILED',
  CollectBoPaymentStatusPending = 'COLLECT_BO_PAYMENT_STATUS_PENDING',
  CollectBoPaymentStatusPendingConfirmation = 'COLLECT_BO_PAYMENT_STATUS_PENDING_CONFIRMATION',
  CollectBoPaymentStatusProcessing = 'COLLECT_BO_PAYMENT_STATUS_PROCESSING',
  CollectBoPaymentStatusSucceeded = 'COLLECT_BO_PAYMENT_STATUS_SUCCEEDED',
  CollectBoPaymentStatusUnspecified = 'COLLECT_BO_PAYMENT_STATUS_UNSPECIFIED'
}

export type CollectBoSearchInvoicesResponse = {
  __typename?: 'CollectBoSearchInvoicesResponse';
  invoices?: Maybe<Array<Maybe<CollectBoInvoice>>>;
  nextPageCursor?: Maybe<Scalars['String']['output']>;
  pageNumber?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export enum CollectBoSearchInvoicesSortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
  /** @deprecated Use ASC instead */
  SortDirectionAscV2 = 'SORT_DIRECTION_ASC_V2',
  /** @deprecated Use DESC instead */
  SortDirectionDescV2 = 'SORT_DIRECTION_DESC_V2',
  SortDirectionUnspecified = 'SORT_DIRECTION_UNSPECIFIED',
  /** @deprecated Use SORT_DIRECTION_UNSPECIFIED instead */
  SortDirectionUnspecifiedV2 = 'SORT_DIRECTION_UNSPECIFIED_V2'
}

export enum CollectBoSearchInvoicesSortField {
  DueAt = 'DUE_AT',
  Id = 'ID',
  InsertedAt = 'INSERTED_AT',
  OrderTotalAmountInCents = 'ORDER_TOTAL_AMOUNT_IN_CENTS',
  PaidInFullAt = 'PAID_IN_FULL_AT',
  /** @deprecated Use DUE_AT instead */
  SortFieldDueAtV2 = 'SORT_FIELD_DUE_AT_V2',
  /** @deprecated Use ID instead */
  SortFieldIdV2 = 'SORT_FIELD_ID_V2',
  /** @deprecated Use INSERTED_AT instead */
  SortFieldInsertedAtV2 = 'SORT_FIELD_INSERTED_AT_V2',
  /** @deprecated Use ORDER_TOTAL_AMOUNT_IN_CENTS instead */
  SortFieldOrderTotalAmountInCentsV2 = 'SORT_FIELD_ORDER_TOTAL_AMOUNT_IN_CENTS_V2',
  /** @deprecated Use PAID_IN_FULL_AT instead */
  SortFieldPaidInFullAtV2 = 'SORT_FIELD_PAID_IN_FULL_AT_V2',
  SortFieldUnspecified = 'SORT_FIELD_UNSPECIFIED',
  /** @deprecated Use SORT_FIELD_UNSPECIFIED instead */
  SortFieldUnspecifiedV2 = 'SORT_FIELD_UNSPECIFIED_V2'
}

export enum CollectBoSellType {
  SellTypeAuction = 'SELL_TYPE_AUCTION',
  SellTypeBuyNow = 'SELL_TYPE_BUY_NOW',
  SellTypeUnspecified = 'SELL_TYPE_UNSPECIFIED'
}

export type CollectBoSellerOrderItem = {
  __typename?: 'CollectBoSellerOrderItem';
  imageSets?: Maybe<Array<Maybe<CollectImageSet>>>;
  listing?: Maybe<CollectListing>;
  listingId?: Maybe<Scalars['String']['output']>;
  listingTitle?: Maybe<Scalars['String']['output']>;
  productValue?: Maybe<Money>;
  quantity?: Maybe<Scalars['Int']['output']>;
  sellerOrderItemId?: Maybe<Scalars['String']['output']>;
};

/** The status of a seller payout */
export enum CollectBoSellerPayoutStatus {
  /** The payout has been paid out */
  PayoutStatusPaidOut = 'PAYOUT_STATUS_PAID_OUT',
  /** The payout has failed */
  PayoutStatusPayoutFailed = 'PAYOUT_STATUS_PAYOUT_FAILED',
  /** The payout is pending */
  PayoutStatusPending = 'PAYOUT_STATUS_PENDING'
}

export type CollectBoSellerSoldRecord = {
  __typename?: 'CollectBoSellerSoldRecord';
  allowOffers?: Maybe<Scalars['Boolean']['output']>;
  askingPrice?: Maybe<Money>;
  cardLadderValue?: Maybe<Money>;
  categoryNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code?: Maybe<Scalars['String']['output']>;
  dealTier?: Maybe<CollectBoListingDealTier>;
  folders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  imageSets?: Maybe<Array<Maybe<CollectImageSet>>>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  invoiceLineItemId?: Maybe<Scalars['String']['output']>;
  invoiceStatus?: Maybe<CollectBoInvoiceStatus>;
  listingId?: Maybe<Scalars['String']['output']>;
  payoutStatus?: Maybe<CollectBoSellerPayoutStatus>;
  pendingOfferMessage?: Maybe<Scalars['String']['output']>;
  safeMarketValue?: Maybe<Money>;
  sellerFeeBasisPoints?: Maybe<Scalars['Int']['output']>;
  sellerFeeBasisPointsDisplay?: Maybe<Scalars['String']['output']>;
  sellerNetValueInCents?: Maybe<Scalars['Int']['output']>;
  sellerOrderItemId?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<CollectBoShipping>;
  soldAt?: Maybe<Scalars['DateTime']['output']>;
  soldPriceBuyNowValueInCents?: Maybe<Scalars['Int']['output']>;
  soldPriceOfferAcceptValueInCents?: Maybe<Scalars['Int']['output']>;
  soldQuantity?: Maybe<Scalars['Int']['output']>;
  variantTitle?: Maybe<Scalars['String']['output']>;
};

/** A seller order is a collection of seller order items, that belong to the same shop. */
export type CollectBoSellerorder = {
  __typename?: 'CollectBoSellerorder';
  /** The allowed shipping options */
  allowedShippingOptions?: Maybe<Array<Maybe<CollectBoShippingFeeOptions>>>;
  orderItems?: Maybe<Array<Maybe<CollectBoSellerOrderItem>>>;
  sellerOrderId?: Maybe<Scalars['String']['output']>;
  /** The shipping information of this seller order */
  shipping?: Maybe<CollectBoShipping>;
  /** The selected shipping fee operation configuration */
  shopConfigShippingFee?: Maybe<CollectBoShippingFeeOptions>;
  /** The shop id */
  shopId?: Maybe<Scalars['String']['output']>;
  /** The shop name */
  shopName?: Maybe<Scalars['String']['output']>;
  /** The total charge amount */
  subTotalProduct?: Maybe<Money>;
};

export type CollectBoShipping = {
  __typename?: 'CollectBoShipping';
  shipFromAddress?: Maybe<CollectShippingAddress>;
  shipToAddress?: Maybe<CollectShippingAddress>;
  shippingId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CollectBoShippingStatus>;
  /** Structured tracking details */
  trackingDetails?: Maybe<CollectBoTrackingInfo>;
};

export type CollectBoShippingAddressInput = {};

export type CollectBoShippingFeeOptions = {
  __typename?: 'CollectBoShippingFeeOptions';
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is deprecated and will be removed in a future version. */
  isUsDomestic?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this shipping option is for shipping from the Fanatics Collect vault.
   *
   * This is always false for any shop that is not Fanatics Collect.
   */
  isVaultShipping?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this shipping option is vault-to-vault shipping in the Fanatics Collect vault.
   *
   * This is always false for any shop that is not Fanatics Collect.
   */
  isVaultToVaultShipping?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shippingFee?: Maybe<Money>;
};

export enum CollectBoShippingStatus {
  CollectBoShippingStatusAwaitingReturn = 'COLLECT_BO_SHIPPING_STATUS_AWAITING_RETURN',
  CollectBoShippingStatusAwaitingReview = 'COLLECT_BO_SHIPPING_STATUS_AWAITING_REVIEW',
  CollectBoShippingStatusCancelled = 'COLLECT_BO_SHIPPING_STATUS_CANCELLED',
  CollectBoShippingStatusComplete = 'COLLECT_BO_SHIPPING_STATUS_COMPLETE',
  CollectBoShippingStatusOpen = 'COLLECT_BO_SHIPPING_STATUS_OPEN',
  CollectBoShippingStatusReadyToProcess = 'COLLECT_BO_SHIPPING_STATUS_READY_TO_PROCESS',
  CollectBoShippingStatusReadyToShip = 'COLLECT_BO_SHIPPING_STATUS_READY_TO_SHIP',
  CollectBoShippingStatusShipped = 'COLLECT_BO_SHIPPING_STATUS_SHIPPED',
  CollectBoShippingStatusUnspecified = 'COLLECT_BO_SHIPPING_STATUS_UNSPECIFIED'
}

export type CollectBoTrackingEvent = {
  __typename?: 'CollectBoTrackingEvent';
  description?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

/** Structured tracking information for back office orders */
export type CollectBoTrackingInfo = {
  __typename?: 'CollectBoTrackingInfo';
  /** Computed field for carrier service compatibility with vault item requests */
  carrier?: Maybe<CollectShippingService>;
  carrierCode?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  estimatedDelivery?: Maybe<Scalars['DateTime']['output']>;
  events?: Maybe<Array<Maybe<CollectBoTrackingEvent>>>;
  serviceLevel?: Maybe<Scalars['String']['output']>;
  shippedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<CollectBoTrackingStatus>;
  trackingNumber: Scalars['String']['output'];
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export enum CollectBoTrackingStatus {
  Delivered = 'DELIVERED',
  Exception = 'EXCEPTION',
  InTransit = 'IN_TRANSIT',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Pending = 'PENDING',
  PickedUp = 'PICKED_UP',
  Returned = 'RETURNED',
  Unspecified = 'UNSPECIFIED'
}

export type CollectBoTrackingUpdateInput = {
  shippingId: Scalars['String']['input'];
  trackingNumber: Scalars['String']['input'];
};

export type CollectBoTrackingUpdateResult = {
  __typename?: 'CollectBoTrackingUpdateResult';
  errorMessage?: Maybe<Scalars['String']['output']>;
  shipping?: Maybe<CollectBoShipping>;
  success: Scalars['Boolean']['output'];
};

export type CollectBoUpdateCartListingInput = {
  listingId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
};

export type CollectBoV2CheckoutCreateIntentResult = CollectBoCheckoutCreateIntentFailure | CollectBoCheckoutV2CreateIntentResponse;

export type CollectBoV2CheckoutDraftIntentResponse = {
  __typename?: 'CollectBoV2CheckoutDraftIntentResponse';
  mainOrder?: Maybe<CollectBoMainOrder>;
};

export type CollectBoV2CheckoutDraftIntentResult = CollectBoCheckoutDraftIntentFailure | CollectBoV2CheckoutDraftIntentResponse;

export type CollectCalendarEvent = {
  __typename?: 'CollectCalendarEvent';
  endsAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  marketplace: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startsAt: Scalars['DateTime']['output'];
  status: CollectCalendarEventStatus;
};

export enum CollectCalendarEventStatus {
  Closed = 'CLOSED',
  ComingSoon = 'COMING_SOON',
  Extended = 'EXTENDED',
  Open = 'OPEN',
  Preview = 'PREVIEW'
}

export type CollectCancelInvoicePaymentAttemptPayload = {
  __typename?: 'CollectCancelInvoicePaymentAttemptPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCancelListingPayload = {
  __typename?: 'CollectCancelListingPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCancelListingResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCancelListingResponse = {
  __typename?: 'CollectCancelListingResponse';
  listing?: Maybe<CollectListing>;
};

export type CollectCancelVaultItemRequestPayload = {
  __typename?: 'CollectCancelVaultItemRequestPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCancelVaultItemRequestResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCancelVaultItemRequestResponse = {
  __typename?: 'CollectCancelVaultItemRequestResponse';
  vaultItemRequest?: Maybe<CollectVaultItemRequest>;
};

export type CollectCancelVaultRetrievalPayload = {
  __typename?: 'CollectCancelVaultRetrievalPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCancelVaultRetrievalResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCancelVaultRetrievalResponse = {
  __typename?: 'CollectCancelVaultRetrievalResponse';
  vaultItemRequest?: Maybe<CollectVaultItemRequest>;
};

export type CollectCancelVaultSubmissionPayload = {
  __typename?: 'CollectCancelVaultSubmissionPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCancelVaultSubmissionResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCancelVaultSubmissionResponse = {
  __typename?: 'CollectCancelVaultSubmissionResponse';
  submission?: Maybe<CollectVaultSubmission>;
};

export type CollectCardGrade = {
  __typename?: 'CollectCardGrade';
  grade?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
};

/** The users cart */
export type CollectCart = {
  __typename?: 'CollectCart';
  /** The list of available for purchase listings */
  availableListings?: Maybe<CollectCartListingConnection>;
  id: Scalars['UUID']['output'];
  status: CollectCartStatus;
  /** The list of unavailable for purchase listings */
  unavailableListings?: Maybe<CollectCartListingConnection>;
};


/** The users cart */
export type CollectCartAvailableListingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** The users cart */
export type CollectCartUnavailableListingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectCartListingConnection = {
  __typename?: 'CollectCartListingConnection';
  edges?: Maybe<Array<Maybe<CollectCartListingEdge>>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
  totalAmount: Money;
};

export type CollectCartListingEdge = {
  __typename?: 'CollectCartListingEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectListing>;
};

export type CollectCartPayload = {
  __typename?: 'CollectCartPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCartResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCartResponse = {
  __typename?: 'CollectCartResponse';
  /** The Cart object */
  cart?: Maybe<CollectCart>;
};

export enum CollectCartStatus {
  Abandoned = 'ABANDONED',
  Active = 'ACTIVE',
  Complete = 'COMPLETE',
  Locked = 'LOCKED'
}

export type CollectCatalogSearchResult = {
  __typename?: 'CollectCatalogSearchResult';
  result?: Maybe<CollectItemOrProductOrListingOrVariantConnection>;
};


export type CollectCatalogSearchResultResultArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectCategory = {
  __typename?: 'CollectCategory';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CollectCategoryHierarchy = {
  __typename?: 'CollectCategoryHierarchy';
  categories?: Maybe<Array<Maybe<CollectCategory>>>;
  categoryType: Scalars['String']['output'];
};

export enum CollectCategoryType {
  CoinsCurrency = 'COINS_CURRENCY',
  Comics = 'COMICS',
  Other = 'OTHER',
  SportCards = 'SPORT_CARDS',
  TradingCardGames = 'TRADING_CARD_GAMES',
  VideoGames = 'VIDEO_GAMES',
  Wax = 'WAX'
}

export type CollectChannelOffer = {
  __typename?: 'CollectChannelOffer';
  channelCid?: Maybe<Scalars['String']['output']>;
  channelId?: Maybe<Scalars['String']['output']>;
  latestOffer?: Maybe<CollectOfferMessage>;
};

export type CollectChannelOffers = {
  __typename?: 'CollectChannelOffers';
  channelId?: Maybe<Scalars['String']['output']>;
  latestOfferId?: Maybe<Scalars['UUID']['output']>;
  listingId?: Maybe<Scalars['UUID']['output']>;
  listingTitle?: Maybe<Scalars['String']['output']>;
};

/**
 * Result type containing the ChatGPT-recognized card details.
 * Represents structured data extracted from card images using AI analysis.
 * Each field corresponds to specific attributes of the recognized card.
 */
export type CollectChatgptMatchResult = {
  __typename?: 'CollectChatgptMatchResult';
  brand?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  issue?: Maybe<Scalars['String']['output']>;
  parallel?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/**
 * Result type containing the combined results from ChatGPT operations.
 * This object encapsulates the outcomes of the card analysis, including match details, descriptions, and chat responses.
 */
export type CollectChatgptOperationsResult = {
  __typename?: 'CollectChatgptOperationsResult';
  /** Chat-related response based on user prompt. */
  chat?: Maybe<Scalars['String']['output']>;
  /** Description generated from card analysis. */
  describe?: Maybe<Scalars['String']['output']>;
  /** Match details from card recognition. */
  match?: Maybe<Array<Maybe<CollectChatgptMatchResult>>>;
};

export type CollectCheckoutCancelWalletPendingPaymentsPayload = {
  __typename?: 'CollectCheckoutCancelWalletPendingPaymentsPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCheckoutCharges = {
  __typename?: 'CollectCheckoutCharges';
  /** Deadline for returning items back to vault */
  deferredFulfillmentDeadline: Scalars['DateTime']['output'];
  /** Potential fee if deadline is missed */
  deferredFulfillmentFee: Money;
  fulfillmentFee: Money;
  insuredValue: Money;
  needsUnderwriting: Scalars['Boolean']['output'];
  shippingFee?: Maybe<Money>;
};

export type CollectCheckoutDetails = {
  __typename?: 'CollectCheckoutDetails';
  accountFundsAvailable: Money;
  accountFundsToUse: Money;
  allowedPaymentMethods?: Maybe<Array<Maybe<CollectValidPaymentMethod>>>;
  amountPaid?: Maybe<Money>;
  amountPaidOutstanding?: Maybe<Money>;
  availableShippingMethods: Array<CollectShippingMethod>;
  availableShippingTypes?: Maybe<Array<Maybe<CollectShippingType>>>;
  balanceDue: Money;
  businessCategory?: Maybe<CollectInvoiceBusinessCategory>;
  creditCardFee: Money;
  creditCardFeePct: Scalars['Float']['output'];
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  errors?: Maybe<Array<Maybe<CollectCheckoutDetailsError>>>;
  invoiceCategory?: Maybe<CollectInvoiceCategory>;
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  lineItems?: Maybe<Array<Maybe<CollectLineItem>>>;
  /** The list of CheckoutDetails Payment Attempts. */
  paymentAttempts?: Maybe<Array<Maybe<CollectPaymentAttempt>>>;
  /** The payment methods fees */
  paymentMethodsFees: Array<Maybe<CollectInvoicePaymentMethodFee>>;
  payments?: Maybe<Array<Maybe<CollectPayment>>>;
  pendingPayments?: Maybe<Array<Maybe<CollectPayment>>>;
  potentialBalanceDueWithCreditCardFee: Money;
  potentialCreditCardFee: Money;
  potentialTotalWithCreditCardFee: Money;
  shipping: Money;
  shippingAddress?: Maybe<CollectShippingAddress>;
  shippingMethod?: Maybe<CollectShippingMethod>;
  shippingType: CollectShippingType;
  status: CollectInvoiceStatus;
  subTotal: Money;
  tax: Money;
  total: Money;
  type: CollectInvoiceType;
  walletAmountsAvailable?: Maybe<CollectCheckoutWalletAmounts>;
  walletAmountsRemaining?: Maybe<CollectCheckoutWalletAmounts>;
  walletAmountsToUse?: Maybe<CollectCheckoutWalletAmounts>;
};

export type CollectCheckoutDetailsError = {
  __typename?: 'CollectCheckoutDetailsError';
  code?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CollectCheckoutDetailsInput = {
  invoice?: InputMaybe<CollectCheckoutDetailsInvoiceInput>;
  listing?: InputMaybe<CollectCheckoutDetailsListingInput>;
};

export type CollectCheckoutDetailsInvoiceInput = {
  alternateShippingAddress?: InputMaybe<CollectAlternatingShippingAddress>;
  invoiceId: Scalars['UUID']['input'];
  /** ShippingMethod UUID, used for external sellers, e.g. Burbank. If missing, the cheapest will be used */
  shippingMethodId?: InputMaybe<Scalars['UUID']['input']>;
  shippingType?: InputMaybe<CollectShippingType>;
  walletUsage?: InputMaybe<CollectCheckoutDetailsWalletUsageInput>;
};

export type CollectCheckoutDetailsListingInput = {
  alternateShippingAddress?: InputMaybe<CollectAlternatingShippingAddress>;
  listingId: Scalars['UUID']['input'];
  listingType: CollectListingType;
  /** ShippingMethod UUID, used for external sellers, e.g. Burbank. If missing, the cheapest will be used */
  shippingMethodId?: InputMaybe<Scalars['UUID']['input']>;
  shippingType?: InputMaybe<CollectShippingType>;
  walletUsage?: InputMaybe<CollectCheckoutDetailsWalletUsageInput>;
};

export type CollectCheckoutDetailsWalletUsageInput = {
  accountFunds?: InputMaybe<Scalars['Boolean']['input']>;
  fancash?: InputMaybe<Scalars['Boolean']['input']>;
  rewards?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectCheckoutInvoiceConfirmInput = {
  alternateShippingAddress?: InputMaybe<CollectAlternatingShippingAddress>;
  fundsAmount?: InputMaybe<Scalars['Int']['input']>;
  invoiceId: Scalars['UUID']['input'];
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  paymentMethod: Array<CollectValidPaymentMethod>;
  /** ShippingMethod UUID, required for external sellers, e.g. Burbank */
  shippingMethodId?: InputMaybe<Scalars['UUID']['input']>;
  shippingType: CollectShippingType;
  walletAmounts?: InputMaybe<CollectCheckoutWalletAmountsInput>;
};

export type CollectCheckoutInvoiceConfirmPayload = {
  __typename?: 'CollectCheckoutInvoiceConfirmPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCheckoutInvoiceConfirmResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCheckoutInvoiceConfirmResponse = {
  __typename?: 'CollectCheckoutInvoiceConfirmResponse';
  invoice: CollectInvoice;
  isFirstPurchase: Scalars['Boolean']['output'];
  results?: Maybe<Array<Maybe<CollectChekcoutInvoiceConfirmSinglePayload>>>;
};

export type CollectCheckoutInvoicePaymentIntentInput = {
  accountFundsAppliedInCents?: InputMaybe<Scalars['Int']['input']>;
  alternateShippingAddress?: InputMaybe<CollectAlternatingShippingAddress>;
  invoiceId: Scalars['UUID']['input'];
  paymentMethod: Array<CollectValidPaymentMethod>;
  /** ShippingMethod UUID, required for external sellers, e.g. Burbank */
  shippingMethodId?: InputMaybe<Scalars['UUID']['input']>;
  shippingType: CollectShippingType;
};

export type CollectCheckoutInvoicePaymentIntentPayload = {
  __typename?: 'CollectCheckoutInvoicePaymentIntentPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCheckoutInvoicePaymentIntentResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCheckoutInvoicePaymentIntentResponse = {
  __typename?: 'CollectCheckoutInvoicePaymentIntentResponse';
  clientSecret?: Maybe<Scalars['String']['output']>;
  ephemeralKey?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
};

export type CollectCheckoutPaymentLockInput = {
  invoice?: InputMaybe<CollectCheckoutPaymentLockInvoiceInput>;
  listing?: InputMaybe<CollectCheckoutPaymentLockListingInput>;
};

export type CollectCheckoutPaymentLockInvoiceInput = {
  alternateShippingAddress?: InputMaybe<CollectAlternatingShippingAddress>;
  invoiceId: Scalars['UUID']['input'];
  paymentMethod: Array<CollectValidPaymentMethod>;
  /** ShippingMethod UUID, used for external sellers, e.g. Burbank. If missing, the cheapest will be used */
  shippingMethodId?: InputMaybe<Scalars['UUID']['input']>;
  shippingType: CollectShippingType;
  walletAmounts?: InputMaybe<CollectCheckoutWalletAmountsInput>;
};

export type CollectCheckoutPaymentLockListingInput = {
  alternateShippingAddress?: InputMaybe<CollectAlternatingShippingAddress>;
  listingId: Scalars['UUID']['input'];
  listingType: CollectListingType;
  paymentMethod: Array<CollectValidPaymentMethod>;
  /** ShippingMethod UUID, used for external sellers, e.g. Burbank. If missing, the cheapest will be used */
  shippingMethodId?: InputMaybe<Scalars['UUID']['input']>;
  shippingType: CollectShippingType;
  walletAmounts?: InputMaybe<CollectCheckoutWalletAmountsInput>;
};

export type CollectCheckoutPaymentLockPayload = {
  __typename?: 'CollectCheckoutPaymentLockPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCheckoutPaymentLockResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCheckoutPaymentLockResponse = {
  __typename?: 'CollectCheckoutPaymentLockResponse';
  clientSecret?: Maybe<Scalars['String']['output']>;
  invoiceId: Scalars['UUID']['output'];
  invoiceIntegerId: Scalars['Int']['output'];
  paymentIntentId?: Maybe<Scalars['String']['output']>;
};

export type CollectCheckoutSetupIntentInput = {
  paymentMethodTypes: Array<CollectInvoicePaymentTypes>;
};

export type CollectCheckoutSetupIntentPayload = {
  __typename?: 'CollectCheckoutSetupIntentPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCheckoutSetupIntentResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCheckoutSetupIntentResponse = {
  __typename?: 'CollectCheckoutSetupIntentResponse';
  ephemeralKey?: Maybe<Scalars['String']['output']>;
  setupIntentClientSecret?: Maybe<Scalars['String']['output']>;
  setupIntentId?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
};

export type CollectCheckoutSummaryConstraintData = {
  __typename?: 'CollectCheckoutSummaryConstraintData';
  /** Potential fraction of the portfolio if request if fulfilled */
  afterCheckoutPct: Scalars['Float']['output'];
  /** Already checked out portfolio share value */
  alreadyCheckedOutValue: Money;
  /** Already checked out portfolio share in fraction */
  beforeCheckoutPct: Scalars['Float']['output'];
  /** Is it allowed to checkout the requested items (portfolio share) */
  isInvalid: Scalars['Boolean']['output'];
  /** Total value of the portfolio */
  totalValue: Money;
};

export type CollectCheckoutV2Address = {
  __typename?: 'CollectCheckoutV2Address';
  city: Scalars['String']['output'];
  country: CollectCheckoutV2Country;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type CollectCheckoutV2AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CollectCheckoutV2BurbankPaymentSummaryShipping = {
  __typename?: 'CollectCheckoutV2BurbankPaymentSummaryShipping';
  address?: Maybe<CollectCheckoutV2Address>;
  method: CollectCheckoutV2ShippingMethod;
  type: CollectCheckoutV2BurbankShippingType;
};

export type CollectCheckoutV2BurbankShipping = {
  __typename?: 'CollectCheckoutV2BurbankShipping';
  address?: Maybe<CollectCheckoutV2Address>;
  /** Available shipping methods */
  availableMethods?: Maybe<Array<Maybe<CollectCheckoutV2ShippingMethod>>>;
  availableTypes: Array<CollectCheckoutV2BurbankShippingType>;
  method: CollectCheckoutV2ShippingMethod;
  type: CollectCheckoutV2BurbankShippingType;
};

/** Collect Shipping Types available for Burbank Sportscards */
export enum CollectCheckoutV2BurbankShippingType {
  /** The default account address */
  Default = 'DEFAULT',
  /** Requires shipping address */
  New = 'NEW'
}

export type CollectCheckoutV2CompletePaymentCartInput = {
  id: Scalars['UUID']['input'];
  /** Stripe Payment Intent ID. Empty for non-Stripe payments */
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  /** Selected payment methods. Can be FUNDS, REGULAR_PM, or FUNDS+REGULAR_PM */
  paymentMethods: Array<CollectCheckoutV2PaymentMethod>;
  walletAmounts?: InputMaybe<CollectCheckoutWalletAmountsInput>;
};

export type CollectCheckoutV2CompletePaymentInvoiceInput = {
  id: Scalars['UUID']['input'];
  /** Stripe Payment Intent ID. Empty for non-Stripe payments */
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  /** Selected payment methods. Can be FUNDS, REGULAR_PM, or FUNDS+REGULAR_PM */
  paymentMethod: Array<CollectCheckoutV2PaymentMethod>;
};

export type CollectCheckoutV2CompletePaymentPayload = {
  __typename?: 'CollectCheckoutV2CompletePaymentPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCheckoutV2CompletePaymentResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCheckoutV2CompletePaymentResponse = {
  __typename?: 'CollectCheckoutV2CompletePaymentResponse';
  invoiceUuids: Array<Scalars['UUID']['output']>;
  isFirstPurchase: Scalars['Boolean']['output'];
  results?: Maybe<Array<Maybe<CollectCheckoutV2CompleteSinglePaymentResult>>>;
};

export type CollectCheckoutV2CompleteSinglePaymentResult = {
  __typename?: 'CollectCheckoutV2CompleteSinglePaymentResult';
  amount?: Maybe<Money>;
  /** ID of the payment transaction */
  paymentTransactionId?: Maybe<Scalars['String']['output']>;
  /** Payment status */
  status?: Maybe<CollectCompletePaymentResultStatus>;
};

export type CollectCheckoutV2Country = {
  __typename?: 'CollectCheckoutV2Country';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEu: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  shippingPriority: Scalars['Int']['output'];
};

export type CollectCheckoutV2Details = {
  __typename?: 'CollectCheckoutV2Details';
  availablePaymentMethods: Array<CollectCheckoutV2PaymentMethod>;
  burbankSportscardsSection?: Maybe<CollectCheckoutV2DetailsBurbankSportscardsSection>;
  errors?: Maybe<Array<Maybe<CollectCheckoutV2DetailsError>>>;
  fanaticsAuthenticSection?: Maybe<CollectCheckoutV2DetailsFanaticsAuthenticSection>;
  fanaticsCollectSection?: Maybe<CollectCheckoutV2DetailsFanaticsCollectSection>;
  /** Successful payments */
  payments?: Maybe<Array<Maybe<CollectCheckoutV2Payment>>>;
  /** Payments that are not completed yet */
  pendingPayments?: Maybe<Array<Maybe<CollectCheckoutV2Payment>>>;
  totals: CollectCheckoutV2DetailsTotals;
};

export type CollectCheckoutV2DetailsBurbankSportscardsSection = {
  __typename?: 'CollectCheckoutV2DetailsBurbankSportscardsSection';
  errors?: Maybe<Array<Maybe<CollectCheckoutV2DetailsError>>>;
  /** Type of a potential or existing invoice */
  invoiceType?: Maybe<CollectInvoiceType>;
  /** Line items in the cart, unavailable items will have error code and error message */
  lineItems?: Maybe<Array<Maybe<CollectCheckoutV2LineItem>>>;
  seller: CollectSeller;
  /** Selected shipping */
  shipping?: Maybe<CollectCheckoutV2BurbankShipping>;
  totals?: Maybe<CollectCheckoutV2DetailsSectionTotals>;
};

export type CollectCheckoutV2DetailsBurbankSportscardsSectionInput = {
  shipping?: InputMaybe<CollectCheckoutV2DetailsBurbankSportscardsShippingInput>;
};

export type CollectCheckoutV2DetailsBurbankSportscardsShippingInput = {
  /** Custom address. Required for all shipping_methods except DEFAULT */
  address?: InputMaybe<CollectCheckoutV2AddressInput>;
  /** If not specified, the cheapest available will be used with saved account address */
  methodId?: InputMaybe<Scalars['UUID']['input']>;
  /** If custom address not specified, DEFAULT will be used */
  type?: InputMaybe<CollectCheckoutV2BurbankShippingType>;
};

export type CollectCheckoutV2DetailsCartInput = {
  burbankSportscardsSection?: InputMaybe<CollectCheckoutV2DetailsBurbankSportscardsSectionInput>;
  fanaticsAuthenticSection?: InputMaybe<CollectCheckoutV2DetailsFanaticsAuthenticSectionInput>;
  fanaticsCollectSection?: InputMaybe<CollectCheckoutV2DetailsFanaticsCollectSectionInput>;
  id: Scalars['UUID']['input'];
  walletUsage?: InputMaybe<CollectCheckoutDetailsWalletUsageInput>;
};

export type CollectCheckoutV2DetailsError = {
  __typename?: 'CollectCheckoutV2DetailsError';
  code?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CollectCheckoutV2DetailsFanaticsAuthenticSection = {
  __typename?: 'CollectCheckoutV2DetailsFanaticsAuthenticSection';
  errors?: Maybe<Array<Maybe<CollectCheckoutV2DetailsError>>>;
  /** Type of a potential or existing invoice */
  invoiceType?: Maybe<CollectInvoiceType>;
  /** Line items in the cart, unavailable items will have error code and error message */
  lineItems?: Maybe<Array<Maybe<CollectCheckoutV2LineItem>>>;
  seller: CollectSeller;
  /** Selected shipping */
  shipping?: Maybe<CollectCheckoutV2FanaticsShipping>;
  totals?: Maybe<CollectCheckoutV2DetailsSectionTotals>;
};

export type CollectCheckoutV2DetailsFanaticsAuthenticSectionInput = {
  shipping?: InputMaybe<CollectCheckoutV2DetailsFanaticsAuthenticShippingInput>;
};

export type CollectCheckoutV2DetailsFanaticsAuthenticShippingInput = {
  /** Custom address. Required for NEW shipping_method */
  address?: InputMaybe<CollectCheckoutV2AddressInput>;
  /** If not specified, VAULT will be used */
  type?: InputMaybe<CollectCheckoutV2FanaticsShippingType>;
};

export type CollectCheckoutV2DetailsFanaticsCollectSection = {
  __typename?: 'CollectCheckoutV2DetailsFanaticsCollectSection';
  errors?: Maybe<Array<Maybe<CollectCheckoutV2DetailsError>>>;
  /** Type of a potential or existing invoice */
  invoiceType?: Maybe<CollectInvoiceType>;
  /** Line items in the cart, unavailable items will have error code and error message */
  lineItems?: Maybe<Array<Maybe<CollectCheckoutV2LineItem>>>;
  seller: CollectSeller;
  /** Selected shipping */
  shipping?: Maybe<CollectCheckoutV2FanaticsShipping>;
  totals?: Maybe<CollectCheckoutV2DetailsSectionTotals>;
};

export type CollectCheckoutV2DetailsFanaticsCollectSectionInput = {
  shipping?: InputMaybe<CollectCheckoutV2DetailsFanaticsCollectShippingInput>;
};

export type CollectCheckoutV2DetailsFanaticsCollectShippingInput = {
  /** Custom address. Required for NEW shipping_method */
  address?: InputMaybe<CollectCheckoutV2AddressInput>;
  /** If not specified, VAULT will be used */
  type?: InputMaybe<CollectCheckoutV2FanaticsShippingType>;
};

export type CollectCheckoutV2DetailsInvoiceInput = {
  fanaticsAuthenticSection?: InputMaybe<CollectCheckoutV2DetailsFanaticsAuthenticSectionInput>;
  fanaticsCollectSection?: InputMaybe<CollectCheckoutV2DetailsFanaticsCollectSectionInput>;
  id: Scalars['UUID']['input'];
};

export type CollectCheckoutV2DetailsSectionTotals = {
  __typename?: 'CollectCheckoutV2DetailsSectionTotals';
  shipping: Money;
  subTotal: Money;
  tax: Money;
  total: Money;
};

/** Overall checkout amounts */
export type CollectCheckoutV2DetailsTotals = {
  __typename?: 'CollectCheckoutV2DetailsTotals';
  /** Total amount of users' account funds */
  accountFunds: Money;
  /** Amount of funds that will remain after the current payment */
  accountFundsRemaining: Money;
  /** The amount of account funds that will be used during the current checkout */
  accountFundsToUse: Money;
  /** Amount that already been paid */
  amountPaid?: Maybe<Money>;
  /** Amount that is left to be paid */
  amountPaidOutstanding?: Maybe<Money>;
  /** The amount to be paid during current checkout */
  balanceDue: Money;
  /** Amount that goes to Seller. Already included in subtotal */
  buyersPremium: Money;
  /** Fraction of a payment amount that potentially be added on top of total if paid by Credit Card, Apple Pay or Google Pay */
  creditCardFeeRate: Scalars['Float']['output'];
  /** The payment methods fees */
  paymentMethodsFees: Array<Maybe<CollectInvoicePaymentMethodFee>>;
  potentialBalanceDueWithCreditCardFee: Money;
  /** Amount that potentially be added on top of total if paid by Credit Card, Apple Pay or Google Pay */
  potentialCreditCardFee: Money;
  potentialTotalWithCreditCardFee: Money;
  /** Sub Total, main payment amount */
  pureSubTotal: Money;
  shipping: Money;
  /** Sub Total, main payment amount. Buyers premium included */
  subTotal: Money;
  tax: Money;
  total: Money;
  walletAmountsAvailable?: Maybe<CollectCheckoutWalletAmounts>;
  walletAmountsRemaining?: Maybe<CollectCheckoutWalletAmounts>;
  walletAmountsToUse?: Maybe<CollectCheckoutWalletAmounts>;
};

export type CollectCheckoutV2DetailsVaultListingInput = {
  burbankSportscardsSection?: InputMaybe<CollectCheckoutV2DetailsBurbankSportscardsSectionInput>;
  fanaticsAuthenticSection?: InputMaybe<CollectCheckoutV2DetailsFanaticsAuthenticSectionInput>;
  fanaticsCollectSection?: InputMaybe<CollectCheckoutV2DetailsFanaticsCollectSectionInput>;
  id: Scalars['UUID']['input'];
};

export type CollectCheckoutV2FanaticsPaymentSummaryShipping = {
  __typename?: 'CollectCheckoutV2FanaticsPaymentSummaryShipping';
  address?: Maybe<CollectCheckoutV2Address>;
  type: CollectCheckoutV2FanaticsShippingType;
};

export type CollectCheckoutV2FanaticsShipping = {
  __typename?: 'CollectCheckoutV2FanaticsShipping';
  address?: Maybe<CollectCheckoutV2Address>;
  availableTypes: Array<CollectCheckoutV2FanaticsShippingType>;
  type: CollectCheckoutV2FanaticsShippingType;
};

/** Collect Shipping Type available for Fanatic Collect and Fanatics Authentic */
export enum CollectCheckoutV2FanaticsShippingType {
  /** The default account address */
  Default = 'DEFAULT',
  /**
   * User will to Vault themselves and pick up items in person.
   * Available only when paying for a Pick Up In Person VaultItemRequest Invoice.
   */
  InPerson = 'IN_PERSON',
  /** Requires shipping address */
  New = 'NEW',
  /**
   * To do a checkout, items will be shipped to a Trade Show.
   * Available only when paying for a Trade Show Checkout VaultItemRequest Invoice.
   */
  TradeShow = 'TRADE_SHOW',
  /** Vault address */
  Vault = 'VAULT'
}

export type CollectCheckoutV2LineItem = {
  __typename?: 'CollectCheckoutV2LineItem';
  amount: Money;
  /** Can the Item be purchased */
  available: Scalars['Boolean']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Has reason why the item is not available */
  error?: Maybe<CollectCheckoutV2LineItemError>;
  id: Scalars['Int']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
};

export type CollectCheckoutV2LineItemError = {
  __typename?: 'CollectCheckoutV2LineItemError';
  /** Code that explains why the item is not available */
  code: Scalars['String']['output'];
  /** Message that explains why the item is not available */
  message: Scalars['String']['output'];
};

export type CollectCheckoutV2LockForPaymentBurbankSportscardsSectionInput = {
  shipping?: InputMaybe<CollectCheckoutV2LockForPaymentBurbankSportscardsShippingInput>;
};

export type CollectCheckoutV2LockForPaymentBurbankSportscardsShippingInput = {
  /** Custom address. Required for NEW shipping_method */
  address?: InputMaybe<CollectCheckoutV2AddressInput>;
  methodId?: InputMaybe<Scalars['UUID']['input']>;
  type: CollectCheckoutV2BurbankShippingType;
};

export type CollectCheckoutV2LockForPaymentCartInput = {
  burbankSportscardsSection?: InputMaybe<CollectCheckoutV2LockForPaymentBurbankSportscardsSectionInput>;
  fanaticsAuthenticSection?: InputMaybe<CollectCheckoutV2LockForPaymentFanaticsAuthenticSectionInput>;
  fanaticsCollectSection?: InputMaybe<CollectCheckoutV2LockForPaymentFanaticsCollectSectionInput>;
  id: Scalars['UUID']['input'];
  /** Selected payment methods. Can be FUNDS, REGULAR_PM, or FUNDS+REGULAR_PM */
  paymentMethods: Array<CollectCheckoutV2PaymentMethod>;
  walletAmounts?: InputMaybe<CollectCheckoutWalletAmountsInput>;
};

export type CollectCheckoutV2LockForPaymentFanaticsAuthenticSectionInput = {
  shipping?: InputMaybe<CollectCheckoutV2LockForPaymentFanaticsAuthenticShippingInput>;
};

export type CollectCheckoutV2LockForPaymentFanaticsAuthenticShippingInput = {
  /** Custom address. Required for NEW shipping_method */
  address?: InputMaybe<CollectCheckoutV2AddressInput>;
  type: CollectCheckoutV2FanaticsShippingType;
};

export type CollectCheckoutV2LockForPaymentFanaticsCollectSectionInput = {
  shipping?: InputMaybe<CollectCheckoutV2LockForPaymentFanaticsCollectShippingInput>;
};

export type CollectCheckoutV2LockForPaymentFanaticsCollectShippingInput = {
  /** Custom address. Required for NEW shipping_method */
  address?: InputMaybe<CollectCheckoutV2AddressInput>;
  type: CollectCheckoutV2FanaticsShippingType;
};

export type CollectCheckoutV2LockForPaymentInvoiceInput = {
  fanaticsAuthenticSection?: InputMaybe<CollectCheckoutV2LockForPaymentFanaticsAuthenticSectionInput>;
  fanaticsCollectSection?: InputMaybe<CollectCheckoutV2LockForPaymentFanaticsCollectSectionInput>;
  id: Scalars['UUID']['input'];
  /** Selected payment methods. Can be FUNDS, REGULAR_PM, or FUNDS+REGULAR_PM */
  paymentMethods: Array<CollectCheckoutV2PaymentMethod>;
};

export type CollectCheckoutV2LockForPaymentPayload = {
  __typename?: 'CollectCheckoutV2LockForPaymentPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCheckoutV2LockForPaymentResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCheckoutV2LockForPaymentResponse = {
  __typename?: 'CollectCheckoutV2LockForPaymentResponse';
  /** Cart UUID to pay for */
  cartUuid?: Maybe<Scalars['UUID']['output']>;
  /** Stripe Client Secret. Empty for non-Stripe payments. */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Invoice IDs to pay */
  invoiceIntegerIds: Array<Scalars['Int']['output']>;
  /** Invoice UUIDs to pay */
  invoiceUuids: Array<Scalars['UUID']['output']>;
  /** Stripe Payment Intent ID. Empty for non-Stripe payments. */
  paymentIntentId?: Maybe<Scalars['String']['output']>;
};

export type CollectCheckoutV2LockForPaymentVaultListingInput = {
  burbankSportscardsSection?: InputMaybe<CollectCheckoutV2LockForPaymentBurbankSportscardsSectionInput>;
  fanaticsAuthenticSection?: InputMaybe<CollectCheckoutV2LockForPaymentFanaticsAuthenticSectionInput>;
  fanaticsCollectSection?: InputMaybe<CollectCheckoutV2LockForPaymentFanaticsCollectSectionInput>;
  id: Scalars['UUID']['input'];
  /** Selected payment methods. Can be FUNDS, REGULAR_PM, or FUNDS+REGULAR_PM */
  paymentMethods: Array<CollectCheckoutV2PaymentMethod>;
};

export type CollectCheckoutV2Order = {
  __typename?: 'CollectCheckoutV2Order';
  /** The date when the invoices were placed (if multiple - picked the earliest) */
  date?: Maybe<Scalars['Date']['output']>;
  /** Invoice integer ID or concatenated by dash IDs if multiple */
  id: Scalars['String']['output'];
  /** The lowest status of all invoices related to this payment */
  status: CollectInvoiceStatus;
};

/** The payment for invoice. */
export type CollectCheckoutV2Payment = {
  __typename?: 'CollectCheckoutV2Payment';
  amount: Money;
  date?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  metadata?: Maybe<CollectInvoicePaymentAttemptData>;
  paymentMethod?: Maybe<CollectCheckoutV2PaymentMethod>;
};

export enum CollectCheckoutV2PaymentMethod {
  Ach = 'ACH',
  ApplePay = 'APPLE_PAY',
  Card = 'CARD',
  Crypto = 'CRYPTO',
  Fancash = 'FANCASH',
  Funds = 'FUNDS',
  GooglePay = 'GOOGLE_PAY',
  Rewards = 'REWARDS',
  Wire = 'WIRE'
}

export type CollectCheckoutV2PaymentSummary = {
  __typename?: 'CollectCheckoutV2PaymentSummary';
  burbankSportscardsSection?: Maybe<CollectCheckoutV2PaymentSummaryBurbankSportscardsSection>;
  fanaticsAuthenticSection?: Maybe<CollectCheckoutV2PaymentSummaryFanaticsAuthenticSection>;
  fanaticsCollectSection?: Maybe<CollectCheckoutV2PaymentSummaryFanaticsCollectSection>;
  /** Virtual Order property, generated from all related invoices */
  order?: Maybe<CollectCheckoutV2Order>;
  /** Successful payments */
  payments?: Maybe<Array<Maybe<CollectCheckoutV2Payment>>>;
  /** Payments that are not completed yet */
  pendingPayments?: Maybe<Array<Maybe<CollectCheckoutV2Payment>>>;
  totals: CollectCheckoutV2PaymentSummaryTotals;
  wireInfo: CollectInvoiceWireInfo;
};

export type CollectCheckoutV2PaymentSummaryBurbankSportscardsSection = {
  __typename?: 'CollectCheckoutV2PaymentSummaryBurbankSportscardsSection';
  /** Type of an invoice */
  invoiceType: CollectInvoiceType;
  /** Line items in the cart. For sales, listing is attached */
  lineItems?: Maybe<Array<Maybe<CollectLineItem>>>;
  seller: CollectSeller;
  /** Selected shipping */
  shipping: CollectCheckoutV2BurbankPaymentSummaryShipping;
  totals: CollectCheckoutV2PaymentSummarySectionTotals;
};

export type CollectCheckoutV2PaymentSummaryCartInput = {
  id: Scalars['UUID']['input'];
};

export type CollectCheckoutV2PaymentSummaryFanaticsAuthenticSection = {
  __typename?: 'CollectCheckoutV2PaymentSummaryFanaticsAuthenticSection';
  /** Type of an invoice */
  invoiceType: CollectInvoiceType;
  /** Line items in the cart. For sales, listing is attached */
  lineItems?: Maybe<Array<Maybe<CollectLineItem>>>;
  seller: CollectSeller;
  /** Selected shipping */
  shipping: CollectCheckoutV2FanaticsPaymentSummaryShipping;
  totals: CollectCheckoutV2PaymentSummarySectionTotals;
};

export type CollectCheckoutV2PaymentSummaryFanaticsCollectSection = {
  __typename?: 'CollectCheckoutV2PaymentSummaryFanaticsCollectSection';
  /** Type of an invoice */
  invoiceType: CollectInvoiceType;
  /** Line items in the cart. For sales, listing is attached */
  lineItems?: Maybe<Array<Maybe<CollectLineItem>>>;
  seller: CollectSeller;
  /** Selected shipping */
  shipping: CollectCheckoutV2FanaticsPaymentSummaryShipping;
  totals: CollectCheckoutV2PaymentSummarySectionTotals;
};

export type CollectCheckoutV2PaymentSummaryInvoiceInput = {
  id: Scalars['UUID']['input'];
};

export type CollectCheckoutV2PaymentSummarySectionTotals = {
  __typename?: 'CollectCheckoutV2PaymentSummarySectionTotals';
  shipping: Money;
  subTotal: Money;
  tax: Money;
  total: Money;
};

/** Overall payment amounts */
export type CollectCheckoutV2PaymentSummaryTotals = {
  __typename?: 'CollectCheckoutV2PaymentSummaryTotals';
  /** Amount that already been paid */
  amountPaid?: Maybe<Money>;
  /** Amount that is left to be paid */
  amountPaidOutstanding?: Maybe<Money>;
  /** Amount that goes to Seller. Already included in subtotal */
  buyersPremium: Money;
  /** Amount was added on top of total if paid by Credit Card, Apple Pay or Google Pay */
  creditCardFee: Money;
  /** Fraction of a payment amount that potentially be added on top of total if paid by Credit Card, Apple Pay or Google Pay */
  creditCardFeeRate: Scalars['Float']['output'];
  /** Sub Total, main payment amount */
  pureSubTotal: Money;
  shipping: Money;
  /** Sub Total, main payment amount. Buyers premium included */
  subTotal: Money;
  tax: Money;
  total: Money;
};

/** All supported Sellers */
export enum CollectCheckoutV2Seller {
  BurbankSportscards = 'BURBANK_SPORTSCARDS',
  FanaticsAuthentic = 'FANATICS_AUTHENTIC',
  FanaticsCollect = 'FANATICS_COLLECT'
}

/** Shipping Method, all require shipping address */
export type CollectCheckoutV2ShippingMethod = {
  __typename?: 'CollectCheckoutV2ShippingMethod';
  cost?: Maybe<Money>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  usDomestic: Scalars['Boolean']['output'];
};

export type CollectCheckoutWalletAmounts = {
  __typename?: 'CollectCheckoutWalletAmounts';
  accountFunds: Money;
  fancash: Money;
  rewards: Money;
};

export type CollectCheckoutWalletAmountsInput = {
  accountFunds?: InputMaybe<Scalars['Int']['input']>;
  fancash?: InputMaybe<Scalars['Int']['input']>;
  rewards?: InputMaybe<Scalars['Int']['input']>;
};

export enum CollectCheckoutWalletPendingPaymentsPayableType {
  Cart = 'CART',
  Invoice = 'INVOICE'
}

export type CollectChekcoutInvoiceConfirmSinglePayload = {
  __typename?: 'CollectChekcoutInvoiceConfirmSinglePayload';
  amount: Money;
  /** The date the payment was made, in PT timezone. */
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentTransactionId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

export type CollectCombinedInvoice = CollectBoInvoice | CollectInvoice;

export enum CollectCompletePaymentResultStatus {
  Fail = 'FAIL',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type CollectCompleteRedRookieRedemptionPayload = {
  __typename?: 'CollectCompleteRedRookieRedemptionPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCounterOfferInput = {
  listingId: Scalars['UUID']['input'];
  listingType?: InputMaybe<CollectListingType>;
  offerId: Scalars['UUID']['input'];
  offerInCents: Scalars['Int']['input'];
  sendChatMessage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectCountriesV2Payload = {
  __typename?: 'CollectCountriesV2Payload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCountriesV2Response>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCountriesV2Response = {
  __typename?: 'CollectCountriesV2Response';
  /** The top countries user can select shipping address from */
  collectAddressTopCountries?: Maybe<Array<Maybe<CollectCountry>>>;
  countries: Array<Maybe<CollectCountry>>;
};

export type CollectCountry = {
  __typename?: 'CollectCountry';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CollectCreateInvoiceInput = {
  offerInCents: Scalars['Int']['input'];
  vaultListingId: Scalars['UUID']['input'];
};

export type CollectCreateInvoicePayload = {
  __typename?: 'CollectCreateInvoicePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCreateInvoiceResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCreateInvoiceResponse = {
  __typename?: 'CollectCreateInvoiceResponse';
  invoice?: Maybe<CollectInvoice>;
};

export type CollectCreateItemEditRequestPayload = {
  __typename?: 'CollectCreateItemEditRequestPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCreateItemEditRequestResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The response of Item Edit Request creation */
export type CollectCreateItemEditRequestResponse = {
  __typename?: 'CollectCreateItemEditRequestResponse';
  itemEditRequest?: Maybe<CollectItemEditRequest>;
};

export type CollectCreateListingInput = {
  allowOffers?: InputMaybe<Scalars['Boolean']['input']>;
  listingPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  /** aka auction ID (if any) */
  marketplaceEventId?: InputMaybe<Scalars['String']['input']>;
  rejectPriceThresholdInCents?: InputMaybe<Scalars['Int']['input']>;
  type: CollectListingType;
  vaultItemId: Scalars['UUID']['input'];
};

export type CollectCreateOwnershipTransferInput = {
  items: Array<InputMaybe<Scalars['UUID']['input']>>;
  transferRecipientIdentity: Scalars['String']['input'];
};

export type CollectCreatePayoutRequestsInput = {
  requestedAmount: Scalars['Int']['input'];
};

export type CollectCreatePayoutRequestsPayload = {
  __typename?: 'CollectCreatePayoutRequestsPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCreatePayoutRequestsResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCreatePayoutRequestsResponse = {
  __typename?: 'CollectCreatePayoutRequestsResponse';
  accountFunds?: Maybe<CollectAccountFunds>;
  payoutRequestGroup?: Maybe<CollectPayoutRequestGroup>;
};

export type CollectCreatePickUpInPersonInput = {
  items: Array<Scalars['UUID']['input']>;
};

export type CollectCreatePickUpInPersonPayload = {
  __typename?: 'CollectCreatePickUpInPersonPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCreatePickUpInPersonResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCreatePickUpInPersonResponse = {
  __typename?: 'CollectCreatePickUpInPersonResponse';
  vaultItemRequest?: Maybe<CollectVaultItemRequest>;
};

export type CollectCreatePlaidLinkTokenPayload = {
  __typename?: 'CollectCreatePlaidLinkTokenPayload';
  expiration?: Maybe<Scalars['String']['output']>;
  linkToken?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
};

export type CollectCreateRedemptionSubmissionInput = {
  autoRedeem?: InputMaybe<Scalars['Boolean']['input']>;
  estimatedValue: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type CollectCreateRedemptionSubmissionItem = {
  quantity: Scalars['Int']['input'];
  redRookiePlayerId: Scalars['UUID']['input'];
};

export type CollectCreateRedemptionSubmissionPayload = {
  __typename?: 'CollectCreateRedemptionSubmissionPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCreateVaultSubmissionResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCreateRedemptionSubmissionV2Input = {
  autoRedeem?: InputMaybe<Scalars['Boolean']['input']>;
  items: Array<CollectCreateRedemptionSubmissionItem>;
};

export type CollectCreateReportPayload = {
  __typename?: 'CollectCreateReportPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCreateReportResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCreateReportResponse = {
  __typename?: 'CollectCreateReportResponse';
  /** Report ID */
  id: Scalars['UUID']['output'];
};

export type CollectCreateSavedSearchPayload = {
  __typename?: 'CollectCreateSavedSearchPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCreateSavedSearchResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCreateSavedSearchResponse = {
  __typename?: 'CollectCreateSavedSearchResponse';
  /** The Saved Search entry */
  savedSearch?: Maybe<CollectSavedSearch>;
};

export type CollectCreateTradeShowCheckoutInput = {
  items: Array<Scalars['UUID']['input']>;
  tradeShowId: Scalars['Int']['input'];
};

export type CollectCreateTradeShowCheckoutPayload = {
  __typename?: 'CollectCreateTradeShowCheckoutPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCreateTradeShowCheckoutResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCreateTradeShowCheckoutResponse = {
  __typename?: 'CollectCreateTradeShowCheckoutResponse';
  vaultItemRequest?: Maybe<CollectVaultItemRequest>;
};

export type CollectCreateVaultItemGroupPayload = {
  __typename?: 'CollectCreateVaultItemGroupPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectVaultItemGroup>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCreateVaultRetrievalInput = {
  alternateAddress?: InputMaybe<CollectVaultRetrievalAlternateAddress>;
  items: Array<InputMaybe<Scalars['UUID']['input']>>;
};

export type CollectCreateVaultRetrievalPayload = {
  __typename?: 'CollectCreateVaultRetrievalPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCreateVaultRetrievalResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCreateVaultRetrievalResponse = {
  __typename?: 'CollectCreateVaultRetrievalResponse';
  vaultItemRequest?: Maybe<CollectVaultItemRequest>;
};

export type CollectCreateVaultSubmissionInput = {
  estimatedValue: Scalars['Int']['input'];
  grader?: InputMaybe<CollectVaultSubmissionGrader>;
  intent: CollectVaultSubmissionIntent;
  quantity: Scalars['Int']['input'];
};

export type CollectCreateVaultSubmissionPayload = {
  __typename?: 'CollectCreateVaultSubmissionPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCreateVaultSubmissionResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCreateVaultSubmissionResponse = {
  __typename?: 'CollectCreateVaultSubmissionResponse';
  submission?: Maybe<CollectVaultSubmission>;
};

export type CollectCreateVaultTransferInput = {
  items: Array<InputMaybe<Scalars['UUID']['input']>>;
  recipientIdentity: Scalars['String']['input'];
};

export type CollectCreateVaultTransferPayload = {
  __typename?: 'CollectCreateVaultTransferPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectCreateVaultTransferResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectCreateVaultTransferResponse = {
  __typename?: 'CollectCreateVaultTransferResponse';
  vaultItemRequest?: Maybe<CollectVaultItemRequest>;
};

export type CollectCurrentUser = {
  __typename?: 'CollectCurrentUser';
  accountFunds?: Maybe<CollectAccountFunds>;
  /** The limit of bid user can make (depends on user trust level) */
  bidLimit?: Maybe<Scalars['Int']['output']>;
  /** Business name */
  businessName?: Maybe<Scalars['String']['output']>;
  canSellOnCustomAuction?: Maybe<Scalars['Boolean']['output']>;
  chatToken?: Maybe<Scalars['String']['output']>;
  collectAcceptedOffers?: Maybe<CollectAcceptedOrDeclinedOffer>;
  collectBidIncrementConfig?: Maybe<Array<Maybe<CollectBidIncrementConfig>>>;
  collectBoInvoiceSummary?: Maybe<CollectBoInvoiceSummary>;
  collectCollection: CollectSetlist;
  collectDeclinedOffers?: Maybe<CollectAcceptedOrDeclinedOffer>;
  collectDefaultAddress?: Maybe<CollectAddress>;
  collectHasVaultItemOverAppraisedValue?: Maybe<Scalars['Boolean']['output']>;
  collectInvoices?: Maybe<CollectInvoiceConnection>;
  collectListings?: Maybe<CollectListingsConnection>;
  collectListingsWithOffers?: Maybe<CollectListingConnection>;
  collectOffers?: Maybe<CollectFixedPriceListingOfferWithHistoryConnection>;
  collectOutbidBidsCount?: Maybe<Scalars['Int']['output']>;
  collectOverdueInvoicesCount?: Maybe<Scalars['Int']['output']>;
  collectPaymentMethods?: Maybe<Array<Maybe<CollectPaymentMethod>>>;
  collectPendingInvoicesCount?: Maybe<Scalars['Int']['output']>;
  collectPendingOffers?: Maybe<CollectPendingOffer>;
  collectPremierAuctionApproved?: Maybe<Scalars['Boolean']['output']>;
  collectPremierAuctionRegisteration?: Maybe<CollectRegistration>;
  collectRecentlyViewed?: Maybe<Array<Maybe<CollectRecentlyViewedItem>>>;
  collectRecentlyViewedListings?: Maybe<Array<Maybe<CollectRecentlyViewedItem>>>;
  collectScanHistory?: Maybe<CollectScanConnection>;
  collectScanHistoryDetail?: Maybe<CollectScanDetailPayload>;
  collectSetlist: CollectSetlist;
  collectSetlists?: Maybe<CollectSetlistConnection>;
  collectTotalVaultItemsCount?: Maybe<Scalars['Int']['output']>;
  collectUnreadOffers?: Maybe<CollectFixedPriceListingOfferWithHistoryConnection>;
  collectUnreadOffersCount?: Maybe<Scalars['Int']['output']>;
  collectVaultItemGroups?: Maybe<CollectVaultItemGroupsConnection>;
  /** Mobile app only supports type_member_transfer and type_fulfill. Use collect_vault_item_requests_v2 to avoid this limitation */
  collectVaultItemRequests?: Maybe<CollectVaultItemRequestsConnection>;
  collectVaultItemRequestsV2?: Maybe<CollectVaultItemRequestsConnection>;
  collectVaultItems?: Maybe<CollectVaultItemsConnection>;
  collectVaultItemsIr?: Maybe<CollectVaultItemsConnection>;
  /** Get aggregated market value for a list of vault items */
  collectVaultItemsMarketValueStatistics?: Maybe<CollectVaultItemsMarketValueStatistics>;
  /** User specific Ship To address in vault submissions */
  collectVaultSubmissionAddress: CollectAddress;
  collectVaultSubmissions?: Maybe<CollectVaultSubmissionsConnection>;
  collectVaultValue?: Maybe<Money>;
  collectWaitingOffersCount?: Maybe<Scalars['Int']['output']>;
  collectWatchlist?: Maybe<CollectWatchlistConnection>;
  collectWinningBidsCount?: Maybe<Scalars['Int']['output']>;
  /** The user's email address */
  email?: Maybe<CollectEmail>;
  /** The user's first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Indicates if user is frozen or not */
  frozen: Scalars['Boolean']['output'];
  hasNewOffersFromBidders?: Maybe<Scalars['Boolean']['output']>;
  hasNewOffersFromSellers?: Maybe<Scalars['Boolean']['output']>;
  /** Checks if current user is admin */
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isDropShipper?: Maybe<Scalars['Boolean']['output']>;
  kycStatus?: Maybe<CollectKycStatus>;
  /** The user's last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The user's phone number. */
  phone?: Maybe<CollectPhone>;
  premierAuctionBids?: Maybe<CollectPremierAuctionBidConnection>;
  proSeller?: Maybe<Array<Maybe<CollectShopSellerIdentity>>>;
  stripeAccountDisabled?: Maybe<Scalars['Boolean']['output']>;
  stripeAccountOnboarded: Scalars['Boolean']['output'];
  stripeAchConsentRequired: Scalars['Boolean']['output'];
  stripeLoginUrl?: Maybe<Scalars['String']['output']>;
  stripeOnboardingUrl?: Maybe<Scalars['String']['output']>;
  stripePublishableKey: Scalars['String']['output'];
  stripePublishableKey2: Scalars['String']['output'];
  /** The user's FanID tenant ID. */
  tenantId: Scalars['UUID']['output'];
  weeklyAuctionBids?: Maybe<CollectWeeklyAuctionBidConnection>;
};


export type CollectCurrentUserCollectHasVaultItemOverAppraisedValueArgs = {
  valueInCents: Scalars['Int']['input'];
};


export type CollectCurrentUserCollectInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invoicePaymentStatus?: InputMaybe<CollectInvoicePaymentStatuses>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectCurrentUserCollectListingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  bidType?: InputMaybe<CollectBidType>;
  categoryId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eyeAppealGrade?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includeBids?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  listingAuctionId?: InputMaybe<Scalars['UUID']['input']>;
  listingCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listingCertifiedSellers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listingEyeAppealGrades?: InputMaybe<Array<InputMaybe<CollectEyeAppealGrade>>>;
  listingGradingServices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listingPricesRange?: InputMaybe<CollectListingPricesRangeFilter>;
  listingSorting?: InputMaybe<CollectListingSorting>;
  listingStatuses?: InputMaybe<Array<InputMaybe<CollectListingStatusFilter>>>;
  listingTitleTerm?: InputMaybe<Scalars['String']['input']>;
  listingTypes?: InputMaybe<Array<InputMaybe<CollectListingType>>>;
  listingYearsRange?: InputMaybe<CollectListingYearsRangeFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectCurrentUserCollectListingsWithOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  listingCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listingEyeAppealGrades?: InputMaybe<Array<InputMaybe<CollectEyeAppealGrade>>>;
  listingGradingServices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listingPricesRange?: InputMaybe<CollectListingPricesRangeFilter>;
  listingYearsRange?: InputMaybe<CollectListingYearsRangeFilter>;
  nextPageCursor?: InputMaybe<Scalars['String']['input']>;
  offerKind: CollectOfferKind;
  offerStatus?: InputMaybe<Array<InputMaybe<CollectOfferStatusFilter>>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CollectListingOffersSortBy>;
  titleSearch?: InputMaybe<Scalars['String']['input']>;
};


export type CollectCurrentUserCollectOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offerKind: CollectOfferKind;
  offerStatus?: InputMaybe<Array<InputMaybe<CollectOfferStatusFilter>>>;
};


export type CollectCurrentUserCollectRecentlyViewedArgs = {
  itemTypes?: InputMaybe<Array<InputMaybe<CollectRecentlyViewedItemType>>>;
};


export type CollectCurrentUserCollectRecentlyViewedListingsArgs = {
  itemTypes?: InputMaybe<Array<InputMaybe<CollectRecentlyViewedItemType>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  listingIdsToExclude?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type CollectCurrentUserCollectScanHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectCurrentUserCollectScanHistoryDetailArgs = {
  scanRequestId: Scalars['UUID']['input'];
};


export type CollectCurrentUserCollectSetlistArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<CollectSetlistKind>;
};


export type CollectCurrentUserCollectSetlistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectCurrentUserCollectUnreadOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectCurrentUserCollectVaultItemGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterStatus?: InputMaybe<CollectVaultItemGroupStatus>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CollectVaultItemGroupSortBy>;
  type: CollectVaultItemGroupType;
  vaultItemGroupId?: InputMaybe<Scalars['ID']['input']>;
};


export type CollectCurrentUserCollectVaultItemRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CollectVaultItemRequestStatus>;
  type?: InputMaybe<CollectVaultItemRequestType>;
};


export type CollectCurrentUserCollectVaultItemRequestsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CollectVaultItemRequestSortBy>;
  status?: InputMaybe<CollectVaultItemRequestStatus>;
  type?: InputMaybe<CollectVaultItemRequestType>;
  vaultItemUuid?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type CollectCurrentUserCollectVaultItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  filterListable?: InputMaybe<Scalars['Boolean']['input']>;
  filterListed?: InputMaybe<Scalars['Boolean']['input']>;
  filterProtoItemUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  filterStatus?: InputMaybe<CollectVaultStatus>;
  filterVaultItemGroupId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  grade?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  gradingServiceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  origins?: InputMaybe<Array<InputMaybe<CollectVaultItemOriginType>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CollectVaultSortBy>;
  state?: InputMaybe<CollectVaultItemState>;
  vaultSubmission?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type CollectCurrentUserCollectVaultItemsIrArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  filterListable?: InputMaybe<Scalars['Boolean']['input']>;
  filterListed?: InputMaybe<Scalars['Boolean']['input']>;
  filterProtoItemUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  filterStatus?: InputMaybe<CollectVaultStatus>;
  filterTitle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterVaultItemGroupId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  grade?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  gradingServiceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  origins?: InputMaybe<Array<InputMaybe<CollectVaultItemOriginType>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CollectVaultSortBy>;
  state?: InputMaybe<CollectVaultItemState>;
  vaultSubmission?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type CollectCurrentUserCollectVaultItemsMarketValueStatisticsArgs = {
  vaultItemIds: Array<Scalars['ID']['input']>;
};


export type CollectCurrentUserCollectVaultSubmissionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CollectVaultSubmissionStatus>;
  withCuratedItems?: InputMaybe<Scalars['Boolean']['input']>;
  withInternal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CollectCurrentUserCollectWatchlistArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  listingAllowsOffers?: InputMaybe<Scalars['Boolean']['input']>;
  listingAuctionId?: InputMaybe<Scalars['UUID']['input']>;
  listingCategories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listingCertifiedSellers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listingEyeAppealGrades?: InputMaybe<Array<InputMaybe<CollectEyeAppealGrade>>>;
  listingGradingServices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listingIsGreatPrice?: InputMaybe<Scalars['Boolean']['input']>;
  listingPricesRange?: InputMaybe<CollectListingPricesRangeFilter>;
  listingSorting?: InputMaybe<CollectListingSorting>;
  listingStatuses?: InputMaybe<Array<InputMaybe<CollectListingStatusFilter>>>;
  listingTitleTerm?: InputMaybe<Scalars['String']['input']>;
  listingTypes?: InputMaybe<Array<InputMaybe<CollectListingType>>>;
  listingYearsRange?: InputMaybe<CollectListingYearsRangeFilter>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectCurrentUserPremierAuctionBidsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CollectCurrentUserStripeOnboardingUrlArgs = {
  returnUrl: Scalars['String']['input'];
};


export type CollectCurrentUserWeeklyAuctionBidsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectDeleteSavedSearchPayload = {
  __typename?: 'CollectDeleteSavedSearchPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['String']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectDeleteVaultItemGroupPayload = {
  __typename?: 'CollectDeleteVaultItemGroupPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectDetailed = {
  debugMetadata?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CollectDetailedActivity = {
  __typename?: 'CollectDetailedActivity';
  stub?: Maybe<Scalars['String']['output']>;
};

export type CollectDetailedSales = {
  __typename?: 'CollectDetailedSales';
  stub?: Maybe<Scalars['String']['output']>;
};

export type CollectDetailedStats = {
  __typename?: 'CollectDetailedStats';
  stub?: Maybe<Scalars['String']['output']>;
};

export enum CollectDuplicateItemType {
  /** Select only graded items (has grade) */
  Graded = 'GRADED',
  /** Select only ungraded items (no grade) */
  Raw = 'RAW'
}

export type CollectDuplicateVaultItemsInput = {
  /** Buyback value for proto items in cents (defaults to 1000 = $10) */
  buybackValueInCents?: InputMaybe<Scalars['Int']['input']>;
  /** Number of copies to create for each vault item (minimum 1, maximum 100). Only used with vault_item_ids. */
  copiesPerItem?: InputMaybe<Scalars['Int']['input']>;
  /** Number of vault items to duplicate (minimum 1, maximum 20000). Required if vault_item_ids is not provided. */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Email address to look up the account */
  email: Scalars['String']['input'];
  /** Name of a new folder to create and place duplicated items into */
  folderName?: InputMaybe<Scalars['String']['input']>;
  /** Type of items to duplicate when using count. RAW selects ungraded items, GRADED selects graded items. Ignored when vault_item_ids is provided. */
  itemType?: InputMaybe<CollectDuplicateItemType>;
  /** Specific vault item UUIDs to duplicate. When provided, count and item_type are ignored. */
  vaultItemIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type CollectDuplicateVaultItemsPayload = {
  __typename?: 'CollectDuplicateVaultItemsPayload';
  /** UUIDs of the created vault items */
  createdVaultItemIds?: Maybe<Array<Scalars['UUID']['output']>>;
  message: Scalars['String']['output'];
  protoItemsCreated: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
  vaultItemsCreated: Scalars['Int']['output'];
};

/** An email address for a user in marketplace. */
export type CollectEmail = {
  __typename?: 'CollectEmail';
  /** The email address. */
  address?: Maybe<Scalars['String']['output']>;
  /** Whether the email address is verified. */
  verified?: Maybe<Scalars['Boolean']['output']>;
};

/** Object which represents videos on external resources, like Vimeo */
export type CollectExternalVideo = {
  __typename?: 'CollectExternalVideo';
  /** Full link to the video */
  link: Scalars['String']['output'];
  /**
   * Links to the video thumbnails.
   * If no sizes argument given, will contain a link to the 640x360 image.
   * Otherwise, returns a list of link in order of the sizes given
   */
  thumbnails: Array<Scalars['String']['output']>;
};


/** Object which represents videos on external resources, like Vimeo */
export type CollectExternalVideoThumbnailsArgs = {
  sizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum CollectEyeAppealGrade {
  /** Eye Appeal - A */
  EyeAppealA = 'EYE_APPEAL_A',
  /** Eye Appeal - E */
  EyeAppealE = 'EYE_APPEAL_E',
  /** Eye Appeal - S */
  EyeAppealS = 'EYE_APPEAL_S',
  /** PWCC-A */
  PwccA = 'PWCC_A',
  /** PWCC-E */
  PwccE = 'PWCC_E',
  /** PWCC-S */
  PwccS = 'PWCC_S'
}

/** Parameters for initiating authentication with FanID */
export type CollectFanIdAuthParams = {
  __typename?: 'CollectFanIdAuthParams';
  applicationClientId: Scalars['String']['output'];
  nonce: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
  responseType: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type CollectFanaticsPricingInfo = {
  __typename?: 'CollectFanaticsPricingInfo';
  debug?: Maybe<Scalars['Json']['output']>;
  price?: Maybe<Money>;
};

export type CollectFilterOption = {
  __typename?: 'CollectFilterOption';
  displayName: Scalars['String']['output'];
  optionKey: Scalars['String']['output'];
  optionValues?: Maybe<Array<Maybe<CollectOptionValue>>>;
};

export type CollectFixedPriceAcceptOfferPayload = {
  __typename?: 'CollectFixedPriceAcceptOfferPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectFixedPriceAcceptOfferResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectFixedPriceAcceptOfferResponse = {
  __typename?: 'CollectFixedPriceAcceptOfferResponse';
  invoice?: Maybe<CollectInvoice>;
  offer?: Maybe<CollectFixedPriceListingOfferWithHistoryInterface>;
};

export type CollectFixedPriceListingBackofficeOffer = CollectFixedPriceListingOfferInterface & {
  __typename?: 'CollectFixedPriceListingBackofficeOffer';
  amount: Money;
  bidderViewedAt?: Maybe<Scalars['DateTime']['output']>;
  bids?: Maybe<Array<Maybe<CollectFixedPriceListingBackofficeOfferBid>>>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  integerId?: Maybe<Scalars['Int']['output']>;
  listing?: Maybe<CollectListing>;
  listingId: Scalars['UUID']['output'];
  offerRoom?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<CollectFixedPriceOfferPaymentDetails>;
  sellerViewedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CollectFixedPriceOfferStatus;
};

export type CollectFixedPriceListingBackofficeOfferBid = CollectFixedPriceListingOfferBidInterface & {
  __typename?: 'CollectFixedPriceListingBackofficeOfferBid';
  amount: Money;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  insertedAt: Scalars['DateTime']['output'];
  integerId?: Maybe<Scalars['Int']['output']>;
  isLatest: Scalars['Boolean']['output'];
  status: CollectFixedPriceListingOfferBidStatus;
  tenantId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CollectFixedPriceListingBackofficeOfferWithHistory = CollectFixedPriceListingOfferWithHistoryInterface & {
  __typename?: 'CollectFixedPriceListingBackofficeOfferWithHistory';
  amount: Money;
  bidderViewedAt?: Maybe<Scalars['DateTime']['output']>;
  bids?: Maybe<Array<Maybe<CollectFixedPriceListingBackofficeOfferBid>>>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  integerId?: Maybe<Scalars['Int']['output']>;
  listing?: Maybe<CollectListing>;
  listingId: Scalars['UUID']['output'];
  offerRoom?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<CollectFixedPriceOfferPaymentDetails>;
  previousOffers?: Maybe<Array<Maybe<CollectFixedPriceListingBackofficeOffer>>>;
  sellerViewedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CollectFixedPriceOfferStatus;
};

export type CollectFixedPriceListingOffer = CollectFixedPriceListingOfferInterface & {
  __typename?: 'CollectFixedPriceListingOffer';
  amount: Money;
  bidderViewedAt?: Maybe<Scalars['DateTime']['output']>;
  bids?: Maybe<Array<Maybe<CollectFixedPriceListingOfferBid>>>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  integerId: Scalars['Int']['output'];
  listing?: Maybe<CollectListing>;
  listingId: Scalars['UUID']['output'];
  offerRoom?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<CollectFixedPriceOfferPaymentDetails>;
  sellerViewedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CollectFixedPriceOfferStatus;
};

export type CollectFixedPriceListingOfferBid = CollectFixedPriceListingOfferBidInterface & {
  __typename?: 'CollectFixedPriceListingOfferBid';
  amount: Money;
  expiresAt: Scalars['DateTime']['output'];
  insertedAt: Scalars['DateTime']['output'];
  integerId: Scalars['Int']['output'];
  status: CollectFixedPriceListingOfferBidStatus;
};

export type CollectFixedPriceListingOfferBidInterface = {
  amount: Money;
  expiresAt: Scalars['DateTime']['output'];
  insertedAt: Scalars['DateTime']['output'];
  integerId?: Maybe<Scalars['Int']['output']>;
  status: CollectFixedPriceListingOfferBidStatus;
};

export enum CollectFixedPriceListingOfferBidStatus {
  StatusBidderAccepted = 'STATUS_BIDDER_ACCEPTED',
  StatusBidderDeclined = 'STATUS_BIDDER_DECLINED',
  StatusBidderRemoved = 'STATUS_BIDDER_REMOVED',
  StatusCounteredByBidder = 'STATUS_COUNTERED_BY_BIDDER',
  StatusCounteredBySeller = 'STATUS_COUNTERED_BY_SELLER',
  StatusSellerAccepted = 'STATUS_SELLER_ACCEPTED',
  StatusSellerDeclined = 'STATUS_SELLER_DECLINED',
  StatusSellerRemoved = 'STATUS_SELLER_REMOVED',
  StatusWaitingForBidder = 'STATUS_WAITING_FOR_BIDDER',
  StatusWaitingForSeller = 'STATUS_WAITING_FOR_SELLER'
}

export type CollectFixedPriceListingOfferInterface = {
  amount: Money;
  bidderViewedAt?: Maybe<Scalars['DateTime']['output']>;
  bids?: Maybe<Array<Maybe<CollectFixedPriceListingOfferBidInterface>>>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  integerId?: Maybe<Scalars['Int']['output']>;
  listing?: Maybe<CollectListing>;
  listingId: Scalars['UUID']['output'];
  offerRoom?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<CollectFixedPriceOfferPaymentDetails>;
  sellerViewedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CollectFixedPriceOfferStatus;
};

export type CollectFixedPriceListingOfferWithHistory = CollectFixedPriceListingOfferWithHistoryInterface & {
  __typename?: 'CollectFixedPriceListingOfferWithHistory';
  amount: Money;
  bidderViewedAt?: Maybe<Scalars['DateTime']['output']>;
  bids?: Maybe<Array<Maybe<CollectFixedPriceListingOfferBid>>>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  integerId: Scalars['Int']['output'];
  listing?: Maybe<CollectListing>;
  listingId: Scalars['UUID']['output'];
  offerRoom?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<CollectFixedPriceOfferPaymentDetails>;
  previousOffers?: Maybe<Array<Maybe<CollectFixedPriceListingOffer>>>;
  sellerViewedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CollectFixedPriceOfferStatus;
};

export type CollectFixedPriceListingOfferWithHistoryConnection = {
  __typename?: 'CollectFixedPriceListingOfferWithHistoryConnection';
  edges?: Maybe<Array<Maybe<CollectFixedPriceListingOfferWithHistoryEdge>>>;
  pageInfo: PageInfo;
};

export type CollectFixedPriceListingOfferWithHistoryEdge = {
  __typename?: 'CollectFixedPriceListingOfferWithHistoryEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectFixedPriceListingOfferWithHistory>;
};

export type CollectFixedPriceListingOfferWithHistoryInterface = {
  amount: Money;
  bidderViewedAt?: Maybe<Scalars['DateTime']['output']>;
  bids?: Maybe<Array<Maybe<CollectFixedPriceListingOfferBidInterface>>>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  integerId?: Maybe<Scalars['Int']['output']>;
  listing?: Maybe<CollectListing>;
  listingId: Scalars['UUID']['output'];
  offerRoom?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<CollectFixedPriceOfferPaymentDetails>;
  previousOffers?: Maybe<Array<Maybe<CollectFixedPriceListingOfferInterface>>>;
  sellerViewedAt?: Maybe<Scalars['DateTime']['output']>;
  status: CollectFixedPriceOfferStatus;
};

export type CollectFixedPriceOfferPayload = {
  __typename?: 'CollectFixedPriceOfferPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectFixedPriceOfferResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectFixedPriceOfferPaymentDetails = {
  __typename?: 'CollectFixedPriceOfferPaymentDetails';
  invoiceId?: Maybe<Scalars['UUID']['output']>;
  invoiceStatus?: Maybe<CollectBoInvoiceStatus>;
  paymentDueDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CollectFixedPriceOfferResponse = {
  __typename?: 'CollectFixedPriceOfferResponse';
  offer?: Maybe<CollectFixedPriceListingOfferWithHistoryInterface>;
};

export enum CollectFixedPriceOfferStatus {
  StatusBidderAccepted = 'STATUS_BIDDER_ACCEPTED',
  StatusBidderDeclined = 'STATUS_BIDDER_DECLINED',
  StatusBidderRemoved = 'STATUS_BIDDER_REMOVED',
  StatusSellerAccepted = 'STATUS_SELLER_ACCEPTED',
  StatusSellerDeclined = 'STATUS_SELLER_DECLINED',
  StatusSellerRemoved = 'STATUS_SELLER_REMOVED',
  StatusWaitingForBidder = 'STATUS_WAITING_FOR_BIDDER',
  StatusWaitingForSeller = 'STATUS_WAITING_FOR_SELLER'
}

export type CollectFixedPriceSale = CollectMarketplaceSale & {
  __typename?: 'CollectFixedPriceSale';
  buyersPremium?: Maybe<Money>;
  id: Scalars['UUID']['output'];
  integerId: Scalars['Int']['output'];
  /** Not affected by faster listing query optimization */
  listing?: Maybe<CollectListing>;
  purchasePrice?: Maybe<Money>;
  shipping?: Maybe<Money>;
  tax?: Maybe<Money>;
  total?: Maybe<Money>;
};

export type CollectFulfillmentChargesInput = {
  alternateShippingAddress?: InputMaybe<CollectAlternatingShippingAddress>;
  invoiceId: Scalars['UUID']['input'];
  shippingType: CollectShippingType;
};

export type CollectFulfillmentChargesPayload = {
  __typename?: 'CollectFulfillmentChargesPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectFulfillmentChargesResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The response of a fulfillment charges calculation. */
export type CollectFulfillmentChargesResponse = {
  __typename?: 'CollectFulfillmentChargesResponse';
  /** The amount of funds that can be used to pay an invoice. */
  accountFundsToUse: Money;
  /** The amount that left to pay. Takes pending payments into account. */
  balanceDue: Money;
  /** The payment methods fees */
  paymentMethodsFees: Array<Maybe<CollectInvoicePaymentMethodFee>>;
  /** The amount that left to pay with potential credit card fee. Takes pending payments into account. */
  potentialBalanceDueWithCreditCardFee: Money;
  /** Potential fee that will be applied if the user pays with a credit card, Apple Pay or Google Pay. */
  potentialCreditCardFee: Money;
  /** Total amount of the invoice with a potential Credit Card, Apple Pay or Google Pay fee. */
  potentialTotalWithCreditCardFee: Money;
  /** Shipping cost. */
  shipping: Money;
  /** Tax amount. */
  tax: Money;
  taxExempt: Scalars['Boolean']['output'];
  /** Total amount of the invoice without a potential Credit Card, Apple Pay or Google Pay fee. */
  total: Money;
};

export type CollectGoogleResult = {
  __typename?: 'CollectGoogleResult';
  link?: Maybe<Scalars['String']['output']>;
  snippet?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Grader of a card */
export type CollectGrader = {
  __typename?: 'CollectGrader';
  /** Ordered list of possible grades */
  grades: Array<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** SVG logo */
  logo: Scalars['String']['output'];
  /** Name of the grader. Example: PSA */
  name: Scalars['String']['output'];
};

export type CollectGradingService = {
  __typename?: 'CollectGradingService';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CollectGradingServices = {
  __typename?: 'CollectGradingServices';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** The allowed file types for image uploads */
export enum CollectImageFileType {
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Png = 'PNG'
}

export type CollectImageMetadata = {
  __typename?: 'CollectImageMetadata';
  height?: Maybe<Scalars['Int']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type CollectImageSet = {
  __typename?: 'CollectImageSet';
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type CollectInvoice = {
  __typename?: 'CollectInvoice';
  allowedPaymentMethods?: Maybe<Array<Maybe<CollectValidPaymentMethod>>>;
  /** The paid invoice amount. */
  amountPaid?: Maybe<Money>;
  /** The oustanding invoice amount. */
  amountPaidOutstanding?: Maybe<Money>;
  /** The business category for an Invoice (marketplace | vault | capital). */
  businessCategory?: Maybe<CollectInvoiceBusinessCategory>;
  /** The Buyers Premium field (purchase price + 20%). */
  buyersPremium?: Maybe<Money>;
  cart?: Maybe<CollectInvoiceCart>;
  createdBy?: Maybe<CollectInvoiceCreatedByEntity>;
  /** The date by which an invoice should be paid. */
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  integerId: Scalars['Int']['output'];
  /**
   * The invoice category for an Invoice
   *       (marketplace | vault | capital | weekly | premier | fixed_price | manual).
   */
  invoiceCategory?: Maybe<CollectInvoiceCategory>;
  /** The date an invoice was created. */
  invoiceDate?: Maybe<Scalars['DateTime']['output']>;
  /** The list of items invoice includes. */
  lineItems?: Maybe<Array<Maybe<CollectLineItem>>>;
  /** The date an invoice was paid. */
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  /** The list of Invoice Payment Attempts. */
  paymentAttempts?: Maybe<Array<Maybe<CollectPaymentAttemptData>>>;
  /** The payment fees amount applied to payment, such as Credit Card Fee. */
  paymentFees: Money;
  /** The number of days to pay an invoice. */
  paymentTermDays: Scalars['Int']['output'];
  /** The list of invoice payments. */
  payments?: Maybe<Array<Maybe<CollectPayment>>>;
  /** The list of invoice pending payments. */
  pendingPayments?: Maybe<Array<Maybe<CollectPayment>>>;
  sales?: Maybe<Array<Maybe<CollectMarketplaceSale>>>;
  /** The cost of shipping of purchased items. */
  shipping: Money;
  /** The Invoice Shipping Address. */
  shippingAddress?: Maybe<CollectShippingAddress>;
  /** The Invoice Shipping Type. */
  shippingType?: Maybe<CollectShippingType>;
  status: CollectInvoiceStatus;
  /** The sum of items price, shipping, tax and fees. */
  subTotal: Money;
  /** The total amount of tax applied to an invoice. */
  tax: Money;
  /** The total amount of an invoice. */
  total: Money;
  type: CollectInvoiceType;
  wireInfo: CollectInvoiceWireInfo;
};

export enum CollectInvoiceBusinessCategory {
  Capital = 'capital',
  Marketplace = 'marketplace',
  Vault = 'vault'
}

export type CollectInvoiceCart = {
  __typename?: 'CollectInvoiceCart';
  id: Scalars['UUID']['output'];
  integerId: Scalars['Int']['output'];
  status?: Maybe<CollectCartStatus>;
};

export enum CollectInvoiceCategory {
  Capital = 'capital',
  FixedPrice = 'fixed_price',
  Manual = 'manual',
  Marketplace = 'marketplace',
  Premier = 'premier',
  Vault = 'vault',
  Weekly = 'weekly'
}

export type CollectInvoiceConnection = {
  __typename?: 'CollectInvoiceConnection';
  edges?: Maybe<Array<Maybe<CollectInvoiceEdge>>>;
  pageInfo: PageInfo;
};

export type CollectInvoiceCreatedByEntity = CollectFixedPriceSale | CollectPremierSale | CollectVaultItemRequest | CollectVaultSubmission | CollectWeeklySale;

export type CollectInvoiceEdge = {
  __typename?: 'CollectInvoiceEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectInvoice>;
};

export type CollectInvoiceInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  integerId?: InputMaybe<Scalars['Int']['input']>;
};

/** Invoice Payment Attempt data object. */
export type CollectInvoicePaymentAttemptData = {
  __typename?: 'CollectInvoicePaymentAttemptData';
  authorizationId?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  payerEmail?: Maybe<Scalars['String']['output']>;
  payerFirstName?: Maybe<Scalars['String']['output']>;
  payerLastName?: Maybe<Scalars['String']['output']>;
  processorResponseCode?: Maybe<Scalars['String']['output']>;
  processorResponseText?: Maybe<Scalars['String']['output']>;
  processorResponseType?: Maybe<Scalars['String']['output']>;
  transactionFeeAmount?: Maybe<Scalars['String']['output']>;
};

/** Payment Fee data */
export type CollectInvoicePaymentMethodFee = {
  __typename?: 'CollectInvoicePaymentMethodFee';
  balanceDueWithFee: Money;
  fee: Money;
  feeRate: Scalars['Float']['output'];
  paymentMethod: CollectValidPaymentMethod;
  totalWithFee: Money;
};

export enum CollectInvoicePaymentStatuses {
  StatusCurrent = 'STATUS_CURRENT',
  StatusPaid = 'STATUS_PAID',
  StatusUnpaid = 'STATUS_UNPAID'
}

export enum CollectInvoicePaymentTypes {
  PaymentTypeCard = 'PAYMENT_TYPE_CARD',
  PaymentTypeUsBankAccount = 'PAYMENT_TYPE_US_BANK_ACCOUNT'
}

export enum CollectInvoiceStatus {
  StatusBuyerDefaulted = 'STATUS_BUYER_DEFAULTED',
  StatusDraft = 'STATUS_DRAFT',
  StatusPaid = 'STATUS_PAID',
  StatusPartiallyPaid = 'STATUS_PARTIALLY_PAID',
  StatusPaymentPending = 'STATUS_PAYMENT_PENDING',
  StatusSent = 'STATUS_SENT',
  StatusTimedOut = 'STATUS_TIMED_OUT',
  StatusViewed = 'STATUS_VIEWED',
  StatusVoided = 'STATUS_VOIDED'
}

export enum CollectInvoiceType {
  TypeAuctionSale = 'TYPE_AUCTION_SALE',
  TypeCapitalNote = 'TYPE_CAPITAL_NOTE',
  TypeCashAdvance = 'TYPE_CASH_ADVANCE',
  TypeDeferredCheckoutFees = 'TYPE_DEFERRED_CHECKOUT_FEES',
  TypeDeferredVaultFees = 'TYPE_DEFERRED_VAULT_FEES',
  TypeExtendedSale = 'TYPE_EXTENDED_SALE',
  TypeGradingFees = 'TYPE_GRADING_FEES',
  TypeInboundShippingLabel = 'TYPE_INBOUND_SHIPPING_LABEL',
  TypeManual = 'TYPE_MANUAL',
  TypeVaultFees = 'TYPE_VAULT_FEES',
  TypeVaultItemRequest = 'TYPE_VAULT_ITEM_REQUEST',
  TypeVaultPortfolioLoan = 'TYPE_VAULT_PORTFOLIO_LOAN',
  TypeVaultPortfolioLoanInterest = 'TYPE_VAULT_PORTFOLIO_LOAN_INTEREST',
  TypeVaultSale = 'TYPE_VAULT_SALE'
}

export type CollectInvoiceWireInfo = {
  __typename?: 'CollectInvoiceWireInfo';
  accountNumber: Scalars['String']['output'];
  achRouting: Scalars['String']['output'];
  bankAddressBusinessName: Scalars['String']['output'];
  bankAddressCity: Scalars['String']['output'];
  bankAddressName: Scalars['String']['output'];
  bankAddressState: Scalars['String']['output'];
  bankAddressStreet1: Scalars['String']['output'];
  bankAddressZipcode: Scalars['String']['output'];
  recipientAddress: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  routing: Scalars['String']['output'];
  swiftCode: Scalars['String']['output'];
};

/** Card or any other item which is owned by some user */
export type CollectItem = CollectDetailed & {
  __typename?: 'CollectItem';
  debugMetadata?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  grader?: Maybe<CollectGrader>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isCandidate: Scalars['Boolean']['output'];
  marketValue?: Maybe<Money>;
  metadata?: Maybe<CollectProductMetadata>;
  myPrice: Money;
  notes?: Maybe<Scalars['String']['output']>;
  owner: CollectPublicUser;
  purchasePrice?: Maybe<Money>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  userPrice?: Maybe<Money>;
  variant?: Maybe<CollectVariant>;
};

/** A list of fields which can be updated in an item */
export type CollectItemChanges = {
  grade?: InputMaybe<Scalars['String']['input']>;
  graderId?: InputMaybe<Scalars['UUID']['input']>;
  marketValueInCents?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  purchasePriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectItemConnection = {
  __typename?: 'CollectItemConnection';
  edges?: Maybe<Array<Maybe<CollectItemEdge>>>;
  pageInfo: PageInfo;
};

export type CollectItemEdge = {
  __typename?: 'CollectItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectItem>;
};

/** Item Edit Request fields */
export type CollectItemEditRequest = {
  __typename?: 'CollectItemEditRequest';
  /** The Item Edit Request entity id */
  entityId: Scalars['Int']['output'];
  /** The Item Edit Request entity type */
  entityType: CollectItemEditRequestEntityTypes;
  /** The Item Edit Request integer id */
  id: Scalars['Int']['output'];
  /** Inserted timestamp */
  insertedAt: Scalars['DateTime']['output'];
  /** The Item Edit Request priority id (low, standard, high) */
  itemEditRequestPriorityId: CollectItemEditRequestPriority;
  /** The attendant notes */
  notes?: Maybe<Scalars['String']['output']>;
  /** The new requested item title */
  propertyEdit: Scalars['String']['output'];
  /** The original title */
  propertyOriginal: Scalars['String']['output'];
  /** The Reply for the Request, initially is nil */
  reply?: Maybe<Scalars['String']['output']>;
  /** The Item Edit Request status */
  status: CollectItemEditRequestStatus;
  /** The Item Edit Request type */
  type: CollectItemEditRequestTypes;
  /** Updated timestamp */
  updatedAt: Scalars['DateTime']['output'];
  /** The item owner user id */
  userId: Scalars['Int']['output'];
};

export type CollectItemEditRequestConnection = {
  __typename?: 'CollectItemEditRequestConnection';
  edges?: Maybe<Array<Maybe<CollectItemEditRequestEdge>>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type CollectItemEditRequestEdge = {
  __typename?: 'CollectItemEditRequestEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectItemEditRequest>;
};

/** Entity types of Items Edit Requests */
export enum CollectItemEditRequestEntityTypes {
  EntityTypeItem = 'ENTITY_TYPE_ITEM',
  EntityTypeVaultItem = 'ENTITY_TYPE_VAULT_ITEM'
}

/** Priorities of Items Edit Requests */
export enum CollectItemEditRequestPriority {
  PriorityHigh = 'PRIORITY_HIGH',
  PriorityLow = 'PRIORITY_LOW',
  PriorityStandard = 'PRIORITY_STANDARD'
}

/** Statuses of Items Edit Requests */
export enum CollectItemEditRequestStatus {
  StatusAccepted = 'STATUS_ACCEPTED',
  StatusPending = 'STATUS_PENDING',
  StatusRejected = 'STATUS_REJECTED'
}

/** Types of Items Edit Requests */
export enum CollectItemEditRequestTypes {
  TypeAuctionTitle = 'TYPE_AUCTION_TITLE',
  TypeVaultTitle = 'TYPE_VAULT_TITLE'
}

export type CollectItemInput = {
  candidateImages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  candidateTitle: Scalars['String']['input'];
  grade?: InputMaybe<Scalars['String']['input']>;
  graderId?: InputMaybe<Scalars['UUID']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  isCandidate?: InputMaybe<Scalars['Boolean']['input']>;
  marketValueInCents?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<CollectItemMetadataInput>;
  notes?: InputMaybe<Scalars['String']['input']>;
  purchasePriceInCents?: InputMaybe<Scalars['Int']['input']>;
  scanRequestId?: InputMaybe<Scalars['UUID']['input']>;
  userPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  variantId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Match status for adding to collection */
export enum CollectItemMatchStatus {
  Match = 'MATCH',
  MatchEdited = 'MATCH_EDITED',
  NoMatch = 'NO_MATCH'
}

export type CollectItemMetadataInput = {
  barcode?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  graderService?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  odds?: InputMaybe<Scalars['String']['input']>;
  parallel?: InputMaybe<Scalars['String']['input']>;
  patch?: InputMaybe<Scalars['String']['input']>;
  populationHigher?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<Scalars['String']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  set?: InputMaybe<Scalars['String']['input']>;
  signatures?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subset?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  totalPopulation?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type CollectItemOrProductOrListingOrVariant = CollectItem | CollectListing | CollectProduct | CollectVariant;

export type CollectItemOrProductOrListingOrVariantConnection = {
  __typename?: 'CollectItemOrProductOrListingOrVariantConnection';
  availableFacets?: Maybe<Array<Maybe<CollectFilterOption>>>;
  edges?: Maybe<Array<Maybe<CollectItemOrProductOrListingOrVariantEdge>>>;
  pageInfo: PageInfo;
  totalHits?: Maybe<Scalars['Int']['output']>;
};

export type CollectItemOrProductOrListingOrVariantEdge = {
  __typename?: 'CollectItemOrProductOrListingOrVariantEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectItemOrProductOrListingOrVariant>;
};

export type CollectItemResponse = {
  __typename?: 'CollectItemResponse';
  collectItem?: Maybe<CollectItem>;
};

export type CollectItemResponsePayload = {
  __typename?: 'CollectItemResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectItemResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export enum CollectKycStatus {
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PendingReview = 'PENDING_REVIEW',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

/** The item an invoice includes. */
export type CollectLineItem = {
  __typename?: 'CollectLineItem';
  amount: Money;
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Not affected by faster listing query optimization */
  listing?: Maybe<CollectListing>;
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * Marketplace auction listing.
 * It resolved by two different queries depending on the data you query.
 * To use the fast query, select only fields which are marked as `fast`.
 *
 * Relation fields (like variant or auction) are considered `fast`, but
 * they're slowing down the query, so please make sure that your queries
 * are granular.
 */
export type CollectListing = CollectDetailed & {
  __typename?: 'CollectListing';
  /** Identifies whether a vault listing is added to a cart */
  addedToCart?: Maybe<Scalars['Boolean']['output']>;
  /** Whether offers are allowed for specified listing. Fast field */
  allowOffers: Scalars['Boolean']['output'];
  /** Asking price of the fixed price listing. Fast field */
  askingPrice?: Maybe<Money>;
  auction?: Maybe<CollectAuction>;
  /** Amount of bids made on this listing. Fast field */
  bidCount?: Maybe<Scalars['Int']['output']>;
  /** Buy now price. Fast field */
  buyNowPrice?: Maybe<Money>;
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardLadderInfo?: Maybe<CollectListingCardLadderInfo>;
  certifiedSeller?: Maybe<Scalars['String']['output']>;
  collectSales?: Maybe<Array<Maybe<CollectSale>>>;
  /** Current bid of the weekly/premier listing. Fast field */
  currentBid?: Maybe<Money>;
  /** The deal tier of the listing (for backoffice listings) */
  dealTier?: Maybe<CollectBoListingDealTier>;
  debugMetadata?: Maybe<Scalars['String']['output']>;
  /** Decline price for fixed price listings. Fast field */
  declinePrice?: Maybe<Money>;
  /** Default item description in current weekly auction. Always NULL for premier and fixed_price */
  defaultItemDescription?: Maybe<Scalars['String']['output']>;
  /** Description of the listing. Fast field. */
  description?: Maybe<Scalars['String']['output']>;
  /** Count of users who have this item in their favorites. Fast field */
  favoritedCount?: Maybe<Scalars['Int']['output']>;
  folders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The guide price of the listing (for backoffice listings) */
  guidePrice?: Maybe<CollectBoListingGuidePrice>;
  highestBidder: Scalars['Boolean']['output'];
  /** UUID of the listing. Fast field */
  id: Scalars['UUID']['output'];
  imageSets: Array<Maybe<CollectImageSet>>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  incomingOffers?: Maybe<Array<Maybe<CollectFixedPriceListingOfferWithHistoryInterface>>>;
  /** Timestamp of insertion of the listing. Fast field */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  integerId?: Maybe<Scalars['Int']['output']>;
  isFlash: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  /** Indicates if this is a single quantity listing (Fanatics Collect or one-off inventory) */
  isSingleQuantityListing?: Maybe<Scalars['Boolean']['output']>;
  /** The date when the listing was listed (for backoffice listings) */
  listedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The sales history data used on the PDP page for the target listing */
  listingSalesHistory?: Maybe<Array<Maybe<CollectSale>>>;
  /** Type of the listing. Fast field */
  listingType: CollectListingType;
  /** Lot number of the listing. Fast field. */
  lotNo?: Maybe<Scalars['Int']['output']>;
  lotString?: Maybe<Scalars['String']['output']>;
  /** Lot subnumber of the listing. Fast field. */
  lotSubNo?: Maybe<Scalars['Int']['output']>;
  marketplaceEyeAppeal?: Maybe<Scalars['String']['output']>;
  /**
   * Minimum allowed offer for the listing.
   * This is null if offers are not allowed for this listing.
   * Fast field.
   */
  minimumAllowedOffer?: Maybe<Money>;
  moreFromTheBrandListings?: Maybe<Array<Maybe<CollectListing>>>;
  moreFromTheSellerListings?: Maybe<Array<Maybe<CollectListing>>>;
  myOffer?: Maybe<CollectFixedPriceListingOfferWithHistoryInterface>;
  /** If offers are allowed, the number of offers for the listing (for backoffice listings) */
  numOffers?: Maybe<Scalars['Int']['output']>;
  offerLimits?: Maybe<CollectOfferLimits>;
  offerRecommendedPrice?: Maybe<Money>;
  ownerId: Scalars['UUID']['output'];
  paymentDetails?: Maybe<CollectListingPaymentDetails>;
  /** The status of the invoice payment for the listing (for sold listings: Weekly, Premier, Fixed Price, and Back Office) */
  paymentStatus?: Maybe<CollectBoPaymentStatus>;
  /** The status of the seller payout (for backoffice sold listings) */
  payoutStatus?: Maybe<CollectBoSellerPayoutStatus>;
  pendingOffer?: Maybe<CollectListingPendingOffer>;
  /** The previous asking price of the fixed price listing. Fast field */
  previousAskingPrice?: Maybe<Money>;
  /** AI-generated product detail page for the listing. Fast field. */
  productDetail?: Maybe<Scalars['String']['output']>;
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  /** Returns quantity of added to a cart for an item */
  quantityInCart?: Maybe<Scalars['Int']['output']>;
  quickOffers?: Maybe<Array<Maybe<CollectQuickOffer>>>;
  relatedListings?: Maybe<Array<Maybe<CollectListing>>>;
  relatedListingsSearchTerm?: Maybe<Scalars['String']['output']>;
  /** The sale price of the listing (for backoffice sold listings) */
  salePrice?: Maybe<Money>;
  /** The basis points of the seller fee (for backoffice sold listings) */
  sellerFeeBasisPoints?: Maybe<BasisPoints>;
  /** Net amount the seller receives for a sold listing (if applicable). */
  sellerNet?: Maybe<Money>;
  /** The shop id of the listing. Fast field */
  shopId?: Maybe<Scalars['UUID']['output']>;
  /** Unique slug of the listing. Fast field */
  slug?: Maybe<Scalars['String']['output']>;
  /** The date when the listing was sold (for backoffice sold listings) */
  soldAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The date a listing was sold.
   * @deprecated Use `collectSales.soldDate` instead
   */
  soldDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use `collectSales.soldFor` instead */
  soldFor?: Maybe<Money>;
  /** Starting price of the listing. Fast field */
  startingPrice?: Maybe<Money>;
  /** Listing states based on user context. Fast field */
  states?: Maybe<CollectListingStates>;
  /** Listing status. Fast field. */
  status?: Maybe<CollectListingStatus>;
  subtitle?: Maybe<Scalars['String']['output']>;
  suggestedMinimumOfferValue?: Maybe<Money>;
  title: Scalars['String']['output'];
  /** Timestamp of last update of the listing. Fast field */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Variant this listing is representing. */
  variant?: Maybe<CollectVariant>;
  /** Vault item this listing is representing. */
  vaultItem: CollectVaultItem;
};


/**
 * Marketplace auction listing.
 * It resolved by two different queries depending on the data you query.
 * To use the fast query, select only fields which are marked as `fast`.
 *
 * Relation fields (like variant or auction) are considered `fast`, but
 * they're slowing down the query, so please make sure that your queries
 * are granular.
 */
export type CollectListingIncomingOffersArgs = {
  offerStatus?: InputMaybe<Array<InputMaybe<CollectOfferStatusFilter>>>;
};


/**
 * Marketplace auction listing.
 * It resolved by two different queries depending on the data you query.
 * To use the fast query, select only fields which are marked as `fast`.
 *
 * Relation fields (like variant or auction) are considered `fast`, but
 * they're slowing down the query, so please make sure that your queries
 * are granular.
 */
export type CollectListingMoreFromTheBrandListingsArgs = {
  itemTypes?: InputMaybe<Array<InputMaybe<CollectRecentlyViewedItemType>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Marketplace auction listing.
 * It resolved by two different queries depending on the data you query.
 * To use the fast query, select only fields which are marked as `fast`.
 *
 * Relation fields (like variant or auction) are considered `fast`, but
 * they're slowing down the query, so please make sure that your queries
 * are granular.
 */
export type CollectListingMoreFromTheSellerListingsArgs = {
  itemTypes?: InputMaybe<Array<InputMaybe<CollectRecentlyViewedItemType>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Marketplace auction listing.
 * It resolved by two different queries depending on the data you query.
 * To use the fast query, select only fields which are marked as `fast`.
 *
 * Relation fields (like variant or auction) are considered `fast`, but
 * they're slowing down the query, so please make sure that your queries
 * are granular.
 */
export type CollectListingRelatedListingsArgs = {
  itemTypes?: InputMaybe<Array<InputMaybe<CollectRecentlyViewedItemType>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectListingCardLadderInfo = {
  __typename?: 'CollectListingCardLadderInfo';
  confidenceValue?: Maybe<Scalars['Int']['output']>;
  estimatedRange: CollectListingCardLadderRange;
  estimatedValue: Money;
  searchUrl?: Maybe<Scalars['String']['output']>;
};

export type CollectListingCardLadderRange = {
  __typename?: 'CollectListingCardLadderRange';
  max: Money;
  min: Money;
};

export type CollectListingConnection = {
  __typename?: 'CollectListingConnection';
  edges?: Maybe<Array<Maybe<CollectListingEdge>>>;
  pageInfo: PageInfo;
};

/** Smaller version of collectListing object. Please prefer refetching the listing if you want all fields */
export type CollectListingDelta = {
  __typename?: 'CollectListingDelta';
  allowBidding?: Maybe<Scalars['Boolean']['output']>;
  askingPrice?: Maybe<Money>;
  bidCount?: Maybe<Scalars['Int']['output']>;
  currentBid?: Maybe<Money>;
  favoritedCount?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  isGreatPrice?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CollectListingEdge = {
  __typename?: 'CollectListingEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectListing>;
};

export type CollectListingFilterOpts = {
  facetFilters?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  similarQuery?: InputMaybe<Scalars['String']['input']>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectListingFilters = {
  auctionScheduleIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  listingTypes?: InputMaybe<Array<InputMaybe<CollectListingType>>>;
};

/** Represents a folder of listings */
export type CollectListingFolder = {
  __typename?: 'CollectListingFolder';
  /** The ID of the folder */
  id: Scalars['UUID']['output'];
  /** The name of the folder */
  name: Scalars['String']['output'];
};

export type CollectListingFolderConnection = {
  __typename?: 'CollectListingFolderConnection';
  edges: Array<CollectListingFolderEdge>;
  pageNumber: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type CollectListingFolderEdge = {
  __typename?: 'CollectListingFolderEdge';
  node: CollectListingFolder;
};

export type CollectListingIdInput = {
  /** Listing ID */
  id: Scalars['UUID']['input'];
  /** Type of the listing */
  type: CollectListingType;
};

export type CollectListingIntegerIdInput = {
  id: Scalars['Int']['input'];
  type: CollectListingType;
};

export enum CollectListingOffersSortBy {
  Activity = 'ACTIVITY',
  Expiring = 'EXPIRING',
  /** Oldest listing first (for Scheduled Actions) */
  ListingCreatedAsc = 'LISTING_CREATED_ASC',
  /** Newest listing first */
  ListingCreatedDesc = 'LISTING_CREATED_DESC',
  OfferHigh = 'OFFER_HIGH',
  OfferLow = 'OFFER_LOW'
}

export type CollectListingPaymentDetails = {
  __typename?: 'CollectListingPaymentDetails';
  invoice?: Maybe<CollectInvoice>;
  invoiceId?: Maybe<Scalars['UUID']['output']>;
  paymentDueDate?: Maybe<Scalars['DateTime']['output']>;
};

export type CollectListingPendingOffer = {
  __typename?: 'CollectListingPendingOffer';
  hasPending?: Maybe<Scalars['Boolean']['output']>;
  maxAmountInCents?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type CollectListingPricesRangeFilter = {
  maxPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  minPriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

export enum CollectListingSorting {
  BestValue = 'BEST_VALUE',
  ConfidenceValueGuidePrice = 'CONFIDENCE_VALUE_GUIDE_PRICE',
  EarliestBid = 'EARLIEST_BID',
  EarliestSaleDate = 'EARLIEST_SALE_DATE',
  EarliestYear = 'EARLIEST_YEAR',
  Favorites = 'FAVORITES',
  Featured = 'FEATURED',
  HighestPrice = 'HIGHEST_PRICE',
  LatestBid = 'LATEST_BID',
  LatestSaleDate = 'LATEST_SALE_DATE',
  LatestYear = 'LATEST_YEAR',
  LowestPrice = 'LOWEST_PRICE',
  OffersPending = 'OFFERS_PENDING',
  RecentlyAdded = 'RECENTLY_ADDED',
  SoonestAuctionLatestBid = 'SOONEST_AUCTION_LATEST_BID'
}

/**
 * The state is checked against the user identity and the listing state.
 *   For unauthed request, it will return the original listing state.
 */
export type CollectListingStates = {
  __typename?: 'CollectListingStates';
  isClosed?: Maybe<Scalars['Boolean']['output']>;
  isFanaticsAuthentic?: Maybe<Scalars['Boolean']['output']>;
  isGreatPrice?: Maybe<Scalars['Boolean']['output']>;
  isWatching?: Maybe<Scalars['Boolean']['output']>;
  lastWindowWhenBidWasReceived?: Maybe<Scalars['Int']['output']>;
  userBidStatus?: Maybe<CollectUserBidState>;
  userCanBuy?: Maybe<Scalars['Boolean']['output']>;
  userMaxBid?: Maybe<Money>;
};

export enum CollectListingStatus {
  BoStatusCancelled = 'BO_STATUS_CANCELLED',
  BoStatusListed = 'BO_STATUS_LISTED',
  BoStatusSold = 'BO_STATUS_SOLD',
  BoStatusSoldOut = 'BO_STATUS_SOLD_OUT',
  BoStatusUnpublished = 'BO_STATUS_UNPUBLISHED',
  FixedPriceStatusBuyerDefaulted = 'FIXED_PRICE_STATUS_BUYER_DEFAULTED',
  FixedPriceStatusListed = 'FIXED_PRICE_STATUS_LISTED',
  FixedPriceStatusPendingSale = 'FIXED_PRICE_STATUS_PENDING_SALE',
  FixedPriceStatusTimedOut = 'FIXED_PRICE_STATUS_TIMED_OUT',
  PremierStatusAwaitingApproval = 'PREMIER_STATUS_AWAITING_APPROVAL',
  PremierStatusAwaitingCuration = 'PREMIER_STATUS_AWAITING_CURATION',
  PremierStatusBuyerDefaulted = 'PREMIER_STATUS_BUYER_DEFAULTED',
  PremierStatusCurated = 'PREMIER_STATUS_CURATED',
  PremierStatusDenied = 'PREMIER_STATUS_DENIED',
  PremierStatusEndedWoSale = 'PREMIER_STATUS_ENDED_WO_SALE',
  PremierStatusInPreview = 'PREMIER_STATUS_IN_PREVIEW',
  PremierStatusLive = 'PREMIER_STATUS_LIVE',
  PremierStatusReviewed = 'PREMIER_STATUS_REVIEWED',
  StatusCancelled = 'STATUS_CANCELLED',
  StatusSold = 'STATUS_SOLD',
  StatusUnknown = 'STATUS_UNKNOWN',
  WeeklyStatusAdminEnded = 'WEEKLY_STATUS_ADMIN_ENDED',
  WeeklyStatusClosed = 'WEEKLY_STATUS_CLOSED',
  WeeklyStatusCurating = 'WEEKLY_STATUS_CURATING',
  WeeklyStatusEndedWoSale = 'WEEKLY_STATUS_ENDED_WO_SALE',
  WeeklyStatusFinalReview = 'WEEKLY_STATUS_FINAL_REVIEW',
  WeeklyStatusListed = 'WEEKLY_STATUS_LISTED',
  WeeklyStatusPendingVaultFulfillment = 'WEEKLY_STATUS_PENDING_VAULT_FULFILLMENT',
  WeeklyStatusReviewed = 'WEEKLY_STATUS_REVIEWED',
  WeeklyStatusScheduling = 'WEEKLY_STATUS_SCHEDULING'
}

export enum CollectListingStatusFilter {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Preview = 'PREVIEW',
  Sold = 'SOLD',
  Unsold = 'UNSOLD'
}

export type CollectListingTimer = {
  __typename?: 'CollectListingTimer';
  asOf?: Maybe<Scalars['DateTime']['output']>;
  auctionEndsAt?: Maybe<Scalars['DateTime']['output']>;
  auctionStartsAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use timestamps please */
  secondsUntilAuctionEnds?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use timestamps please */
  secondsUntilAuctionStart?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use timestamps please */
  secondsUntilExtednedBiddingEnds?: Maybe<Scalars['Int']['output']>;
  windowDurationSeconds?: Maybe<Scalars['Int']['output']>;
  windowEndsAt?: Maybe<Scalars['DateTime']['output']>;
  windowOrdinal?: Maybe<Scalars['Int']['output']>;
};

export enum CollectListingType {
  Bo = 'BO',
  FixedPrice = 'FIXED_PRICE',
  Premier = 'PREMIER',
  Weekly = 'WEEKLY'
}

export type CollectListingYearsRangeFilter = {
  maxYear?: InputMaybe<Scalars['Int']['input']>;
  minYear?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectListingsConnection = {
  __typename?: 'CollectListingsConnection';
  edges?: Maybe<Array<Maybe<CollectListingsEdge>>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type CollectListingsEdge = {
  __typename?: 'CollectListingsEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectListing>;
};

export type CollectMakeOfferInput = {
  listingId: Scalars['UUID']['input'];
  listingType?: InputMaybe<CollectListingType>;
  offerInCents: Scalars['Int']['input'];
  sendChatMessage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CollectMarkOfferAsViewedInput = {
  offerId: Scalars['UUID']['input'];
};

export type CollectMarkOfferAsViewedPayload = {
  __typename?: 'CollectMarkOfferAsViewedPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['String']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectMarkOfferNotificationAsViewedInput = {
  listingType?: InputMaybe<CollectListingType>;
  offerIds: Array<Scalars['UUID']['input']>;
  offerType?: InputMaybe<CollectOfferTypeNotification>;
};

export type CollectMarkOfferNotificationAsViewedPayload = {
  __typename?: 'CollectMarkOfferNotificationAsViewedPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['String']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectMarketplaceAuthResult = {
  __typename?: 'CollectMarketplaceAuthResult';
  accessExpirationSecs: Scalars['Int']['output'];
  accessToken: Scalars['String']['output'];
  nonce: Scalars['String']['output'];
  refreshExpirationSecs: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
};

export enum CollectMarketplaceEventType {
  Premier = 'PREMIER',
  Weekly = 'WEEKLY'
}

export type CollectMarketplaceSale = {
  buyersPremium?: Maybe<Money>;
  id: Scalars['UUID']['output'];
  integerId: Scalars['Int']['output'];
  listing?: Maybe<CollectListing>;
  purchasePrice?: Maybe<Money>;
  shipping?: Maybe<Money>;
  tax?: Maybe<Money>;
  total?: Maybe<Money>;
};

/** Match level for search results */
export enum CollectMatchLevel {
  Match = 'MATCH',
  Possible = 'POSSIBLE',
  Prediction = 'PREDICTION',
  Similar = 'SIMILAR'
}

export enum CollectMemberCheckoutAddressType {
  Alternate = 'ALTERNATE',
  Default = 'DEFAULT'
}

export enum CollectMfaChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type CollectMonolithicSearchAuctionOption = {
  __typename?: 'CollectMonolithicSearchAuctionOption';
  auctionId: Scalars['UUID']['output'];
  auctionStatus: CollectAuctionStatus;
  displayName: Scalars['String']['output'];
};

export type CollectMonolithicSearchCategoryFilter = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  categoryType?: InputMaybe<CollectCategoryType>;
  tagName?: InputMaybe<Scalars['String']['input']>;
  type: CollectMonolithicSearchCategoryType;
};

export type CollectMonolithicSearchCategoryGroup = {
  __typename?: 'CollectMonolithicSearchCategoryGroup';
  displayName: Scalars['String']['output'];
  value: CollectCategoryType;
};

export type CollectMonolithicSearchCategoryOption = {
  __typename?: 'CollectMonolithicSearchCategoryOption';
  displayName: Scalars['String']['output'];
  group: CollectCategoryType;
  id: CollectMonolithicSearchCategoryOptionId;
  value: Array<CollectMonolithicSearchCategoryOptionValue>;
};

export enum CollectMonolithicSearchCategoryOptionId {
  Baseball = 'BASEBALL',
  Basketball = 'BASKETBALL',
  BoxingMma = 'BOXING_MMA',
  CollectibleCardGames = 'COLLECTIBLE_CARD_GAMES',
  ComicsBronzeAge = 'COMICS_BRONZE_AGE',
  ComicsGoldenAge = 'COMICS_GOLDEN_AGE',
  ComicsModernAge = 'COMICS_MODERN_AGE',
  ComicsPublisherDc = 'COMICS_PUBLISHER_DC',
  ComicsPublisherMarvel = 'COMICS_PUBLISHER_MARVEL',
  ComicsPublisherOther = 'COMICS_PUBLISHER_OTHER',
  ComicsSilverAge = 'COMICS_SILVER_AGE',
  Football = 'FOOTBALL',
  Golf = 'GOLF',
  Hockey = 'HOCKEY',
  MagicTheGathering = 'MAGIC_THE_GATHERING',
  Memorabilia = 'MEMORABILIA',
  MiscSports = 'MISC_SPORTS',
  NonSport = 'NON_SPORT',
  Photos = 'PHOTOS',
  PokemonEnglish = 'POKEMON_ENGLISH',
  PokemonJapanese = 'POKEMON_JAPANESE',
  PokemonOther = 'POKEMON_OTHER',
  Racing = 'RACING',
  Soccer = 'SOCCER',
  Tickets = 'TICKETS',
  VideoGamesAtari = 'VIDEO_GAMES_ATARI',
  VideoGamesMags = 'VIDEO_GAMES_MAGS',
  VideoGamesNintendo = 'VIDEO_GAMES_NINTENDO',
  VideoGamesOther = 'VIDEO_GAMES_OTHER',
  VideoGamesPlaystation = 'VIDEO_GAMES_PLAYSTATION',
  VideoGamesSega = 'VIDEO_GAMES_SEGA',
  VideoGamesXbox = 'VIDEO_GAMES_XBOX',
  Wax = 'WAX',
  YuGiOh = 'YU_GI_OH'
}

export type CollectMonolithicSearchCategoryOptionValue = {
  __typename?: 'CollectMonolithicSearchCategoryOptionValue';
  categoryId?: Maybe<Scalars['Int']['output']>;
  categoryType?: Maybe<CollectCategoryType>;
  tagName?: Maybe<Scalars['String']['output']>;
  type: CollectMonolithicSearchCategoryType;
};

export enum CollectMonolithicSearchCategoryType {
  CategoryId = 'CATEGORY_ID',
  CategoryType = 'CATEGORY_TYPE',
  TagName = 'TAG_NAME'
}

export type CollectMonolithicSearchOptionAuthenticator = {
  __typename?: 'CollectMonolithicSearchOptionAuthenticator';
  displayName: Scalars['String']['output'];
  value: CollectMonolithicSearchSettingAuthenticatorValue;
};

export type CollectMonolithicSearchOptionCollection = {
  __typename?: 'CollectMonolithicSearchOptionCollection';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CollectMonolithicSearchOptions = {
  __typename?: 'CollectMonolithicSearchOptions';
  auctions?: Maybe<Array<CollectMonolithicSearchAuctionOption>>;
  authenticators: Array<CollectMonolithicSearchOptionAuthenticator>;
  categories: Array<CollectMonolithicSearchCategoryOption>;
  categoryGroups: Array<CollectMonolithicSearchCategoryGroup>;
  eyeAppealGrades: Array<CollectMonolithicSearchSettingEyeAppealGrade>;
  featuredCollections: Array<CollectMonolithicSearchOptionCollection>;
};

export type CollectMonolithicSearchPriceRange = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectMonolithicSearchResponse = {
  __typename?: 'CollectMonolithicSearchResponse';
  entries: Array<CollectMonolithicSearchResponseEntry>;
  totalPages: Scalars['Int']['output'];
};

export type CollectMonolithicSearchResponseEntry = {
  __typename?: 'CollectMonolithicSearchResponseEntry';
  listingType: CollectListingType;
  listingUuid: Scalars['UUID']['output'];
};

export enum CollectMonolithicSearchSettingAuthenticatorValue {
  Beckett = 'BECKETT',
  Cgc = 'CGC',
  Csg = 'CSG',
  Mba = 'MBA',
  Ngc = 'NGC',
  Other = 'OTHER',
  Psa = 'PSA',
  Sgc = 'SGC',
  Vga = 'VGA',
  Wata = 'WATA'
}

export enum CollectMonolithicSearchSettingEyeAppealGrade {
  AboveAverage = 'ABOVE_AVERAGE',
  Exceptional = 'EXCEPTIONAL',
  None = 'NONE',
  Superior = 'SUPERIOR'
}

export type CollectMonolithicSearchYearRange = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

/** Multi bid request */
export type CollectMultiBidRequest = {
  auctionType: CollectAuctionType;
  bidRequests?: InputMaybe<Array<InputMaybe<CollectBigSingle>>>;
};

export type CollectOfferData = {
  __typename?: 'CollectOfferData';
  listingId?: Maybe<Scalars['UUID']['output']>;
  listingTitle?: Maybe<Scalars['String']['output']>;
  listingType?: Maybe<CollectListingType>;
  offerId?: Maybe<Scalars['UUID']['output']>;
  showNotification?: Maybe<Scalars['Boolean']['output']>;
};

export enum CollectOfferKind {
  Buying = 'BUYING',
  Selling = 'SELLING'
}

export type CollectOfferLimits = {
  __typename?: 'CollectOfferLimits';
  max: Money;
  min: Money;
};

export type CollectOfferMessage = {
  __typename?: 'CollectOfferMessage';
  listingId?: Maybe<Scalars['UUID']['output']>;
  listingTitle?: Maybe<Scalars['String']['output']>;
  listingType?: Maybe<CollectVaultListingType>;
  offerId?: Maybe<Scalars['UUID']['output']>;
};

export type CollectOfferRoom = {
  __typename?: 'CollectOfferRoom';
  room?: Maybe<Scalars['String']['output']>;
};

export enum CollectOfferStatusFilter {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Declined = 'DECLINED',
  Expired = 'EXPIRED'
}

export enum CollectOfferTypeNotification {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED'
}

export type CollectOptionValue = {
  __typename?: 'CollectOptionValue';
  count?: Maybe<Scalars['Int']['output']>;
  displayName: Scalars['String']['output'];
};

export type CollectOwnershipTransferSummary = {
  __typename?: 'CollectOwnershipTransferSummary';
  needsUnderwriting: Scalars['Boolean']['output'];
};

/** Represents a parallel variation of a sports card. */
export type CollectParallel = {
  __typename?: 'CollectParallel';
  /** Parallel ID. */
  id: Scalars['UUID']['output'];
  /** Parallel name. */
  name: Scalars['String']['output'];
  /** Print run (e.g., '/125'). */
  serialCount?: Maybe<Scalars['String']['output']>;
};

/** The payment for invoice. */
export type CollectPayment = {
  __typename?: 'CollectPayment';
  amount: Money;
  date?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  paymentMethod?: Maybe<CollectPaymentType>;
};

/** The payment attempt data for invoice. */
export type CollectPaymentAttempt = {
  __typename?: 'CollectPaymentAttempt';
  data?: Maybe<CollectInvoicePaymentAttemptData>;
  externalKey?: Maybe<Scalars['String']['output']>;
  fundsDisbursed: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  invoiceId: Scalars['Int']['output'];
  merchantAccountKey?: Maybe<Scalars['String']['output']>;
  paymentProcessorId: Scalars['Int']['output'];
  paymentTypeId: Scalars['Int']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

/** Payment Attempt data object. */
export type CollectPaymentAttemptData = {
  __typename?: 'CollectPaymentAttemptData';
  bankName?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<CollectValidPaymentMethod>;
  pending: Scalars['Boolean']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type CollectPaymentMethod = {
  id: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
};

export type CollectPaymentMethodBank = CollectPaymentMethod & {
  __typename?: 'CollectPaymentMethodBank';
  bank?: Maybe<CollectPaymentMethodBankDetails>;
  id: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
};

export type CollectPaymentMethodBankDetails = {
  __typename?: 'CollectPaymentMethodBankDetails';
  lastFour: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CollectPaymentMethodCard = CollectPaymentMethod & {
  __typename?: 'CollectPaymentMethodCard';
  card?: Maybe<CollectPaymentMethodCardDetails>;
  id: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
};

export type CollectPaymentMethodCardDetails = {
  __typename?: 'CollectPaymentMethodCardDetails';
  brand: Scalars['String']['output'];
  expirationMonth: Scalars['Int']['output'];
  expirationYear: Scalars['Int']['output'];
  lastFour: Scalars['String']['output'];
};

export type CollectPaymentMethodOther = CollectPaymentMethod & {
  __typename?: 'CollectPaymentMethodOther';
  id: Scalars['String']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
};

export enum CollectPaymentType {
  Ach = 'ACH',
  ApplePay = 'APPLE_PAY',
  Card = 'CARD',
  Check = 'CHECK',
  Crypto = 'CRYPTO',
  Fancash = 'FANCASH',
  Funds = 'FUNDS',
  GooglePay = 'GOOGLE_PAY',
  Other = 'OTHER',
  Rewards = 'REWARDS',
  Wire = 'WIRE'
}

export enum CollectPayoutMethod {
  Ach = 'ACH',
  Check = 'CHECK',
  StripeConnectedAccount = 'STRIPE_CONNECTED_ACCOUNT',
  WireTransferInternational = 'WIRE_TRANSFER_INTERNATIONAL',
  WireTransferUsDomestic = 'WIRE_TRANSFER_US_DOMESTIC'
}

export type CollectPayoutRequest = {
  __typename?: 'CollectPayoutRequest';
  fees: Money;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  netPayout: Money;
  payableTo: Scalars['String']['output'];
  payoutMethod: CollectPayoutMethod;
  payoutNote?: Maybe<Scalars['String']['output']>;
  requestedAmount: Money;
  status: CollectPayoutRequestStatus;
};

export type CollectPayoutRequestGroup = {
  __typename?: 'CollectPayoutRequestGroup';
  id: Scalars['Int']['output'];
  payoutRequests?: Maybe<Array<Maybe<CollectPayoutRequest>>>;
};

export enum CollectPayoutRequestStatus {
  Canceled = 'CANCELED',
  Declined = 'DECLINED',
  PaidOut = 'PAID_OUT',
  Pending = 'PENDING',
  Underwriting = 'UNDERWRITING'
}

export type CollectPendingOffer = {
  __typename?: 'CollectPendingOffer';
  counterOffersForBuyer?: Maybe<Array<Maybe<CollectOfferData>>>;
  counterOffersForSeller?: Maybe<Array<Maybe<CollectOfferData>>>;
  offersForSeller?: Maybe<Array<Maybe<CollectOfferData>>>;
};

/** A phone number for a user. */
export type CollectPhone = {
  __typename?: 'CollectPhone';
  /** The phone number. */
  number?: Maybe<Scalars['String']['output']>;
  /** The verification status. */
  status?: Maybe<CollectPhoneStatus>;
};

/** The verification status of a phone number. */
export enum CollectPhoneStatus {
  PhoneStatusBypassed = 'PHONE_STATUS_BYPASSED',
  PhoneStatusCallRequested = 'PHONE_STATUS_CALL_REQUESTED',
  PhoneStatusCodeSent = 'PHONE_STATUS_CODE_SENT',
  PhoneStatusManuallyVerified = 'PHONE_STATUS_MANUALLY_VERIFIED',
  PhoneStatusUnverifiable = 'PHONE_STATUS_UNVERIFIABLE',
  PhoneStatusUnverified = 'PHONE_STATUS_UNVERIFIED',
  PhoneStatusVerified = 'PHONE_STATUS_VERIFIED'
}

export type CollectPickUpInPersonCharges = {
  __typename?: 'CollectPickUpInPersonCharges';
  /** Grading and Archival fees */
  additionalFee: Money;
  fulfillmentFee: Money;
  handlingFee?: Maybe<Money>;
  needsUnderwriting: Scalars['Boolean']['output'];
  salesTax: Money;
};

export type CollectPickUpInPersonSummary = {
  __typename?: 'CollectPickUpInPersonSummary';
  /** Grading and Archival fees */
  additionalFee: Money;
  fulfillmentFee: Money;
  handlingFee?: Maybe<Money>;
  needsUnderwriting: Scalars['Boolean']['output'];
  salesTax: Money;
};

export enum CollectPlaidLinkTokenProfile {
  Kyc = 'KYC',
  PremierAuctionApproval = 'PREMIER_AUCTION_APPROVAL'
}

/** prediction sources for search results */
export enum CollectPredictionSource {
  Chatgpt = 'CHATGPT',
  Ximilar = 'XIMILAR'
}

export type CollectPremierAuction = CollectAuction & {
  __typename?: 'CollectPremierAuction';
  /** Does this auction allow flash submissions at the moment */
  allowsFlashSubmissions?: Maybe<Scalars['Boolean']['output']>;
  auctionIntegerId?: Maybe<Scalars['Int']['output']>;
  collectListingTimer: CollectListingTimer;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  extendedEndsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  integerId?: Maybe<Scalars['Int']['output']>;
  /** Identifies whether an auction is custom */
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payoutDate?: Maybe<Scalars['Date']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: CollectAuctionStatus;
  /** Applicable only for custom auctions */
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type CollectPremierAuctionBid = {
  __typename?: 'CollectPremierAuctionBid';
  status: CollectPremierAuctionBidStatus;
  uuid: Scalars['UUID']['output'];
};

export type CollectPremierAuctionBidConnection = {
  __typename?: 'CollectPremierAuctionBidConnection';
  edges?: Maybe<Array<Maybe<CollectPremierAuctionBidEdge>>>;
  pageInfo: PageInfo;
};

export type CollectPremierAuctionBidEdge = {
  __typename?: 'CollectPremierAuctionBidEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectPremierAuctionBid>;
};

export enum CollectPremierAuctionBidStatus {
  StatusFirst = 'STATUS_FIRST',
  StatusNewHighest = 'STATUS_NEW_HIGHEST',
  StatusNewSecondHighest = 'STATUS_NEW_SECOND_HIGHEST',
  StatusNotProcessed = 'STATUS_NOT_PROCESSED',
  StatusRejected = 'STATUS_REJECTED',
  StatusStale = 'STATUS_STALE',
  StatusUpdatedHighest = 'STATUS_UPDATED_HIGHEST'
}

export type CollectPremierSale = CollectMarketplaceSale & {
  __typename?: 'CollectPremierSale';
  buyersPremium?: Maybe<Money>;
  id: Scalars['UUID']['output'];
  integerId: Scalars['Int']['output'];
  /** Not affected by faster listing query optimization */
  listing?: Maybe<CollectListing>;
  purchasePrice?: Maybe<Money>;
  shipping?: Maybe<Money>;
  tax?: Maybe<Money>;
  total?: Maybe<Money>;
};

export type CollectPresignedUrlPayload = {
  __typename?: 'CollectPresignedUrlPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectPresignedUrlPayloadType>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectPresignedUrlPayloadType = {
  __typename?: 'CollectPresignedUrlPayloadType';
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Object which represents price range */
export type CollectPriceRange = {
  __typename?: 'CollectPriceRange';
  high?: Maybe<Money>;
  low?: Maybe<Money>;
};

export type CollectProcessStripeAchConsentPayload = {
  __typename?: 'CollectProcessStripeAchConsentPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Card or any other product which can be found in catalog */
export type CollectProduct = CollectDetailed & {
  __typename?: 'CollectProduct';
  activity?: Maybe<CollectDetailedActivity>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  debugMetadata?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  matchLevel?: Maybe<CollectMatchLevel>;
  metadata?: Maybe<CollectProductMetadata>;
  ownItCount: Scalars['Int']['output'];
  sales?: Maybe<CollectDetailedSales>;
  stats?: Maybe<CollectDetailedStats>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  variants?: Maybe<CollectVariantConnection>;
  wantItCount: Scalars['Int']['output'];
};


/** Card or any other product which can be found in catalog */
export type CollectProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectProductDetailFeedback = {
  __typename?: 'CollectProductDetailFeedback';
  feedbackValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  originalValue?: Maybe<Scalars['String']['output']>;
  productDetailAttribute: Scalars['String']['output'];
  typeId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CollectProductDetailFeedbackInput = {
  feedbackValue: Scalars['String']['input'];
  id: Scalars['String']['input'];
  listingType: Scalars['String']['input'];
  originalValue?: InputMaybe<Scalars['String']['input']>;
  productDetailAttribute: Scalars['String']['input'];
};

export type CollectProductDetailFeedbackPayload = {
  __typename?: 'CollectProductDetailFeedbackPayload';
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  result?: Maybe<CollectProductDetailFeedback>;
  successful: Scalars['Boolean']['output'];
};

export type CollectProductMetadata = {
  __typename?: 'CollectProductMetadata';
  barcode?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  graderService?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  odds?: Maybe<Scalars['String']['output']>;
  parallel?: Maybe<Scalars['String']['output']>;
  patch?: Maybe<Scalars['String']['output']>;
  populationHigher?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  rarity?: Maybe<Scalars['String']['output']>;
  serial?: Maybe<Scalars['String']['output']>;
  set?: Maybe<Scalars['String']['output']>;
  signatures?: Maybe<Scalars['String']['output']>;
  sport?: Maybe<Scalars['String']['output']>;
  subcategory?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  subset?: Maybe<Scalars['String']['output']>;
  tcgRarity?: Maybe<Scalars['String']['output']>;
  tcgType?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  totalPopulation?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type CollectProtoItem = {
  __typename?: 'CollectProtoItem';
  cardSerial?: Maybe<Scalars['String']['output']>;
  compAtPurchase?: Maybe<Scalars['Int']['output']>;
  gradingPriceInCents?: Maybe<Scalars['Int']['output']>;
  hasAutograph?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  invoice?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  purchasePriceInCents?: Maybe<Scalars['Int']['output']>;
  team?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['UUID']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type CollectPublicUser = {
  __typename?: 'CollectPublicUser';
  collectCollection: CollectSetlist;
  collectSetlist?: Maybe<CollectSetlist>;
  collectSetlists?: Maybe<CollectSetlistConnection>;
  tenantId: Scalars['UUID']['output'];
};


export type CollectPublicUserCollectSetlistArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  kind?: InputMaybe<CollectSetlistKind>;
};


export type CollectPublicUserCollectSetlistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectQuickOffer = {
  __typename?: 'CollectQuickOffer';
  amount: Money;
  label: Scalars['String']['output'];
  pricePercentage: Scalars['Int']['output'];
};

export type CollectRecentlyViewedItem = {
  __typename?: 'CollectRecentlyViewedItem';
  item: CollectItemOrProductOrListingOrVariant;
  itemId: Scalars['String']['output'];
  itemType: CollectRecentlyViewedItemType;
  lastViewedAt: Scalars['DateTime']['output'];
};

export enum CollectRecentlyViewedItemType {
  BoListing = 'BO_LISTING',
  FixedPrice = 'FIXED_PRICE',
  Item = 'ITEM',
  Premier = 'PREMIER',
  Product = 'PRODUCT',
  Weekly = 'WEEKLY'
}

export type CollectRedRookieAward = {
  __typename?: 'CollectRedRookieAward';
  amount: Money;
  availableUntilAt?: Maybe<Scalars['DateTime']['output']>;
  code: CollectRedRookieAwardCode;
  description: Scalars['String']['output'];
  status: CollectRedRookieAwardStatus;
  timing?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum CollectRedRookieAwardCode {
  Hof = 'HOF',
  Mvpcy = 'MVPCY',
  Mvpcy2 = 'MVPCY2',
  Mvpcy3 = 'MVPCY3',
  Roy = 'ROY'
}

export enum CollectRedRookieAwardStatus {
  Available = 'AVAILABLE',
  Failed = 'FAILED',
  NotRedeemed = 'NOT_REDEEMED',
  Pending = 'PENDING',
  Redeemed = 'REDEEMED',
  Unavailable = 'UNAVAILABLE'
}

export type CollectRedRookiePlayer = {
  __typename?: 'CollectRedRookiePlayer';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type CollectRedRookiePlayerConnection = {
  __typename?: 'CollectRedRookiePlayerConnection';
  edges?: Maybe<Array<Maybe<CollectRedRookiePlayerEdge>>>;
  pageInfo: PageInfo;
};

export type CollectRedRookiePlayerEdge = {
  __typename?: 'CollectRedRookiePlayerEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectRedRookiePlayer>;
};

export type CollectRedRookieRedemption = {
  __typename?: 'CollectRedRookieRedemption';
  awards: Array<Maybe<CollectRedRookieAward>>;
  status: CollectRedRookieRedemptionStatus;
};

export enum CollectRedRookieRedemptionStatus {
  Available = 'AVAILABLE',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  NotRedeemed = 'NOT_REDEEMED',
  Pending = 'PENDING'
}

export type CollectRegistration = {
  __typename?: 'CollectRegistration';
  status: CollectRegistrationStatus;
};

export enum CollectRegistrationStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Pending = 'PENDING'
}

export type CollectRejectToCreateVaultItemRequestError = {
  __typename?: 'CollectRejectToCreateVaultItemRequestError';
  code: CollectRejectedToCreateVaultItemRequestErrorCode;
  userMessage: Scalars['String']['output'];
};

export enum CollectRejectedToCreateVaultItemRequestErrorCode {
  CheckedOutByMember = 'CHECKED_OUT_BY_MEMBER',
  HasActiveFulfillmentOrTransferRequest = 'HAS_ACTIVE_FULFILLMENT_OR_TRANSFER_REQUEST',
  InvalidGradingServiceForCheckout = 'INVALID_GRADING_SERVICE_FOR_CHECKOUT',
  ListedInBuyNow = 'LISTED_IN_BUY_NOW',
  ListedInPremierAuction = 'LISTED_IN_PREMIER_AUCTION',
  ListedInWeeklyAuction = 'LISTED_IN_WEEKLY_AUCTION',
  NotCurated = 'NOT_CURATED',
  NotInCollect = 'NOT_IN_COLLECT',
  NoInsuranceValue = 'NO_INSURANCE_VALUE',
  RedeemableForCheckout = 'REDEEMABLE_FOR_CHECKOUT',
  RedeemableForTransfer = 'REDEEMABLE_FOR_TRANSFER'
}

export type CollectRelatedListingsInput = {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  vaultItemId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CollectRemoveFixedPriceFromSetlistPayload = {
  __typename?: 'CollectRemoveFixedPriceFromSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectRemoveFixedPriceFromSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectRemoveFixedPriceFromSetlistResponse = {
  __typename?: 'CollectRemoveFixedPriceFromSetlistResponse';
  fixedPrice: CollectListing;
};

export type CollectRemoveFromCollectionPayload = {
  __typename?: 'CollectRemoveFromCollectionPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectRemoveFromCollectionResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectRemoveFromCollectionResponse = {
  __typename?: 'CollectRemoveFromCollectionResponse';
  product: CollectProduct;
};

export type CollectRemoveItemFromSetlistPayload = {
  __typename?: 'CollectRemoveItemFromSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectRemoveItemFromSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectRemoveItemFromSetlistResponse = {
  __typename?: 'CollectRemoveItemFromSetlistResponse';
  item: CollectItem;
};

export type CollectRemovePremierFromSetlistPayload = {
  __typename?: 'CollectRemovePremierFromSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectRemovePremierFromSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectRemovePremierFromSetlistResponse = {
  __typename?: 'CollectRemovePremierFromSetlistResponse';
  premier: CollectListing;
};

export type CollectRemoveProductFromSetlistPayload = {
  __typename?: 'CollectRemoveProductFromSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectRemoveProductFromSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectRemoveProductFromSetlistResponse = {
  __typename?: 'CollectRemoveProductFromSetlistResponse';
  product: CollectProduct;
};

export type CollectRemoveVariantFromSetlistPayload = {
  __typename?: 'CollectRemoveVariantFromSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectRemoveVariantFromSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectRemoveVariantFromSetlistResponse = {
  __typename?: 'CollectRemoveVariantFromSetlistResponse';
  variant: CollectVariant;
};

export type CollectRemoveVaultItemFromVaultItemGroupPayload = {
  __typename?: 'CollectRemoveVaultItemFromVaultItemGroupPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectVaultItemGroup>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectRemoveWeeklyFromSetlistPayload = {
  __typename?: 'CollectRemoveWeeklyFromSetlistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectRemoveWeeklyFromSetlistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectRemoveWeeklyFromSetlistResponse = {
  __typename?: 'CollectRemoveWeeklyFromSetlistResponse';
  weekly: CollectListing;
};

export enum CollectReportEntityType {
  BoListing = 'BO_LISTING',
  FixedPrice = 'FIXED_PRICE',
  Item = 'ITEM',
  Premier = 'PREMIER',
  Product = 'PRODUCT',
  Setlist = 'SETLIST',
  Variant = 'VARIANT',
  Weekly = 'WEEKLY'
}

/** Input type for reporting an incorrect match */
export type CollectReportIncorrectMatchInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  candidateImages: Array<InputMaybe<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parallel?: InputMaybe<Scalars['String']['input']>;
  scanRequestId?: InputMaybe<Scalars['UUID']['input']>;
  set?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subset?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  variantId: Scalars['UUID']['input'];
  year?: InputMaybe<Scalars['String']['input']>;
};

export type CollectReportIncorrectMatchPayload = {
  __typename?: 'CollectReportIncorrectMatchPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectScanResultFeedbackPayloadType>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectReportReason = {
  __typename?: 'CollectReportReason';
  /** ID of the report reason */
  id: Scalars['UUID']['output'];
  /** Parent ID of the report reason if present */
  parentId?: Maybe<Scalars['UUID']['output']>;
  /** Description of the report reason */
  title: Scalars['String']['output'];
};

export type CollectRequestCsvExportPayload = {
  __typename?: 'CollectRequestCsvExportPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectRequestCsvExportResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectRequestCsvExportResponse = {
  __typename?: 'CollectRequestCsvExportResponse';
  taskId: Scalars['UUID']['output'];
};

export type CollectRequestSessionEmailOtpPayload = {
  __typename?: 'CollectRequestSessionEmailOtpPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectResendPhoneVerificationCodePayload = {
  __typename?: 'CollectResendPhoneVerificationCodePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectResendWelcomeEmailPayload = {
  __typename?: 'CollectResendWelcomeEmailPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectResolvePhoneConflict = {
  __typename?: 'CollectResolvePhoneConflict';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectSale = {
  __typename?: 'CollectSale';
  soldDate?: Maybe<Scalars['DateTime']['output']>;
  soldFor?: Maybe<Money>;
};

export type CollectSaleCharges = {
  __typename?: 'CollectSaleCharges';
  shippingFee?: Maybe<Money>;
};

/** The data to return for Saved Search */
export type CollectSavedSearch = {
  __typename?: 'CollectSavedSearch';
  id: Scalars['UUID']['output'];
  lastUsedAt: Scalars['DateTime']['output'];
  searchData?: Maybe<CollectSearchData>;
  usagesCount: Scalars['Int']['output'];
};

export type CollectSavedSearchConnection = {
  __typename?: 'CollectSavedSearchConnection';
  edges?: Maybe<Array<Maybe<CollectSavedSearchEdge>>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type CollectSavedSearchEdge = {
  __typename?: 'CollectSavedSearchEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectSavedSearch>;
};

export type CollectScan = {
  __typename?: 'CollectScan';
  barcode?: Maybe<Scalars['String']['output']>;
  dataSource?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  graderService?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  insertedAt: Scalars['DateTime']['output'];
  matchLevel?: Maybe<CollectMatchLevel>;
  metadata?: Maybe<CollectProductMetadata>;
  opaqueData?: Maybe<Scalars['String']['output']>;
  predictionSource?: Maybe<CollectPredictionSource>;
  productName?: Maybe<Scalars['String']['output']>;
  resultCnt: Scalars['Int']['output'];
  scanRequestId?: Maybe<Scalars['UUID']['output']>;
  sequence?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The allowed capture types for scan */
export enum CollectScanCaptureType {
  Auto = 'AUTO',
  Manual = 'MANUAL'
}

export type CollectScanConnection = {
  __typename?: 'CollectScanConnection';
  edges?: Maybe<Array<Maybe<CollectScanEdge>>>;
  pageInfo: PageInfo;
};

export type CollectScanDetailPayload = {
  __typename?: 'CollectScanDetailPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectScanDetailResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectScanDetailResponse = {
  __typename?: 'CollectScanDetailResponse';
  scanRequestId?: Maybe<Scalars['UUID']['output']>;
  scanResults?: Maybe<Array<Maybe<CollectScan>>>;
};

export type CollectScanEdge = {
  __typename?: 'CollectScanEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectScan>;
};

/**
 * Input type for scan feedback results.
 * This type encapsulates the details of a scanned item, including its metadata,
 * images, and match level. It is used to provide feedback on the results of a scan operation.
 */
export type CollectScanFeedbackResultInput = {
  id: Scalars['UUID']['input'];
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  matchLevel?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<CollectScanFeedbackResultMetadataInput>;
};

export type CollectScanFeedbackResultMetadataInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parallel?: InputMaybe<Scalars['String']['input']>;
  patch?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  serial?: InputMaybe<Scalars['String']['input']>;
  set?: InputMaybe<Scalars['String']['input']>;
  signatures?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  subset?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
};

export type CollectScanResultFeedbackPayload = {
  __typename?: 'CollectScanResultFeedbackPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectScanResultFeedbackPayloadType>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectScanResultFeedbackPayloadType = {
  __typename?: 'CollectScanResultFeedbackPayloadType';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CollectScanV3Response = {
  __typename?: 'CollectScanV3Response';
  collectVariant?: Maybe<Array<Maybe<CollectVariant>>>;
  isCard?: Maybe<Scalars['Boolean']['output']>;
  scanRequestId?: Maybe<Scalars['UUID']['output']>;
};

export type CollectScanVariantPayload = {
  __typename?: 'CollectScanVariantPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectScanV3Response>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The data to return for Saved Search */
export type CollectSearchData = {
  __typename?: 'CollectSearchData';
  /** The Search filters */
  filters?: Maybe<Scalars['String']['output']>;
  /** The Search query itself */
  query?: Maybe<Scalars['String']['output']>;
};

/** Data that should be input to create the Saved Search */
export type CollectSearchDataInput = {
  /** The Search filters */
  filters?: InputMaybe<Scalars['String']['input']>;
  /** The Search query itself */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type CollectSearchDefaultFilter = {
  __typename?: 'CollectSearchDefaultFilter';
  indexName: CollectSearchIndexName;
  params: CollectSearchParams;
  prebuiltFilters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CollectSearchFacetAuction = {
  __typename?: 'CollectSearchFacetAuction';
  attributeName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<CollectSearchFacetValueAuction>>>;
};

export type CollectSearchFacetSimple = {
  __typename?: 'CollectSearchFacetSimple';
  attributeName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<CollectSearchFacetValueSimple>>>;
};

export type CollectSearchFacetTypes = CollectSearchFacetAuction | CollectSearchFacetSimple;

export type CollectSearchFacetValueAuction = {
  __typename?: 'CollectSearchFacetValueAuction';
  auction: CollectAuction;
  count?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type CollectSearchFacetValueSimple = {
  __typename?: 'CollectSearchFacetValueSimple';
  count?: Maybe<Scalars['Int']['output']>;
  value: Scalars['String']['output'];
};

export type CollectSearchIndex = {
  __typename?: 'CollectSearchIndex';
  displayName: Scalars['String']['output'];
  indexName: CollectSearchIndexName;
  indexValue: Scalars['String']['output'];
  type: CollectSearchType;
};

export enum CollectSearchIndexName {
  /** Algolia Primary Index. Sometimes referred as 'For You' index */
  Listing = 'LISTING',
  ListingBestDeals = 'LISTING_BEST_DEALS',
  ListingBestValueDesc = 'LISTING_BEST_VALUE_DESC',
  ListingConfidenceValueGuidePrice = 'LISTING_CONFIDENCE_VALUE_GUIDE_PRICE',
  ListingFeatured = 'LISTING_FEATURED',
  ListingHighestPrice = 'LISTING_HIGHEST_PRICE',
  ListingLowestPrice = 'LISTING_LOWEST_PRICE',
  ListingRecentlyAdded = 'LISTING_RECENTLY_ADDED',
  ListingSoldAsc = 'LISTING_SOLD_ASC',
  ListingSoldDesc = 'LISTING_SOLD_DESC',
  ListingYearAsc = 'LISTING_YEAR_ASC',
  ListingYearDesc = 'LISTING_YEAR_DESC',
  Product = 'PRODUCT'
}

/**
 * Input type for ChatGPT card scanning operations.
 * Contains URLs for card images to be analyzed.
 * Each field represents a URL pointing to the respective card image.
 */
export type CollectSearchItemsInput = {
  backImageUrl?: InputMaybe<Scalars['String']['input']>;
  imageUrl: Scalars['String']['input'];
};

export type CollectSearchListing = {
  __typename?: 'CollectSearchListing';
  result?: Maybe<CollectSearchListingResultConnection>;
};


export type CollectSearchListingResultArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export enum CollectSearchListingIndexName {
  Listing = 'LISTING',
  ListingBestDeals = 'LISTING_BEST_DEALS',
  ListingBestValueDesc = 'LISTING_BEST_VALUE_DESC',
  ListingHighestPrice = 'LISTING_HIGHEST_PRICE',
  ListingLowestPrice = 'LISTING_LOWEST_PRICE',
  ListingRecentlyAdded = 'LISTING_RECENTLY_ADDED'
}

export type CollectSearchListingResultConnection = {
  __typename?: 'CollectSearchListingResultConnection';
  edges?: Maybe<Array<Maybe<CollectSearchListingResultEdge>>>;
  facets?: Maybe<Array<Maybe<CollectSearchFacetTypes>>>;
  pageInfo: PageInfo;
  totalHits?: Maybe<Scalars['Int']['output']>;
};

export type CollectSearchListingResultEdge = {
  __typename?: 'CollectSearchListingResultEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectListing>;
};

export type CollectSearchParams = {
  __typename?: 'CollectSearchParams';
  filters?: Maybe<Scalars['String']['output']>;
};

export type CollectSearchParamsInput = {
  filters?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
  similarQuery?: InputMaybe<Scalars['String']['input']>;
  userToken?: InputMaybe<Scalars['String']['input']>;
};

export type CollectSearchPrebuiltFilter = {
  __typename?: 'CollectSearchPrebuiltFilter';
  displayName: Scalars['String']['output'];
  facets: Array<Maybe<CollectSearchPrebuiltFilterFacet>>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  indexName?: Maybe<CollectSearchIndexName>;
};

export type CollectSearchPrebuiltFilterFacet = {
  __typename?: 'CollectSearchPrebuiltFilterFacet';
  attributeName: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CollectSearchProduct = {
  __typename?: 'CollectSearchProduct';
  result?: Maybe<CollectSearchProductResultConnection>;
};


export type CollectSearchProductResultArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectSearchProductResultConnection = {
  __typename?: 'CollectSearchProductResultConnection';
  edges?: Maybe<Array<Maybe<CollectSearchProductResultEdge>>>;
  facets?: Maybe<Array<Maybe<CollectSearchFacetTypes>>>;
  pageInfo: PageInfo;
  totalHits?: Maybe<Scalars['Int']['output']>;
};

export type CollectSearchProductResultEdge = {
  __typename?: 'CollectSearchProductResultEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectProduct>;
};

export type CollectSearchSettings = {
  __typename?: 'CollectSearchSettings';
  defaultFilter: CollectSearchDefaultFilter;
  indexes?: Maybe<Array<Maybe<CollectSearchIndex>>>;
  prebuiltFilters?: Maybe<Array<Maybe<CollectSearchPrebuiltFilter>>>;
};

export enum CollectSearchSortBy {
  /** Sort by best deals first */
  BestDeals = 'BEST_DEALS',
  /** Sort by best value first */
  BestValueDesc = 'BEST_VALUE_DESC',
  /** Sort by highest price first */
  HighestPrice = 'HIGHEST_PRICE',
  /** Sort by lowest price first */
  LowestPrice = 'LOWEST_PRICE',
  /** Sort by recently added items */
  RecentlyAdded = 'RECENTLY_ADDED'
}

export enum CollectSearchType {
  Listing = 'LISTING',
  Product = 'PRODUCT'
}

export type CollectSeller = {
  __typename?: 'CollectSeller';
  /** Collect seller name */
  name: Scalars['String']['output'];
  /**
   * This ENUM is important, because FANATICS_COLLECT is unified seller that may contain items from different locations.
   * For external locations there can be only one location per seller.
   */
  type: CollectCheckoutV2Seller;
  /** External Location ID. NULL for FANATICS_COLLECT because it's a unified seller */
  vaultItemLocationId?: Maybe<Scalars['Int']['output']>;
};

/** Seller Fee rate example */
export type CollectSellerFeeRate = {
  __typename?: 'CollectSellerFeeRate';
  sellerFee?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

/** Simplified Seller Fee rates example */
export type CollectSellerFeeRateV2 = {
  __typename?: 'CollectSellerFeeRateV2';
  baseRatio?: Maybe<Scalars['Float']['output']>;
  greatPriceRatio?: Maybe<Scalars['Float']['output']>;
};

export type CollectSession = {
  __typename?: 'CollectSession';
  message?: Maybe<Scalars['String']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type CollectSetlist = {
  __typename?: 'CollectSetlist';
  hidden: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['UUID']['output']>;
  items?: Maybe<CollectItemOrProductOrListingOrVariantConnection>;
  kind: CollectSetlistKind;
  title?: Maybe<Scalars['String']['output']>;
  totalNumberOfItems: Scalars['Int']['output'];
  totalWorth?: Maybe<Money>;
};


export type CollectSetlistItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectSetlistConnection = {
  __typename?: 'CollectSetlistConnection';
  edges?: Maybe<Array<Maybe<CollectSetlistEdge>>>;
  pageInfo: PageInfo;
};

export type CollectSetlistEdge = {
  __typename?: 'CollectSetlistEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectSetlist>;
};

export enum CollectSetlistKind {
  /** Indicates setlist which must be referenced by ID */
  Regular = 'REGULAR',
  /** Special setlist which can be referenced by kind */
  Wantlist = 'WANTLIST'
}

/** The Shipping Address for an Invoice. */
export type CollectShippingAddress = {
  __typename?: 'CollectShippingAddress';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  vaultAccountId?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type CollectShippingMethod = {
  __typename?: 'CollectShippingMethod';
  cost?: Maybe<Money>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  usDomestic: Scalars['Boolean']['output'];
};

export type CollectShippingService = {
  __typename?: 'CollectShippingService';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum CollectShippingType {
  Custom = 'CUSTOM',
  Default = 'DEFAULT',
  InPerson = 'IN_PERSON',
  New = 'NEW',
  TradeShow = 'TRADE_SHOW',
  Unknown = 'UNKNOWN',
  Vault = 'VAULT'
}

export type CollectShopSellerIdentity = {
  __typename?: 'CollectShopSellerIdentity';
  fanId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  shop: CollectShopSellerIdentityShop;
  shopId: Scalars['String']['output'];
};

export type CollectShopSellerIdentityShop = {
  __typename?: 'CollectShopSellerIdentityShop';
  id: Scalars['String']['output'];
  isDropShipper: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CollectShortLink = {
  __typename?: 'CollectShortLink';
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  type: CollectShortLinkType;
  url: Scalars['String']['output'];
};

/** Represents the 2 types of short links */
export enum CollectShortLinkType {
  /** General Shortlink */
  General = 'GENERAL',
  /** Shorlink for vault shares */
  VaultShares = 'VAULT_SHARES'
}

/** Token pair obtained after authenticating a user. */
export type CollectTokenPair = {
  __typename?: 'CollectTokenPair';
  /** Access token to be used for authenticated requests. */
  accessToken: Scalars['String']['output'];
  /** Refresh token to be used to obtain a new token pair. */
  refreshToken: Scalars['String']['output'];
};

/** A pair of tokens obtained after authenticating a user. */
export type CollectTokenSet = {
  __typename?: 'CollectTokenSet';
  /** Access token to be used for authenticated requests. */
  accessToken: Scalars['String']['output'];
  /** The action that was taken to authenticate the user */
  action: CollectAuthenticateAction;
  /** The expiry timestamp returned by the FanID authentication flow */
  expiresAt: Scalars['Int']['output'];
  /** Refresh token to be used to obtain a new token pair. */
  refreshToken: Scalars['String']['output'];
  /** The user's tenant ID. */
  tenantId: Scalars['UUID']['output'];
};

/** Trade Shows can be used to Checkout Vault Items */
export type CollectTradeShow = {
  __typename?: 'CollectTradeShow';
  address: CollectAddress;
  allowsCheckout: Scalars['Boolean']['output'];
  checkoutDeadline?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endsAt: Scalars['Date']['output'];
  integerId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  startsAt: Scalars['Date']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type CollectTradeShowCheckoutCharges = {
  __typename?: 'CollectTradeShowCheckoutCharges';
  /** Deadline for returning items back to vault */
  deferredFulfillmentDeadline: Scalars['DateTime']['output'];
  /** Potential fee if deadline is missed */
  deferredFulfillmentFee: Money;
  /** Discount applied to a shipping fee */
  discountedShippingFee?: Maybe<Money>;
  fulfillmentFee: Money;
  insuredValue: Money;
  needsUnderwriting: Scalars['Boolean']['output'];
  shippingFee?: Maybe<Money>;
  /** Discount applied to a shipping fee in case of a trade show checkout type */
  tradeShowShippingDiscount: Scalars['Float']['output'];
};

export type CollectTradeShowCheckoutSummary = {
  __typename?: 'CollectTradeShowCheckoutSummary';
  constraintData?: Maybe<CollectCheckoutSummaryConstraintData>;
  /** Deadline for returning items back to vault */
  deferredFulfillmentDeadline: Scalars['DateTime']['output'];
  /** Potential fee if deadline is missed */
  deferredFulfillmentFee: Money;
  /** Discount applied to a shipping fee */
  discountedShippingFee?: Maybe<Money>;
  fulfillmentFee: Money;
  insuredValue: Money;
  needsUnderwriting: Scalars['Boolean']['output'];
  shippingFee?: Maybe<Money>;
  /** Discount applied to a shipping fee in case of a trade show checkout type */
  tradeShowShippingDiscount: Scalars['Float']['output'];
};

export type CollectUnableToListError = {
  __typename?: 'CollectUnableToListError';
  code: CollectUnableToListErrorCode;
  userMessage: Scalars['String']['output'];
};

export enum CollectUnableToListErrorCode {
  Flagged = 'FLAGGED',
  HasActiveFulfillmentOrTransferRequest = 'HAS_ACTIVE_FULFILLMENT_OR_TRANSFER_REQUEST',
  HasOffers = 'HAS_OFFERS',
  IneligibleCategory = 'INELIGIBLE_CATEGORY',
  IneligibleTitle = 'INELIGIBLE_TITLE',
  ListedInPremierAuction = 'LISTED_IN_PREMIER_AUCTION',
  ListedInWeeklyAuction = 'LISTED_IN_WEEKLY_AUCTION',
  NotArchived = 'NOT_ARCHIVED',
  NotInCollect = 'NOT_IN_COLLECT',
  NotOwned = 'NOT_OWNED',
  NotSellable = 'NOT_SELLABLE',
  Redeemable = 'REDEEMABLE',
  TemporaryBlocked = 'TEMPORARY_BLOCKED'
}

export type CollectUpdateFixedPriceListingPayload = {
  __typename?: 'CollectUpdateFixedPriceListingPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectUpdateFixedPriceListingResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateFixedPriceListingResponse = {
  __typename?: 'CollectUpdateFixedPriceListingResponse';
  id: Scalars['UUID']['output'];
  listing?: Maybe<CollectListing>;
  type: CollectListingType;
};

export type CollectUpdateItemPayload = {
  __typename?: 'CollectUpdateItemPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectUpdateItemResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateItemResponse = {
  __typename?: 'CollectUpdateItemResponse';
  item: CollectItem;
};

export type CollectUpdateMemberCheckoutInput = {
  addressType: CollectMemberCheckoutAddressType;
  alternateAddress?: InputMaybe<CollectVaultItemRequestAlternateAddress>;
};

export type CollectUpdateMemberCheckoutPayload = {
  __typename?: 'CollectUpdateMemberCheckoutPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectUpdateMemberCheckoutResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateMemberCheckoutResponse = {
  __typename?: 'CollectUpdateMemberCheckoutResponse';
  vaultItemRequest?: Maybe<CollectVaultItemRequest>;
};

export type CollectUpdateOfferInput = {
  listingId: Scalars['UUID']['input'];
  listingType?: InputMaybe<CollectListingType>;
  offerId: Scalars['UUID']['input'];
  sendChatMessage?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Fields for updating the vault item's owner value */
export type CollectUpdateOwnerValueData = {
  id: Scalars['UUID']['input'];
  ownerValueInCents: Scalars['Int']['input'];
};

export type CollectUpdateOwnerValuesPayload = {
  __typename?: 'CollectUpdateOwnerValuesPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectUpdateOwnerValuesResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateOwnerValuesResponse = {
  __typename?: 'CollectUpdateOwnerValuesResponse';
  vaultItems: Array<Maybe<CollectVaultItemOwnerValue>>;
};

export type CollectUpdatePremierListingPayload = {
  __typename?: 'CollectUpdatePremierListingPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectUpdatePremierListingResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdatePremierListingResponse = {
  __typename?: 'CollectUpdatePremierListingResponse';
  id: Scalars['UUID']['output'];
  listing?: Maybe<CollectListing>;
  type: CollectListingType;
};

export type CollectUpdateProfile = {
  __typename?: 'CollectUpdateProfile';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateProfileName = {
  __typename?: 'CollectUpdateProfileName';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateTradeShowCheckoutInput = {
  tradeShowId: Scalars['Int']['input'];
};

export type CollectUpdateTradeShowCheckoutPayload = {
  __typename?: 'CollectUpdateTradeShowCheckoutPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectUpdateTradeShowCheckoutResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateTradeShowCheckoutResponse = {
  __typename?: 'CollectUpdateTradeShowCheckoutResponse';
  vaultItemRequest?: Maybe<CollectVaultItemRequest>;
};

export type CollectUpdateUserPhone = {
  __typename?: 'CollectUpdateUserPhone';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateVaultItemGroupPayload = {
  __typename?: 'CollectUpdateVaultItemGroupPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectVaultItemGroup>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateVaultRetrievalInput = {
  addressType: CollectVaultRetrievalAddressType;
  alternateAddress?: InputMaybe<CollectVaultRetrievalAlternateAddress>;
};

export type CollectUpdateVaultRetrievalPayload = {
  __typename?: 'CollectUpdateVaultRetrievalPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectUpdateVaultRetrievalResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateVaultRetrievalResponse = {
  __typename?: 'CollectUpdateVaultRetrievalResponse';
  vaultItemRequest?: Maybe<CollectVaultItemRequest>;
};

export type CollectUpdateVaultSubmissionInput = {
  trackingNumber: Scalars['String']['input'];
};

export type CollectUpdateVaultSubmissionPayload = {
  __typename?: 'CollectUpdateVaultSubmissionPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectUpdateVaultSubmissionResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateVaultSubmissionResponse = {
  __typename?: 'CollectUpdateVaultSubmissionResponse';
  submission?: Maybe<CollectVaultSubmission>;
};

export type CollectUpdateWeeklyListingPayload = {
  __typename?: 'CollectUpdateWeeklyListingPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectUpdateWeeklyListingResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectUpdateWeeklyListingResponse = {
  __typename?: 'CollectUpdateWeeklyListingResponse';
  id: Scalars['UUID']['output'];
  listing?: Maybe<CollectListing>;
  type: CollectListingType;
};

export type CollectUseSavedSearchPayload = {
  __typename?: 'CollectUseSavedSearchPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['String']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Represents any user in the system */
export type CollectUser = {
  __typename?: 'CollectUser';
  email?: Maybe<CollectEmail>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  integerId: Scalars['Int']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['UUID']['output'];
};

/** The Collect-specific attributes of a user. */
export type CollectUserAttributes = {
  __typename?: 'CollectUserAttributes';
  /** The limit of bid user can make (depends on user trust level) */
  bidLimit?: Maybe<Scalars['Int']['output']>;
  /** Business name */
  businessName?: Maybe<Scalars['String']['output']>;
  canSellOnCustomAuction?: Maybe<Scalars['Boolean']['output']>;
  chatToken?: Maybe<Scalars['String']['output']>;
  collectBidIncrementConfig?: Maybe<Array<Maybe<CollectBidIncrementConfig>>>;
  collectDefaultAddress?: Maybe<CollectAddress>;
  collectPaymentMethods?: Maybe<Array<Maybe<CollectPaymentMethod>>>;
  collectPremierAuctionApproved?: Maybe<Scalars['Boolean']['output']>;
  collectPremierAuctionRegistration?: Maybe<CollectRegistration>;
  /** User specific Ship To address in vault submissions */
  collectVaultSubmissionAddress: CollectAddress;
  stripeAccountOnboarded: Scalars['Boolean']['output'];
  stripeAchConsentRequired: Scalars['Boolean']['output'];
  stripeLoginUrl?: Maybe<Scalars['String']['output']>;
  stripeOnboardingUrl?: Maybe<Scalars['String']['output']>;
  stripePublishableKey: Scalars['String']['output'];
};


/** The Collect-specific attributes of a user. */
export type CollectUserAttributesStripeOnboardingUrlArgs = {
  returnUrl: Scalars['String']['input'];
};

export enum CollectUserBidState {
  HighBid = 'HIGH_BID',
  NoBids = 'NO_BIDS',
  NoStatus = 'NO_STATUS',
  Outbid = 'OUTBID'
}

export type CollectUserReport = {
  /** ID of the reported entity */
  entityId: Scalars['UUID']['input'];
  /** Type of the reported entity */
  entityType: CollectReportEntityType;
  /** Optional string note from the reporter. Max 100KB */
  note?: InputMaybe<Scalars['String']['input']>;
  /** ID of the report reason */
  reasonId: Scalars['UUID']['input'];
};

export enum CollectValidPaymentMethod {
  Ach = 'ACH',
  ApplePay = 'APPLE_PAY',
  Card = 'CARD',
  Crypto = 'CRYPTO',
  Fancash = 'FANCASH',
  Funds = 'FUNDS',
  GooglePay = 'GOOGLE_PAY',
  Rewards = 'REWARDS',
  Wire = 'WIRE'
}

export type CollectValidateMfaPayload = {
  __typename?: 'CollectValidateMfaPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectValidateMfaResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectValidateMfaResponse = {
  __typename?: 'CollectValidateMfaResponse';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Card variant which can be found in catalog */
export type CollectVariant = {
  __typename?: 'CollectVariant';
  barcode?: Maybe<Scalars['String']['output']>;
  dataSource?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  graderService?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Use `collectionItems` instead */
  items?: Maybe<CollectItemConnection>;
  matchLevel?: Maybe<CollectMatchLevel>;
  metadata: CollectProductMetadata;
  opaqueData?: Maybe<Scalars['String']['output']>;
  predictionSource?: Maybe<CollectPredictionSource>;
  product?: Maybe<CollectProduct>;
  productName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


/** Card variant which can be found in catalog */
export type CollectVariantItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectVariantConnection = {
  __typename?: 'CollectVariantConnection';
  edges?: Maybe<Array<Maybe<CollectVariantEdge>>>;
  pageInfo: PageInfo;
};

export type CollectVariantEdge = {
  __typename?: 'CollectVariantEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectVariant>;
};

export type CollectVaultCategory = {
  __typename?: 'CollectVaultCategory';
  categoryType?: Maybe<CollectVaultCategoryType>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export enum CollectVaultCategoryType {
  CoinsCurrency = 'COINS_CURRENCY',
  Comics = 'COMICS',
  Other = 'OTHER',
  SportsCards = 'SPORTS_CARDS',
  TradingCardGames = 'TRADING_CARD_GAMES',
  VideoGames = 'VIDEO_GAMES',
  Wax = 'WAX'
}

/** Vault item category type */
export enum CollectVaultCategoryTypeDeprecated {
  /** Coins Currency */
  CoinsCurrency = 'COINS_CURRENCY',
  /** Comics */
  Comics = 'COMICS',
  /** Other */
  Other = 'OTHER',
  /** Sports Cards */
  SportsCards = 'SPORTS_CARDS',
  /** Trading Card Games */
  TradingCardGames = 'TRADING_CARD_GAMES',
  /** Video Games */
  VideoGames = 'VIDEO_GAMES',
  /** Wax */
  Wax = 'WAX'
}

export type CollectVaultItem = CollectDetailed & {
  __typename?: 'CollectVaultItem';
  activeBackOfficeListing?: Maybe<CollectListing>;
  activeListing?: Maybe<CollectListing>;
  appraisalValue?: Maybe<Money>;
  appraisalValueDate?: Maybe<Scalars['Date']['output']>;
  buybackValue?: Maybe<Money>;
  canLeaveVault?: Maybe<Scalars['Boolean']['output']>;
  cardGrade?: Maybe<CollectCardGrade>;
  cardLadderSearchUrl?: Maybe<Scalars['String']['output']>;
  cardLadderValue?: Maybe<Money>;
  cardLadderValueDate?: Maybe<Scalars['DateTime']['output']>;
  category?: Maybe<CollectVaultCategory>;
  checklistPoolItem?: Maybe<ChecklistPoolItem>;
  curatedDate?: Maybe<Scalars['Date']['output']>;
  debugMetadata?: Maybe<Scalars['String']['output']>;
  gradeCert?: Maybe<Scalars['String']['output']>;
  gradingService?: Maybe<CollectGradingService>;
  gradingServiceUrl?: Maybe<Scalars['String']['output']>;
  /** This is the guide price for the item */
  guidePrice?: Maybe<Money>;
  guidePriceType: GuidePriceType;
  id: Scalars['UUID']['output'];
  imageMetadata?: Maybe<Array<Maybe<CollectImageMetadata>>>;
  imageSets: Array<Maybe<CollectImageSet>>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  insertedAt: Scalars['DateTime']['output'];
  /** The instant rip state of a vault item after transfering to users vault */
  instantRipState?: Maybe<VaultItemInstantRipState>;
  insuredValue?: Maybe<Money>;
  insuredValueDate?: Maybe<Scalars['Date']['output']>;
  integerId: Scalars['Int']['output'];
  listableOnFixedPriceMarketplace?: Maybe<Scalars['Boolean']['output']>;
  listableOnPremierAuction?: Maybe<Scalars['Boolean']['output']>;
  listableOnWeeklyAuction?: Maybe<Scalars['Boolean']['output']>;
  /** This is essentially */
  marketValue?: Maybe<Money>;
  marketValueDate?: Maybe<Scalars['Date']['output']>;
  /**
   * Minimum allowed offer for the listing.
   * Fast field.
   */
  minimumAllowedOffer: Money;
  origin?: Maybe<CollectVaultItemOrigin>;
  ownerValue?: Maybe<Money>;
  pendingPayoutListings?: Maybe<Array<Maybe<CollectListing>>>;
  protoItemUuid?: Maybe<Scalars['UUID']['output']>;
  purchasePriceInCents?: Maybe<Scalars['Int']['output']>;
  redRookieRedemption?: Maybe<CollectRedRookieRedemption>;
  rotation?: Maybe<Scalars['Int']['output']>;
  /** aka Market Value in UI aka PWCC Value */
  safeMarketValue?: Maybe<Money>;
  serial?: Maybe<Scalars['String']['output']>;
  similarItemTransactions?: Maybe<Array<Maybe<CollectSale>>>;
  soldListing?: Maybe<CollectListing>;
  status?: Maybe<CollectVaultStatus>;
  subtitle?: Maybe<Scalars['String']['output']>;
  suggestedAskingPrice?: Maybe<Money>;
  suggestedAskingPriceRange?: Maybe<CollectPriceRange>;
  suggestedMinimumOfferValue?: Maybe<Money>;
  title: Scalars['String']['output'];
  /**
   * If this vault item can't be listed, this field will contain a string with reason.
   * Otherwise, this field will be null
   */
  unlistableReason?: Maybe<CollectUnableToListError>;
  unsoldListings?: Maybe<Array<Maybe<CollectListing>>>;
  vaultItemGroups?: Maybe<Array<Maybe<CollectVaultItemGroup>>>;
  vaultItemRequest?: Maybe<CollectVaultItemRequest>;
  /**
   * If this vault item can't be submitted in Vault Item Request, this field will contain a string with reason.
   * Otherwise, this field will be null
   */
  vaultItemRequestRejectionReason?: Maybe<CollectRejectToCreateVaultItemRequestError>;
  vaultSubmission?: Maybe<CollectVaultSubmission>;
  video?: Maybe<CollectExternalVideo>;
};


export type CollectVaultItemVaultItemGroupsArgs = {
  vaultItemGroupTypes?: InputMaybe<Array<InputMaybe<CollectVaultItemGroupType>>>;
};

export type CollectVaultItemConnection = {
  __typename?: 'CollectVaultItemConnection';
  edges?: Maybe<Array<Maybe<CollectVaultItemEdge>>>;
  pageInfo: PageInfo;
};

export type CollectVaultItemEdge = {
  __typename?: 'CollectVaultItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectVaultItem>;
};

export type CollectVaultItemForRequest = {
  __typename?: 'CollectVaultItemForRequest';
  vaultItem?: Maybe<CollectVaultItem>;
};

export type CollectVaultItemGroup = {
  __typename?: 'CollectVaultItemGroup';
  /** Expiration date of the VaultItemGroup */
  expiresOn?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Date and time the VaultItemGroup was inserted */
  insertedAt: Scalars['DateTime']['output'];
  /** Represents if a share is publically accessible */
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  /** Notes associated with the VaultItemGroup */
  notes?: Maybe<Scalars['String']['output']>;
  /** Number of historical vault items in the group */
  numHistoricalItems: Scalars['Int']['output'];
  /** Number of vault items in the group */
  numItems: Scalars['Int']['output'];
  shortLink?: Maybe<CollectShortLink>;
  /** Title of the VaultItemGroup */
  title: Scalars['String']['output'];
  /** Type of the VaultItemGroup either Folder or share */
  type: CollectVaultItemGroupType;
  updatedAt: Scalars['DateTime']['output'];
  /** URL UUID of the VaultItemGroup */
  urlUuid?: Maybe<Scalars['String']['output']>;
  vaultItems?: Maybe<Array<Maybe<CollectVaultItem>>>;
};

export enum CollectVaultItemGroupSortBy {
  /** Sort by creation time ascending */
  CreatedAtAsc = 'CREATED_AT_ASC',
  /** Sort by creation time descending */
  CreatedAtDesc = 'CREATED_AT_DESC',
  /** Sort by expiration date ascending */
  ExpirationDtAsc = 'EXPIRATION_DT_ASC',
  /** Sort by expiration date descending */
  ExpirationDtDesc = 'EXPIRATION_DT_DESC',
  /** Sort by title ascending */
  TitleAsc = 'TITLE_ASC',
  /** Sort by title descending */
  TitleDesc = 'TITLE_DESC',
  /** Sort by last updated time ascending */
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  /** Sort by last updated time descending */
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export enum CollectVaultItemGroupStatus {
  /** Represents active vault item groups */
  Active = 'ACTIVE',
  /** Represents inactive vault item groups */
  Inactive = 'INACTIVE'
}

/** Represents the 2 types of VaultItemGroup Folders and Shares */
export enum CollectVaultItemGroupType {
  /** Represents Folders */
  Folders = 'FOLDERS',
  /** Represents Shares */
  Shares = 'SHARES'
}

export type CollectVaultItemGroupsConnection = {
  __typename?: 'CollectVaultItemGroupsConnection';
  edges?: Maybe<Array<Maybe<CollectVaultItemGroupsEdge>>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type CollectVaultItemGroupsEdge = {
  __typename?: 'CollectVaultItemGroupsEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectVaultItemGroup>;
};

export type CollectVaultItemOrigin = {
  __typename?: 'CollectVaultItemOrigin';
  label?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CollectVaultItemOriginType>;
};

export enum CollectVaultItemOriginType {
  FixedPrice = 'FIXED_PRICE',
  InstantRips = 'INSTANT_RIPS',
  Premier = 'PREMIER',
  ToppsDirect = 'TOPPS_DIRECT',
  VaultSubmission = 'VAULT_SUBMISSION',
  Weekly = 'WEEKLY'
}

export type CollectVaultItemOwnerValue = {
  __typename?: 'CollectVaultItemOwnerValue';
  id: Scalars['UUID']['output'];
  ownerValue?: Maybe<Money>;
};

export type CollectVaultItemRequest = {
  __typename?: 'CollectVaultItemRequest';
  address?: Maybe<CollectVaultItemRequestAddress>;
  addressType?: Maybe<CollectVaultItemRequestAddressType>;
  backOfficeInvoiceId?: Maybe<Scalars['String']['output']>;
  combinedInvoice?: Maybe<CollectCombinedInvoice>;
  createdByEntity?: Maybe<CollectVaultItemRequestCreatedByEntity>;
  createdByEntityType?: Maybe<CollectVaultItemRequestCreatedByEntityTypes>;
  id: Scalars['Int']['output'];
  insertedAt: Scalars['DateTime']['output'];
  invoice?: Maybe<CollectInvoice>;
  items?: Maybe<CollectVaultItemConnection>;
  /** Vault Item Request states based on user context */
  states?: Maybe<CollectVaultItemRequestStates>;
  status: CollectVaultItemRequestStatus;
  toEntity?: Maybe<CollectVaultItemRequestToEntity>;
  toEntityType?: Maybe<CollectVaultItemRequestToEntityTypes>;
  trackingInfo?: Maybe<CollectVaultItemRequestTrackingInfo>;
  type: CollectVaultItemRequestType;
  updatedAt: Scalars['DateTime']['output'];
};


export type CollectVaultItemRequestItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectVaultItemRequestAddress = {
  __typename?: 'CollectVaultItemRequestAddress';
  city: Scalars['String']['output'];
  countryId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street1: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export enum CollectVaultItemRequestAddressType {
  Alternate = 'ALTERNATE',
  Default = 'DEFAULT',
  TradeShow = 'TRADE_SHOW'
}

export type CollectVaultItemRequestAlternateAddress = {
  city: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CollectVaultItemRequestCharges = CollectCheckoutCharges | CollectPickUpInPersonCharges | CollectSaleCharges | CollectTradeShowCheckoutCharges | CollectVaultRetrievalCharges;

export type CollectVaultItemRequestCreatedByEntity = CollectFixedPriceSale | CollectPremierSale | CollectUser | CollectWeeklySale;

export enum CollectVaultItemRequestCreatedByEntityTypes {
  EntityTypeAuctionSale = 'ENTITY_TYPE_AUCTION_SALE',
  EntityTypeExtendedSale = 'ENTITY_TYPE_EXTENDED_SALE',
  EntityTypeUser = 'ENTITY_TYPE_USER',
  EntityTypeVaultSale = 'ENTITY_TYPE_VAULT_SALE'
}

export type CollectVaultItemRequestDetails = {
  __typename?: 'CollectVaultItemRequestDetails';
  chargesInfo?: Maybe<CollectVaultItemRequestCharges>;
};

export enum CollectVaultItemRequestSortBy {
  /** Sort by creation time ascending */
  CreatedAtAsc = 'CREATED_AT_ASC',
  /** Sort by creation time descending */
  CreatedAtDesc = 'CREATED_AT_DESC',
  /** Sort by creating user ascending */
  CreatedByAsc = 'CREATED_BY_ASC',
  /** Sort by creating user descending */
  CreatedByDesc = 'CREATED_BY_DESC',
  /** Sort by status ascending */
  StatusAsc = 'STATUS_ASC',
  /** Sort by status descending */
  StatusDesc = 'STATUS_DESC',
  /** Sort by type ascending */
  TypeAsc = 'TYPE_ASC',
  /** Sort by type descending */
  TypeDesc = 'TYPE_DESC',
  /** Sort by last updated time ascending */
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  /** Sort by last updated time descending */
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type CollectVaultItemRequestStates = {
  __typename?: 'CollectVaultItemRequestStates';
  userCanCancel?: Maybe<Scalars['Boolean']['output']>;
  userCanUpdate?: Maybe<Scalars['Boolean']['output']>;
};

export enum CollectVaultItemRequestStatus {
  AwaitingReturn = 'AWAITING_RETURN',
  AwaitingReview = 'AWAITING_REVIEW',
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Open = 'OPEN',
  ReadyToProcess = 'READY_TO_PROCESS',
  ReadyToShip = 'READY_TO_SHIP'
}

export type CollectVaultItemRequestToEntity = CollectAddress | CollectTradeShow | CollectUser;

export enum CollectVaultItemRequestToEntityTypes {
  EntityTypeAddress = 'ENTITY_TYPE_ADDRESS',
  EntityTypeAuctionSchedule = 'ENTITY_TYPE_AUCTION_SCHEDULE',
  EntityTypeEbayAddress = 'ENTITY_TYPE_EBAY_ADDRESS',
  EntityTypeExtendedAuction = 'ENTITY_TYPE_EXTENDED_AUCTION',
  EntityTypeTradeShow = 'ENTITY_TYPE_TRADE_SHOW',
  EntityTypeUser = 'ENTITY_TYPE_USER'
}

export type CollectVaultItemRequestTrackingInfo = {
  __typename?: 'CollectVaultItemRequestTrackingInfo';
  carrier: CollectShippingService;
  trackingNumber: Scalars['String']['output'];
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export enum CollectVaultItemRequestType {
  AdminSaleTransfer = 'ADMIN_SALE_TRANSFER',
  AdminTransfer = 'ADMIN_TRANSFER',
  AuctionSale = 'AUCTION_SALE',
  BackOfficeOrder = 'BACK_OFFICE_ORDER',
  Checkout = 'CHECKOUT',
  ExtendedSale = 'EXTENDED_SALE',
  External = 'EXTERNAL',
  FulfillToVault = 'FULFILL_TO_VAULT',
  Grade = 'GRADE',
  InstantRipsReveal = 'INSTANT_RIPS_REVEAL',
  PickUpInPerson = 'PICK_UP_IN_PERSON',
  RedemptionTransfer = 'REDEMPTION_TRANSFER',
  Retrieval = 'RETRIEVAL',
  SendAuction = 'SEND_AUCTION',
  SendExtendedAuction = 'SEND_EXTENDED_AUCTION',
  TradeShowCheckout = 'TRADE_SHOW_CHECKOUT',
  Transfer = 'TRANSFER',
  VaultSale = 'VAULT_SALE',
  Verify = 'VERIFY'
}

export type CollectVaultItemRequestsConnection = {
  __typename?: 'CollectVaultItemRequestsConnection';
  edges?: Maybe<Array<Maybe<CollectVaultItemRequestsEdge>>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type CollectVaultItemRequestsEdge = {
  __typename?: 'CollectVaultItemRequestsEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectVaultItemRequest>;
};

export enum CollectVaultItemState {
  All = 'ALL',
  ArchivedOnly = 'ARCHIVED_ONLY',
  BuyNowListed = 'BUY_NOW_LISTED',
  CheckedOutByOwner = 'CHECKED_OUT_BY_OWNER',
  Historical = 'HISTORICAL',
  OwnershipTransfer = 'OWNERSHIP_TRANSFER',
  PendingMove = 'PENDING_MOVE',
  PremierSubmitted = 'PREMIER_SUBMITTED',
  UnlistedOnly = 'UNLISTED_ONLY',
  WeeklySubmitted = 'WEEKLY_SUBMITTED'
}

/** Vault item state */
export enum CollectVaultItemStateArg {
  /** All */
  All = 'ALL',
  /** Archived only */
  ArchivedOnly = 'ARCHIVED_ONLY',
  /** Buy now listed */
  BuyNowListed = 'BUY_NOW_LISTED',
  /** Checked out by owner */
  CheckedOutByOwner = 'CHECKED_OUT_BY_OWNER',
  /** Historical */
  Historical = 'HISTORICAL',
  /** Ownership transfer */
  OwnershipTransfer = 'OWNERSHIP_TRANSFER',
  /** Pending move */
  PendingMove = 'PENDING_MOVE',
  /** Premier submitted */
  PremierSubmitted = 'PREMIER_SUBMITTED',
  /** Weekly submitted */
  WeeklySubmitted = 'WEEKLY_SUBMITTED'
}

export type CollectVaultItemsConnection = {
  __typename?: 'CollectVaultItemsConnection';
  edges?: Maybe<Array<Maybe<CollectVaultItemsEdge>>>;
  insuredValue: Money;
  ownerValue: Money;
  ownerValueCount: Scalars['Int']['output'];
  pageInfo: PageInfo;
  safeMarketValue: Money;
  total: Scalars['Int']['output'];
};

export type CollectVaultItemsEdge = {
  __typename?: 'CollectVaultItemsEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectVaultItem>;
};

export type CollectVaultItemsExportPayload = {
  __typename?: 'CollectVaultItemsExportPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectVaultItemsExportResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The response of Vault Items export */
export type CollectVaultItemsExportResponse = {
  __typename?: 'CollectVaultItemsExportResponse';
  vaultItemsExportFileUrl?: Maybe<Scalars['String']['output']>;
};

export type CollectVaultItemsForRequestConnection = {
  __typename?: 'CollectVaultItemsForRequestConnection';
  edges?: Maybe<Array<Maybe<CollectVaultItemsForRequestEdge>>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type CollectVaultItemsForRequestEdge = {
  __typename?: 'CollectVaultItemsForRequestEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectVaultItemForRequest>;
};

export enum CollectVaultItemsForRequestInputType {
  Checkout = 'CHECKOUT',
  PickUpInPerson = 'PICK_UP_IN_PERSON',
  Retrieval = 'RETRIEVAL',
  TradeShowCheckout = 'TRADE_SHOW_CHECKOUT',
  Transfer = 'TRANSFER'
}

export type CollectVaultItemsMarketValueStatistics = {
  __typename?: 'CollectVaultItemsMarketValueStatistics';
  average?: Maybe<Scalars['Float']['output']>;
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ceiling?: Maybe<Scalars['Int']['output']>;
  floor?: Maybe<Scalars['Int']['output']>;
};

export enum CollectVaultListingType {
  Bo = 'BO',
  FixedPrice = 'FIXED_PRICE'
}

export enum CollectVaultRetrievalAddressType {
  Alternate = 'ALTERNATE',
  Default = 'DEFAULT'
}

export type CollectVaultRetrievalAlternateAddress = {
  city: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CollectVaultRetrievalCharges = {
  __typename?: 'CollectVaultRetrievalCharges';
  additionalFee: Money;
  fulfillmentFee: Money;
  insuredValue: Money;
  needsUnderwriting: Scalars['Boolean']['output'];
  shippingFee?: Maybe<Money>;
};

export type CollectVaultRetrievalSummary = {
  __typename?: 'CollectVaultRetrievalSummary';
  additionalFee: Money;
  fulfillmentFee: Money;
  insuredValue: Money;
  needsUnderwriting: Scalars['Boolean']['output'];
  shippingFee?: Maybe<Money>;
};

export enum CollectVaultSortBy {
  /** Sort by highest value first */
  HighestValue = 'HIGHEST_VALUE',
  /** Sort by item type ascending, used only for collectVaultItemsChecklist */
  ItemTypeAsc = 'ITEM_TYPE_ASC',
  /** Sort by item type descending, used only for collectVaultItemsChecklist */
  ItemTypeDesc = 'ITEM_TYPE_DESC',
  /** Sort by lowest value first */
  LowestValue = 'LOWEST_VALUE',
  /** Sort by recently added items */
  RecentlyAdded = 'RECENTLY_ADDED',
  /** Sort by title ascending */
  TitleAsc = 'TITLE_ASC',
  /** Sort by title descending */
  TitleDesc = 'TITLE_DESC'
}

/** Vault sort by */
export enum CollectVaultSortByDeprecated {
  /** Highest value */
  HighestValue = 'HIGHEST_VALUE',
  /** Lowest value */
  LowestValue = 'LOWEST_VALUE',
  /** Recently added */
  RecentlyAdded = 'RECENTLY_ADDED',
  /** Title asc */
  TitleAsc = 'TITLE_ASC',
  /** Title desc */
  TitleDesc = 'TITLE_DESC'
}

export enum CollectVaultStatus {
  /** @deprecated Deprecated */
  StatusAwaitingAppraisal = 'STATUS_AWAITING_APPRAISAL',
  StatusAwaitingCuration = 'STATUS_AWAITING_CURATION',
  StatusAwaitingGradingFee = 'STATUS_AWAITING_GRADING_FEE',
  StatusAwaitingReview = 'STATUS_AWAITING_REVIEW',
  StatusCurated = 'STATUS_CURATED',
  StatusFulfilled = 'STATUS_FULFILLED',
  StatusGraded = 'STATUS_GRADED',
  StatusLocked = 'STATUS_LOCKED',
  StatusPendingSale = 'STATUS_PENDING_SALE',
  StatusProcessing = 'STATUS_PROCESSING',
  StatusReturned = 'STATUS_RETURNED',
  StatusSentAuction = 'STATUS_SENT_AUCTION',
  StatusSentExchange = 'STATUS_SENT_EXCHANGE',
  StatusSentNft = 'STATUS_SENT_NFT',
  StatusSold = 'STATUS_SOLD',
  StatusTransferred = 'STATUS_TRANSFERRED',
  StatusUnsold = 'STATUS_UNSOLD'
}

export type CollectVaultSubmission = {
  __typename?: 'CollectVaultSubmission';
  autoRedeem?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<CollectVaultSubmissionCategory>;
  curatedItemsCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  estimatedValue: Money;
  grader?: Maybe<CollectVaultSubmissionGrader>;
  id: Scalars['UUID']['output'];
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  integerId: Scalars['Int']['output'];
  intent: CollectVaultSubmissionIntent;
  items?: Maybe<CollectVaultSubmissionItemsConnection>;
  packingSlipUrl?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  questions?: Maybe<Scalars['String']['output']>;
  receiptConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  receivedAt?: Maybe<Scalars['DateTime']['output']>;
  receivedForGradingAt?: Maybe<Scalars['DateTime']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  status: CollectVaultSubmissionStatus;
  trackingNumber?: Maybe<Scalars['String']['output']>;
};


export type CollectVaultSubmissionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectVaultSubmissionCategory = {
  __typename?: 'CollectVaultSubmissionCategory';
  code: CollectVaultSubmissionCategoryCode;
  name: Scalars['String']['output'];
};

export enum CollectVaultSubmissionCategoryCode {
  AuthenticatedCards = 'AUTHENTICATED_CARDS',
  AuthenticatedLarge = 'AUTHENTICATED_LARGE',
  AuthenticatedWax = 'AUTHENTICATED_WAX',
  CoinsCurrency = 'COINS_CURRENCY',
  Memorabilia = 'MEMORABILIA',
  Misc = 'MISC',
  RawCards = 'RAW_CARDS',
  RedRookieRedemption = 'RED_ROOKIE_REDEMPTION'
}

export enum CollectVaultSubmissionGrader {
  Beckett = 'BECKETT',
  Cgc = 'CGC',
  CgcAuth = 'CGC_AUTH',
  Mba = 'MBA',
  Psa = 'PSA',
  Sgc = 'SGC'
}

export type CollectVaultSubmissionGradingRate = {
  __typename?: 'CollectVaultSubmissionGradingRate';
  grader: CollectVaultSubmissionGrader;
  max?: Maybe<Money>;
  min: Money;
};

export enum CollectVaultSubmissionIntent {
  Premier = 'PREMIER',
  RedRookieRedemption = 'RED_ROOKIE_REDEMPTION',
  Vault = 'VAULT',
  Weekly = 'WEEKLY'
}

export type CollectVaultSubmissionItemsConnection = {
  __typename?: 'CollectVaultSubmissionItemsConnection';
  edges?: Maybe<Array<Maybe<CollectVaultSubmissionItemsEdge>>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type CollectVaultSubmissionItemsEdge = {
  __typename?: 'CollectVaultSubmissionItemsEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectVaultItem>;
};

export type CollectVaultSubmissionProcessingRate = {
  __typename?: 'CollectVaultSubmissionProcessingRate';
  max?: Maybe<Money>;
  min: Money;
};

export type CollectVaultSubmissionRates = {
  __typename?: 'CollectVaultSubmissionRates';
  gradingRates?: Maybe<Array<Maybe<CollectVaultSubmissionGradingRate>>>;
  processingRate: CollectVaultSubmissionProcessingRate;
};

export enum CollectVaultSubmissionStatus {
  Grading = 'GRADING',
  Received = 'RECEIVED',
  Started = 'STARTED',
  Submitted = 'SUBMITTED',
  Unknown = 'UNKNOWN'
}

export type CollectVaultSubmissionSummary = {
  __typename?: 'CollectVaultSubmissionSummary';
  autoRedeem?: Maybe<Scalars['Boolean']['output']>;
  estimatedValue: Money;
  grader?: Maybe<CollectVaultSubmissionGrader>;
  gradingFee?: Maybe<Money>;
  gradingFeePerItem?: Maybe<Money>;
  intent: CollectVaultSubmissionIntent;
  itemsNumber: Scalars['Int']['output'];
  processingFee: Money;
  shippingFee: Money;
  taxFee: Money;
  totalFee: Money;
  vaultId: Scalars['Int']['output'];
};

export type CollectVaultSubmissionsConnection = {
  __typename?: 'CollectVaultSubmissionsConnection';
  edges?: Maybe<Array<Maybe<CollectVaultSubmissionsEdge>>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type CollectVaultSubmissionsEdge = {
  __typename?: 'CollectVaultSubmissionsEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectVaultSubmission>;
};

export type CollectVerifyMfaPayload = {
  __typename?: 'CollectVerifyMfaPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectVerifyPhonePayload = {
  __typename?: 'CollectVerifyPhonePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectVerifySessionEmailOtpPayload = {
  __typename?: 'CollectVerifySessionEmailOtpPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectWatchListingPayload = {
  __typename?: 'CollectWatchListingPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectWatchListingResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectWatchListingResponse = {
  __typename?: 'CollectWatchListingResponse';
  listing?: Maybe<CollectListing>;
};

export type CollectWatchlistConnection = {
  __typename?: 'CollectWatchlistConnection';
  edges?: Maybe<Array<Maybe<CollectWatchlistEdge>>>;
  pageInfo: PageInfo;
  total: Scalars['Int']['output'];
};

export type CollectWatchlistEdge = {
  __typename?: 'CollectWatchlistEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectListing>;
};

export type CollectWeeklyAuction = CollectAuction & {
  __typename?: 'CollectWeeklyAuction';
  /** Does this auction allow flash submissions at the moment */
  allowsFlashSubmissions?: Maybe<Scalars['Boolean']['output']>;
  auctionIntegerId?: Maybe<Scalars['Int']['output']>;
  collectListingTimer: CollectListingTimer;
  /** Same as starts_at, this is coming from auction table ends at, and always in UTC timezone. */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  integerId?: Maybe<Scalars['Int']['output']>;
  /** Identifies whether an auction is custom */
  isCustom?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  payoutDate?: Maybe<Scalars['Date']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  /**
   * The actual starts_at timestamp of the weekly auction.
   * In application logic we always use the auction starts_at timestamp, instead of the
   * start_date field on auction_schedule table. This timestamp is always in UTC timezone
   */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  status: CollectAuctionStatus;
  /** Applicable only for custom auctions */
  subtitle?: Maybe<Scalars['String']['output']>;
};

export type CollectWeeklyAuctionBid = {
  __typename?: 'CollectWeeklyAuctionBid';
  status: CollectWeeklyAuctionBidStatus;
  uuid: Scalars['UUID']['output'];
};

export type CollectWeeklyAuctionBidConnection = {
  __typename?: 'CollectWeeklyAuctionBidConnection';
  edges?: Maybe<Array<Maybe<CollectWeeklyAuctionBidEdge>>>;
  pageInfo: PageInfo;
};

export type CollectWeeklyAuctionBidEdge = {
  __typename?: 'CollectWeeklyAuctionBidEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectWeeklyAuctionBid>;
};

export enum CollectWeeklyAuctionBidStatus {
  StatusFirst = 'STATUS_FIRST',
  StatusNewHighest = 'STATUS_NEW_HIGHEST',
  StatusNewSecondHighest = 'STATUS_NEW_SECOND_HIGHEST',
  StatusNotProcessed = 'STATUS_NOT_PROCESSED',
  StatusRejected = 'STATUS_REJECTED',
  StatusStale = 'STATUS_STALE',
  StatusUpdatedHighest = 'STATUS_UPDATED_HIGHEST'
}

export type CollectWeeklySale = CollectMarketplaceSale & {
  __typename?: 'CollectWeeklySale';
  buyersPremium?: Maybe<Money>;
  id: Scalars['UUID']['output'];
  integerId: Scalars['Int']['output'];
  /** Not affected by faster listing query optimization */
  listing?: Maybe<CollectListing>;
  purchasePrice?: Maybe<Money>;
  shipping?: Maybe<Money>;
  tax?: Maybe<Money>;
  total?: Maybe<Money>;
};

export type CollectionsAccount = {
  __typename?: 'CollectionsAccount';
  customLists?: Maybe<CollectionsCustomListConnection>;
  id?: Maybe<Scalars['UUID']['output']>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<CollectUser>;
};


export type CollectionsAccountCustomListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionsAddItemsToCustomListPayload = {
  __typename?: 'CollectionsAddItemsToCustomListPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectionsAddItemsToCustomListResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectionsAddItemsToCustomListResponse = {
  __typename?: 'CollectionsAddItemsToCustomListResponse';
  customList?: Maybe<CollectionsCustomList>;
};

export type CollectionsAddItemsToCustomListsPayload = {
  __typename?: 'CollectionsAddItemsToCustomListsPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectionsAddItemsToCustomListsResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectionsAddItemsToCustomListsResponse = {
  __typename?: 'CollectionsAddItemsToCustomListsResponse';
  customLists: Array<CollectionsCustomList>;
};

export type CollectionsCategory = {
  __typename?: 'CollectionsCategory';
  /** It is an opaque string now but it may be a UUID in the future */
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CollectionsCategoryConnection = {
  __typename?: 'CollectionsCategoryConnection';
  edges?: Maybe<Array<Maybe<CollectionsCategoryEdge>>>;
  pageInfo: PageInfo;
};

export type CollectionsCategoryEdge = {
  __typename?: 'CollectionsCategoryEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectionsCategory>;
};

export type CollectionsCreateCustomListInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CollectionsCreateCustomListPayload = {
  __typename?: 'CollectionsCreateCustomListPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectionsCreateCustomListResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectionsCreateCustomListResponse = {
  __typename?: 'CollectionsCreateCustomListResponse';
  customList?: Maybe<CollectionsCustomList>;
};

export type CollectionsCustodySubmittedInfo = {
  __typename?: 'CollectionsCustodySubmittedInfo';
  /** The vault submission that this collection item is submitted in */
  submission?: Maybe<CollectVaultSubmission>;
};

export type CollectionsCustodyVaultInfo = {
  __typename?: 'CollectionsCustodyVaultInfo';
  /** The vault item that this collection item is custodied in */
  vaultItem?: Maybe<CollectVaultItem>;
};

export type CollectionsCustomList = {
  __typename?: 'CollectionsCustomList';
  background?: Maybe<Scalars['String']['output']>;
  collectionsItems?: Maybe<CollectionsItemConnection>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  itemsCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the ownerUser field instead */
  ownerAccount?: Maybe<CollectionsAccount>;
  ownerUser?: Maybe<CollectionsUser>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type CollectionsCustomListCollectionsItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CollectionsItemsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CollectionsCustomListConnection = {
  __typename?: 'CollectionsCustomListConnection';
  collectionCount?: Maybe<Scalars['Int']['output']>;
  edges?: Maybe<Array<Maybe<CollectionsCustomListEdge>>>;
  pageInfo: PageInfo;
};

export type CollectionsCustomListEdge = {
  __typename?: 'CollectionsCustomListEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectionsCustomList>;
};

export type CollectionsDeleteCustomListPayload = {
  __typename?: 'CollectionsDeleteCustomListPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectionsDeleteCustomListResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectionsDeleteCustomListResponse = {
  __typename?: 'CollectionsDeleteCustomListResponse';
  customListId?: Maybe<Scalars['UUID']['output']>;
};

export type CollectionsItem = {
  __typename?: 'CollectionsItem';
  brand?: Maybe<Scalars['String']['output']>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<Scalars['UUID']['output']>;
  categoryTags?: Maybe<Array<Scalars['String']['output']>>;
  custodyInfo?: Maybe<CustodyInfo>;
  custodyType?: Maybe<CustodyType>;
  /** @deprecated Use the grading_info.grade field instead */
  grade?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use the grading_info.grader_name field instead */
  grader?: Maybe<Scalars['String']['output']>;
  gradingInfo?: Maybe<GradingInfo>;
  gradingStatus?: Maybe<GradingStatus>;
  guideMarketValue?: Maybe<Money>;
  id?: Maybe<Scalars['UUID']['output']>;
  images?: Maybe<Array<Scalars['String']['output']>>;
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated This field is no longer used */
  listingStatus?: Maybe<Scalars['String']['output']>;
  ownerAccount?: Maybe<CollectionsAccount>;
  ownerUser?: Maybe<CollectionsUser>;
  parallel?: Maybe<Scalars['String']['output']>;
  pricingInfo?: Maybe<PricingInfo>;
  productId?: Maybe<Scalars['UUID']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  purchaseDate?: Maybe<Scalars['Date']['output']>;
  purchasePrice?: Maybe<Money>;
  serial?: Maybe<Scalars['String']['output']>;
  setName?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is no longer used */
  soldAt?: Maybe<Scalars['DateTime']['output']>;
  sourceScanItemId?: Maybe<Scalars['UUID']['output']>;
  /** @deprecated This field is no longer used */
  sourceVaultExitedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use the custody_info.vault_item field instead when custody_type is VAULT */
  sourceVaultItem?: Maybe<CollectVaultItem>;
  subjectName?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  variantId?: Maybe<Scalars['UUID']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type CollectionsItemConnection = {
  __typename?: 'CollectionsItemConnection';
  edges?: Maybe<Array<Maybe<CollectionsItemEdge>>>;
  pageInfo: PageInfo;
  pageSize?: Maybe<Scalars['Int']['output']>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  totalValue?: Maybe<Money>;
};

export type CollectionsItemEdge = {
  __typename?: 'CollectionsItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CollectionsItem>;
};

export type CollectionsItemsFilters = {
  authenticators?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryTags?: InputMaybe<Array<Scalars['String']['input']>>;
  custodyType?: InputMaybe<CustodyType>;
  customListIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  gradeFrom?: InputMaybe<Scalars['Int']['input']>;
  gradeTo?: InputMaybe<Scalars['Int']['input']>;
  guidePriceFrom?: InputMaybe<Scalars['Int']['input']>;
  guidePriceTo?: InputMaybe<Scalars['Int']['input']>;
  listed?: InputMaybe<Scalars['Boolean']['input']>;
  origins?: InputMaybe<Array<InputMaybe<CollectVaultItemOriginType>>>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<CollectionsItemsSort>;
  yearFrom?: InputMaybe<Scalars['Int']['input']>;
  yearTo?: InputMaybe<Scalars['Int']['input']>;
};

export enum CollectionsItemsSort {
  HighestGuidePrice = 'HIGHEST_GUIDE_PRICE',
  LowestGuidePrice = 'LOWEST_GUIDE_PRICE',
  NewestYear = 'NEWEST_YEAR',
  OldestYear = 'OLDEST_YEAR',
  RecentlyAdded = 'RECENTLY_ADDED',
  TitleAscending = 'TITLE_ASCENDING',
  TitleDescending = 'TITLE_DESCENDING'
}

export type CollectionsRemoveItemsFromCustomListPayload = {
  __typename?: 'CollectionsRemoveItemsFromCustomListPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectionsRemoveItemsFromCustomListResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectionsRemoveItemsFromCustomListResponse = {
  __typename?: 'CollectionsRemoveItemsFromCustomListResponse';
  customList?: Maybe<CollectionsCustomList>;
};

export type CollectionsUpdateCustomListInput = {
  background?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CollectionsUpdateCustomListPayload = {
  __typename?: 'CollectionsUpdateCustomListPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CollectionsUpdateCustomListResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CollectionsUpdateCustomListResponse = {
  __typename?: 'CollectionsUpdateCustomListResponse';
  customList?: Maybe<CollectionsCustomList>;
};

export type CollectionsUser = {
  __typename?: 'CollectionsUser';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export enum Country {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bv = 'BV',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gs = 'GS',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hm = 'HM',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pn = 'PN',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tf = 'TF',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Um = 'UM',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

export type CreateBreakPayload = {
  __typename?: 'CreateBreakPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CreateBreakResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CreateBreakResponse = {
  __typename?: 'CreateBreakResponse';
  break?: Maybe<Break>;
};

export type CreateConsignmentInput = {
  breakId: Scalars['ID']['input'];
  livestreamId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  screenshot?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConsignmentPayload = {
  __typename?: 'CreateConsignmentPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CreateConsignmentResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CreateConsignmentResult = {
  __typename?: 'CreateConsignmentResult';
  status?: Maybe<Scalars['String']['output']>;
};

export type CreateGiveawayPayload = {
  __typename?: 'CreateGiveawayPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CreateGiveawayResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CreateGiveawayResponse = {
  __typename?: 'CreateGiveawayResponse';
  foundUsers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  giveaway?: Maybe<Giveaway>;
  notFoundUsers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userCounts?: Maybe<UserCounts>;
};

export type CreateGiveawayResponsePayload = {
  __typename?: 'CreateGiveawayResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<GiveawayResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for creating a new live stream. */
export type CreateLiveStreamInput = {
  /** The ID of the channel where the livestream will be broadcasted. */
  channelId: Scalars['ID']['input'];
  /** The URL of the cover image for the livestream. */
  coverImage: Scalars['String']['input'];
  /** The name of the livestream. */
  name: Scalars['String']['input'];
  /** The starting time of the livestream in UTC. */
  startsAt: Scalars['DateTime']['input'];
};

export type CreateLiveStreamPayload = {
  __typename?: 'CreateLiveStreamPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveStreamResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CreatePersonalInput = {
  /** The product configuration */
  breakProductsConfig: Array<InputMaybe<PersonalProductsConfigs>>;
  /** If the listing has an auction, this field enables extended bidding */
  extendedBiddingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the listing has an auction, this field sets the extended bidding refill threshold in seconds */
  extendedBiddingRefillThresholdInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** The categories of the products */
  leagues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The live stream ID of the listing */
  liveStreamId: Scalars['UUID']['input'];
  /** If the listing has an auction, this field sets the minimum bid amount */
  minimumBidAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  /** Cost basis of the listing */
  priceInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The listing's pricing type */
  pricingType: BreakPricingType;
  /** The quantity of the personal */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The unique identifier of a shipping profile ID belonging to the shop to be used with a given break */
  shippingProfileId?: InputMaybe<Scalars['UUID']['input']>;
  /** The title of the listing */
  title: Scalars['String']['input'];
};

/** Input for creating a repack allocation */
export type CreateRepackAllocationInput = {
  /** ID of the child shop to allocate the repack to */
  childShopId: Scalars['UUID']['input'];
  /** ID of the parent repack */
  parentRepackId: Scalars['UUID']['input'];
  /** Quantity to allocate */
  quantity: Scalars['Int']['input'];
};

export type CreateRepackAllocationPayload = {
  __typename?: 'CreateRepackAllocationPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Repack>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Input for creating a new repack */
export type CreateRepackInput = {
  /** The break template ID to associate with this checklist */
  breakTemplateId?: InputMaybe<Scalars['UUID']['input']>;
  /** The hexadecimal color of the checklist */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Description of the checklist */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether the checklist is dynamic */
  isDynamic: Scalars['Boolean']['input'];
  /** List of items to include */
  items: Array<RepackItemInput>;
  /** The MSRP of the repack in cents */
  msrpInCents?: InputMaybe<Scalars['Int']['input']>;
  /** Pack texture category */
  packTextureCategory?: InputMaybe<PackTextureCategory>;
  /** Pack tier (1-4) */
  packTier?: InputMaybe<Scalars['Int']['input']>;
  /** Configuration of repack */
  repackConfiguration?: InputMaybe<RepackConfigurationInput>;
  /** The path of the checklist */
  repackUrl?: InputMaybe<Scalars['String']['input']>;
  /** Status of the repack */
  status: RepackStatus;
  /** The path of the pack texture */
  textureUrl?: InputMaybe<Scalars['String']['input']>;
  /** Title of the checklist */
  title: Scalars['String']['input'];
  /** The variant of this checklist, can hold values (standard, gold) */
  variant?: InputMaybe<RepackVariant>;
  /** Vault tenant ID to source items from for dynamic checklists */
  vaultSourceTenantId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Payload for creating or updating a repack */
export type CreateRepackPayload = {
  __typename?: 'CreateRepackPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Repack>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Input for the createShopProduct mutation */
export type CreateShopProductInput = {
  /** the break id, optional */
  breakId?: InputMaybe<Scalars['UUID']['input']>;
  /** The cost of the product in cents */
  costInCents: Scalars['Int']['input'];
  /** the product id */
  productId: Scalars['UUID']['input'];
  /** the number of products we want to associate to a shop */
  quantity: Scalars['Int']['input'];
  /** the shop id */
  shopId: Scalars['UUID']['input'];
};

/** Input for creating a new wax checklist */
export type CreateWaxChecklistInput = {
  /** Description of the checklist */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The MSRP of the repack in cents */
  msrpInCents?: InputMaybe<Scalars['Int']['input']>;
  /** Configuration of repack */
  repackConfiguration?: InputMaybe<RepackConfigurationInput>;
  /** Status of the repack */
  status: RepackStatus;
  /** The path of the pack texture */
  textureUrl?: InputMaybe<Scalars['String']['input']>;
  /** Title of the checklist */
  title: Scalars['String']['input'];
  /** Vault tenant ID to source items from for wax checklists */
  vaultSourceTenantId: Scalars['UUID']['input'];
  /** List of wax treatments for this checklist */
  waxTreatments: Array<WaxTreatmentInput>;
};

/** Newly created account and auth tokens */
export type CreatedUser = {
  __typename?: 'CreatedUser';
  /** Token with a short expiry that can be used to gain access to the application. */
  accessToken: Scalars['String']['output'];
  /** The user's email address */
  email: Scalars['String']['output'];
  /** The user's unique ID */
  id: Scalars['UUID']['output'];
  /** A timestamp indicating when this user was created */
  insertedAt: Scalars['DateTime']['output'];
  /** Token with a long expiry that can only be used to get a new access token. */
  refreshToken: Scalars['String']['output'];
  /** The user's username */
  username: Scalars['String']['output'];
};

export enum CreditDebit {
  /** The transaction is a credit (an increase in balance) */
  Credit = 'CREDIT',
  /** The transaction is a debit (a decrease in balance) */
  Debit = 'DEBIT'
}

/** Generic metadata which relates to a transaction */
export type CreditPurchaseMetadata = {
  __typename?: 'CreditPurchaseMetadata';
  transactionId?: Maybe<Scalars['String']['output']>;
  transactionUrl?: Maybe<Scalars['String']['output']>;
};

export enum CreditPurchaseStatus {
  /** The transaction is confirmed */
  Confirmed = 'CONFIRMED',
  /** The transaction has failed */
  Failed = 'FAILED',
  /** The transaction is new */
  New = 'NEW',
  /** The transaction is pending */
  Pending = 'PENDING'
}

/** A credit purchase transaction */
export type CreditPurchaseTransaction = {
  __typename?: 'CreditPurchaseTransaction';
  /** The amount of the transaction */
  amount: MoneyAmount;
  /** The time at which the transaction was created (UTC) */
  date: Scalars['DateTime']['output'];
  /** The description of the transaction */
  description: Scalars['String']['output'];
  /** Metadata associated with the transaction */
  metadata: CreditPurchaseMetadata;
  /** The status of the transaction */
  status: CreditPurchaseStatus;
  /** The type of transaction */
  type: CreditPurchaseTransactionType;
};

export type CreditPurchaseTransactionConnection = {
  __typename?: 'CreditPurchaseTransactionConnection';
  edges?: Maybe<Array<Maybe<CreditPurchaseTransactionEdge>>>;
  pageInfo: PageInfo;
};

export type CreditPurchaseTransactionEdge = {
  __typename?: 'CreditPurchaseTransactionEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CreditPurchaseTransaction>;
};

export enum CreditPurchaseTransactionType {
  /** The transaction is related to ACH */
  Ach = 'ACH',
  /** The transaction is related to BitPay */
  Bitpay = 'BITPAY',
  /** The transaction is related to Coinbase */
  Coinbase = 'COINBASE'
}

/** A crypto invoice */
export type CryptoInvoice = {
  __typename?: 'CryptoInvoice';
  /** The currency of the crypto invoice */
  currency: Scalars['String']['output'];
  /** The ID of the crypto invoice */
  id: Scalars['ID']['output'];
  /** The item description of the crypto invoice */
  itemDesc: Scalars['String']['output'];
  /** The price of the crypto invoice */
  price: Scalars['Float']['output'];
  /** The status of the crypto invoice */
  status: Scalars['String']['output'];
  /** The URL of the crypto invoice */
  url: Scalars['String']['output'];
};

/** Input object for creating a crypto invoice */
export type CryptoInvoiceCreateInput = {
  /** The details of the items in the invoice */
  itemDetails: Scalars['String']['input'];
  /** The price of the invoice */
  price: Scalars['Float']['input'];
};

/** Filter for bid status on BIDS_* exports */
export enum CsvBidStatusFilter {
  Outbid = 'OUTBID',
  Winning = 'WINNING'
}

/** Filters for SELLING_* CSV exports */
export type CsvExportFiltersInput = {
  /** UUID of auction_schedule (weekly) or extended_auction (premier) - only for Auction/Premier exports */
  auctionId?: InputMaybe<Scalars['String']['input']>;
  /** Category names as strings (e.g. 'Baseball', 'Basketball') - matches listing query format */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Eye appeal grades as strings (e.g. 'ABOVE_AVERAGE', 'EXCEPTIONAL', 'SUPERIOR') - matches DB values */
  eyeAppeal?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyeAppealGrades?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  folderIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gradingServiceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Grading service names (e.g. 'PSA', 'BGS', 'SGC') - matches listing query format */
  gradingServices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pricesRange?: InputMaybe<CsvExportPriceRangeInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  yearsRange?: InputMaybe<CsvExportYearRangeInput>;
};

/** Price range filter for CSV exports */
export type CsvExportPriceRangeInput = {
  maxPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  minPriceInCents?: InputMaybe<Scalars['Int']['input']>;
};

/** Available CSV export types */
export enum CsvExportType {
  /** @deprecated Bids CSV exports are no longer supported per product requirements. */
  BidsActiveAuctions = 'BIDS_ACTIVE_AUCTIONS',
  /** @deprecated Bids CSV exports are no longer supported per product requirements. */
  BidsActivePremier = 'BIDS_ACTIVE_PREMIER',
  /** @deprecated Bids CSV exports are no longer supported per product requirements. */
  BidsEndedAuctions = 'BIDS_ENDED_AUCTIONS',
  /** @deprecated Bids CSV exports are no longer supported per product requirements. */
  BidsEndedPremier = 'BIDS_ENDED_PREMIER',
  /** @deprecated Offers CSV exports are not supported per product requirements. */
  OffersBuying = 'OFFERS_BUYING',
  /** @deprecated Offers CSV exports are not supported per product requirements. */
  OffersSelling = 'OFFERS_SELLING',
  /** @deprecated Orders CSV exports are not supported per product requirements. */
  Orders = 'ORDERS',
  SellingActiveAuction = 'SELLING_ACTIVE_AUCTION',
  SellingActiveBuyNow = 'SELLING_ACTIVE_BUY_NOW',
  SellingActivePremier = 'SELLING_ACTIVE_PREMIER',
  SellingScheduledAuction = 'SELLING_SCHEDULED_AUCTION',
  SellingScheduledPremier = 'SELLING_SCHEDULED_PREMIER',
  SellingSoldAuction = 'SELLING_SOLD_AUCTION',
  SellingSoldBuyNow = 'SELLING_SOLD_BUY_NOW',
  SellingSoldPremier = 'SELLING_SOLD_PREMIER',
  SellingUnsoldAuction = 'SELLING_UNSOLD_AUCTION',
  SellingUnsoldBuyNow = 'SELLING_UNSOLD_BUY_NOW',
  SellingUnsoldPremier = 'SELLING_UNSOLD_PREMIER',
  Unspecified = 'UNSPECIFIED',
  /** @deprecated Watchlist CSV exports are no longer supported. */
  WatchlistActiveAuction = 'WATCHLIST_ACTIVE_AUCTION',
  /** @deprecated Watchlist CSV exports are no longer supported. */
  WatchlistActiveBuyNow = 'WATCHLIST_ACTIVE_BUY_NOW',
  /** @deprecated Watchlist CSV exports are no longer supported. */
  WatchlistActivePremier = 'WATCHLIST_ACTIVE_PREMIER',
  /** @deprecated Watchlist CSV exports are no longer supported. */
  WatchlistEndedAuction = 'WATCHLIST_ENDED_AUCTION',
  /** @deprecated Watchlist CSV exports are no longer supported. */
  WatchlistEndedBuyNow = 'WATCHLIST_ENDED_BUY_NOW',
  /** @deprecated Watchlist CSV exports are no longer supported. */
  WatchlistEndedPremier = 'WATCHLIST_ENDED_PREMIER'
}

/** Year range filter for CSV exports */
export type CsvExportYearRangeInput = {
  maxYear?: InputMaybe<Scalars['Int']['input']>;
  minYear?: InputMaybe<Scalars['Int']['input']>;
};

/** The payload sent when the current break changes */
export type CurrentBreakChangedPayload = {
  __typename?: 'CurrentBreakChangedPayload';
  /** The break that is currently active */
  currentBreak: Break;
  /** The current break spot auction for this break (if any) */
  currentBreakSpotAuction?: Maybe<BreakSpotAuction>;
};

/** Current instant rip spot information */
export type CurrentInstantRipSpot = {
  __typename?: 'CurrentInstantRipSpot';
  /** The break this spot belongs to */
  break: Break;
  /** The most recent break spot auction related to this spot */
  breakSpotAuction?: Maybe<BreakSpotAuction>;
  /** The break spot auctions related to this spot */
  breakSpotAuctions: Array<BreakSpotAuction>;
  /** The break template spot related to this spot */
  breakTemplateSpot: BreakTemplateSpot;
  /** The break spot's digital rip status */
  digitalRipStatus?: Maybe<DigitalRipStatus>;
  /** The break spot's unique ID */
  id: Scalars['UUID']['output'];
  /** The instant rip pack status */
  instantRipPackState: InstantRipPackState;
  /** The vault items opened in a repack */
  items?: Maybe<GetVaultItemsResponse>;
  itemsV2: GetVaultItemsResponseV3;
  /** The break spot's label */
  label: Scalars['String']['output'];
  /** The break spot's label abbreviation (up to 3 letters) */
  labelAbbreviation: Scalars['String']['output'];
  leagues: Array<League>;
  /** The break template slot logo url */
  logoUrl?: Maybe<Scalars['String']['output']>;
  previousPrice?: Maybe<MoneyAmount>;
  /** The break spot's price before discount in cents */
  previousPriceInCents?: Maybe<Scalars['Int']['output']>;
  previousPriceLocal?: Maybe<MoneyAmount>;
  price?: Maybe<MoneyAmount>;
  /** The break spot's price discount percentage */
  priceDiscountPercentage?: Maybe<Scalars['Int']['output']>;
  priceDisplay?: Maybe<Scalars['String']['output']>;
  /**
   * The template spot's price in cents
   * @deprecated Use price instead
   */
  priceInCents?: Maybe<Scalars['Int']['output']>;
  priceLocal?: Maybe<MoneyAmount>;
  pricingType: BreakPricingType;
  /** Whether this spot is available for purchase */
  purchasable: Scalars['Boolean']['output'];
  rawPrice?: Maybe<MoneyAmount>;
  /**
   * The template spot's raw price display
   * @deprecated Use rawPrice instead
   */
  rawPriceDisplay?: Maybe<Scalars['String']['output']>;
  /**
   * The template spot's raw price in cents
   * @deprecated Use rawPrice instead
   */
  rawPriceInCents?: Maybe<Scalars['Int']['output']>;
  rawPriceLocal?: Maybe<MoneyAmount>;
  /** The template spot's number */
  spotNumber: Scalars['Int']['output'];
  user?: Maybe<BreakUser>;
  userV2: BreakUser;
};


/** Current instant rip spot information */
export type CurrentInstantRipSpotBreakSpotAuctionsArgs = {
  status?: InputMaybe<BreakSpotAuctionStatus>;
};

/** Information about the currently authenticated user */
export type CurrentUser = {
  __typename?: 'CurrentUser';
  _resolveReference?: Maybe<CurrentUser>;
  /** Whether the user has accepted chat guidelines or not */
  acceptedGuidelines: Scalars['Boolean']['output'];
  /**
   * A list of addresses associated with the current user (US addresses only)
   * @deprecated Please addresses_v2 to support all addresses includun non-US addresses with an enpty state
   */
  addresses: Array<Address>;
  /** A list of addresses associated with the current user (supports non-US addresses with an empty state) */
  addressesV2: Array<AddressV2>;
  /** True if the user has admin privileges */
  admin: Scalars['Boolean']['output'];
  /** List of user admin roles if the user has admin privileges */
  adminRoles: Array<AdminRole>;
  /**
   * The user's selected payment method to be used with live auctions
   * @deprecated This field is being replaced by default_payment_method
   */
  auctionPaymentMethod?: Maybe<PaymentMethod>;
  /**
   * The user's selected shipping address to be used with live auctions
   * @deprecated This field is being replaced by default_shipping_address
   */
  auctionShippingAddress?: Maybe<Address>;
  /** True if the user qualifies as an authorized buyer */
  authorizedBuyer: Scalars['Boolean']['output'];
  /**
   * Paginated list of live streams which contain all active and upcoming live streamss that a user
   * has bought into or has followed.
   */
  availableLiveStreams?: Maybe<LiveStreamConnection>;
  /** The color to be used for the user's avatar */
  avatarColor?: Maybe<AvatarColor>;
  /** The image url to be used for the user's avatar */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The user's active badges */
  badges?: Maybe<Array<Badge>>;
  /** The biography of the user */
  biography?: Maybe<Scalars['String']['output']>;
  /** If set, the user is blocked from referring other users */
  blockedFromReferringAt?: Maybe<Scalars['DateTime']['output']>;
  brazeExternalId: Scalars['UUID']['output'];
  /**
   * The user's breaking profile
   * @deprecated This object is deprecated. These fields have been flattened directly into CurrentUser
   */
  breakingProfile: BreakingProfile;
  /**
   * The list of cards on the user's profile
   * @deprecated Deprecated: cards of a user without pagination is deprecated
   */
  cards?: Maybe<Array<Maybe<Card>>>;
  /** A paginated list of the cards those belongs to current user */
  cardsPaginated?: Maybe<CardConnection>;
  /** A token for accessing chat */
  chatToken: Scalars['String']['output'];
  /**
   * Paginated list of live streams which contain all completed live streams that a user has bought
   * into or has followed.
   * @deprecated This query was used to list streams with replays, not completed ones.
   * Therefore, use the `liveStreamsWithReplays` instead
   */
  completedLiveStreams?: Maybe<LiveStreamConnection>;
  /**
   * A timestamp indicating when this user was confirmed.
   * Null if the user has not been confirmed.
   */
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The user's country
   * @deprecated Use countryV2 instead
   */
  country: Scalars['String']['output'];
  /** The user's country */
  countryV2: Country;
  /** The user's currency */
  currency: Scalars['String']['output'];
  /**
   * The shop associated with the current user.
   * Returns nil if the user is not associated with a shop.
   */
  currentShop?: Maybe<Shop>;
  /**
   * The user's default payment method
   * @deprecated This field is deprecated. Use default_payment_method_v2 instead.
   */
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  defaultPaymentMethodV2?: Maybe<PaymentMethodV2>;
  /**
   * The user's default shipping address
   * @deprecated This field is deprecated. Use default_shipping_address_v2 instead.
   */
  defaultShippingAddress?: Maybe<Address>;
  /** The user's default shipping address */
  defaultShippingAddressV2?: Maybe<AddressV2>;
  /** The user's email address */
  email: Scalars['String']['output'];
  /** The FanID token */
  fanIdToken?: Maybe<Scalars['String']['output']>;
  /** The list of channels that the user follows */
  followedChannels: Array<Channel>;
  /** The list of shops that the user follows */
  followedShops: Array<Shop>;
  /** The number of users that follow this user */
  followerCount: Scalars['Int']['output'];
  /** The number of users that this user follows */
  followingCount: Scalars['Int']['output'];
  /** The user's unique ID */
  id: Scalars['UUID']['output'];
  /** A timestamp indicating when this user was created */
  insertedAt: Scalars['DateTime']['output'];
  /** The invitation code for currently authenticated user. */
  invitationCode?: Maybe<Scalars['String']['output']>;
  /** Is invitation code redeemed? */
  isRedeemed: Scalars['Boolean']['output'];
  /** Is tax exempt? */
  isTaxExempt: Scalars['Boolean']['output'];
  /** Whether the user is trusted or not */
  isTrusted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The live streams that contain a break or breaks that the current user has bought into
   * @deprecated Field is obsolete
   */
  liveStreams?: Maybe<LiveStreamConnection>;
  /**
   * Paginated list of live streams which contain all live streams that a user has bought into or has followed
   * with available replays.
   */
  liveStreamsWithReplays?: Maybe<LiveStreamConnection>;
  loyalty?: Maybe<Loyalty>;
  /** True if the user is subscribed to the mailing list */
  mailingListSubscription: Scalars['Boolean']['output'];
  /** The user's client‑side metadata blob */
  metadata: UserMetadata;
  /** True if the user has enabled notifications */
  notificationsEnabled: Scalars['Boolean']['output'];
  /** Whether the user has finished onboarding */
  onboardingComplete: Scalars['Boolean']['output'];
  /** A list of orders made by the current user */
  orders?: Maybe<BreakOrderConnection>;
  /** True if the user is over 18 years of age */
  over18: Scalars['Boolean']['output'];
  /**
   * A list of payment methods associated with the current user
   * @deprecated This field is deprecated. Use paymentMethodsV2 instead.
   */
  paymentMethods: Array<PaymentMethod>;
  /** A list of payment methods associated with the current user */
  paymentMethodsV2: Array<PaymentMethodV2>;
  paymentRequiresAction?: Maybe<PaymentRequiresAction>;
  phoneNumber?: Maybe<PhoneNumber>;
  /**
   * The user's preferred countries
   * @deprecated Use preferred_countries_v2 instead
   */
  preferredCountries: Array<Scalars['String']['output']>;
  /** The user's preferred countries */
  preferredCountriesV2: Array<Country>;
  /** Whether the user has completed registration or not */
  registrationComplete: Scalars['Boolean']['output'];
  /** True if the user has been banned from purchasing any products */
  softBan: Scalars['Boolean']['output'];
  /** User staffer object if user is a staffer */
  staffer?: Maybe<UserStaffer>;
  /** A set of settings user is associated with */
  stafferSettings?: Maybe<StafferSettings>;
  /** True if the user qualifies as tax exempt */
  taxExempt: Scalars['Boolean']['output'];
  tenantId: Scalars['UUID']['output'];
  /** A timestamp indicating when this user was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** The user's username */
  username?: Maybe<Scalars['String']['output']>;
  /** The datetime the user's username was last updated. */
  usernameUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Information about the currently authenticated user */
export type CurrentUserAddressesArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


/** Information about the currently authenticated user */
export type CurrentUserAddressesV2Args = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


/** Information about the currently authenticated user */
export type CurrentUserAvailableLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


/** Information about the currently authenticated user */
export type CurrentUserCardsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CardSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


/** Information about the currently authenticated user */
export type CurrentUserCompletedLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


/** Information about the currently authenticated user */
export type CurrentUserLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<LiveStreamStatus>;
};


/** Information about the currently authenticated user */
export type CurrentUserLiveStreamsWithReplaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


/** Information about the currently authenticated user */
export type CurrentUserOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Information about the currently authenticated user */
export type CurrentUserPaymentMethodsArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


/** Information about the currently authenticated user */
export type CurrentUserPaymentMethodsV2Args = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

export type CurrentUserZendeskWebWidgetResponse = {
  __typename?: 'CurrentUserZendeskWebWidgetResponse';
  /** Maximum permitted token livetime is 7 minutes from the issuedAt value */
  jwtToken: Scalars['String']['output'];
  tokenExpiresAt: Scalars['DateTime']['output'];
  tokenIssuedAt: Scalars['DateTime']['output'];
};

export type CustodyInfo = CollectionsCustodySubmittedInfo | CollectionsCustodyVaultInfo;

export enum CustodyType {
  Inhand = 'INHAND',
  Submitted = 'SUBMITTED',
  Vault = 'VAULT'
}

export type Custom = {
  __typename?: 'Custom';
  title: Scalars['String']['output'];
};

/** Input object for archiving a break template */
export type CustomBreakTemplateArchiveInput = {
  /** The break template's unique ID */
  breakTemplateId: Scalars['UUID']['input'];
};

export type CustomBreakTemplateArchivePayload = {
  __typename?: 'CustomBreakTemplateArchivePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CustomBreakTemplateArchiveResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CustomBreakTemplateArchiveResponse = {
  __typename?: 'CustomBreakTemplateArchiveResponse';
  isArchived?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomBreakTemplateCreateFromCsvInput = {
  /** CSV file containing break spots */
  csvFile: Scalars['Upload']['input'];
  /** Assign template to shop */
  shopId: Scalars['UUID']['input'];
  /** Title of the template */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CustomBreakTemplateCreateFromCsvPayload = {
  __typename?: 'CustomBreakTemplateCreateFromCsvPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CustomBreakTemplateCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CustomBreakTemplateCreateInput = {
  /** List of spots that belong to this template */
  breakTemplateSpots: Array<InputMaybe<BreakTemplateSpotCreateInput>>;
  /** Label of the template */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Assign template to shop */
  shopId: Scalars['UUID']['input'];
};

export type CustomBreakTemplateCreatePayload = {
  __typename?: 'CustomBreakTemplateCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CustomBreakTemplateCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CustomBreakTemplateCreateResponse = {
  __typename?: 'CustomBreakTemplateCreateResponse';
  breakTemplate?: Maybe<BreakTemplate>;
};

/** Input object to updating a break template */
export type CustomBreakTemplateUpdateInput = {
  /** The break template's unique ID */
  breakTemplateId: Scalars['UUID']['input'];
  /** List of spots that belong to this template */
  breakTemplateSpots: Array<InputMaybe<BreakTemplateSpotUpdateInput>>;
  /** Label of the template */
  label?: InputMaybe<Scalars['String']['input']>;
};

export type CustomBreakTemplateUpdatePayload = {
  __typename?: 'CustomBreakTemplateUpdatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<CustomBreakTemplateCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type CustomGiveawayCreateInput = {
  /** Flag to indicate whether to perform the check or proceed with the mutation */
  confirmGiveaway?: InputMaybe<Scalars['Boolean']['input']>;
  /** CSV file containing giveaway participants */
  csvFile: Scalars['Upload']['input'];
  /** The live stream ID associated with the giveaway */
  liveStreamId: Scalars['UUID']['input'];
  /** Title of the giveaway */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DataPrivacySettings = {
  __typename?: 'DataPrivacySettings';
  /** Allow app personalization */
  appPersonalization?: Maybe<Scalars['Boolean']['output']>;
  /** Allow new about partners emails */
  emailNewsAboutPartners?: Maybe<Scalars['Boolean']['output']>;
  /** Allow news and new features emails */
  emailNewsNewFeatures?: Maybe<Scalars['Boolean']['output']>;
  /** Allow poromotions and vauchers emails */
  emailPromotionsVouchers?: Maybe<Scalars['Boolean']['output']>;
  /** Allow shows and events emails */
  emailShowsEvents?: Maybe<Scalars['Boolean']['output']>;
  /** Allow pomotions and vauchers emails */
  smsPromotionsVouchers?: Maybe<Scalars['Boolean']['output']>;
  /** Allow share data with third party services */
  thirdPartiesShareData?: Maybe<Scalars['Boolean']['output']>;
  /** True if user received data consent request */
  userHasReceivedDataConsentRequest?: Maybe<Scalars['Boolean']['output']>;
};

export type DataPrivacySettingsInput = {
  /** Allow app personalization */
  appPersonalization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow new about partners emails */
  emailNewsAboutPartners?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow news and new features emails */
  emailNewsNewFeatures?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow poromotions and vauchers emails */
  emailPromotionsVouchers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow shows and events emails */
  emailShowsEvents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow pomotions and vauchers emails */
  smsPromotionsVouchers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow share data with third party services */
  thirdPartiesShareData?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if user received data consent request */
  userHasReceivedDataConsentRequest?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DateOptions {
  Ninety = 'NINETY',
  Seven = 'SEVEN',
  Thirty = 'THIRTY',
  Year = 'YEAR'
}

/** A collection of data related to a given live stream to aid in debugging */
export type Debug = {
  __typename?: 'Debug';
  /** The latest break spot auction associated with the live stream */
  breakSpotAuction?: Maybe<BreakSpotAuction>;
  /** The debug data json encoded */
  data?: Maybe<Scalars['String']['output']>;
  /** The requested live stream */
  liveStream: LiveStream;
};

export type DebutPackUserJoinedInput = {
  liveStreamId: Scalars['UUID']['input'];
};

export type DebutPackUserJoinedPayload = {
  __typename?: 'DebutPackUserJoinedPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<PublicUser>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** A default avatar. */
export type DefaultAvatar = {
  __typename?: 'DefaultAvatar';
  /** The avatar id. */
  id: Scalars['UUID']['output'];
  /** The avatar name. */
  name: Scalars['String']['output'];
  /** The avatar url. */
  url: Scalars['String']['output'];
};

/** Input object for deleting a break */
export type DeleteBreakInput = {
  breakId: Scalars['UUID']['input'];
};

export type DeleteBreakPayload = {
  __typename?: 'DeleteBreakPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<DeleteBreakResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type DeleteBreakResponse = {
  __typename?: 'DeleteBreakResponse';
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
};

/** Parameters for deleting a live stream. */
export type DeleteLiveStreamInput = {
  /** The ID of the object we want to update */
  id: Scalars['ID']['input'];
};

export type DeleteLiveStreamPayload = {
  __typename?: 'DeleteLiveStreamPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveStreamResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for deleting path to logo for given profile type. */
export type DeleteLogoPathInput = {
  /** The unique ID of profile. */
  id: Scalars['UUID']['input'];
  /** Profile type. */
  type: ProfileType;
};

export type DeleteLogoPathPayload = {
  __typename?: 'DeleteLogoPathPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Result>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The input object to delete a repack */
export type DeleteRepackInput = {
  /** The ID of the repack */
  repackId: Scalars['UUID']['input'];
};

export type DeleteRepackPayload = {
  __typename?: 'DeleteRepackPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<DeleteRepackResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type DeleteRepackResponse = {
  __typename?: 'DeleteRepackResponse';
  /** The status of the repack deletion */
  status?: Maybe<Scalars['String']['output']>;
};

/** Information about a deleted user */
export type DeletedUser = {
  __typename?: 'DeletedUser';
  /** The timestamp when the user was deleted */
  accountDeletedAt: Scalars['DateTime']['output'];
  /** The deleted user's id */
  id: Scalars['UUID']['output'];
};

/** Input object for creating a digital break */
export type DigitalBreakInput = {
  /** The break's break mechanic threshold in cents */
  breakMechanicThresholdInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The break's break mechanic type */
  breakMechanicType?: InputMaybe<BreakMechanicType>;
  /** If the break is auction, this field enables extended bidding */
  extendedBiddingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the associated live stream */
  liveStreamId: Scalars['UUID']['input'];
  /** Minimum bid amount in cents for auction pricing */
  minimumBidInCents?: InputMaybe<Scalars['Int']['input']>;
  /** Price of the break in cents */
  priceInCents: Scalars['Int']['input'];
  /** Pricing type of the break */
  pricingType?: InputMaybe<BreakPricingType>;
  /** Whether the break is available for purchase */
  purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Quantity of items in the break */
  quantity: Scalars['Int']['input'];
  /** ID of the associated repack */
  repackId: Scalars['UUID']['input'];
  /** Selection type of the break */
  selectionType?: InputMaybe<BreakSelectionType>;
  /** Title of the break */
  title: Scalars['String']['input'];
};

/** The digital rip status of a break spot */
export enum DigitalRipStatus {
  /** The Digital Rip card has been revealed */
  CardRevealed = 'CARD_REVEALED',
  /** The Digital Rip has been completed */
  Completed = 'COMPLETED',
  /** The Digital Rip pack is visible */
  PackVisible = 'PACK_VISIBLE',
  /** The Digital Rip is ready */
  Ready = 'READY'
}

/** Three dimensions */
export type Dimensions = {
  __typename?: 'Dimensions';
  height: Scalars['Float']['output'];
  length: Scalars['Float']['output'];
  unit: DistanceUnit;
  width: Scalars['Float']['output'];
};

/** Distance units */
export enum DistanceUnit {
  Cm = 'CM',
  Ft = 'FT',
  In = 'IN',
  M = 'M',
  Mm = 'MM',
  Yd = 'YD'
}

export type Duration = {
  __typename?: 'Duration';
  measurement: DurationMeasurement;
  units: Scalars['Int']['output'];
};

export enum DurationMeasurement {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Parameters for ending a live stream. */
export type EndLiveStreamInput = {
  /** The ID of the live stream to end */
  id: Scalars['ID']['input'];
};

export type EndLiveStreamPayload = {
  __typename?: 'EndLiveStreamPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveStreamResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type EnterGiveawayPayload = {
  __typename?: 'EnterGiveawayPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<EnterGiveawayResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the enterGiveaway mutation */
export type EnterGiveawayResponse = {
  __typename?: 'EnterGiveawayResponse';
  /** The giveaway that the user entered */
  giveaway: Giveaway;
  /**
   * Users will automatically follow the shop for giveaways which require the user to be following.
   * This property indicates whether the user has been automatically followed or not
   */
  hasFollowedShop: Scalars['Boolean']['output'];
};

/** The types of Entity */
export enum Entity {
  Auction = 'AUCTION',
  Giveaway = 'GIVEAWAY'
}

/** The types of Event */
export enum Event {
  Seen = 'SEEN',
  Started = 'STARTED'
}

export type ExchangeTokenInput = {
  /**
   * A valid refresh token.
   * The token must be a refresh token and it must not be expired.
   */
  refreshToken: Scalars['String']['input'];
};

export type FanIdInputParams = {
  /** The access token returned by the FanID authentication flow */
  accessToken: Scalars['String']['input'];
  /** The expiry timestamp returned by the FanID authentication flow */
  expiresAt: Scalars['Int']['input'];
  /** The refresh token returned by the FanID authentication flow */
  refreshToken: Scalars['String']['input'];
  /** The ID of the user returned by the FanID authentication flow */
  userId: Scalars['UUID']['input'];
};

/** FanCash wallet balance information */
export type FancashWalletBalance = {
  __typename?: 'FancashWalletBalance';
  balance: MoneyAmount;
  isSupported: Scalars['Boolean']['output'];
};

/** Parameters for registering a new FanID account */
export type FanidAccountCreateInput = {
  /** The authentication code returned by FanID */
  code: Scalars['String']['input'];
  /** The email address of the user */
  email: Scalars['String']['input'];
  /** The user's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The user's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The user's phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type FanidAccountCreatePayload = {
  __typename?: 'FanidAccountCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<UpdatedUser>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  flagEnabled: Scalars['Boolean']['output'];
  flagName: Scalars['String']['output'];
};

export enum FeatureFlagScope {
  Liveos = 'LIVEOS'
}

export type FeatureFlagsInput = {
  scope: FeatureFlagScope;
};

/** An avatar to be shown in the follow bar */
export type FollowBarAvatar = {
  __typename?: 'FollowBarAvatar';
  /** The avatar details */
  avatar: Avatar;
  /** The live stream related to the avatar */
  liveStream?: Maybe<LiveStream>;
};

/** Input for the followChannelCreate mutation */
export type FollowChannelCreateInput = {
  /** The ID of the channel that the user wants to follow */
  channelId: Scalars['UUID']['input'];
};

export type FollowChannelCreatePayload = {
  __typename?: 'FollowChannelCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowChannelCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the followChannelCreate mutation */
export type FollowChannelCreateResponse = {
  __typename?: 'FollowChannelCreateResponse';
  /** The channel that is being followed */
  channel: Channel;
  /** The user that is following the channel */
  user: UpdatedUser;
};

/** Input for the followChannelDelete mutation */
export type FollowChannelDeleteInput = {
  /** The ID of the channel that the user wants to unfollow */
  channelId: Scalars['UUID']['input'];
};

export type FollowChannelDeletePayload = {
  __typename?: 'FollowChannelDeletePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowChannelCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Input for the followLeagueCreate mutation */
export type FollowLeagueCreateInput = {
  /** The ID of the league that the user wants to follow */
  leagueId: Scalars['UUID']['input'];
};

export type FollowLeagueCreatePayload = {
  __typename?: 'FollowLeagueCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowLeagueCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the followLeagueCreate mutation */
export type FollowLeagueCreateResponse = {
  __typename?: 'FollowLeagueCreateResponse';
  /** The league that is being followed */
  league: League;
  /** The user that is following the league */
  user: UpdatedUser;
};

/** Input for the followLeagueDelete mutation */
export type FollowLeagueDeleteInput = {
  /** The ID of the league that the user wants to follow */
  leagueId: Scalars['UUID']['input'];
};

export type FollowLeagueDeletePayload = {
  __typename?: 'FollowLeagueDeletePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowLeagueCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Input for the followLeagueMemberCreate mutation */
export type FollowLeagueMemberCreateInput = {
  /** The ID of the league member that the user wants to follow */
  leagueMemberId: Scalars['UUID']['input'];
};

export type FollowLeagueMemberCreatePayload = {
  __typename?: 'FollowLeagueMemberCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowLeagueMemberResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Input for the followLeagueDelete mutation */
export type FollowLeagueMemberDeleteInput = {
  /** The ID of the league member that the user wants to follow */
  leagueMemberId: Scalars['UUID']['input'];
};

export type FollowLeagueMemberDeletePayload = {
  __typename?: 'FollowLeagueMemberDeletePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowLeagueMemberResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the followLeagueMemberCreate & followLeagueMemberDelete mutation */
export type FollowLeagueMemberResponse = {
  __typename?: 'FollowLeagueMemberResponse';
  /** The league member that is being followed */
  leagueMember: LeagueMember;
  /** The user that is following the league member */
  user: UpdatedUser;
};

export type FollowLiveStreamCreatePayload = {
  __typename?: 'FollowLiveStreamCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowLiveStreamCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the followLiveStreamCreate mutation */
export type FollowLiveStreamCreateResponse = {
  __typename?: 'FollowLiveStreamCreateResponse';
  /** The live stream that is being followed */
  liveStream: LiveStream;
  /** The user that is following the live_stream */
  user: UpdatedUser;
};

/** Input for the followShopCreate mutation */
export type FollowShopCreateInput = {
  /** The ID of the shop that the user wants to follow */
  shopId: Scalars['UUID']['input'];
};

export type FollowShopCreatePayload = {
  __typename?: 'FollowShopCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowShopCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the followShopCreate mutation */
export type FollowShopCreateResponse = {
  __typename?: 'FollowShopCreateResponse';
  /** The shop that is being followed */
  shop: Shop;
  /** The user that is following the shop */
  user: UpdatedUser;
};

/** Input for the followShopDelete mutation */
export type FollowShopDeleteInput = {
  /** The ID of the shop that the user wants to unfollow */
  shopId: Scalars['UUID']['input'];
};

export type FollowShopDeletePayload = {
  __typename?: 'FollowShopDeletePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowShopCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type FollowUserCreatePayload = {
  __typename?: 'FollowUserCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowUserCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the followUserCreate mutation */
export type FollowUserCreateResponse = {
  __typename?: 'FollowUserCreateResponse';
  /** The user that is being followed */
  user: PublicUser;
};

export type FollowUserDeletePayload = {
  __typename?: 'FollowUserDeletePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowUserDeleteResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the followUserDelete mutation */
export type FollowUserDeleteResponse = {
  __typename?: 'FollowUserDeleteResponse';
  /** The user that is being followed */
  user: PublicUser;
};

export type FormField = {
  /** The text to display to a user to describe the form field */
  label: Scalars['String']['output'];
  /** The name of the form field by which to identify the value submitted with it */
  name: Scalars['String']['output'];
};

/** A button to submit values collected from a set of form fields */
export type FormFieldButtonSubmit = FormField & {
  __typename?: 'FormFieldButtonSubmit';
  /** The text to display to a user to describe the form field */
  label: Scalars['String']['output'];
  /** The name of the form field by which to identify the value submitted with it */
  name: Scalars['String']['output'];
};

export type FormFieldInputInteger = FormField & {
  __typename?: 'FormFieldInputInteger';
  /** The integer value that is submitted with the associated form field */
  integerValue?: Maybe<Scalars['Int']['output']>;
  /** The text to display to a user to describe the form field */
  label: Scalars['String']['output'];
  /** The name of the form field by which to identify the value submitted with it */
  name: Scalars['String']['output'];
};

export type FormFieldModalFilter = {
  name: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type FormFieldModalSelectOneString = FormField & {
  __typename?: 'FormFieldModalSelectOneString';
  /** The text to display to a user to describe the form field */
  label: Scalars['String']['output'];
  /** The name of the form field by which to identify the value submitted with it */
  name: Scalars['String']['output'];
  /** The list of string-type options available for the requested field */
  options?: Maybe<FormOptionStringConnection>;
  /** The string-type option that should be displayed as an option selected by the user */
  selectedOption?: Maybe<FormOptionString>;
};


export type FormFieldModalSelectOneStringOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FormFieldPromptSelectManyStrings = FormField & {
  __typename?: 'FormFieldPromptSelectManyStrings';
  /** The text to display to a user to describe the form field */
  label: Scalars['String']['output'];
  /** The name of the form field by which to identify the value submitted with it */
  name: Scalars['String']['output'];
  /** The list of string options which are selected by the user from this form field */
  selectedOptions: Array<FormOptionString>;
};

export type FormFieldPromptSelectOneString = FormField & {
  __typename?: 'FormFieldPromptSelectOneString';
  /** The text to display to a user to describe the form field */
  label: Scalars['String']['output'];
  /** The name of the form field by which to identify the value submitted with it */
  name: Scalars['String']['output'];
  /** The string option which is selected by the user from this form field */
  selectedOption?: Maybe<FormOptionString>;
};

export type FormFieldRangeInteger = FormField & {
  __typename?: 'FormFieldRangeInteger';
  /** A list of available range of integers which the users may select from this form field */
  availableOptions: Array<FormOptionRangeInteger>;
  /** An optional list of custom integer form fields which can be nested within this one */
  formFields?: Maybe<Array<FormFieldInputInteger>>;
  /** The text to display to a user to describe the form field */
  label: Scalars['String']['output'];
  /** The name of the form field by which to identify the value submitted with it */
  name: Scalars['String']['output'];
  /** The range of integers option which is selected by the user from this form field */
  selectedOption?: Maybe<FormOptionRangeInteger>;
};

export type FormFieldSelectOneString = FormField & {
  __typename?: 'FormFieldSelectOneString';
  /** A list of available string options which the users may select from this form field */
  availableOptions: Array<FormOptionString>;
  /** The text to display to a user to describe the form field */
  label: Scalars['String']['output'];
  /** The name of the form field by which to identify the value submitted with it */
  name: Scalars['String']['output'];
  /** The selected string option that the user has chosen from this form field */
  selectedOption?: Maybe<FormOptionString>;
};

export type FormModalSelectManyStrings = FormField & {
  __typename?: 'FormModalSelectManyStrings';
  /** The text to display to a user to describe the form field */
  label: Scalars['String']['output'];
  /** The name of the form field by which to identify the value submitted with it */
  name: Scalars['String']['output'];
  /** The list of string-type options available for the requested field */
  options?: Maybe<FormOptionStringConnection>;
  /** The string-type option that should be displayed as an option selected by the user */
  selectedOptions?: Maybe<Array<FormOptionString>>;
};


export type FormModalSelectManyStringsOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FormOption = {
  /** The label to associate with a given option of a form field */
  label: Scalars['String']['output'];
  /** The value to associate with a given option of a form field */
  value: Scalars['String']['output'];
};

export type FormOptionRangeInteger = FormOption & {
  __typename?: 'FormOptionRangeInteger';
  /** The label to associate with a given option of a range integer field */
  label: Scalars['String']['output'];
  /** The minimum value that will be range will be bound to */
  maximum?: Maybe<Scalars['Int']['output']>;
  /** The minimum value that will be range will be bound to */
  minimum?: Maybe<Scalars['Int']['output']>;
  /** The value to associate with a given option of a range integer field */
  value: Scalars['String']['output'];
};

export type FormOptionString = FormOption & {
  __typename?: 'FormOptionString';
  /** The url of an image associated with the option */
  image?: Maybe<Scalars['String']['output']>;
  /** The label to associate with a given option of a string field */
  label: Scalars['String']['output'];
  /** The value to associate with a given option of a string field */
  value: Scalars['String']['output'];
};

export type FormOptionStringConnection = {
  __typename?: 'FormOptionStringConnection';
  edges?: Maybe<Array<Maybe<FormOptionStringEdge>>>;
  pageInfo: PageInfo;
};

export type FormOptionStringEdge = {
  __typename?: 'FormOptionStringEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<FormOptionString>;
};

export type GetItemsV4Input = {
  /** Cursor for pagination (after). */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Cursor for pagination (before). */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Filter items by a given category. */
  category?: InputMaybe<Scalars['Int']['input']>;
  /** Filter items that are listable. */
  filterListable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter items by their listed status. */
  filterListed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter items by a specific vault item group ID. */
  filterVaultItemGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** Number of items to return beginning from the cursor. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** List of UUIDs to fetch. */
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** List of item UUIDs to filter by. */
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Number of items to return backward from the cursor. */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** Offset for pagination. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** The unique identifier for the product. */
  productId: Scalars['UUID']['input'];
  /** Filter cards by their reveal status. 'all' returns everything; 'available' returns only cards still available; 'revealed' returns only cards that have been pulled. */
  revealStatus?: InputMaybe<RevealStatus>;
  /** Search term for filtering items. */
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  /** Alternative sorting options. */
  sortByValues?: InputMaybe<SortByValues>;
  /** Filter items by their vault item state. */
  state?: InputMaybe<CollectVaultItemStateArg>;
  /** Type of items to return; defaults to :all. */
  type?: InputMaybe<ItemType>;
  /** List of vault submissions for filtering items. */
  vaultSubmission?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The response from getPoll query */
export type GetPollResponse = {
  __typename?: 'GetPollResponse';
  poll?: Maybe<PollWithUserVotes>;
};

/** The response from getPolls query */
export type GetPollsResponse = {
  __typename?: 'GetPollsResponse';
  polls?: Maybe<Array<Maybe<PollWithUserVotes>>>;
};

export type GetRepackInput = {
  /** The product id of the repack */
  productId: Scalars['UUID']['input'];
};

/** Input for getting repacks */
export type GetRepacksInput = {
  /** The status of the repacks */
  status?: InputMaybe<RepackStatus>;
};

/** Input for getting repacks */
export type GetRepacksInputV2 = {
  /** The break template ID to filter by */
  breakTemplateId?: InputMaybe<Scalars['UUID']['input']>;
  /** Filter dynamic repacks by user email (vault source) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The scope of the checklists */
  scope?: InputMaybe<GetRepacksScope>;
  /** The status of the checklists */
  status?: InputMaybe<Array<InputMaybe<RepackStatus>>>;
  /** The title of the checklist */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The type of the checklist */
  type?: InputMaybe<Array<RepackType>>;
};

export enum GetRepacksScope {
  /** Access granted repacks */
  AccessGranted = 'ACCESS_GRANTED',
  /** Created repacks */
  Created = 'CREATED'
}

export type GetRippedPackInput = {
  itemId: Scalars['UUID']['input'];
};

export type GetTokenPairResult = {
  __typename?: 'GetTokenPairResult';
  /** The action that was taken to authenticate the user */
  action: CollectAuthenticateAction;
  /** The expiry timestamp for the access token */
  expiresAt: Scalars['Int']['output'];
  /** The promo code the user used to sign up with */
  promoCode?: Maybe<Scalars['String']['output']>;
  tokens: TokenPair;
  user: AuthUser;
};

/** Get vault items response */
export type GetVaultItemsResponse = {
  __typename?: 'GetVaultItemsResponse';
  /** Item edges */
  edges?: Maybe<Array<Maybe<VaultItemEdge>>>;
  /** Pagination info */
  pageInfo?: Maybe<PageInfoType>;
  /** Total count */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Get vault items response V2 */
export type GetVaultItemsResponseV2 = {
  __typename?: 'GetVaultItemsResponseV2';
  /** Item edges */
  edges?: Maybe<Array<Maybe<VaultItemEdge>>>;
  /** Pagination info */
  pageInfo?: Maybe<PageInfoTypeV2>;
  /** Total count */
  total?: Maybe<Scalars['Int']['output']>;
};

/** Get vault items response V2 */
export type GetVaultItemsResponseV3 = {
  __typename?: 'GetVaultItemsResponseV3';
  /** Item edges */
  edges: Array<VaultItemEdge>;
  /** Pagination info */
  pageInfo?: Maybe<PageInfoTypeV2>;
  /** Total count */
  total?: Maybe<Scalars['Int']['output']>;
};

/** A giveaway that can be entered by viewers in a live stream */
export type Giveaway = {
  __typename?: 'Giveaway';
  /** The audience of the giveaway */
  audience: GiveawayAudience;
  /** The break spot associated with the giveaway */
  breakSpot: BreakSpot;
  /** The giveaway's end time (UTC) */
  endsAt: Scalars['DateTime']['output'];
  /** List of usernames of users that have entered the giveaway */
  enteredUsernames?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether the current user has entered the giveaway */
  hasUserEntered?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the giveaway */
  id: Scalars['UUID']['output'];
  /** The number of participants that have entered the giveaway */
  participantCount: Scalars['Int']['output'];
  /** The status of the giveaway */
  status: GiveawayStatus;
  /** The name of the giveaway */
  title: Scalars['String']['output'];
  /** The user that won the giveaway */
  winner?: Maybe<BreakUser>;
};

/** The audience of a giveaway */
export enum GiveawayAudience {
  /** All viewers */
  AllViewers = 'ALL_VIEWERS',
  /** Followers only */
  FollowersOnly = 'FOLLOWERS_ONLY'
}

export type GiveawayResponse = {
  __typename?: 'GiveawayResponse';
  giveaway?: Maybe<Giveaway>;
};

export type GiveawayResult = {
  __typename?: 'GiveawayResult';
  giveaway: Giveaway;
};

/** The status of a giveaway */
export enum GiveawayStatus {
  /** Giveaway is active, users can enter */
  Active = 'ACTIVE',
  /** Giveaway has ended, but winner has not been chosen */
  WaitingForWinner = 'WAITING_FOR_WINNER',
  /** Giveaway is complete, with a winner chosen */
  WinnerChosen = 'WINNER_CHOSEN'
}

export type GradingInfo = {
  __typename?: 'GradingInfo';
  certNumber?: Maybe<Scalars['String']['output']>;
  gemrateId?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  graderName?: Maybe<Scalars['String']['output']>;
  population?: Maybe<Scalars['Int']['output']>;
  populationHigher?: Maybe<Scalars['String']['output']>;
  populationIndex?: Maybe<Scalars['Int']['output']>;
};

export enum GradingService {
  /** BCCG */
  Bccg = 'BCCG',
  /** BGS */
  Bgs = 'BGS',
  /** BVG */
  Bvg = 'BVG',
  /** CBCS */
  Cbcs = 'CBCS',
  /** CGC */
  Cgc = 'CGC',
  /** CSG */
  Csg = 'CSG',
  /** MBA */
  Mba = 'MBA',
  /** Other Approved */
  OtherApproved = 'OTHER_APPROVED',
  /** PSA */
  Psa = 'PSA',
  /** PSA/DNA */
  PsaDna = 'PSA_DNA',
  /** SGC */
  Sgc = 'SGC',
  /** VGA */
  Vga = 'VGA',
  /** WATA */
  Wata = 'WATA'
}

export type GradingServiceItem = {
  __typename?: 'GradingServiceItem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum GradingStatus {
  Graded = 'GRADED',
  NotGraded = 'NOT_GRADED',
  Pending = 'PENDING'
}

export enum GuidePriceType {
  GuidePrice = 'GUIDE_PRICE',
  GuidePriceByCardLadder = 'GUIDE_PRICE_BY_CARD_LADDER'
}

export type HealthCheckInput = {
  /** The unique UUID of an entity */
  entityId: Scalars['UUID']['input'];
  /** The unique UUID of liveStream */
  liveStreamId: Scalars['UUID']['input'];
};

/** The response from healthCheck query */
export type HealthCheckPayload = {
  __typename?: 'HealthCheckPayload';
  health: Scalars['Float']['output'];
};

export type HierarchyCategoryItem = {
  __typename?: 'HierarchyCategoryItem';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** The home feed for a user */
export type Home = {
  __typename?: 'Home';
  /** The list of avatars to be shown in the follow bar */
  followBarAvatars?: Maybe<Array<FollowBarAvatar>>;
  /** The list of cards to be shown in the home hero section */
  heroCards?: Maybe<Array<LiveStreamCard>>;
  /** The single rail for the home feed */
  rail: Rail;
  /** The paginated sections for the home feed */
  rails?: Maybe<RailConnection>;
  /** The list of sections to be shown in the home feed */
  sections?: Maybe<Array<HomeSection>>;
  /**
   * The paginated sections for the home feed
   * @deprecated this field is deprecated use rails field instead
   */
  sectionsV2?: Maybe<SectionV2Connection>;
};


/** The home feed for a user */
export type HomeRailArgs = {
  id: Scalars['String']['input'];
};


/** The home feed for a user */
export type HomeRailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The home feed for a user */
export type HomeSectionsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A section of the home feed */
export type HomeSection = {
  __typename?: 'HomeSection';
  /**
   * The list of live stream cards to be shown in the section
   * @deprecated No longer supported
   */
  allItems?: Maybe<Array<LiveStreamCard>>;
  /** The list of live stream cards to be shown in the section */
  items?: Maybe<Array<LiveStreamCard>>;
  /** A preview of the first five unfiltered items from the Direct Buy Marketplace */
  marketplaceItems?: Maybe<Array<MarketplaceItem>>;
  /** The section type */
  sectionType: HomeSectionType;
  /** The list of suggested shops to be shown in the section */
  suggestedShops?: Maybe<Array<Avatar>>;
};

/** The type of a home section */
export enum HomeSectionType {
  /** A section with live breaks */
  Live = 'LIVE',
  /**
   * A section with items available to purchase directly
   * @deprecated No longer supported, use marketplace query instead
   */
  Marketplace = 'MARKETPLACE',
  /** A section for popular completed live streams */
  PopularLivestreams = 'POPULAR_LIVESTREAMS',
  /** A section with suggested shops to follow */
  SuggestedShops = 'SUGGESTED_SHOPS',
  /** A section with upcoming breaks */
  Upcoming = 'UPCOMING'
}

/** The allowed file types for image uploads */
export enum ImageFileType {
  Jpeg = 'JPEG',
  Jpg = 'JPG',
  Png = 'PNG'
}

/** Images metadata */
export type ImageMetadata = {
  __typename?: 'ImageMetadata';
  /** height */
  height?: Maybe<Scalars['Int']['output']>;
  /** orientation */
  orientation?: Maybe<Scalars['String']['output']>;
  /** width */
  width?: Maybe<Scalars['Int']['output']>;
};

/** The allowed upload types for image uploads */
export enum ImageUploadType {
  Break = 'BREAK',
  Channel = 'CHANNEL',
  Collectible = 'COLLECTIBLE',
  Livestream = 'LIVESTREAM',
  Product = 'PRODUCT',
  Shop = 'SHOP',
  Spottemplate = 'SPOTTEMPLATE',
  User = 'USER'
}

export type ImageUploadUrlCreatePayload = {
  __typename?: 'ImageUploadUrlCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ImageUploadUrlCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type ImageUploadUrlCreateResponse = {
  __typename?: 'ImageUploadUrlCreateResponse';
  url: Scalars['String']['output'];
};

/** An instant rip current item */
export type InstantRipCurrentItem = {
  __typename?: 'InstantRipCurrentItem';
  /** Appraisal value */
  appraisalValue?: Maybe<MoneyAmount>;
  /** Auction url */
  auctionUrl?: Maybe<Scalars['String']['output']>;
  /** The break template spot assigned to this item via checklist_item_spot_templates */
  breakTemplateSpot?: Maybe<BreakTemplateSpot>;
  /** Buy now url */
  buyNowUrl?: Maybe<Scalars['String']['output']>;
  /** Buyback value */
  buybackValue?: Maybe<MoneyAmount>;
  /** The time when the buyback window ends */
  buybackWindowEndsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Card grade */
  cardGrade?: Maybe<VaultItemCardGrade>;
  /** Card ladder value */
  cardLadderValue?: Maybe<MoneyAmount>;
  /** Card value */
  cardValue?: Maybe<MoneyAmount>;
  /** Category */
  category?: Maybe<VaultItemCategory>;
  currentItemRevealState: InstantRipCurrentItemState;
  /** Grade Cert */
  gradeCert?: Maybe<Scalars['String']['output']>;
  /** grading service */
  gradingService?: Maybe<VaultItemGradingService>;
  /** Id */
  id: Scalars['String']['output'];
  /** Metadata for each image */
  imageMetadata?: Maybe<Array<Maybe<ImageMetadata>>>;
  /** Images */
  images: Array<Maybe<Scalars['String']['output']>>;
  /** Metadata for each image */
  imagesV2: Array<Scalars['String']['output']>;
  /** Date insterted into db */
  insertedAt: Scalars['DateTime']['output'];
  /** Instant rip completed at */
  instantRipCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Insured value */
  insuredValue?: Maybe<MoneyAmount>;
  /**
   * Item ID
   * @deprecated Use `itemIdV2` instead
   */
  itemId?: Maybe<Scalars['UUID']['output']>;
  /** Item ID */
  itemIdV2: Scalars['UUID']['output'];
  /**
   * Item status
   * @deprecated This object is deprecated.
   */
  itemStatus?: Maybe<RepackItemStatus>;
  /**
   * Type of repack item (base, chase, grail)
   * @deprecated Use `itemTypeV2` instead
   */
  itemType?: Maybe<RepackItemType>;
  /** Type of repack item (base, chase, grail) */
  itemTypeV2: RepackItemType;
  /** Market value */
  marketValue?: Maybe<MoneyAmount>;
  /** Premier url */
  premierUrl?: Maybe<Scalars['String']['output']>;
  /** Proto item uuid */
  protoItemUuid: Scalars['String']['output'];
  revealInfo?: Maybe<RevealInfo>;
  revealOrder?: Maybe<Scalars['Int']['output']>;
  /**
   * Current reveal state of this item
   * @deprecated Use `revealStateV2` instead
   */
  revealState?: Maybe<RepackItemRevealState>;
  /** Current reveal state of this item */
  revealStateV2: RepackItemRevealState;
  /** Rotation value for the item */
  rotation?: Maybe<Scalars['Int']['output']>;
  /** Serial */
  serial?: Maybe<Scalars['String']['output']>;
  /** Subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title */
  title: Scalars['String']['output'];
};

/** The instant rip item reveal state */
export enum InstantRipCurrentItemState {
  /** Item is shrouded */
  Shrouded = 'SHROUDED',
  /** Item is visible */
  Visible = 'VISIBLE'
}

export type InstantRipPackState = CardStep | PackStep;

export type IntrospectResult = {
  __typename?: 'IntrospectResult';
  active: Scalars['Boolean']['output'];
  exp?: Maybe<Scalars['Int']['output']>;
};

/** A product which is in the sellers inventory. Shows aggregate information about all units of that product */
export type InventoryProduct = {
  __typename?: 'InventoryProduct';
  /** The average cost paid for these units */
  averageCostBasis: MoneyAmount;
  /** The product in the inventory */
  product: Product;
  /** The number units in the sellers inventory */
  quantity: Scalars['Int']['output'];
};

export type InventoryProductConnection = {
  __typename?: 'InventoryProductConnection';
  edges?: Maybe<Array<Maybe<InventoryProductEdge>>>;
  pageInfo: PageInfo;
};

export type InventoryProductEdge = {
  __typename?: 'InventoryProductEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<InventoryProduct>;
};

/** Vault sort by card type */
export enum ItemType {
  /** All cards which includes both cards that's been marked base, chase or grail */
  All = 'ALL',
  /** All cards that has been marked as base */
  Base = 'BASE',
  /** All cards that has been marked as chase */
  Chase = 'CHASE',
  /** All cards that has been marked as grail */
  Grail = 'GRAIL'
}

export type LaunchLiveSteamGiveawayPayload = {
  __typename?: 'LaunchLiveSteamGiveawayPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<GiveawayResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for launching a live stream giveaway. */
export type LaunchLiveStreamGiveawayInput = {
  audience: GiveawayAudience;
  breakSpotId?: InputMaybe<Scalars['UUID']['input']>;
  durationMins: Scalars['Int']['input'];
  /** The ID of the object we want to update */
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

/** The response for the leader board promo code query. */
export type LeaderBoardPromoResponse = {
  __typename?: 'LeaderBoardPromoResponse';
  /** The candidates for the leader board. */
  candidates?: Maybe<Array<Maybe<Candidate>>>;
  /** The metadata for the leader board. */
  metadata?: Maybe<Scalars['String']['output']>;
};

/** A sports league for product and interest purposes */
export type League = {
  __typename?: 'League';
  /** Denotes whether or not a client should issue a query for league members */
  hasLeagueMembers: Scalars['Boolean']['output'];
  /** The ID for this league */
  id: Scalars['UUID']['output'];
  /** Whether the current user is following the league */
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  /** The URL for the league's logo */
  logoUrl: Scalars['String']['output'];
  /** The name of this league */
  name: Scalars['String']['output'];
  /** The type used for searching/retrieval */
  type: LeagueTypes;
};

/** A team that is a member of a league */
export type LeagueMember = {
  __typename?: 'LeagueMember';
  /** The ID for the league member */
  id: Scalars['UUID']['output'];
  /** Indicates whether or not the current user is following the league member */
  isFollowed: Scalars['Boolean']['output'];
  /** The URL for the league members logo */
  logoUrl: Scalars['String']['output'];
  /** The name of the league member */
  name: Scalars['String']['output'];
};

export enum LeagueTypes {
  /** @deprecated Use SOCCER instead */
  ChampionsLeague = 'CHAMPIONS_LEAGUE',
  Disney = 'DISNEY',
  DragonBallSuper = 'DRAGON_BALL_SUPER',
  DudePerfect = 'DUDE_PERFECT',
  /** @deprecated Use SOCCER instead */
  Epl = 'EPL',
  F1 = 'F1',
  /** @deprecated Use SOCCER instead */
  Fifa = 'FIFA',
  FinalFantasy = 'FINAL_FANTASY',
  GarbagePailKids = 'GARBAGE_PAIL_KIDS',
  Golf = 'GOLF',
  Hro = 'HRO',
  Lorcana = 'LORCANA',
  MagicTheGathering = 'MAGIC_THE_GATHERING',
  MetaZoo = 'META_ZOO',
  Mlb = 'MLB',
  /** @deprecated Use SOCCER instead */
  Mls = 'MLS',
  Nascar = 'NASCAR',
  Nba = 'NBA',
  Ncaa = 'NCAA',
  NcaaBk = 'NCAA_BK',
  NcaaFb = 'NCAA_FB',
  Nfl = 'NFL',
  Nhl = 'NHL',
  OnePiece = 'ONE_PIECE',
  Other = 'OTHER',
  Pokemon = 'POKEMON',
  Singles = 'SINGLES',
  Soccer = 'SOCCER',
  StarWars = 'STAR_WARS',
  /** @deprecated Use SOCCER instead */
  Uefa = 'UEFA',
  Ufc = 'UFC',
  VeeFriends = 'VEE_FRIENDS',
  Wnba = 'WNBA',
  Wwe = 'WWE',
  Yugioh = 'YUGIOH'
}

/** External links the shop has */
export type Links = {
  __typename?: 'Links';
  /** Link to Instagram */
  instagram?: Maybe<Scalars['String']['output']>;
  /** Link to Tiktok */
  tiktok?: Maybe<Scalars['String']['output']>;
  /** Link to external website */
  web?: Maybe<Scalars['String']['output']>;
  /** Link to X (Twitter) */
  x?: Maybe<Scalars['String']['output']>;
  /** Link to Youtube */
  youtube?: Maybe<Scalars['String']['output']>;
};

export type ListLiveSupportTicketCommentsResponse = {
  __typename?: 'ListLiveSupportTicketCommentsResponse';
  liveSupportTicketComments: Array<Maybe<LiveSupportComment>>;
};

/** A listing object */
export type Listing = {
  __typename?: 'Listing';
  /** The listing's unique ID */
  id: Scalars['UUID']['output'];
  /** The price of the listing in cents */
  priceInCents?: Maybe<Scalars['Int']['output']>;
  /** The product associated with the listing */
  product: Product;
  /** The shop associated with the digital listing */
  shopId: Scalars['UUID']['output'];
  /** The title of the listing */
  title?: Maybe<Scalars['String']['output']>;
  /** The total count of product available as part of this listing */
  totalCount: Scalars['Int']['output'];
};

export type ListingPurchaseInput = {
  /** If true, apply the user's account funds to the purchase */
  applyAccountFunds?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, apply the user's entire reward balance to the purchase */
  applyRewardsBalance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The listing id to be purchased */
  listingId: Scalars['UUID']['input'];
  /** The id of the live stream in which the listing is purchased */
  liveStreamId: Scalars['UUID']['input'];
  /** The payment method to be used for this purchase */
  paymentMethodId?: InputMaybe<Scalars['UUID']['input']>;
  /** The promo code to be used for this purchase */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** Quantity of the purchased product */
  quantity: Scalars['Int']['input'];
};

export type ListingSuccessResponse = {
  __typename?: 'ListingSuccessResponse';
  /** Indicates if the purchase was successful */
  success: Scalars['Boolean']['output'];
};

export type ListingSuccessResponsePayload = {
  __typename?: 'ListingSuccessResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ListingSuccessResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type LiveProgressiveBreak = {
  __typename?: 'LiveProgressiveBreak';
  break?: Maybe<Break>;
  spotAvailable?: Maybe<Scalars['Int']['output']>;
  spotTotal?: Maybe<Scalars['Int']['output']>;
};

export type LiveProgressiveBreaksInput = {
  isFollowing?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

/** A live stream that belongs to a channel and may contain one or more breaks */
export type LiveStream = {
  __typename?: 'LiveStream';
  /** The live stream's access code */
  accessCode?: Maybe<AccessCode>;
  /** The live stream's breaks */
  breaks: Array<Break>;
  /** Whether the live stream can purchase spots */
  canPurchase: Scalars['Boolean']['output'];
  /** The live stream's current celebration */
  celebration?: Maybe<CelebrationType>;
  /** The channel the live stream belongs to */
  channel: Channel;
  /**
   * The live stream's country
   * @deprecated Use countryV2 instead
   */
  country: Scalars['String']['output'];
  /** The live stream's country */
  countryV2: Country;
  /** The live stream's cover image URL */
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  /** The live stream's current break */
  currentBreak?: Maybe<Break>;
  /** Current active break game */
  currentBreakGame?: Maybe<BreakGame>;
  /** The live stream's current break spot auction, if any */
  currentBreakSpotAuction?: Maybe<BreakSpotAuction>;
  /** Whether this live stream is a debut show or not */
  debutShow?: Maybe<Scalars['Boolean']['output']>;
  /** The live stream's description */
  description?: Maybe<Scalars['String']['output']>;
  /** The live stream's duration */
  duration?: Maybe<Scalars['Float']['output']>;
  /** The live stream's end time (UTC) */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Indicates if the raid target was manually forced (true) or will use automatic recommendation (false)
   * @deprecated Use forcedRaid field from liveStreamRecommendation query result instead
   */
  forcedRaid?: Maybe<Scalars['Boolean']['output']>;
  /** The live stream's latest giveaway, if any */
  giveaway?: Maybe<Giveaway>;
  /**
   * Link for a guest to share. This link contains streaming token in the parameters
   * with publishing and subcription capabilities
   */
  guestLink?: Maybe<Scalars['String']['output']>;
  /** The live stream's unique ID */
  id: Scalars['UUID']['output'];
  /** Whether this live stream is demo or not */
  isDemo?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the current user is following the live stream */
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Field for compatibility with existing frontend. Use viewing_token instead
   * @deprecated Use viewing_token instead
   */
  ivsStreamToken?: Maybe<Scalars['String']['output']>;
  /** The leagues associated with the live stream. This value is cached for 10 minutes. */
  leagues: Array<League>;
  /**
   * Listings for the live stream
   * @deprecated This object is deprecated
   */
  listings: Array<Listing>;
  /** Session ID for current live stream */
  liveStreamSessionId?: Maybe<Scalars['String']['output']>;
  /**
   * Field for compatibility with existing frontend. Use viewing_token instead
   * @deprecated Use viewing_token instead
   */
  livekitStreamToken?: Maybe<Scalars['String']['output']>;
  /** Websocket url for livekit instance */
  livekitUrl?: Maybe<Scalars['String']['output']>;
  /** The live stream's max viewer count */
  maxViewerCount: Scalars['Int']['output'];
  metrics?: Maybe<LiveStreamMetrics>;
  /** Multicasting keys for different platforms */
  multicastingKeys: MulticastingKeys;
  /** The live stream's Mux Asset ID */
  muxAssetId?: Maybe<Scalars['String']['output']>;
  /** The live stream's playback ID */
  muxPlaybackId?: Maybe<Scalars['String']['output']>;
  /** The live stream's name */
  name: Scalars['String']['output'];
  /** The number of unique buyers in the live stream */
  numBuyers?: Maybe<Scalars['Int']['output']>;
  /** The number of spots available for sale in the live stream */
  numOfSpotsAvailable?: Maybe<Scalars['Int']['output']>;
  /** The number of active breaks in the live stream with spots available */
  numUnfilledBreaks?: Maybe<Scalars['Int']['output']>;
  /**
   * Deprecated. The live stream's phenix stream token
   * @deprecated Phenix provider is no longer supported
   */
  phenixStreamToken?: Maybe<Scalars['String']['output']>;
  /** The live stream's latest started or voting closed poll, if any */
  poll?: Maybe<PollWithUserVotes>;
  /** The live stream's published time (UTC) */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The raid target of the stream. Querying this field fails for not completed streams */
  raidTarget?: Maybe<LiveStream>;
  /** The live stream's current randomization */
  randomization?: Maybe<Randomization>;
  /** The shop the live stream belongs to */
  shop: Shop;
  /** The live stream's staffers */
  staffers: Array<Staffer>;
  /** The live stream's start time (UTC) */
  startsAt: Scalars['DateTime']['output'];
  /** The live stream's status */
  status: LiveStreamStatus;
  /** Streaming tokens for both IVS and Livekit */
  streamTokens?: Maybe<StreamTokens>;
  /** The streaming provider for a live stream */
  streamingProvider: StreamingProvider;
  transactions?: Maybe<TransactionConnection>;
  videoOnDemand: Array<VideoOnDemand>;
  /** The live stream's viewer count */
  viewers: Scalars['Int']['output'];
  /** Viewing token for both IVS and Livekit */
  viewingToken?: Maybe<Scalars['String']['output']>;
  /** The live stream's WebRTC playback url */
  webrtcPlaybackUrl?: Maybe<Scalars['String']['output']>;
  /** WHIP URL and tokens */
  whipDetails?: Maybe<WhipDetails>;
};


/** A live stream that belongs to a channel and may contain one or more breaks */
export type LiveStreamBreaksArgs = {
  hasSlotsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  pricingType?: InputMaybe<BreakPricingType>;
  selectionType?: InputMaybe<BreakSelectionType>;
};


/** A live stream that belongs to a channel and may contain one or more breaks */
export type LiveStreamGuestLinkArgs = {
  participantName: Scalars['String']['input'];
};


/** A live stream that belongs to a channel and may contain one or more breaks */
export type LiveStreamLivekitStreamTokenArgs = {
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  subscribe?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A live stream that belongs to a channel and may contain one or more breaks */
export type LiveStreamTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A card to display a live stream */
export type LiveStreamCard = {
  __typename?: 'LiveStreamCard';
  /** The avatar to be shown in the card */
  avatar: Avatar;
  /** The current break in the live stream */
  currentBreak?: Maybe<Break>;
  /** The live stream */
  liveStream: LiveStream;
};

export type LiveStreamCardConnection = {
  __typename?: 'LiveStreamCardConnection';
  edges?: Maybe<Array<Maybe<LiveStreamCardEdge>>>;
  pageInfo: PageInfo;
};

export type LiveStreamCardEdge = {
  __typename?: 'LiveStreamCardEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<LiveStreamCard>;
};

export type LiveStreamConnection = {
  __typename?: 'LiveStreamConnection';
  edges?: Maybe<Array<Maybe<LiveStreamEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type LiveStreamEdge = {
  __typename?: 'LiveStreamEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<LiveStream>;
};

export type LiveStreamEventPayload = AuctionStartedPayload | CardRotatedPayload | CardSwipedPayload | PublicUser;

/** The Live stream latest event response */
export type LiveStreamEventResponse = {
  __typename?: 'LiveStreamEventResponse';
  payload?: Maybe<LiveStreamEventPayload>;
  type?: Maybe<LiveStreamEventType>;
};

/** Latest action taken on a livestream */
export enum LiveStreamEventType {
  AuctionStarted = 'AUCTION_STARTED',
  CardRotated = 'CARD_ROTATED',
  CardSwiped = 'CARD_SWIPED',
  DebutPackUserJoined = 'DEBUT_PACK_USER_JOINED'
}

export enum LiveStreamMetricAggWindow {
  AllTime = 'ALL_TIME',
  DayBeforeYesterday = 'DAY_BEFORE_YESTERDAY',
  OneDay = 'ONE_DAY',
  ThirtyDays = 'THIRTY_DAYS',
  Yesterday = 'YESTERDAY'
}

/** The metrics for the live stream */
export type LiveStreamMetrics = {
  __typename?: 'LiveStreamMetrics';
  /** The credit card processing fee amount in cents */
  applicationProcessingFeeInCents?: Maybe<Scalars['Int']['output']>;
  /** Date when the first order made in that livestream */
  firstOrderDate?: Maybe<Scalars['Date']['output']>;
  /** GMV in MoneyAmount */
  gmv?: Maybe<MoneyAmount>;
  /** String display representation of the GMV amount */
  gmvDisplay?: Maybe<Scalars['String']['output']>;
  /** GMV in cents amount */
  gmvInCents?: Maybe<Scalars['Int']['output']>;
  /** GMV per hour based on any aggregation level, for display */
  gmvPerHourDisplay?: Maybe<Scalars['String']['output']>;
  /** GMV per hour based on any aggregation level */
  gmvPerHourInCents?: Maybe<Scalars['Int']['output']>;
  /** Gross reveune amount in cents */
  grossInCents?: Maybe<Scalars['Int']['output']>;
  /** Net revenue in MoneyAmount */
  netRevenue?: Maybe<MoneyAmount>;
  /** String display representation of the net reveune amount */
  netRevenueDisplay?: Maybe<Scalars['String']['output']>;
  /** Net revenue in cents amount */
  netRevenueInCents?: Maybe<Scalars['Int']['output']>;
  /** Total number of unique orders placed in this livestream. */
  orderCount?: Maybe<Scalars['Int']['output']>;
  /** Total number of shipping packages, one package can have multiple orders */
  packageCount?: Maybe<Scalars['Int']['output']>;
  /** Total shipping cost */
  shippingValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Average spot price in cents */
  spotAvgPrice?: Maybe<Scalars['Int']['output']>;
  /** Total number of spots sold in this livestream */
  spotsSold?: Maybe<Scalars['Int']['output']>;
  /** Sub total value of the products */
  subTotalValueInCents?: Maybe<Scalars['Int']['output']>;
  /** Application fee collected. This is a combination of all the fees including platform cut, tax, shipping and credit card processing, minus discounts */
  totalFee?: Maybe<Scalars['Int']['output']>;
  /** Total product tax amount in cents */
  totalProductTaxInCents?: Maybe<Scalars['Int']['output']>;
  /** Total sales tax amonut in cents */
  totalSalesTaxInCents?: Maybe<Scalars['Int']['output']>;
  /** Total shipping tax amount in cents */
  totalShippingTaxInCents?: Maybe<Scalars['Int']['output']>;
  /** Total number of unique buyers who bought into this livestream */
  uniqueBuyerCount?: Maybe<Scalars['Int']['output']>;
};

/** The metrics for the live stream */
export type LiveStreamMetricsDated = {
  __typename?: 'LiveStreamMetricsDated';
  aggregationWindow?: Maybe<LiveStreamMetricAggWindow>;
  dateAfter?: Maybe<Scalars['Date']['output']>;
  metrics: LiveStreamMetrics;
  shopId: Scalars['UUID']['output'];
};

export type LiveStreamPayload = {
  __typename?: 'LiveStreamPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveStream>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** A preferred live stream to refer viewers of an ending live stream to */
export type LiveStreamRaid = {
  __typename?: 'LiveStreamRaid';
  /** The live stream for viewers to be redirected to */
  liveStream?: Maybe<LiveStream>;
};

export type LiveStreamRail = Rail & {
  __typename?: 'LiveStreamRail';
  id: Scalars['String']['output'];
  items?: Maybe<LiveStreamConnection>;
  position: Scalars['Int']['output'];
  railType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type LiveStreamRailItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Recommendation response including the target stream and whether the raid was forced */
export type LiveStreamRecommendationResult = {
  __typename?: 'LiveStreamRecommendationResult';
  /** Whether the raid to this recommendation was forced (auto-redirect) or optional (show popup) */
  forcedRaid: Scalars['Boolean']['output'];
  /** The recommended live stream to redirect to */
  liveStream?: Maybe<LiveStream>;
};

export type LiveStreamResult = {
  __typename?: 'LiveStreamResult';
  liveStream: LiveStream;
};

export type LiveStreamSectionV2 = SectionV2 & {
  __typename?: 'LiveStreamSectionV2';
  displayType: SectionDisplayType;
  id: Scalars['String']['output'];
  items?: Maybe<LiveStreamConnection>;
  position: Scalars['Int']['output'];
  sectionType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type LiveStreamSectionV2ItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The key to use when sorting live streams */
export enum LiveStreamSortKey {
  /** Sort by the start time of the stream */
  StartsAt = 'STARTS_AT',
  /** Sort by the number of viewers */
  Viewers = 'VIEWERS'
}

export type LiveStreamSpotsRandomizationResult = {
  __typename?: 'LiveStreamSpotsRandomizationResult';
  randomizationResult: RandomizationResult;
};

/** The content status of a live stream */
export enum LiveStreamStatus {
  /** Live stream is active (live) */
  Active = 'ACTIVE',
  /** Live stream is completed */
  Complete = 'COMPLETE',
  /** Live stream is being prepared */
  Preparing = 'PREPARING'
}

export type LiveStreamViewersCounterDetailsPayload = {
  __typename?: 'LiveStreamViewersCounterDetailsPayload';
  anonViewers: Scalars['Int']['output'];
  purchaseReadyViewers: Scalars['Int']['output'];
  totalViewers: Scalars['Int']['output'];
};

/** A section with live streams */
export type LiveStreamsSection = {
  __typename?: 'LiveStreamsSection';
  allItems?: Maybe<Array<LiveStreamCard>>;
  items?: Maybe<Array<LiveStreamCard>>;
  sectionType: SearchSectionType;
};

export type LiveSupportComment = {
  __typename?: 'LiveSupportComment';
  author: LiveSupportUser;
  body: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
};

export type LiveSupportTicket = {
  __typename?: 'LiveSupportTicket';
  author: LiveSupportUser;
  createdAt: Scalars['DateTime']['output'];
  currentStatus: TicketStatus;
  description: Scalars['String']['output'];
  /** @deprecated Deprecated: use currentStatus instead */
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  ticketId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type LiveSupportTicketCommentResponse = {
  __typename?: 'LiveSupportTicketCommentResponse';
  liveSupportTicketComment: LiveSupportComment;
};

export type LiveSupportTicketCommentResponsePayload = {
  __typename?: 'LiveSupportTicketCommentResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveSupportTicketCommentResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type LiveSupportTicketResponse = {
  __typename?: 'LiveSupportTicketResponse';
  liveSupportTicket: LiveSupportTicket;
};

export type LiveSupportTicketResponsePayload = {
  __typename?: 'LiveSupportTicketResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveSupportTicketResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type LiveSupportUser = {
  __typename?: 'LiveSupportUser';
  /** The user avatar url */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The user email */
  email: Scalars['String']['output'];
  /** The user id */
  id?: Maybe<Scalars['UUID']['output']>;
  /** The user username */
  username?: Maybe<Scalars['String']['output']>;
  /** Zendesk user name */
  zendeskName: Scalars['String']['output'];
};

/** The Live-specific attributes of a user. */
export type LiveUserAttributes = {
  __typename?: 'LiveUserAttributes';
  /** The date and time the user was blocked from referring. */
  blockedFromReferringAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user's unique identifier to be utilized with Braze SDK's as their external ID. */
  brazeExternalId: Scalars['UUID']['output'];
  /**
   * The shop associated with the current user.
   * Returns nil if the user is not associated with a shop.
   */
  currentShop?: Maybe<Shop>;
  /** The user's default payment method */
  defaultPaymentMethod?: Maybe<PaymentMethod>;
  /** The user's default shipping address */
  defaultShippingAddressV2?: Maybe<AddressV2>;
  /** The follower count of the user. */
  followerCount?: Maybe<Scalars['Int']['output']>;
  /** The following count of the user. */
  followingCount?: Maybe<Scalars['Int']['output']>;
  /** The Live ID of the user. */
  id?: Maybe<Scalars['UUID']['output']>;
  /** Whether the user's onboarding is complete. */
  onboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user's payment requires action. */
  paymentRequiresAction?: Maybe<PaymentRequiresAction>;
  /** Whether the user's registration is complete. */
  registrationComplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the user is tax exempt. */
  taxExempt?: Maybe<Scalars['Boolean']['output']>;
};

/** User with restrictions in a livestream */
export type LivestreamRestrictedUser = {
  __typename?: 'LivestreamRestrictedUser';
  /** Auction ban status for this user */
  auctionBan?: Maybe<BanStatus>;
  /** Chat ban status for this user */
  chatBan?: Maybe<BanStatus>;
  /** Profile image path for the user */
  logoPath?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the user */
  userId: Scalars['UUID']['output'];
  /** Username of the restricted user */
  username: Scalars['String']['output'];
};

/** The result of a logout attempt */
export type LogOutResult = {
  __typename?: 'LogOutResult';
  success: Scalars['Boolean']['output'];
};

export type LoginInput = {
  /** Unique Device identifier */
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The email address or username of the user to authenticate */
  emailOrUsername?: InputMaybe<Scalars['String']['input']>;
  /** The password for the user to authenticate */
  password: Scalars['String']['input'];
  /** Unique SEON identifier for fraud detection */
  seonIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type LogoutInput = {
  /** An access token */
  accessToken: Scalars['String']['input'];
  /** A refresh token */
  refreshToken: Scalars['String']['input'];
  /** Terminate the session */
  terminateSession?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Loyalty = {
  __typename?: 'Loyalty';
  accountBalanceDisplay?: Maybe<Scalars['String']['output']>;
};

/** A manufacturer */
export type Manufacturer = {
  __typename?: 'Manufacturer';
  /** The ID for this manufacturer */
  id: Scalars['UUID']['output'];
  /** The name of this manufacturer */
  name: Scalars['String']['output'];
};

export type MarkUsersDebutPackIneligibleInput = {
  /** List of usernames to mark as ineligible for debut pack */
  usernames: Array<Scalars['String']['input']>;
};

export type MarkUsersDebutPackIneligiblePayload = {
  __typename?: 'MarkUsersDebutPackIneligiblePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<MarkUsersDebutPackIneligibleResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type MarkUsersDebutPackIneligibleResponse = {
  __typename?: 'MarkUsersDebutPackIneligibleResponse';
  markedUsers: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Marketplace = {
  __typename?: 'Marketplace';
  metadata: MarketplaceMetadata;
  results?: Maybe<MarketplaceItemConnection>;
  userSortAndFiltersApplied: Scalars['Boolean']['output'];
};


export type MarketplaceResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketplaceBreakSpot = {
  __typename?: 'MarketplaceBreakSpot';
  break: Break;
  id: Scalars['UUID']['output'];
  label: Scalars['String']['output'];
  leagueMembers: Array<LeagueMember>;
  liveStream: LiveStream;
  price: MoneyAmount;
  products: Array<MarketplaceBreakSpotProduct>;
};

/** A flattened version of a `break_product` object with a nested `product` field */
export type MarketplaceBreakSpotProduct = {
  __typename?: 'MarketplaceBreakSpotProduct';
  brand: Scalars['String']['output'];
  cardsPerPack?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<ProductCategory>;
  checklistUrl?: Maybe<Scalars['String']['output']>;
  displayYear?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  imagePaths?: Maybe<ProductImagePaths>;
  name: Scalars['String']['output'];
  packsPerBox?: Maybe<Scalars['Int']['output']>;
  producerId?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type MarketplaceFilterPrice = {
  maximum?: InputMaybe<Scalars['Int']['input']>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['String']['input'];
};

export type MarketplaceFilters = {
  leagueId?: InputMaybe<Scalars['String']['input']>;
  leagueMemberIds?: InputMaybe<Array<Scalars['String']['input']>>;
  manufacturerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  price?: InputMaybe<MarketplaceFilterPrice>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Items which are tailored for Direct Buy Marketplace and can be purchased directly */
export type MarketplaceItem = MarketplaceBreakSpot;

export type MarketplaceItemConnection = {
  __typename?: 'MarketplaceItemConnection';
  edges?: Maybe<Array<Maybe<MarketplaceItemEdge>>>;
  pageInfo: PageInfo;
};

export type MarketplaceItemEdge = {
  __typename?: 'MarketplaceItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<MarketplaceItem>;
};

export type MarketplaceMetadata = {
  __typename?: 'MarketplaceMetadata';
  count: Scalars['Int']['output'];
};

export type MarketplaceSortAndFilterPage = {
  __typename?: 'MarketplaceSortAndFilterPage';
  form: Array<FormField>;
};

/** A message that accompanies a successful result */
export type Message = {
  __typename?: 'Message';
  /** Code that describes the message */
  code: Scalars['String']['output'];
  /** Text that can be shown to the user */
  text: Scalars['String']['output'];
};

/** Generic metadata which relates to a transaction */
export type Metadata = {
  __typename?: 'Metadata';
  orderId?: Maybe<Scalars['String']['output']>;
  shopName?: Maybe<Scalars['String']['output']>;
};

export type Money = {
  __typename?: 'Money';
  amountDisplay: Scalars['String']['output'];
  amountInCents: Scalars['Int']['output'];
  currency: Scalars['Currency']['output'];
};

export type MoneyAmount = {
  __typename?: 'MoneyAmount';
  /** The amount in pennies */
  amount: Scalars['Int']['output'];
  /** Formatted amount with currency symbol */
  amountDisplay: Scalars['String']['output'];
  /** The ISO 4217 currency code */
  currency: Scalars['String']['output'];
};

/** Input object for moving a break */
export type MoveBreakInput = {
  breakId: Scalars['UUID']['input'];
  liveStreamId: Scalars['UUID']['input'];
};

export type MoveBreakPayload = {
  __typename?: 'MoveBreakPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<MoveBreakResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type MoveBreakResponse = {
  __typename?: 'MoveBreakResponse';
  break?: Maybe<Break>;
};

/** Tokens used for stream multicasting */
export type MulticastingKeys = {
  __typename?: 'MulticastingKeys';
  /** Streaming key for facebook */
  streamKeyFb?: Maybe<Scalars['String']['output']>;
  /** Streaming key for instagram */
  streamKeyInstagram?: Maybe<Scalars['String']['output']>;
  /** Streaming key for tiktok */
  streamKeyTiktok?: Maybe<Scalars['String']['output']>;
  /** Streaming key for twitch */
  streamKeyTwitch?: Maybe<Scalars['String']['output']>;
  /** Streaming key for youtube */
  streamKeyYoutube?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept a buyback offer for an item */
  acceptBuyback?: Maybe<AcceptBuybackPayload>;
  /** Create a new account */
  accountCreate?: Maybe<AccountCreatePayload>;
  /** Delete the current user's account */
  accountDelete?: Maybe<AccountDeletePayload>;
  /** Update the current user's account */
  accountUpdate?: Maybe<AccountUpdatePayload>;
  /**
   * Update the current user's email
   * @deprecated Account email changes are now managed through FanID
   */
  accountUpdateEmail?: Maybe<AccountUpdatePayload>;
  /** Acknowledge the event for a given entity */
  acknowledgeEvent: AcknowledgeEventPayload;
  /** Ackowledge a user in a live stream */
  acknowledgeReceipt?: Maybe<AcknowledgeReceiptResponsePayload>;
  addItemsToChecklist?: Maybe<UpdateRepackPayload>;
  /**
   * Add a new shipping/billing address to the current user
   * @deprecated Please use addressCreateV2 instead
   */
  addressCreate?: Maybe<AddressChangePayload>;
  /** Add a new shipping/billing address to the current user. Supports US and non-US addresses */
  addressCreateV2?: Maybe<AddressChangePayloadV2>;
  /** Delete an existing shipping/billing address */
  addressDelete?: Maybe<AddressChangePayload>;
  /**
   * Update an existing shipping/billing address
   * @deprecated Do not update addresses. Add a new address and remove the old one.
   * In the future this mutation will be a noop.
   */
  addressUpdate?: Maybe<AddressChangePayload>;
  /**
   * Update an existing shipping/billing address. Supports US and non-US addresses
   * @deprecated Do not update addresses. Add a new address and remove the old one.
   * In the future this mutation will be a noop.
   */
  addressUpdateV2?: Maybe<AddressChangePayloadV2>;
  /**
   * Applies a promo code to the current user
   * @deprecated Use `codeApply` instead
   */
  applyPromoCode: PromoCode;
  /** Mutation for assigning a spot */
  assignSpot?: Maybe<AssignSpotPayload>;
  /** Assign staffers to a live stream */
  assignStaffersToLiveStream?: Maybe<AssignStaffersToLiveStreamPayload>;
  /** Apply an auction ban to a user in a specific livestream */
  auctionBanUser?: Maybe<AuctionBanPayload>;
  auctionFail?: Maybe<AuctionFailPayload>;
  /** Remove an auction ban for a user in a specific livestream */
  auctionUnbanUser?: Maybe<UnbanAuctionPayload>;
  /**
   * Authenticate a user and return access and refresh tokens if auth is successful.
   * Used for native FanID authentication flows (mobile).
   */
  authenticate: AuthenticateResult;
  /** Creates a follow relationship between the current user and specified shops. */
  batchFollowShopCreate?: Maybe<BatchFollowShopCreatePayload>;
  /**
   * Bid on a spot in a break auction
   * @deprecated Prefer bidV2 instead, which returns BreakSpotAuction type
   */
  bid?: Maybe<BidPayload>;
  /** Bid on a spot in a break auction */
  bidV2?: Maybe<BidV2Payload>;
  /** Update break game end time */
  breakGameAddTime?: Maybe<BreakGameResponsePayload>;
  /** Create a break game */
  breakGameCreate?: Maybe<BreakGameResponsePayload>;
  /** End Break Game immediately: will set game status to completed or failed and game end time to now */
  breakGameEndGame?: Maybe<BreakGameResponsePayload>;
  /**
   * Launch giveaway for completed break game with giveaway reward
   * @deprecated use generic break_game_launch_reward mutation instead
   */
  breakGameLaunchGiveaway?: Maybe<CreateGiveawayResponsePayload>;
  /** Launch reward mechanics for completed break game */
  breakGameLaunchReward?: Maybe<RewardResponsePayload>;
  /**
   * Update the current user's breaking profile
   * @deprecated Please use accountUpdate instead
   */
  breakingProfileUpdate?: Maybe<BreakingProfileChangePayload>;
  captureSubscriptionList?: Maybe<CaptureSubscriptionListPayload>;
  /** Attach a specific card to current user */
  cardAttach?: Maybe<CardAttachedPayload>;
  /** Create a new card */
  cardCreate?: Maybe<CardPayload>;
  cardDelete?: Maybe<CardDeletePayload>;
  cardUpdate?: Maybe<CardUpdatePayload>;
  /** Update an existing live stream with the provided parameters. */
  celebrateLiveStream?: Maybe<CelebrateLiveStreamPayload>;
  /** Mutation for changing break status */
  changeBreakStatus?: Maybe<ChangeBreakStatusPayload>;
  /** Change data and privacy settings of current user */
  changeDataPrivacySettings?: Maybe<ChangeDataPrivacySettingsPayload>;
  /** Changes staffer settings of current user */
  changeStafferSettings?: Maybe<ChangeStafferSettingsPayload>;
  /** Trigger the open box status on an odyssey break */
  closeBox: UpdatedBreakPayload;
  /** Applies a code (promotion or reward) to the current user */
  codeApply: CodeResult;
  collectAcceptOffer?: Maybe<CollectFixedPriceAcceptOfferPayload>;
  collectAddCandidateToCollection: CollectAddToCollectionPayload;
  collectAddFixedPriceToSetlist: CollectAddFixedPriceToSetlistPayload;
  collectAddItemToSetlist: CollectAddItemToSetlistPayload;
  collectAddPremierToSetlist: CollectAddPremierToSetlistPayload;
  collectAddProductToSetlist: CollectAddProductToSetlistPayload;
  /** @deprecated Use `collectBoAddToCart` instead. This legacy cart will be removed in a future version. */
  collectAddToCart?: Maybe<CollectCartPayload>;
  collectAddToCollection: CollectAddToCollectionPayload;
  collectAddVariantToSetlist: CollectAddVariantToSetlistPayload;
  collectAddVaultItemsToGroup?: Maybe<CollectAddVaultItemsToGroupPayload>;
  collectAddWeeklyToSetlist: CollectAddWeeklyToSetlistPayload;
  collectAddressCreate?: Maybe<CollectAddressCreatePayload>;
  collectAddressValidate?: Maybe<CollectAddressValidatePayload>;
  /**
   * Authenticate a user with an authorization code.
   *
   * This is meant to be called by native mobile apps, after completing the first
   * part of the FanID authentication flow.
   */
  collectAuthenticate?: Maybe<CollectTokenSet>;
  /**
   * Cancels several listings in a single batch.
   *
   * When updates for the same listing are specified in this call,
   * all updates will be applied but their order is undefined
   */
  collectBatchCancelListings?: Maybe<CollectBatchCancelListingsPayload>;
  collectBatchCreateListing?: Maybe<CollectBatchCreateListingPayload>;
  collectBatchCreateListingsV2?: Maybe<CollectBatchCreateListingsV2Payload>;
  collectBatchMakeOffers?: Maybe<CollectBatchMakeOffersPayload>;
  /**
   * Updates several listings in a single batch.
   *
   * For detailed description on available options see documentation
   * for type-specific update mutations.
   *
   * When updates for the same listing are specified in this call,
   * all updates will be applied but their order is undefined
   */
  collectBatchUpdateListings?: Maybe<CollectBatchUpdateListingsPayload>;
  collectBoAddToCart?: Maybe<CollectBoCartPayload>;
  collectBoBatchUpdateTrackingInformation?: Maybe<CollectBoBatchUpdateTrackingInformationPayload>;
  /** @deprecated Use `checkoutV2` instead */
  collectBoCheckoutListingConfirmIntent?: Maybe<CollectBoCheckoutListingConfirmIntentPayload>;
  /** @deprecated Use `checkoutV2` instead */
  collectBoCheckoutListingCreateIntent?: Maybe<CollectBoCheckoutListingCreateIntentPayload>;
  collectBoCheckoutV2ConfirmIntent?: Maybe<CollectBoCheckoutV2ConfirmIntentPayload>;
  collectBoCheckoutV2CreateIntent?: Maybe<CollectBoV2CheckoutCreateIntentResult>;
  collectBoRemoveFromCart?: Maybe<CollectBoCartPayload>;
  collectBoUpdateCart?: Maybe<CollectBoCartPayload>;
  collectCancelInvoicePaymentAttempt?: Maybe<CollectCancelInvoicePaymentAttemptPayload>;
  collectCancelListing?: Maybe<CollectCancelListingPayload>;
  collectCancelOffer?: Maybe<CollectFixedPriceOfferPayload>;
  collectCancelVaultItemRequest?: Maybe<CollectCancelVaultItemRequestPayload>;
  collectCancelVaultRetrieval?: Maybe<CollectCancelVaultRetrievalPayload>;
  collectCancelVaultSubmission?: Maybe<CollectCancelVaultSubmissionPayload>;
  /**
   * Add an item to the collection (Deprecated).
   * @deprecated This mutation is deprecated and will be removed in the next release. Use `collect_catalog_add_item_to_collection_modern` instead.
   */
  collectCatalogAddItemToCollection?: Maybe<CollectItem>;
  /** Add an item to the collection. */
  collectCatalogAddItemToCollectionModern?: Maybe<CollectItemResponsePayload>;
  /**
   * Update an existing item (Deprecated).
   * @deprecated This mutation is deprecated and will be removed in the next release. Use `collect_catalog_update_item_modern` instead.
   */
  collectCatalogUpdateItem?: Maybe<CollectItem>;
  /** Update an existing item. */
  collectCatalogUpdateItemModern?: Maybe<CollectItemResponsePayload>;
  collectCheckoutCancelWalletPendingPayments: CollectCheckoutCancelWalletPendingPaymentsPayload;
  collectCheckoutFulfillmentCharges?: Maybe<CollectFulfillmentChargesPayload>;
  collectCheckoutInvoiceConfirm?: Maybe<CollectCheckoutInvoiceConfirmPayload>;
  /** This creates a client secret, that can be used for client side to generate the payment intent */
  collectCheckoutInvoicePaymentIntent?: Maybe<CollectCheckoutInvoicePaymentIntentPayload>;
  /** This creates an Invoice in case of listing type input and create a Payment Intent for Stripe payment method */
  collectCheckoutPaymentLock?: Maybe<CollectCheckoutPaymentLockPayload>;
  /** This creates a setup intent, that can be used for client side to create payment method */
  collectCheckoutSetupIntent?: Maybe<CollectCheckoutSetupIntentPayload>;
  collectCheckoutV2CompletePayment: CollectCheckoutV2CompletePaymentPayload;
  collectCheckoutV2LockForPayment: CollectCheckoutV2LockForPaymentPayload;
  collectCompleteRedRookieRedemption: CollectCompleteRedRookieRedemptionPayload;
  collectCounterOffer?: Maybe<CollectFixedPriceOfferPayload>;
  collectCreateInvoice?: Maybe<CollectCreateInvoicePayload>;
  /** Create Item Edit Request for a specific user */
  collectCreateItemEditRequest: CollectCreateItemEditRequestPayload;
  collectCreatePayoutRequests?: Maybe<CollectCreatePayoutRequestsPayload>;
  collectCreatePickUpInPerson?: Maybe<CollectCreatePickUpInPersonPayload>;
  collectCreatePlaidLinkToken: CollectCreatePlaidLinkTokenPayload;
  collectCreatePresignedUrl?: Maybe<CollectPresignedUrlPayload>;
  collectCreateRedemptionSubmission?: Maybe<CollectCreateRedemptionSubmissionPayload>;
  collectCreateRedemptionSubmissionV2?: Maybe<CollectCreateRedemptionSubmissionPayload>;
  collectCreateReport: CollectCreateReportPayload;
  collectCreateSavedSearch?: Maybe<CollectCreateSavedSearchPayload>;
  collectCreateScanResultFeedback?: Maybe<CollectScanResultFeedbackPayload>;
  collectCreateTradeShowCheckout?: Maybe<CollectCreateTradeShowCheckoutPayload>;
  collectCreateVaultItemGroup?: Maybe<CollectCreateVaultItemGroupPayload>;
  collectCreateVaultRetrieval?: Maybe<CollectCreateVaultRetrievalPayload>;
  collectCreateVaultSubmission?: Maybe<CollectCreateVaultSubmissionPayload>;
  collectCreateVaultTransfer?: Maybe<CollectCreateVaultTransferPayload>;
  collectDeclineOffer?: Maybe<CollectFixedPriceOfferPayload>;
  collectDeleteSavedSearch?: Maybe<CollectDeleteSavedSearchPayload>;
  collectDeleteVaultItemGroup?: Maybe<CollectDeleteVaultItemGroupPayload>;
  /** Duplicate vault items for a given account by email address (Development only) - DEPRECATED: use collect_duplicate_vault_items_v2 */
  collectDuplicateVaultItems: CollectDuplicateVaultItemsPayload;
  /** Duplicate vault items for a given account by email address (Development only) */
  collectDuplicateVaultItemsV2: CollectDuplicateVaultItemsPayload;
  /**
   * Exchange a refresh token for a new token pair.
   * @deprecated Use collectRefreshToken mutation instead.
   */
  collectExchangeToken?: Maybe<CollectTokenSet>;
  collectForgetRecentView?: Maybe<CollectActivityForgetRecentViewPayload>;
  /**
   * Issue a new token pair for a user.
   *
   * This is meant to be called by web applications, after completing the first
   * part of the FanID authentication flow.
   */
  collectGetTokenPair?: Maybe<CollectTokenSet>;
  collectLinkPlaidIdentityVerification: Scalars['Boolean']['output'];
  /** Logout the current user. */
  collectLogout?: Maybe<Scalars['Boolean']['output']>;
  collectMakeOffer?: Maybe<CollectFixedPriceOfferPayload>;
  collectMarkOfferAsViewed?: Maybe<CollectMarkOfferAsViewedPayload>;
  collectMarkOfferNotificationAsViewed?: Maybe<CollectMarkOfferNotificationAsViewedPayload>;
  /** Place a list of bids */
  collectMultiBid?: Maybe<CollectBidPayload>;
  collectProcessStripeAchConsent?: Maybe<CollectProcessStripeAchConsentPayload>;
  collectRefreshToken?: Maybe<CollectTokenPair>;
  collectRemoveFixedPriceFromSetlist: CollectRemoveFixedPriceFromSetlistPayload;
  /** @deprecated Use `collectBoRemoveFromCart` instead. This legacy cart will be removed in a future version. */
  collectRemoveFromCart?: Maybe<CollectCartPayload>;
  collectRemoveFromCollection: CollectRemoveFromCollectionPayload;
  collectRemoveItemFromSetlist: CollectRemoveItemFromSetlistPayload;
  collectRemovePremierFromSetlist: CollectRemovePremierFromSetlistPayload;
  collectRemoveProductFromSetlist: CollectRemoveProductFromSetlistPayload;
  collectRemoveVariantFromSetlist: CollectRemoveVariantFromSetlistPayload;
  collectRemoveVaultItemFromGroup?: Maybe<CollectRemoveVaultItemFromVaultItemGroupPayload>;
  collectRemoveWeeklyFromSetlist: CollectRemoveWeeklyFromSetlistPayload;
  collectReportIncorrectMatch: CollectReportIncorrectMatchPayload;
  collectRequestCsvExport?: Maybe<CollectRequestCsvExportPayload>;
  /** Request an OTP via email */
  collectRequestSessionEmailOtp?: Maybe<CollectRequestSessionEmailOtpPayload>;
  collectResendPhoneVerificationCode?: Maybe<CollectResendPhoneVerificationCodePayload>;
  /** Resends verification email for the current user */
  collectResendWelcomeEmail?: Maybe<CollectResendWelcomeEmailPayload>;
  collectResolvePhoneConflict?: Maybe<CollectResolvePhoneConflict>;
  collectTrackView?: Maybe<CollectActivityTrackViewPayload>;
  collectUnwatchListing?: Maybe<CollectWatchListingPayload>;
  collectUpdateFixedPriceListing?: Maybe<CollectUpdateFixedPriceListingPayload>;
  collectUpdateItem: CollectUpdateItemPayload;
  collectUpdateMemberCheckout?: Maybe<CollectUpdateMemberCheckoutPayload>;
  collectUpdateOwnerValues: CollectUpdateOwnerValuesPayload;
  collectUpdatePremierListing?: Maybe<CollectUpdatePremierListingPayload>;
  collectUpdateProfile?: Maybe<CollectUpdateProfile>;
  collectUpdateProfileName?: Maybe<CollectUpdateProfileName>;
  collectUpdateProtoItem?: Maybe<CollectProtoItem>;
  collectUpdateProtoItemPurchasePrice?: Maybe<CollectProtoItem>;
  collectUpdateTradeShowCheckout?: Maybe<CollectUpdateTradeShowCheckoutPayload>;
  collectUpdateUserPhone?: Maybe<CollectUpdateUserPhone>;
  collectUpdateVaultItemGroup?: Maybe<CollectUpdateVaultItemGroupPayload>;
  collectUpdateVaultRetrieval?: Maybe<CollectUpdateVaultRetrievalPayload>;
  collectUpdateVaultSubmission?: Maybe<CollectUpdateVaultSubmissionPayload>;
  collectUpdateWeeklyListing?: Maybe<CollectUpdateWeeklyListingPayload>;
  collectUseSavedSearch?: Maybe<CollectUseSavedSearchPayload>;
  collectValidateMfa?: Maybe<CollectValidateMfaPayload>;
  collectVaultItemsExport: CollectVaultItemsExportPayload;
  collectVerifyMfa?: Maybe<CollectVerifyMfaPayload>;
  collectVerifyPhone?: Maybe<CollectVerifyPhonePayload>;
  collectVerifyPremierAuctionApprovalRequirement: Scalars['Boolean']['output'];
  /** Verify an OTP via email */
  collectVerifySessionEmailOtp?: Maybe<CollectVerifySessionEmailOtpPayload>;
  collectWatchListing?: Maybe<CollectWatchListingPayload>;
  collectionsAddItemsToCustomList?: Maybe<CollectionsAddItemsToCustomListPayload>;
  collectionsAddItemsToCustomLists?: Maybe<CollectionsAddItemsToCustomListsPayload>;
  collectionsCreateCustomList?: Maybe<CollectionsCreateCustomListPayload>;
  collectionsDeleteCustomList?: Maybe<CollectionsDeleteCustomListPayload>;
  collectionsRemoveItemsFromCustomList?: Maybe<CollectionsRemoveItemsFromCustomListPayload>;
  collectionsUpdateCustomList?: Maybe<CollectionsUpdateCustomListPayload>;
  /** Create a break */
  createBreak?: Maybe<CreateBreakPayload>;
  createConsignment?: Maybe<CreateConsignmentPayload>;
  createDigitalBreak?: Maybe<CreateBreakPayload>;
  createLiveStream?: Maybe<CreateLiveStreamPayload>;
  /** Create a personal */
  createPersonal?: Maybe<CreateBreakPayload>;
  createProductDetailFeedback?: Maybe<CollectProductDetailFeedbackPayload>;
  createRepack?: Maybe<CreateRepackPayload>;
  /** @deprecated This is deprecated */
  createRepackAllocation?: Maybe<CreateRepackAllocationPayload>;
  /** Create a sub-break */
  createSubBreak?: Maybe<CreateBreakPayload>;
  createWaxChecklist?: Maybe<CreateRepackPayload>;
  /**
   * Create a white elephant break game
   * @deprecated This mutation is no longer supported. Please use the `break_game_create` mutation instead.
   */
  createWhiteElephantBreakGame?: Maybe<WhiteElephantBreakPayload>;
  /** Create a new crypto invoice */
  cryptoInvoiceCreate: CryptoInvoice;
  /** Archive custom break template */
  customBreakTemplateArchive?: Maybe<CustomBreakTemplateArchivePayload>;
  customBreakTemplateCreate?: Maybe<CustomBreakTemplateCreatePayload>;
  /** Create a custom break template from a CSV */
  customBreakTemplateCreateFromCsv?: Maybe<CustomBreakTemplateCreateFromCsvPayload>;
  customBreakTemplateUpdate?: Maybe<CustomBreakTemplateUpdatePayload>;
  /** Create a custom giveaway from a CSV */
  customGiveawayCreate?: Maybe<CreateGiveawayPayload>;
  debutPackUserJoined?: Maybe<DebutPackUserJoinedPayload>;
  /** Mutation for deleting a break */
  deleteBreak?: Maybe<DeleteBreakPayload>;
  /** Update an existing live stream with the provided parameters. */
  deleteLiveStream?: Maybe<DeleteLiveStreamPayload>;
  deleteLogoPath?: Maybe<DeleteLogoPathPayload>;
  deleteRepack?: Maybe<DeleteRepackPayload>;
  disableUseCreditBalance?: Maybe<AccountUpdatePayload>;
  enableUseCreditBalance?: Maybe<AccountUpdatePayload>;
  /** End a live stream (internal use only) */
  endLiveStream?: Maybe<EndLiveStreamPayload>;
  /** Enters the current user into a giveaway */
  enterGiveaway?: Maybe<EnterGiveawayPayload>;
  /** Exchanges a valid refresh token for a new access token */
  exchangeToken: TokenPair;
  /** Register a new account created with FanID */
  fanidAccountCreate: FanidAccountCreatePayload;
  /** Creates a follow relationship between the current user and a specified channel. */
  followChannelCreate?: Maybe<FollowChannelCreatePayload>;
  /** Removes a follow relationship between the current user and a specified channel. */
  followChannelDelete?: Maybe<FollowChannelDeletePayload>;
  /** Creates a follow relationship between the current user and a specified league. */
  followLeagueCreate?: Maybe<FollowLeagueCreatePayload>;
  /** Removes a follow relationship between the current user and a specified league. */
  followLeagueDelete?: Maybe<FollowLeagueDeletePayload>;
  /** Creates a follow relationship between the current user and a specified league member. */
  followLeagueMemberCreate?: Maybe<FollowLeagueMemberCreatePayload>;
  /** Removes a follow relationship between the current user and a specified league. */
  followLeagueMemberDelete?: Maybe<FollowLeagueMemberDeletePayload>;
  /** Creates a follow relationship between the current user and a specified live stream. */
  followLiveStreamCreate?: Maybe<FollowLiveStreamCreatePayload>;
  /** Removes a follow relationship between the current user and a specified live stream. */
  followLiveStreamDelete?: Maybe<UnfollowLiveStreamCreatePayload>;
  /** Creates a follow relationship between the current user and a specified shop. */
  followShopCreate?: Maybe<FollowShopCreatePayload>;
  /** Removes a follow relationship between the current user and a specified shop. */
  followShopDelete?: Maybe<FollowShopDeletePayload>;
  followUserCreate?: Maybe<FollowUserCreatePayload>;
  followUserDelete?: Maybe<FollowUserDeletePayload>;
  /**
   * Returns an access and refresh token pair if the user has an active FanID session.
   * Used for FanID authentication on web clients.
   */
  getTokenPair: GetTokenPairResult;
  /** Generate a presigned url for uploading an image to S3 */
  imageUploadUrlCreate?: Maybe<ImageUploadUrlCreatePayload>;
  /** Launch giveaway */
  launchLiveSteamGiveaway?: Maybe<LaunchLiveSteamGiveawayPayload>;
  /** Authenticate a user and return access and refresh tokens if auth is successful */
  login: TokenPair;
  logout: LogOutResult;
  /** Mark users as ineligible for debut pack */
  markUsersDebutPackIneligible?: Maybe<MarkUsersDebutPackIneligiblePayload>;
  /** Mutation for moving a break */
  moveBreak?: Maybe<MoveBreakPayload>;
  /** Trigger the next card */
  nextCard: UpdatedBreakPayload;
  /** Trigger the open box status on an odyssey break */
  openBox: UpdatedBreakPayload;
  /**
   * Add a new payment method to the current user
   * @deprecated Please use paymentMethodCreateV2 instead
   */
  paymentMethodCreate?: Maybe<PaymentMethodChangePayload>;
  /** Set up for adding a payment method in Stripe */
  paymentMethodCreatePrepare?: Maybe<PaymentMethodCreatePreparePayload>;
  /** Add a new payment method to the current user */
  paymentMethodCreateV2?: Maybe<PaymentMethodChangePayloadV2>;
  /**
   * Delete an existing payment method
   * @deprecated Please use paymentMethodDeleteV2 instead
   */
  paymentMethodDelete?: Maybe<PaymentMethodChangePayload>;
  /** Delete an existing payment method */
  paymentMethodDeleteV2?: Maybe<PaymentMethodChangePayloadV2>;
  phoneNumberSubmit?: Maybe<PhoneNumberResponse>;
  phoneNumberVerify?: Maybe<PhoneNumberResponse>;
  pickBreakMechanicSpot?: Maybe<PickBreakMechanicSpotPayload>;
  ping?: Maybe<PingPayload>;
  /** Create a poll */
  pollCreate: PollCreateResponsePayload;
  /** Start a poll */
  pollStart: PollStartResponsePayload;
  /** Terminate a poll */
  pollTerminate: PollTerminateResponsePayload;
  prepareMulticasting?: Maybe<LiveStreamPayload>;
  /** Prepares a stream and returns a set of tokens for the streamer */
  prepareStream?: Maybe<StreamTokensPayload>;
  /** Prepares a WHIP URL and key */
  prepareWhip?: Maybe<WhipPayload>;
  /**
   * Create a new product
   * @deprecated Use product_create_v2 instead.
   */
  productCreate?: Maybe<ProductCreatePayload>;
  /** Create a new product */
  productCreateV2?: Maybe<ProductCreatePayload>;
  /** Create a product order */
  productOrderCreate?: Maybe<ProductOrderCreatePayload>;
  /** Update a product, currently only support V2 version of uploading images */
  productUpdate?: Maybe<ProductUpdatePayload>;
  /** Publish a live stream */
  publishLiveStream?: Maybe<PublishLiveStreamPayload>;
  /** Purchase from a listing */
  purchaseListing?: Maybe<ListingSuccessResponsePayload>;
  /** Purchase random spot in a fixed-price break */
  purchaseRandomSpot?: Maybe<PurchaseRandomSpotPayload>;
  /** Purchase a specific fixed-price spot in a break */
  purchaseSpot?: Maybe<PurchaseSpotPayload>;
  /** Purchase a specific fixed-price spot with client-side payment confirmation */
  purchaseWithClientConfirmation?: Maybe<PurchaseSpotPayload>;
  /** Login a user via Marketplace authentication. */
  pwccLogin?: Maybe<CollectMarketplaceAuthResult>;
  /** Logout via PWCCID. */
  pwccLogout?: Maybe<Scalars['Boolean']['output']>;
  /** Refresh a token pair via PWCCID. */
  pwccRefresh?: Maybe<CollectMarketplaceAuthResult>;
  quickCreateBreak?: Maybe<QuickCreateBreakPayload>;
  /** Mutation for randomizing break spots */
  randomizeBreakSpots?: Maybe<RandomizeBreakSpotsPayload>;
  randomizeLiveStreamSpots?: Maybe<RandomizeLiveStreamSpotsPayload>;
  referralCodeRedeem?: Maybe<ReferralCodeResponsePayload>;
  /** Refresh prices for a repack/checklist */
  refreshPrices?: Maybe<PriceRefreshPayload>;
  /** Refund a specific fixed-price spot in a break */
  refundSpot?: Maybe<RefundSpotPayload>;
  /** Remove items from checklist */
  removeItemsFromChecklist?: Maybe<RemoveItemsFromChecklistPayload>;
  /** Request CSV export of shop analytics values */
  requestCsvExport?: Maybe<RequestCsvExportPayload>;
  /** Request CSV export of shops referred users */
  requestReferralsCsvExport?: Maybe<RequestReferralsCsvExportPayload>;
  /** Request CSV export of shops analytics reports */
  requestShopAnalyticsCustomReportCsvExport?: Maybe<RequestShopAnalyticsCustomReportCsvExportPayload>;
  /** Reset current user's password */
  resetPassword?: Maybe<ResetPasswordPayload>;
  /** Restrict a user in a live stream chat */
  restrictUser?: Maybe<RestrictUserPayload>;
  /** Reveal a spot in a break auction with break mechanics */
  revealBreakMechanicSpot?: Maybe<RevealSpotPayload>;
  /** Trigger the reveal card */
  revealCard: UpdatedBreakPayload;
  /** Trigger the rip pack */
  ripPack: UpdatedBreakPayload;
  /** Rollback a checklist from ready_to_seal back to draft state */
  rollbackChecklistToDraft?: Maybe<UpdateRepackPayload>;
  rotateCard?: Maybe<RotateCardPayload>;
  sealDynamicChecklist?: Maybe<CreateRepackPayload>;
  /** Run sealing pre-checks: constraint presence + price refresh (no persist) and mark ready_to_seal */
  sealingPreChecks?: Maybe<UpdateRepackPayload>;
  /** Submit SEON device fingerprint for login fraud detection (web platform only) */
  seonLoginFraudCheck?: Maybe<SeonLoginFraudCheckPayload>;
  /** Submit SEON device fingerprint for registration fraud detection (web platform only) */
  seonRegisterFraudCheck?: Maybe<SeonRegisterFraudCheckPayload>;
  /** Set account flags */
  setAccountFlags: SetAccountFlagsPayload;
  /** Set buyback population enabled status for a checklist pool item */
  setBuybackPopulationEnabled?: Maybe<SetBuybackPopulationEnabledPayload>;
  /** Set the current break in a live stream. */
  setCurrentBreak?: Maybe<SetCurrentBreakPayload>;
  /** Change streaming provider mutation */
  setStreamingProvider?: Maybe<LiveStreamPayload>;
  /** Restrict a user in a live stream chat (formerly shadow ban) */
  shadowBanUser?: Maybe<ShadowBanPayload>;
  /** Request CSV export of shops analytics reports */
  shopAnalyticsCustomReportCreate?: Maybe<ShopAnalyticsCustomReportCreatePayload>;
  /** Create new shop products */
  shopProductCreate?: Maybe<ShopProductCreatePayload>;
  /** Shutoff a dynamic checklist and move to awaiting_refill for adjustments (internal use only) */
  shutoffDynamicChecklist?: Maybe<ShutoffDynamicChecklistPayload>;
  startAuction?: Maybe<StartAuctionPayload>;
  /**
   * Starts IVS resources and returns IVS tokens
   * @deprecated Use prepare_stream instead
   */
  startIvsRecording?: Maybe<StreamTokensPayload>;
  /**
   * Starts Livekit recording and returns IVS tokens
   * @deprecated Use start_stream instead. It automatically starts the stream
   */
  startLivekitRecording?: Maybe<LiveStreamPayload>;
  startOneUpAuction?: Maybe<StartOneUpAuctionPayload>;
  startOneUpAuctionForFixedPriceSpot?: Maybe<StartOneUpAuctionForFixedPriceSpotPayload>;
  /** Starts the stream and returns IVS tokens */
  startStream?: Maybe<StreamTokensPayload>;
  /** Stops the stream */
  stopStream?: Maybe<StreamTokensPayload>;
  swipeCard?: Maybe<SwipeCardPayload>;
  /** Sync badge data to StreamAPI for all users with a specific badge (internal use only) */
  syncBadgeUsersToStream?: Maybe<SyncBadgeUsersToStreamPayload>;
  /**
   * Create live support ticket comment. Comment is created from the name of the current user,
   * if current user email is not found in Zendesk then comment will be authored by engineering admin user.
   * Comment body must be between 1 and 4096 characters in length.
   */
  ticketCommentCreate?: Maybe<LiveSupportTicketCommentResponsePayload>;
  /** Update live support ticket status */
  ticketStatusUpdate?: Maybe<LiveSupportTicketResponsePayload>;
  /** @deprecated Tips feature is deprecated and will be removed in a future release */
  tipCreate?: Maybe<TipCreatePayload>;
  /** Mutation for toggling extended bidding */
  toggleExtendedBidding?: Maybe<ToggleExtendedBiddingPayload>;
  /** Toggle the current user's notifications enabled flag */
  toggleNotificationsEnabled?: Maybe<AccountUpdatePayload>;
  /** @deprecated Use acknowledgeEvent mutation instead */
  trackAuctionEvent?: Maybe<TrackAuctionEventPayload>;
  /** Track an event */
  trackEvent?: Maybe<TrackEventPayload>;
  /** Transfer vault items to a user or a seller */
  transferVaultItems: TransferVaultItemsPayload;
  /** Mutation for unassigning a spot */
  unassignSpot?: Maybe<UnassignSpotPayload>;
  /** Update a break */
  updateBreak?: Maybe<UpdateBreakPayload>;
  /** Mutation for updating break mechanic */
  updateBreakMechanic?: Maybe<UpdateBreakMechanicPayload>;
  /** Create a new live stream with the provided parameters. */
  updateLiveStream?: Maybe<UpdateLiveStreamPayload>;
  /** Update logo_path for given profile type. */
  updateLogoPath?: Maybe<UpdateLogoPathPayload>;
  updateRepack?: Maybe<UpdateRepackPayload>;
  updateRepackConfiguration?: Maybe<UpdateRepackConfigurationPayload>;
  /** Mutation for updating spot price */
  updateSpotPrice?: Maybe<UpdateSpotPricePayload>;
  /** Only updates a user's client‑side metadata blob */
  updateUserMetadata?: Maybe<AccountUpdatePayload>;
  /**
   * Update the preferred countries a user operates in
   * @deprecated Please use updateUserPreferredCountriesV2 instead
   */
  updateUserPreferredCountries?: Maybe<AccountUpdatePayload>;
  /** Update the preferred countries a user operates in */
  updateUserPreferredCountriesV2?: Maybe<AccountUpdatePayload>;
  updateWalletPreferences?: Maybe<UpdateWalletPreferencesPayload>;
  /** Cast a vote in a poll */
  voteCast: VoteCastResponsePayload;
};


export type MutationAcceptBuybackArgs = {
  input: AcceptBuybackInput;
};


export type MutationAccountCreateArgs = {
  input: AccountCreateInput;
};


export type MutationAccountDeleteArgs = {
  userId: Scalars['UUID']['input'];
};


export type MutationAccountUpdateArgs = {
  input: AccountUpdateInput;
};


export type MutationAccountUpdateEmailArgs = {
  input: AccountUpdateEmailInput;
};


export type MutationAcknowledgeEventArgs = {
  input: AcknowledgeEventInput;
};


export type MutationAcknowledgeReceiptArgs = {
  input: AcknowledgeReceiptInput;
};


export type MutationAddItemsToChecklistArgs = {
  input: AddItemsToChecklistInput;
};


export type MutationAddressCreateArgs = {
  input: AddressCreateInput;
};


export type MutationAddressCreateV2Args = {
  input: AddressCreateInputV2;
};


export type MutationAddressDeleteArgs = {
  input: AddressDeleteInput;
};


export type MutationAddressUpdateArgs = {
  input: AddressUpdateInput;
};


export type MutationAddressUpdateV2Args = {
  input: AddressUpdateInputV2;
};


export type MutationApplyPromoCodeArgs = {
  promoCode: Scalars['String']['input'];
};


export type MutationAssignSpotArgs = {
  input: AssignSpotInput;
};


export type MutationAssignStaffersToLiveStreamArgs = {
  input: AssignStaffersToLiveStreamInput;
};


export type MutationAuctionBanUserArgs = {
  input: AuctionBanInput;
};


export type MutationAuctionFailArgs = {
  input: AuctionFailInput;
};


export type MutationAuctionUnbanUserArgs = {
  input: UnbanAuctionInput;
};


export type MutationAuthenticateArgs = {
  input: AuthenticateInput;
};


export type MutationBatchFollowShopCreateArgs = {
  input: Array<FollowShopCreateInput>;
};


export type MutationBidArgs = {
  input: BidInput;
};


export type MutationBidV2Args = {
  input: BidInput;
};


export type MutationBreakGameAddTimeArgs = {
  input: BreakGameAddTimeInput;
};


export type MutationBreakGameCreateArgs = {
  input: BreakGameCreateInput;
};


export type MutationBreakGameEndGameArgs = {
  input: BreakGameEndGameInput;
};


export type MutationBreakGameLaunchGiveawayArgs = {
  input: BreakGameLaunchGiveawayInput;
};


export type MutationBreakGameLaunchRewardArgs = {
  input: BreakGameLaunchRewardInput;
};


export type MutationBreakingProfileUpdateArgs = {
  input: BreakingProfileUpdateInput;
};


export type MutationCaptureSubscriptionListArgs = {
  input: CaptureSubscriptionListInput;
};


export type MutationCardAttachArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationCardCreateArgs = {
  input: CardCreateInput;
};


export type MutationCardDeleteArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type MutationCardUpdateArgs = {
  id: Scalars['UUID']['input'];
  input: CardUpdateInput;
};


export type MutationCelebrateLiveStreamArgs = {
  input: CelebrateLiveStreamInput;
};


export type MutationChangeBreakStatusArgs = {
  input: ChangeBreakStatusInput;
};


export type MutationChangeDataPrivacySettingsArgs = {
  input: DataPrivacySettingsInput;
};


export type MutationChangeStafferSettingsArgs = {
  input: StafferSettingsInput;
};


export type MutationCloseBoxArgs = {
  input: RevealInput;
};


export type MutationCodeApplyArgs = {
  code: Scalars['String']['input'];
  codeType: Array<InputMaybe<CodeType>>;
  shopId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCollectAcceptOfferArgs = {
  input: CollectUpdateOfferInput;
};


export type MutationCollectAddCandidateToCollectionArgs = {
  candidateImages: Array<Scalars['Upload']['input']>;
  candidateTitle: Scalars['String']['input'];
  changes?: InputMaybe<CollectItemChanges>;
};


export type MutationCollectAddFixedPriceToSetlistArgs = {
  fixedPriceId: Scalars['UUID']['input'];
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
};


export type MutationCollectAddItemToSetlistArgs = {
  itemId: Scalars['UUID']['input'];
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
};


export type MutationCollectAddPremierToSetlistArgs = {
  premierId: Scalars['UUID']['input'];
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
};


export type MutationCollectAddProductToSetlistArgs = {
  productId: Scalars['UUID']['input'];
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
};


export type MutationCollectAddToCartArgs = {
  cartId: Scalars['UUID']['input'];
  listingIds: Array<Scalars['UUID']['input']>;
};


export type MutationCollectAddToCollectionArgs = {
  changes?: InputMaybe<CollectItemChanges>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  variantId: Scalars['UUID']['input'];
};


export type MutationCollectAddVariantToSetlistArgs = {
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
  variantId: Scalars['UUID']['input'];
};


export type MutationCollectAddVaultItemsToGroupArgs = {
  vaultItemId: Scalars['ID']['input'];
  vaultItemUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type MutationCollectAddWeeklyToSetlistArgs = {
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
  weeklyId: Scalars['UUID']['input'];
};


export type MutationCollectAddressCreateArgs = {
  ignoreSuggestions?: InputMaybe<Scalars['Boolean']['input']>;
  input: CollectAddressCreateInput;
};


export type MutationCollectAddressValidateArgs = {
  input: CollectAddressValidateInput;
};


export type MutationCollectAuthenticateArgs = {
  authorizationCode: Scalars['String']['input'];
};


export type MutationCollectBatchCancelListingsArgs = {
  ids: Array<CollectListingIdInput>;
};


export type MutationCollectBatchCreateListingArgs = {
  input: CollectBatchCreateListingInput;
};


export type MutationCollectBatchCreateListingsV2Args = {
  inputs: Array<CollectCreateListingInput>;
};


export type MutationCollectBatchMakeOffersArgs = {
  inputs: Array<CollectMakeOfferInput>;
};


export type MutationCollectBatchUpdateListingsArgs = {
  updates: Array<CollectBatchUpdateListingsInput>;
};


export type MutationCollectBoAddToCartArgs = {
  listings: Array<CollectBoAddToCartListingInput>;
};


export type MutationCollectBoBatchUpdateTrackingInformationArgs = {
  trackingUpdates: Array<CollectBoTrackingUpdateInput>;
};


export type MutationCollectBoCheckoutListingConfirmIntentArgs = {
  orderId: Scalars['String']['input'];
};


export type MutationCollectBoCheckoutListingCreateIntentArgs = {
  listingId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
  shipToAddress: CollectBoShippingAddressInput;
  shippingOptionId?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePaymentMethodId: Scalars['String']['input'];
};


export type MutationCollectBoCheckoutV2ConfirmIntentArgs = {
  cartId?: InputMaybe<Scalars['String']['input']>;
  invoicePaymentId: Scalars['String']['input'];
};


export type MutationCollectBoCheckoutV2CreateIntentArgs = {
  accountFundsToBeApplied?: InputMaybe<Scalars['Int']['input']>;
  cryptoBalanceToBeApplied?: InputMaybe<Scalars['Int']['input']>;
  fancashBalanceToBeApplied?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  listings: Array<InputMaybe<CollectBoCheckoutOneShopInput>>;
  paymentMethodToBeUsed?: InputMaybe<CollectBoPaymentMethod>;
  rewardBalanceToBeApplied?: InputMaybe<Scalars['Int']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  walletBalanceToBeApplied?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCollectBoRemoveFromCartArgs = {
  listingIds: Array<Scalars['UUID']['input']>;
};


export type MutationCollectBoUpdateCartArgs = {
  listings: Array<CollectBoUpdateCartListingInput>;
};


export type MutationCollectCancelInvoicePaymentAttemptArgs = {
  invoiceId: Scalars['UUID']['input'];
};


export type MutationCollectCancelListingArgs = {
  id: Scalars['UUID']['input'];
  type: CollectListingType;
};


export type MutationCollectCancelOfferArgs = {
  input: CollectUpdateOfferInput;
};


export type MutationCollectCancelVaultItemRequestArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCollectCancelVaultRetrievalArgs = {
  id: Scalars['Int']['input'];
};


export type MutationCollectCancelVaultSubmissionArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCollectCatalogAddItemToCollectionArgs = {
  input: CollectItemInput;
  matchStatus: CollectItemMatchStatus;
};


export type MutationCollectCatalogAddItemToCollectionModernArgs = {
  input: CollectItemInput;
  matchStatus: CollectItemMatchStatus;
};


export type MutationCollectCatalogUpdateItemArgs = {
  id: Scalars['UUID']['input'];
  input: CollectItemInput;
};


export type MutationCollectCatalogUpdateItemModernArgs = {
  id: Scalars['UUID']['input'];
  input: CollectItemInput;
};


export type MutationCollectCheckoutCancelWalletPendingPaymentsArgs = {
  id: Scalars['UUID']['input'];
  payableType: CollectCheckoutWalletPendingPaymentsPayableType;
};


export type MutationCollectCheckoutFulfillmentChargesArgs = {
  input: CollectFulfillmentChargesInput;
};


export type MutationCollectCheckoutInvoiceConfirmArgs = {
  input: CollectCheckoutInvoiceConfirmInput;
};


export type MutationCollectCheckoutInvoicePaymentIntentArgs = {
  input: CollectCheckoutInvoicePaymentIntentInput;
};


export type MutationCollectCheckoutPaymentLockArgs = {
  input: CollectCheckoutPaymentLockInput;
};


export type MutationCollectCheckoutSetupIntentArgs = {
  input: CollectCheckoutSetupIntentInput;
};


export type MutationCollectCheckoutV2CompletePaymentArgs = {
  cart?: InputMaybe<CollectCheckoutV2CompletePaymentCartInput>;
  invoice?: InputMaybe<CollectCheckoutV2CompletePaymentInvoiceInput>;
};


export type MutationCollectCheckoutV2LockForPaymentArgs = {
  cart?: InputMaybe<CollectCheckoutV2LockForPaymentCartInput>;
  invoice?: InputMaybe<CollectCheckoutV2LockForPaymentInvoiceInput>;
  vaultListing?: InputMaybe<CollectCheckoutV2LockForPaymentVaultListingInput>;
};


export type MutationCollectCompleteRedRookieRedemptionArgs = {
  vaultItemId: Scalars['UUID']['input'];
};


export type MutationCollectCounterOfferArgs = {
  input: CollectCounterOfferInput;
};


export type MutationCollectCreateInvoiceArgs = {
  input: CollectCreateInvoiceInput;
};


export type MutationCollectCreateItemEditRequestArgs = {
  notes?: InputMaybe<Scalars['String']['input']>;
  pendingListing?: InputMaybe<Scalars['Boolean']['input']>;
  propertyEdit?: InputMaybe<Scalars['String']['input']>;
  vaultItemId: Scalars['UUID']['input'];
};


export type MutationCollectCreatePayoutRequestsArgs = {
  input: CollectCreatePayoutRequestsInput;
};


export type MutationCollectCreatePickUpInPersonArgs = {
  input: CollectCreatePickUpInPersonInput;
};


export type MutationCollectCreatePlaidLinkTokenArgs = {
  androidPackageName?: InputMaybe<Scalars['String']['input']>;
  profile: CollectPlaidLinkTokenProfile;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCollectCreatePresignedUrlArgs = {
  fileType: CollectImageFileType;
};


export type MutationCollectCreateRedemptionSubmissionArgs = {
  input: CollectCreateRedemptionSubmissionInput;
};


export type MutationCollectCreateRedemptionSubmissionV2Args = {
  input: CollectCreateRedemptionSubmissionV2Input;
};


export type MutationCollectCreateReportArgs = {
  input: CollectUserReport;
};


export type MutationCollectCreateSavedSearchArgs = {
  collectSearchDataInput: CollectSearchDataInput;
};


export type MutationCollectCreateScanResultFeedbackArgs = {
  firstCorrectResult?: InputMaybe<CollectScanFeedbackResultInput>;
  imgKey: Scalars['String']['input'];
  isImageResultCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  isMetadataResultCorrect?: InputMaybe<Scalars['Boolean']['input']>;
  rawResults?: InputMaybe<Array<InputMaybe<CollectScanFeedbackResultInput>>>;
  scanRequestId?: InputMaybe<Scalars['UUID']['input']>;
  userSuggestedBestMatchVariantId?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCollectCreateTradeShowCheckoutArgs = {
  input: CollectCreateTradeShowCheckoutInput;
};


export type MutationCollectCreateVaultItemGroupArgs = {
  expiresOn?: InputMaybe<Scalars['Date']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type?: InputMaybe<CollectVaultItemGroupType>;
  vaultItemUuids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type MutationCollectCreateVaultRetrievalArgs = {
  input: CollectCreateVaultRetrievalInput;
};


export type MutationCollectCreateVaultSubmissionArgs = {
  input: CollectCreateVaultSubmissionInput;
};


export type MutationCollectCreateVaultTransferArgs = {
  input: CollectCreateVaultTransferInput;
};


export type MutationCollectDeclineOfferArgs = {
  input: CollectUpdateOfferInput;
};


export type MutationCollectDeleteSavedSearchArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCollectDeleteVaultItemGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCollectDuplicateVaultItemsArgs = {
  input: CollectDuplicateVaultItemsInput;
};


export type MutationCollectDuplicateVaultItemsV2Args = {
  buybackValueInCents?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
  folderName?: InputMaybe<Scalars['String']['input']>;
  itemType?: InputMaybe<CollectDuplicateItemType>;
  vaultItemIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};


export type MutationCollectExchangeTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationCollectForgetRecentViewArgs = {
  input: CollectActivityTrackViewInput;
};


export type MutationCollectGetTokenPairArgs = {
  accessToken: Scalars['String']['input'];
  applicationClientId: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
};


export type MutationCollectLinkPlaidIdentityVerificationArgs = {
  identityVerificationId: Scalars['String']['input'];
};


export type MutationCollectLogoutArgs = {
  accessToken: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
  terminateSession?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCollectMakeOfferArgs = {
  input: CollectMakeOfferInput;
};


export type MutationCollectMarkOfferAsViewedArgs = {
  input: CollectMarkOfferAsViewedInput;
};


export type MutationCollectMarkOfferNotificationAsViewedArgs = {
  input: CollectMarkOfferNotificationAsViewedInput;
};


export type MutationCollectMultiBidArgs = {
  input: CollectMultiBidRequest;
};


export type MutationCollectProcessStripeAchConsentArgs = {
  consent: Scalars['Boolean']['input'];
};


export type MutationCollectRefreshTokenArgs = {
  refreshToken: Scalars['String']['input'];
};


export type MutationCollectRemoveFixedPriceFromSetlistArgs = {
  fixedPriceId: Scalars['UUID']['input'];
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
};


export type MutationCollectRemoveFromCartArgs = {
  cartId: Scalars['UUID']['input'];
  listingIds: Array<Scalars['UUID']['input']>;
};


export type MutationCollectRemoveFromCollectionArgs = {
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  itemId: Scalars['UUID']['input'];
};


export type MutationCollectRemoveItemFromSetlistArgs = {
  itemId: Scalars['UUID']['input'];
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
};


export type MutationCollectRemovePremierFromSetlistArgs = {
  premierId: Scalars['UUID']['input'];
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
};


export type MutationCollectRemoveProductFromSetlistArgs = {
  productId: Scalars['UUID']['input'];
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
};


export type MutationCollectRemoveVariantFromSetlistArgs = {
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
  variantId: Scalars['UUID']['input'];
};


export type MutationCollectRemoveVaultItemFromGroupArgs = {
  vaultItemGroupId: Scalars['ID']['input'];
  vaultItemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type MutationCollectRemoveWeeklyFromSetlistArgs = {
  setlistId?: InputMaybe<Scalars['UUID']['input']>;
  setlistKind?: InputMaybe<CollectSetlistKind>;
  weeklyId: Scalars['UUID']['input'];
};


export type MutationCollectReportIncorrectMatchArgs = {
  input: CollectReportIncorrectMatchInput;
};


export type MutationCollectRequestCsvExportArgs = {
  bidStatus?: InputMaybe<CsvBidStatusFilter>;
  exportType: CsvExportType;
  filters?: InputMaybe<CsvExportFiltersInput>;
};


export type MutationCollectResolvePhoneConflictArgs = {
  phone: Scalars['String']['input'];
};


export type MutationCollectTrackViewArgs = {
  input: CollectActivityTrackViewInput;
};


export type MutationCollectUnwatchListingArgs = {
  id: Scalars['UUID']['input'];
  type: CollectListingType;
};


export type MutationCollectUpdateFixedPriceListingArgs = {
  allowOffers?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  listingPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  marketplaceEventId?: InputMaybe<Scalars['UUID']['input']>;
  marketplaceEventType?: InputMaybe<CollectMarketplaceEventType>;
  rejectPriceThresholdInCents?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<CollectListingType>;
};


export type MutationCollectUpdateItemArgs = {
  changes: CollectItemChanges;
  itemId: Scalars['UUID']['input'];
};


export type MutationCollectUpdateMemberCheckoutArgs = {
  id: Scalars['Int']['input'];
  input: CollectUpdateMemberCheckoutInput;
};


export type MutationCollectUpdateOwnerValuesArgs = {
  vaultItemsToUpdate: Array<InputMaybe<CollectUpdateOwnerValueData>>;
};


export type MutationCollectUpdatePremierListingArgs = {
  id: Scalars['UUID']['input'];
  marketplaceEventId: Scalars['UUID']['input'];
};


export type MutationCollectUpdateProfileArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  optInSms?: InputMaybe<Scalars['Boolean']['input']>;
  phone: Scalars['String']['input'];
};


export type MutationCollectUpdateProfileNameArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationCollectUpdateProtoItemArgs = {
  cardSerial?: InputMaybe<Scalars['String']['input']>;
  compAtPurchase?: InputMaybe<Scalars['Int']['input']>;
  gradingPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  hasAutograph?: InputMaybe<Scalars['Boolean']['input']>;
  invoice?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  protoItemUuid: Scalars['UUID']['input'];
  purchasePriceInCents?: InputMaybe<Scalars['Int']['input']>;
  team?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCollectUpdateProtoItemPurchasePriceArgs = {
  protoItemUuid: Scalars['UUID']['input'];
  purchasePriceInCents?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCollectUpdateTradeShowCheckoutArgs = {
  id: Scalars['Int']['input'];
  input: CollectUpdateTradeShowCheckoutInput;
};


export type MutationCollectUpdateUserPhoneArgs = {
  phone: Scalars['String']['input'];
};


export type MutationCollectUpdateVaultItemGroupArgs = {
  expiresOn?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};


export type MutationCollectUpdateVaultRetrievalArgs = {
  id: Scalars['Int']['input'];
  input: CollectUpdateVaultRetrievalInput;
};


export type MutationCollectUpdateVaultSubmissionArgs = {
  id: Scalars['UUID']['input'];
  input: CollectUpdateVaultSubmissionInput;
};


export type MutationCollectUpdateWeeklyListingArgs = {
  id: Scalars['UUID']['input'];
  marketplaceEventId: Scalars['UUID']['input'];
};


export type MutationCollectUseSavedSearchArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationCollectValidateMfaArgs = {
  channel?: InputMaybe<CollectMfaChannel>;
  code: Scalars['String']['input'];
};


export type MutationCollectVaultItemsExportArgs = {
  itemIds: Array<Scalars['UUID']['input']>;
};


export type MutationCollectVerifyMfaArgs = {
  channel?: InputMaybe<CollectMfaChannel>;
};


export type MutationCollectVerifyPhoneArgs = {
  code: Scalars['String']['input'];
};


export type MutationCollectVerifyPremierAuctionApprovalRequirementArgs = {
  plaidPublicToken: Scalars['String']['input'];
};


export type MutationCollectVerifySessionEmailOtpArgs = {
  code: Scalars['String']['input'];
};


export type MutationCollectWatchListingArgs = {
  id: Scalars['UUID']['input'];
  type: CollectListingType;
};


export type MutationCollectionsAddItemsToCustomListArgs = {
  collectionItemsIds: Array<Scalars['UUID']['input']>;
  customListId: Scalars['UUID']['input'];
};


export type MutationCollectionsAddItemsToCustomListsArgs = {
  collectionItemsIds: Array<Scalars['UUID']['input']>;
  customListIds: Array<Scalars['UUID']['input']>;
};


export type MutationCollectionsCreateCustomListArgs = {
  input: CollectionsCreateCustomListInput;
};


export type MutationCollectionsDeleteCustomListArgs = {
  customListId: Scalars['UUID']['input'];
};


export type MutationCollectionsRemoveItemsFromCustomListArgs = {
  collectionItemsIds: Array<Scalars['UUID']['input']>;
  customListId: Scalars['UUID']['input'];
};


export type MutationCollectionsUpdateCustomListArgs = {
  customListId: Scalars['UUID']['input'];
  input: CollectionsUpdateCustomListInput;
};


export type MutationCreateBreakArgs = {
  input: BreakInput;
};


export type MutationCreateConsignmentArgs = {
  input: CreateConsignmentInput;
};


export type MutationCreateDigitalBreakArgs = {
  input: DigitalBreakInput;
};


export type MutationCreateLiveStreamArgs = {
  input: CreateLiveStreamInput;
};


export type MutationCreatePersonalArgs = {
  input: CreatePersonalInput;
};


export type MutationCreateProductDetailFeedbackArgs = {
  input: CollectProductDetailFeedbackInput;
};


export type MutationCreateRepackArgs = {
  input: CreateRepackInput;
};


export type MutationCreateRepackAllocationArgs = {
  input: CreateRepackAllocationInput;
};


export type MutationCreateSubBreakArgs = {
  input: SubBreakInput;
};


export type MutationCreateWaxChecklistArgs = {
  input: CreateWaxChecklistInput;
};


export type MutationCreateWhiteElephantBreakGameArgs = {
  input: WhiteElephantBreakInput;
};


export type MutationCryptoInvoiceCreateArgs = {
  input: CryptoInvoiceCreateInput;
};


export type MutationCustomBreakTemplateArchiveArgs = {
  input: CustomBreakTemplateArchiveInput;
};


export type MutationCustomBreakTemplateCreateArgs = {
  input: CustomBreakTemplateCreateInput;
};


export type MutationCustomBreakTemplateCreateFromCsvArgs = {
  input: CustomBreakTemplateCreateFromCsvInput;
};


export type MutationCustomBreakTemplateUpdateArgs = {
  input: CustomBreakTemplateUpdateInput;
};


export type MutationCustomGiveawayCreateArgs = {
  input: CustomGiveawayCreateInput;
};


export type MutationDebutPackUserJoinedArgs = {
  input: DebutPackUserJoinedInput;
};


export type MutationDeleteBreakArgs = {
  input: DeleteBreakInput;
};


export type MutationDeleteLiveStreamArgs = {
  input: DeleteLiveStreamInput;
};


export type MutationDeleteLogoPathArgs = {
  input: DeleteLogoPathInput;
};


export type MutationDeleteRepackArgs = {
  input: DeleteRepackInput;
};


export type MutationEndLiveStreamArgs = {
  input: EndLiveStreamInput;
};


export type MutationEnterGiveawayArgs = {
  giveawayId: Scalars['UUID']['input'];
};


export type MutationExchangeTokenArgs = {
  input: ExchangeTokenInput;
};


export type MutationFanidAccountCreateArgs = {
  input: FanidAccountCreateInput;
};


export type MutationFollowChannelCreateArgs = {
  input: FollowChannelCreateInput;
};


export type MutationFollowChannelDeleteArgs = {
  input: FollowChannelDeleteInput;
};


export type MutationFollowLeagueCreateArgs = {
  input: FollowLeagueCreateInput;
};


export type MutationFollowLeagueDeleteArgs = {
  input: FollowLeagueDeleteInput;
};


export type MutationFollowLeagueMemberCreateArgs = {
  input: FollowLeagueMemberCreateInput;
};


export type MutationFollowLeagueMemberDeleteArgs = {
  input: FollowLeagueMemberDeleteInput;
};


export type MutationFollowLiveStreamCreateArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type MutationFollowLiveStreamDeleteArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type MutationFollowShopCreateArgs = {
  input: FollowShopCreateInput;
};


export type MutationFollowShopDeleteArgs = {
  input: FollowShopDeleteInput;
};


export type MutationFollowUserCreateArgs = {
  input: UserFollowInput;
};


export type MutationFollowUserDeleteArgs = {
  input: UserFollowInput;
};


export type MutationGetTokenPairArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fanIdParams: FanIdInputParams;
  seonIdentifier?: InputMaybe<Scalars['String']['input']>;
};


export type MutationImageUploadUrlCreateArgs = {
  fileType: ImageFileType;
  id?: InputMaybe<Scalars['UUID']['input']>;
  uploadType: ImageUploadType;
};


export type MutationLaunchLiveSteamGiveawayArgs = {
  input: LaunchLiveStreamGiveawayInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationLogoutArgs = {
  input: LogoutInput;
};


export type MutationMarkUsersDebutPackIneligibleArgs = {
  input: MarkUsersDebutPackIneligibleInput;
};


export type MutationMoveBreakArgs = {
  input: MoveBreakInput;
};


export type MutationNextCardArgs = {
  input: RevealItemInput;
};


export type MutationOpenBoxArgs = {
  input: RevealInput;
};


export type MutationPaymentMethodCreateArgs = {
  input: PaymentMethodCreateInput;
};


export type MutationPaymentMethodCreatePrepareArgs = {
  paymentMethodType?: InputMaybe<PaymentMethodType>;
};


export type MutationPaymentMethodCreateV2Args = {
  input: PaymentMethodCreateInput;
};


export type MutationPaymentMethodDeleteArgs = {
  input: PaymentMethodDeleteInput;
};


export type MutationPaymentMethodDeleteV2Args = {
  input: PaymentMethodDeleteInput;
};


export type MutationPhoneNumberSubmitArgs = {
  phoneNumber: Scalars['String']['input'];
};


export type MutationPhoneNumberVerifyArgs = {
  phoneNumber: Scalars['String']['input'];
  verificationCode: Scalars['String']['input'];
};


export type MutationPickBreakMechanicSpotArgs = {
  input: PickBreakMechanicSpotInput;
};


export type MutationPingArgs = {
  pingId: Scalars['UUID']['input'];
};


export type MutationPollCreateArgs = {
  input: PollCreateInput;
};


export type MutationPollStartArgs = {
  input: PollStartInput;
};


export type MutationPollTerminateArgs = {
  input: PollEndInput;
};


export type MutationPrepareMulticastingArgs = {
  input: PrepareMulticastingInput;
};


export type MutationPrepareStreamArgs = {
  input: PrepareStreamInput;
};


export type MutationPrepareWhipArgs = {
  input: PrepareWhipInput;
};


export type MutationProductCreateArgs = {
  input: ProductCreateInput;
};


export type MutationProductCreateV2Args = {
  input: ProductCreateInputV2;
};


export type MutationProductOrderCreateArgs = {
  input?: InputMaybe<ProductOrderCreateInput>;
};


export type MutationProductUpdateArgs = {
  input: ProductUpdateInput;
};


export type MutationPublishLiveStreamArgs = {
  input: PublishLiveStreamInput;
};


export type MutationPurchaseListingArgs = {
  input: ListingPurchaseInput;
};


export type MutationPurchaseRandomSpotArgs = {
  input: PurchaseRandomSpotInput;
};


export type MutationPurchaseSpotArgs = {
  input: PurchaseSpotInput;
};


export type MutationPurchaseWithClientConfirmationArgs = {
  input: PurchaseWithClientConfirmationInput;
};


export type MutationPwccLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationPwccRefreshArgs = {
  nonce: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
};


export type MutationQuickCreateBreakArgs = {
  input: QuickCreateBreakInput;
};


export type MutationRandomizeBreakSpotsArgs = {
  input: RandomizeBreakSpotsInput;
};


export type MutationRandomizeLiveStreamSpotsArgs = {
  input: RandomizeLiveStreamSpotsInput;
};


export type MutationReferralCodeRedeemArgs = {
  code: Scalars['String']['input'];
};


export type MutationRefreshPricesArgs = {
  input: PriceRefreshInput;
};


export type MutationRefundSpotArgs = {
  input: RefundSpotInput;
};


export type MutationRemoveItemsFromChecklistArgs = {
  input: RemoveItemsFromChecklistInput;
};


export type MutationRequestCsvExportArgs = {
  input: RequestCsvExportInput;
};


export type MutationRequestReferralsCsvExportArgs = {
  input: RequestCsvExportInput;
};


export type MutationRequestShopAnalyticsCustomReportCsvExportArgs = {
  input: RequestAnalyticsCsvExportInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationRestrictUserArgs = {
  input: RestrictUserInput;
};


export type MutationRevealBreakMechanicSpotArgs = {
  auctionId: Scalars['UUID']['input'];
};


export type MutationRevealCardArgs = {
  input: RevealItemInput;
};


export type MutationRipPackArgs = {
  input: RevealInput;
};


export type MutationRollbackChecklistToDraftArgs = {
  checklistId: Scalars['UUID']['input'];
};


export type MutationRotateCardArgs = {
  input: RotateCardInput;
};


export type MutationSealDynamicChecklistArgs = {
  allowNilPrices?: InputMaybe<Scalars['Boolean']['input']>;
  checklistId: Scalars['UUID']['input'];
};


export type MutationSealingPreChecksArgs = {
  allowNilPrices?: InputMaybe<Scalars['Boolean']['input']>;
  repackId: Scalars['UUID']['input'];
};


export type MutationSeonLoginFraudCheckArgs = {
  input: SeonLoginFraudCheckInput;
};


export type MutationSeonRegisterFraudCheckArgs = {
  input: SeonRegisterFraudCheckInput;
};


export type MutationSetAccountFlagsArgs = {
  input: SetAccountFlagsInput;
};


export type MutationSetBuybackPopulationEnabledArgs = {
  input: SetBuybackPopulationEnabledInput;
};


export type MutationSetCurrentBreakArgs = {
  input: SetCurrentBreakInput;
};


export type MutationSetStreamingProviderArgs = {
  input: SetStreamingProviderInput;
};


export type MutationShadowBanUserArgs = {
  input: ShadowBanInput;
};


export type MutationShopAnalyticsCustomReportCreateArgs = {
  input: ShopAnalyticsCustomReportCreateInput;
};


export type MutationShopProductCreateArgs = {
  input: CreateShopProductInput;
};


export type MutationShutoffDynamicChecklistArgs = {
  checklistId: Scalars['UUID']['input'];
};


export type MutationStartAuctionArgs = {
  input: StartAuctionInput;
};


export type MutationStartIvsRecordingArgs = {
  input: StartIvsRecordingInput;
};


export type MutationStartLivekitRecordingArgs = {
  input: StartLivekitRecordingInput;
};


export type MutationStartOneUpAuctionArgs = {
  input: StartOneUpAuctionInput;
};


export type MutationStartOneUpAuctionForFixedPriceSpotArgs = {
  input: StartOneUpAuctionForFixedPriceSpotInput;
};


export type MutationStartStreamArgs = {
  input: StartStreamInput;
};


export type MutationStopStreamArgs = {
  input: StopStreamInput;
};


export type MutationSwipeCardArgs = {
  input: SwipeCardInput;
};


export type MutationSyncBadgeUsersToStreamArgs = {
  input: SyncBadgeUsersToStreamInput;
};


export type MutationTicketCommentCreateArgs = {
  input: TicketCommentCreateInput;
};


export type MutationTicketStatusUpdateArgs = {
  input: TicketStatusUpdateInput;
};


export type MutationTipCreateArgs = {
  input: TipCreateInput;
};


export type MutationToggleExtendedBiddingArgs = {
  input: ToggleExtendedBiddingInput;
};


export type MutationTrackAuctionEventArgs = {
  input: TrackAuctionEventInput;
};


export type MutationTrackEventArgs = {
  input: TrackEventInput;
};


export type MutationTransferVaultItemsArgs = {
  input: TransferVaultItemsInput;
};


export type MutationUnassignSpotArgs = {
  input: UnassignSpotInput;
};


export type MutationUpdateBreakArgs = {
  input: UpdateBreakInput;
};


export type MutationUpdateBreakMechanicArgs = {
  input: UpdateBreakMechanicInput;
};


export type MutationUpdateLiveStreamArgs = {
  input: UpdateLiveStreamInput;
};


export type MutationUpdateLogoPathArgs = {
  input: UpdateLogoPathInput;
};


export type MutationUpdateRepackArgs = {
  input: UpdateRepackInput;
};


export type MutationUpdateRepackConfigurationArgs = {
  input: UpdateRepackConfigurationInput;
};


export type MutationUpdateSpotPriceArgs = {
  input: UpdateSpotPriceInput;
};


export type MutationUpdateUserMetadataArgs = {
  input: UpdateUserMetadataInput;
};


export type MutationUpdateUserPreferredCountriesArgs = {
  input: UpdateUserPreferredCountriesInput;
};


export type MutationUpdateUserPreferredCountriesV2Args = {
  input: UpdateUserPreferredCountriesInputV2;
};


export type MutationUpdateWalletPreferencesArgs = {
  defaultContributions: WalletDefaultContributionsInput;
};


export type MutationVoteCastArgs = {
  input: VoteCastInput;
};

export type Option = {
  __typename?: 'Option';
  /** The description of option */
  description?: Maybe<Scalars['String']['output']>;
  /** The unique ID of an option in a poll */
  id: Scalars['UUID']['output'];
  /** The title of option */
  title: Scalars['String']['output'];
  /** List of usernames of users that have voted in a given option */
  usernames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The total vote count of a particular option */
  voteCount?: Maybe<Scalars['Int']['output']>;
  /** The total vote percentage of a particular option */
  votePercentage?: Maybe<Percentage>;
};

export type OptionInput = {
  /** The description of the option */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The title of the option */
  title: Scalars['String']['input'];
};

/** Input object for filtering orders */
export type OrderFilter = {
  /** Optional filter used to request a specific order */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Optional filter used to request orders in a range */
  range?: InputMaybe<DateOptions>;
  /** Optional filter used to request orders by status */
  status?: InputMaybe<OrderStatus>;
};

/** Status of an order */
export enum OrderStatus {
  Delivered = 'DELIVERED',
  Fulfilled = 'FULFILLED',
  InTransit = 'IN_TRANSIT',
  OutForDelivery = 'OUT_FOR_DELIVERY',
  Pending = 'PENDING',
  Shipped = 'SHIPPED'
}

/** Pack step in instant rip flow */
export type PackStep = {
  __typename?: 'PackStep';
  /** The instant rip pack status */
  digitalRipStatus: PackStepStatus;
};

/** Pack step status */
export enum PackStepStatus {
  /** Pack is visible */
  PackVisible = 'PACK_VISIBLE'
}

export enum PackTextureCategory {
  /** The pack texture category is baseball */
  Baseball = 'BASEBALL',
  /** The pack texture category is basketball */
  Basketball = 'BASKETBALL',
  /** The pack texture category is football */
  Football = 'FOOTBALL',
  /** The pack texture category is multisport */
  Multisport = 'MULTISPORT',
  /** The pack texture category is pokemon */
  Pokemon = 'POKEMON',
  /** The pack texture category is starwars */
  Starwars = 'STARWARS'
}

/** Package protection options */
export type PackageProtection = {
  __typename?: 'PackageProtection';
  insured: Scalars['Boolean']['output'];
  packageValueInCents: Scalars['Int']['output'];
  shippingCost?: Maybe<Scalars['Int']['output']>;
  signatureRequired: Scalars['Boolean']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Pagination info */
export type PageInfoType = {
  __typename?: 'PageInfoType';
  /** Pagination Cursor */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** has next page */
  hasNextPage: Scalars['Boolean']['output'];
};

/** Pagination info V2, supports backwards pagination */
export type PageInfoTypeV2 = {
  __typename?: 'PageInfoTypeV2';
  /** Ending pagination Cursor */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** has next page */
  hasNextPage: Scalars['Boolean']['output'];
  /** has previous page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Starting pagination Cursor */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A set of fields denoting metadata about a set of paginated results */
export type PaginatedMetadata = {
  __typename?: 'PaginatedMetadata';
  /** The total number of results in the paginated dataset */
  count: Scalars['Int']['output'];
};

/** Basic credit card details for billing purposes */
export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  /** The brand of the credit card used */
  brand: Scalars['String']['output'];
  /** The month of the credit card's expiration */
  expMonth: Scalars['String']['output'];
  /** The year of the credit card's expiration */
  expYear: Scalars['String']['output'];
  /** The unique ID for this payment method */
  id: Scalars['UUID']['output'];
  /** The last 4 digits of the credit card number */
  last4: Scalars['String']['output'];
  /** The type of payment method */
  type: PaymentMethodType;
};

export type PaymentMethodChangePayload = {
  __typename?: 'PaymentMethodChangePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<PaymentMethod>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type PaymentMethodChangePayloadV2 = {
  __typename?: 'PaymentMethodChangePayloadV2';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<PaymentMethodV2>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for adding a payment method to the current user */
export type PaymentMethodCreateInput = {
  /** The payment method type */
  paymentMethodType?: InputMaybe<PaymentMethodType>;
  /** The setup intent ID from Stripe for this payment method */
  setupIntentId: Scalars['String']['input'];
};

export type PaymentMethodCreatePreparePayload = {
  __typename?: 'PaymentMethodCreatePreparePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<UserStripeInformation>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for deleting a payment method belonging to the current user */
export type PaymentMethodDeleteInput = {
  /** The unique ID for this payment method */
  id: Scalars['UUID']['input'];
};

/** Payment method options available for the user based on country */
export type PaymentMethodOptions = {
  __typename?: 'PaymentMethodOptions';
  /** List of available payment methods */
  paymentMethodOptions: Array<PaymentMethodType>;
};

export enum PaymentMethodType {
  Card = 'CARD',
  Paypal = 'PAYPAL'
}

export type PaymentMethodV2 = {
  __typename?: 'PaymentMethodV2';
  /** The brand of the credit card used */
  brand?: Maybe<Scalars['String']['output']>;
  /** The month of the credit card's expiration */
  expMonth?: Maybe<Scalars['String']['output']>;
  /** The year of the credit card's expiration */
  expYear?: Maybe<Scalars['String']['output']>;
  /** The unique ID for this payment method */
  id: Scalars['UUID']['output'];
  /** The last 4 digits of the credit card number */
  last4?: Maybe<Scalars['String']['output']>;
  /** The type of payment method */
  type: PaymentMethodType;
};

export type PaymentRequiresAction = {
  __typename?: 'PaymentRequiresAction';
  /** @deprecated Use destination_country_v2 instead */
  destinationCountry: Scalars['String']['output'];
  destinationCountryV2: Country;
  paymentIntentClientSecret: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export type PaymentRequiresActionClosedPayload = {
  __typename?: 'PaymentRequiresActionClosedPayload';
  paymentRequiresActionClosed: Scalars['Boolean']['output'];
};

export type PaymentRequiresActionPayload = {
  __typename?: 'PaymentRequiresActionPayload';
  /** @deprecated Use destination_country_v2 instead */
  destinationCountry: Scalars['String']['output'];
  destinationCountryV2: Country;
  paymentIntentClientSecret: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export type Percentage = {
  __typename?: 'Percentage';
  /** The raw percentage as a number */
  percentage: Scalars['Float']['output'];
  /** Formatted percentage of upto 3 decimal places */
  percentageDisplay: Scalars['String']['output'];
};

export enum PersonalProductType {
  Other = 'OTHER',
  Repack = 'REPACK',
  SealedWax = 'SEALED_WAX',
  Single = 'SINGLE'
}

export type PersonalProductsConfigs = {
  /** The product ID */
  productId?: InputMaybe<Scalars['UUID']['input']>;
  /** The quantity of the product */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** The type of the product */
  type: PersonalProductType;
};

/** The phone number for a given user */
export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  /** The verification status of the users phone number */
  isVerified: Scalars['Boolean']['output'];
  /** The value provided by the user as their phone number */
  sequence: Scalars['String']['output'];
};

/** An unsuccessful phone number mutation response */
export type PhoneNumberError = {
  __typename?: 'PhoneNumberError';
  /** A message to accompany the status to give context to the error */
  message: Scalars['String']['output'];
  /** The type of phone number mutation error */
  status: PhoneNumberErrorStatus;
};

/** Phone number mutation error status indicators */
export enum PhoneNumberErrorStatus {
  /**
   * The phone number has been already used before
   * @deprecated Phone numbers can be reused now
   */
  AlreadyTaken = 'ALREADY_TAKEN',
  /** The phone number has been already verified before */
  AlreadyVerified = 'ALREADY_VERIFIED',
  /** A phone number argument was submitted with an invalid value */
  InvalidPhoneNumber = 'INVALID_PHONE_NUMBER',
  /** A verification code argument was submitted with an invalid value */
  InvalidVerificationCode = 'INVALID_VERIFICATION_CODE',
  /** The maximum number of attempts has been reached */
  MaxAttemptReached = 'MAX_ATTEMPT_REACHED',
  /** Phone numbers from this country are not accepted */
  PhoneNumberIsGeoBlocked = 'PHONE_NUMBER_IS_GEO_BLOCKED',
  /** The request has been rate-limited */
  RateLimited = 'RATE_LIMITED',
  /** An error that requires investigation to determine its origin */
  Unknown = 'UNKNOWN'
}

/** The type of response to serve for phone number mutations */
export type PhoneNumberResponse = {
  __typename?: 'PhoneNumberResponse';
  /** Contains information about the reason for a non-successful mutation */
  error?: Maybe<PhoneNumberError>;
  /** Denotes the success or failure of a mutation */
  isSuccess: Scalars['Boolean']['output'];
};

/** Parameters for selecting a spot in a break mechanic */
export type PickBreakMechanicSpotInput = {
  /** The ID of the auction */
  auctionId: Scalars['UUID']['input'];
  /** The ID of a specific spot to be selected */
  breakSpotId: Scalars['UUID']['input'];
};

export type PickBreakMechanicSpotPayload = {
  __typename?: 'PickBreakMechanicSpotPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<BreakSpotAuction>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type PingPayload = {
  __typename?: 'PingPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<PingResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type PingResponse = {
  __typename?: 'PingResponse';
  id: Scalars['UUID']['output'];
  payload: Scalars['String']['output'];
};

export type Poll = {
  __typename?: 'Poll';
  /** The description of poll */
  description?: Maybe<Scalars['String']['output']>;
  /** The polls's end time (UTC) */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of a poll */
  id: Scalars['UUID']['output'];
  /** The list of all possible options of a poll */
  options?: Maybe<Array<Option>>;
  /** The status of a particular poll */
  status: Status;
  /** The title of poll */
  title: Scalars['String']['output'];
  /** The total vote count in a poll */
  totalVotes?: Maybe<Scalars['Int']['output']>;
  /** The type to be used to create a poll */
  type: PollType;
  /** List of usernames of users participated in a Poll */
  usernames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The winning option in a poll */
  winningOption?: Maybe<Option>;
};

export type PollCreateInput = {
  /** The description of poll */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The poll running time */
  durationSeconds: Scalars['Int']['input'];
  /** The live stream ID where poll will be created */
  id: Scalars['UUID']['input'];
  /** The list of all possible options of a poll */
  options?: InputMaybe<Array<OptionInput>>;
  /** The title of poll */
  title: Scalars['String']['input'];
  /** The type of the poll */
  type: PollType;
};

/** The response from pollCreate mutation */
export type PollCreateResponse = {
  __typename?: 'PollCreateResponse';
  poll: Poll;
};

export type PollCreateResponsePayload = {
  __typename?: 'PollCreateResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<PollCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type PollEndInput = {
  /** The UUID of live_stream */
  id: Scalars['UUID']['input'];
  /** The UUID of a poll */
  pollId: Scalars['UUID']['input'];
};

export type PollGetInput = {
  /** The UUID of a poll */
  pollId: Scalars['UUID']['input'];
};

export type PollStartInput = {
  /** The UUID of live_stream */
  id: Scalars['UUID']['input'];
  /** The UUID of a poll */
  pollId: Scalars['UUID']['input'];
};

/** The response from pollStart mutation */
export type PollStartResponse = {
  __typename?: 'PollStartResponse';
  poll: Poll;
};

export type PollStartResponsePayload = {
  __typename?: 'PollStartResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<PollStartResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The response from pollEnd mutation */
export type PollTerminateResponse = {
  __typename?: 'PollTerminateResponse';
  poll: Poll;
};

export type PollTerminateResponsePayload = {
  __typename?: 'PollTerminateResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<PollTerminateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The type of a poll */
export enum PollType {
  MultiSelect = 'MULTI_SELECT',
  SingleSelect = 'SINGLE_SELECT'
}

export type PollWithUserVotes = {
  __typename?: 'PollWithUserVotes';
  /** The description of poll */
  description?: Maybe<Scalars['String']['output']>;
  /** The polls's end time (UTC) */
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The unique ID of a poll */
  id: Scalars['UUID']['output'];
  /** The list of all possible options of a poll */
  options?: Maybe<Array<Option>>;
  /** The status of a particular poll */
  status: Status;
  /** The title of poll */
  title: Scalars['String']['output'];
  /** The total vote count in a poll */
  totalVotes?: Maybe<Scalars['Int']['output']>;
  /** The type to be used to create a poll */
  type: PollType;
  /** List of Option Ids a user voted in a Poll */
  userVotes?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  /** List of usernames of users participated in a Poll */
  usernames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The winning option in a poll */
  winningOption?: Maybe<Option>;
};

export type PollsGetInput = {
  /** The UUID of live_stream */
  id: Scalars['UUID']['input'];
};

/** A section with popular searches */
export type PopularSearchesSection = {
  __typename?: 'PopularSearchesSection';
  allItems?: Maybe<Array<Avatar>>;
  items?: Maybe<Array<Avatar>>;
  sectionType: SearchSectionType;
};

/** Preference options available for the user */
export type PreferenceOptions = {
  __typename?: 'PreferenceOptions';
  /** List of supported country codes */
  supportedCountries: Array<Country>;
};

export type PrepareMulticastingInput = {
  liveStreamId: Scalars['UUID']['input'];
  /** Streaming key for facebook */
  streamKeyFb?: InputMaybe<Scalars['String']['input']>;
  /** Streaming key for instagram */
  streamKeyInstagram?: InputMaybe<Scalars['String']['input']>;
  /** Streaming key for tiktok */
  streamKeyTiktok?: InputMaybe<Scalars['String']['input']>;
  /** Streaming key for twitch */
  streamKeyTwitch?: InputMaybe<Scalars['String']['input']>;
  /** Streaming key for youtube */
  streamKeyYoutube?: InputMaybe<Scalars['String']['input']>;
};

export type PrepareStreamInput = {
  liveStreamId: Scalars['UUID']['input'];
};

export type PrepareWhipInput = {
  liveStreamId: Scalars['UUID']['input'];
};

/** Parameters for refreshing prices */
export type PriceRefreshInput = {
  /** Whether to persist buyback values to proto_item (optional, defaults to false) */
  buybackPersist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional list of specific item IDs to refresh */
  itemIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** The ID of the repack/checklist */
  repackId: Scalars['UUID']['input'];
};

export type PriceRefreshPayload = {
  __typename?: 'PriceRefreshPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<PriceRefreshResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The response from refreshing prices */
export type PriceRefreshResponse = {
  __typename?: 'PriceRefreshResponse';
  /** Messages about the operation */
  messages?: Maybe<Array<Maybe<Message>>>;
  /** The repack that was updated */
  repack: Repack;
  /** The number of items that were updated */
  updatedCount: Scalars['Int']['output'];
};

export type PricingInfo = {
  __typename?: 'PricingInfo';
  guidePrice?: Maybe<Money>;
  guidePriceLastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  guidePriceRange?: Maybe<CollectPriceRange>;
  guidePriceType?: Maybe<GuidePriceType>;
};

/** Describes a product being made available for sale or breaking */
export type Product = {
  __typename?: 'Product';
  /**
   * The product's audience
   * @deprecated Field is no longer used
   */
  audience?: Maybe<ProductAudience>;
  /** The average value of the product */
  averageValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The product's brand */
  brand: Scalars['String']['output'];
  /** The breaks this product is in */
  breaks: Array<Break>;
  /** The product's cards per pack */
  cardsPerPack?: Maybe<Scalars['Int']['output']>;
  /** The product's category */
  category?: Maybe<ProductCategory>;
  /** The ceiling value of the product */
  ceilingValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The checklist url of the product */
  checklistUrl?: Maybe<Scalars['String']['output']>;
  /** The barcode of the product */
  code?: Maybe<Scalars['String']['output']>;
  /** Description of the product */
  description?: Maybe<Scalars['String']['output']>;
  /** The product's display year */
  displayYear: Scalars['String']['output'];
  /**
   * The product's edition
   * @deprecated Field is no longer used
   */
  edition?: Maybe<Scalars['String']['output']>;
  /** The product's featured at */
  featuredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The floor value of the product */
  floorValueInCents?: Maybe<Scalars['Int']['output']>;
  /**
   * The product's form factor
   * @deprecated Field is no longer used
   */
  formFactor?: Maybe<ProductFormFactor>;
  /** The product's unique ID */
  id: Scalars['UUID']['output'];
  /** The product's images */
  imagePaths?: Maybe<ProductImagePaths>;
  /** The product's images, including multiple images */
  imagePathsV2?: Maybe<ProductImagePathsV2>;
  /** Product image urls */
  imageUrls?: Maybe<Array<Maybe<ProductImageUrl>>>;
  /** Whether the product is a digital repersentation or physical */
  isDigital?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The product's league
   * @deprecated Use leagues instead
   */
  league?: Maybe<ProductLeague>;
  /** Leages */
  leagues: Array<League>;
  /** The product's listing price */
  listingPrice?: Maybe<MoneyAmount>;
  /**
   * The product's market price in cents
   * @deprecated Field is no longer used
   */
  marketPriceInCents?: Maybe<Scalars['Int']['output']>;
  /** The product's name */
  name: Scalars['String']['output'];
  /** The product's packs per box */
  packsPerBox?: Maybe<Scalars['Int']['output']>;
  /** The product's producer's id (eg, for Topps this will be SKU) */
  producerId?: Maybe<Scalars['String']['output']>;
  /** The type of the product */
  productType?: Maybe<ProductTypeV2>;
  /** Whether you can purchase the product or not */
  purchasable?: Maybe<Scalars['Boolean']['output']>;
  /** The purchase price in cents */
  purchasePriceInCents?: Maybe<Scalars['Int']['output']>;
  /** Repack */
  repack?: Maybe<Repack>;
  /**
   * The product's series
   * @deprecated Field is no longer used
   */
  series?: Maybe<Scalars['String']['output']>;
  /**
   * The product's sku
   * @deprecated Field is replaced by producerId
   */
  sku?: Maybe<Scalars['String']['output']>;
  /**
   * The product's slug
   * @deprecated Field is no longer used
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The product's type
   * @deprecated Field is no longer used
   */
  type?: Maybe<ProductType>;
  /** The product's year */
  year: Scalars['Int']['output'];
};

/** Describes the relevant audience for a product */
export enum ProductAudience {
  /** The product is intended for hobbyist collectors */
  Hobby = 'HOBBY',
  /** The product is intended for retail sellers */
  Retail = 'RETAIL'
}

/** Describes the product's category */
export enum ProductCategory {
  /** Baseball category */
  Baseball = 'BASEBALL',
  /** Basketball category */
  Basketball = 'BASKETBALL',
  /** Boxing category */
  Boxing = 'BOXING',
  /** Combat Sports category */
  CombatSports = 'COMBAT_SPORTS',
  /** Entertainment category */
  Entertainment = 'ENTERTAINMENT',
  /** Football category */
  Football = 'FOOTBALL',
  /** Golf category */
  Golf = 'GOLF',
  /** Hockey category */
  Hockey = 'HOCKEY',
  /** Motor Racing category */
  MotorRacing = 'MOTOR_RACING',
  /** Olympics category */
  Olympics = 'OLYMPICS',
  /** Other category */
  Other = 'OTHER',
  /** Soccer category */
  Soccer = 'SOCCER',
  /** Tennis category */
  Tennis = 'TENNIS',
  /** Wrestling category */
  Wrestling = 'WRESTLING'
}

export type ProductConnection = {
  __typename?: 'ProductConnection';
  edges?: Maybe<Array<Maybe<ProductEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductCreateInput = {
  /** The average value of the product */
  averageValueInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The ceiling value of the product */
  ceilingValueInCents?: InputMaybe<Scalars['Int']['input']>;
  /** Product checklist url */
  checklistUrl?: InputMaybe<Scalars['String']['input']>;
  /** The barcode of the product */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The floor value of the product */
  floorValueInCents?: InputMaybe<Scalars['Int']['input']>;
  /** List of image paths for the product */
  imagePaths: Array<Scalars['String']['input']>;
  /** V2 version for List of image urls for the product */
  imageUrls?: InputMaybe<Array<ProductImageUrlsInput>>;
  /** Product leagues */
  leagues?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Product manufacturer id */
  manufacturerId: Scalars['UUID']['input'];
  /** Product brand/manufacturer name */
  manufacturerName: Scalars['String']['input'];
  /** The name of the product */
  name: Scalars['String']['input'];
  /** The type of the product */
  productType?: InputMaybe<ProductTypeV2>;
  /** Product year */
  year: Scalars['Int']['input'];
};

export type ProductCreateInputV2 = {
  /** The average value of the product */
  averageValueInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The ceiling value of the product */
  ceilingValueInCents?: InputMaybe<Scalars['Int']['input']>;
  /** Product checklist url */
  checklistUrl?: InputMaybe<Scalars['String']['input']>;
  /** The barcode of the product */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The floor value of the product */
  floorValueInCents?: InputMaybe<Scalars['Int']['input']>;
  /** List of image paths for the product */
  imagePaths: Array<Scalars['String']['input']>;
  /** V2 version for List of image urls for the product */
  imageUrls?: InputMaybe<Array<ProductImageUrlsInput>>;
  /** Product leagues */
  leagues?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Product manufacturer id */
  manufacturerId?: InputMaybe<Scalars['UUID']['input']>;
  /** Product brand/manufacturer name */
  manufacturerName?: InputMaybe<Scalars['String']['input']>;
  /** The name of the product */
  name: Scalars['String']['input'];
  /** The type of the product */
  productType?: InputMaybe<ProductTypeV2>;
  /** Product year */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCreatePayload = {
  __typename?: 'ProductCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ProductCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type ProductCreateResponse = {
  __typename?: 'ProductCreateResponse';
  product: Product;
};

export type ProductEdge = {
  __typename?: 'ProductEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Product>;
};

export type ProductFilters = {
  brand?: InputMaybe<Scalars['String']['input']>;
  leagues?: InputMaybe<Array<Scalars['UUID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** Describes how the product is packaged */
export enum ProductFormFactor {
  /** The product represents a box */
  Box = 'BOX',
  /** The product represents a single card */
  Card = 'CARD',
  /** The product represents a full case */
  Case = 'CASE',
  /** The product is packaged as a mix of packaging options */
  Mixed = 'MIXED',
  /** The product represents a pack */
  Pack = 'PACK'
}

/** Images for the product */
export type ProductImagePaths = {
  __typename?: 'ProductImagePaths';
  /** The main image for this product */
  main?: Maybe<Scalars['String']['output']>;
  /** The secondary image for this product */
  secondary?: Maybe<Scalars['String']['output']>;
};

/** Images for the product */
export type ProductImagePathsV2 = {
  __typename?: 'ProductImagePathsV2';
  /** The main image for this product */
  main?: Maybe<Scalars['String']['output']>;
  /** Multiple images for this product */
  multiple?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The secondary image for this product */
  secondary?: Maybe<Scalars['String']['output']>;
};

export type ProductImageUrl = {
  __typename?: 'ProductImageUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type ProductImageUrlsInput = {
  url: Scalars['String']['input'];
};

/** Describes the product's league */
export enum ProductLeague {
  /**
   * Champions League
   * @deprecated Use SOCCER instead
   */
  ChampionsLeague = 'CHAMPIONS_LEAGUE',
  /** Disney League */
  Disney = 'DISNEY',
  /** Dude Perfect League */
  DudePerfect = 'DUDE_PERFECT',
  /**
   * English Premier League
   * @deprecated Use SOCCER instead
   */
  Epl = 'EPL',
  /** F1 League */
  F1 = 'F1',
  /** JACKASS */
  Jackass = 'JACKASS',
  /** MLB League */
  Mlb = 'MLB',
  /** NASCAR League */
  Nascar = 'NASCAR',
  /** NBA League */
  Nba = 'NBA',
  /** NCAA BK League */
  NcaaBk = 'NCAA_BK',
  /** NCAA FB League */
  NcaaFb = 'NCAA_FB',
  /** NFL League */
  Nfl = 'NFL',
  /** NHL League */
  Nhl = 'NHL',
  /** Other League */
  Other = 'OTHER',
  /** Singles */
  Singles = 'SINGLES',
  /** Soccer */
  Soccer = 'SOCCER',
  /**
   * UEFA
   * @deprecated Use SOCCER instead
   */
  Uefa = 'UEFA',
  /** UFC League */
  Ufc = 'UFC',
  /** VeeFriends */
  VeeFriends = 'VEE_FRIENDS',
  /** WNBA League */
  Wnba = 'WNBA'
}

/** A request to add a product to a seller's inventory */
export type ProductOrder = {
  __typename?: 'ProductOrder';
  /** The unique identifier for the product order */
  id: Scalars['UUID']['output'];
  /** The price of the product in cents */
  priceInCents: Scalars['Int']['output'];
  /** The product to add to the inventory */
  product: Product;
  /** The quantity of the product to add to the inventory */
  quantity: Scalars['Int']['output'];
  /** The shop to add the product to */
  shop: Shop;
  /** The user who is adding the product to the inventory */
  user: User;
};

export type ProductOrderCreateInput = {
  productId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
  shopId: Scalars['UUID']['input'];
};

export type ProductOrderCreatePayload = {
  __typename?: 'ProductOrderCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ProductOrderCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type ProductOrderCreateResponse = {
  __typename?: 'ProductOrderCreateResponse';
  productOrder?: Maybe<ProductOrder>;
};

export type ProductRail = Rail & {
  __typename?: 'ProductRail';
  id: Scalars['String']['output'];
  items?: Maybe<ProductConnection>;
  position: Scalars['Int']['output'];
  railType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ProductRailItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductSectionV2 = SectionV2 & {
  __typename?: 'ProductSectionV2';
  displayType: SectionDisplayType;
  id: Scalars['String']['output'];
  items?: Maybe<ProductConnection>;
  position: Scalars['Int']['output'];
  sectionType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type ProductSectionV2ItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The key to use when sorting products */
export enum ProductSortKey {
  /** Sort by the featured time of the product */
  FeaturedAt = 'FEATURED_AT',
  /** Sort by the created time of the product */
  InsertedAt = 'INSERTED_AT'
}

/** Describes the type of product */
export enum ProductType {
  Blaster = 'BLASTER',
  Fotl = 'FOTL',
  Giant = 'GIANT',
  Hanger = 'HANGER',
  Hobby = 'HOBBY',
  Jumbo = 'JUMBO',
  Mega = 'MEGA'
}

/** Describes the type of the product */
export enum ProductTypeV2 {
  Other = 'OTHER',
  Repack = 'REPACK',
  SealedWax = 'SEALED_WAX',
  Single = 'SINGLE'
}

export type ProductUpdateInput = {
  /** V2 version of Images urls to be associated with the product */
  imageUrls: Array<ProductImageUrlsInput>;
  /** Product id which images are to be associated */
  productId: Scalars['UUID']['input'];
};

export type ProductUpdatePayload = {
  __typename?: 'ProductUpdatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ProductUpdateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type ProductUpdateResponse = {
  __typename?: 'ProductUpdateResponse';
  product?: Maybe<Product>;
};

/** We have a few profile types that have a logo. */
export enum ProfileType {
  Channel = 'CHANNEL',
  Shop = 'SHOP',
  User = 'USER'
}

/** A promotion code issued by a shop which can be used to apply discounts */
export type PromoCode = {
  __typename?: 'PromoCode';
  /** The promo code */
  code: Scalars['String']['output'];
  /** The amount of the discount in cents (if discountType is amountOff) */
  discountAmount?: Maybe<MoneyAmount>;
  /** The amount of the discount in cents (if discountType is amountOff) */
  discountAmountInCents?: Maybe<Scalars['Int']['output']>;
  /** The amount of the discount in cents (if discountType is percentOff) */
  discountAmountPercentage?: Maybe<Scalars['Int']['output']>;
  /** Discounts can be either a fixed amount or a percentage */
  discountType?: Maybe<PromotionType>;
  /** The shop that issued the promo code */
  shop?: Maybe<Shop>;
};

/** A promotion code issued by a shop which can be used to apply discounts */
export type PromotionCode = {
  __typename?: 'PromotionCode';
  /** The promotion code */
  code: Scalars['String']['output'];
  /** Discounts can be either a fixed amount or a percentage */
  discountType: PromotionType;
  /** The shop that issued the promo code */
  shop?: Maybe<Shop>;
  /** The value of the promotion_code */
  value: PromotionCodeValue;
};

export type PromotionCodeValue = MoneyAmount | Percentage;

export enum PromotionType {
  /** The promotion applies a fixed amount off */
  AmountOff = 'AMOUNT_OFF',
  /** The promotion applies a percentage off */
  PercentOff = 'PERCENT_OFF'
}

/** Information about a user */
export type PublicUser = {
  __typename?: 'PublicUser';
  _resolveReference?: Maybe<PublicUser>;
  /**
   * Paginated list of live streams which contain all upcoming and active live streams that a user
   * has bought into or has followed.
   */
  availableLiveStreams?: Maybe<LiveStreamConnection>;
  /** The user's avatar URL */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The user's active badges */
  badges?: Maybe<Array<Badge>>;
  /** The biography of the user */
  biography?: Maybe<Scalars['String']['output']>;
  /** The user's channels */
  channels: UserChannels;
  /** The section title for the user's channels */
  channelsSectionTitle: Scalars['String']['output'];
  /**
   * Paginated list of live streams which contain all completed live streams that a user has bought
   * into or has followed.
   * @deprecated This query was used to list streams with replays, not completed ones.
   * Therefore, use the `liveStreamsWithReplays` instead
   */
  completedLiveStreams?: Maybe<LiveStreamConnection>;
  /** The user's cover image URL */
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  /** The user's follower count */
  followerCount: Scalars['Int']['output'];
  /**
   * The users that follow the user
   * @deprecated Use followersPaginated instead
   */
  followers?: Maybe<Array<PublicUser>>;
  /** The users that follow the user */
  followersPaginated?: Maybe<PublicUserConnection>;
  /**
   * The users followed channels, shops and users
   * @deprecated Use followingPaginated instead
   */
  following?: Maybe<Array<Avatar>>;
  /** The user's following count */
  followingCount: Scalars['Int']['output'];
  /** The users that follow the user */
  followingPaginated?: Maybe<AvatarConnection>;
  /** The user's unique id */
  id: Scalars['UUID']['output'];
  /** Whether the current user follows this user or not */
  isFollowed: Scalars['Boolean']['output'];
  /** Whether the user is currently live, if the user is a seller */
  isLiveNow?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The user's live streams
   * @deprecated This field is deprecated. Please use paginated_live_streams instead.
   */
  liveStreams?: Maybe<UserLiveStreams>;
  /**
   * Paginated list of live streams which contain all live streams that a user has bought into or has followed
   * with available replays.
   */
  liveStreamsWithReplays?: Maybe<LiveStreamConnection>;
  /** The user's client‑side metadata blob */
  metadata: UserMetadata;
  /** The user's live streams */
  paginatedLiveStreams?: Maybe<LiveStreamConnection>;
  /** The user's role */
  role: UserRole;
  /** The shop associated with the user */
  shop?: Maybe<Shop>;
  /** The section title for the user's streams */
  streamsSectionTitle: Scalars['String']['output'];
  tenantId: Scalars['UUID']['output'];
  /** The user's username */
  username?: Maybe<Scalars['String']['output']>;
};


/** Information about a user */
export type PublicUserAvailableLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


/** Information about a user */
export type PublicUserCompletedLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


/** Information about a user */
export type PublicUserFollowersPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Information about a user */
export type PublicUserFollowingPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Information about a user */
export type PublicUserLiveStreamsWithReplaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


/** Information about a user */
export type PublicUserPaginatedLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicUserConnection = {
  __typename?: 'PublicUserConnection';
  edges?: Maybe<Array<Maybe<PublicUserEdge>>>;
  pageInfo: PageInfo;
};

export type PublicUserEdge = {
  __typename?: 'PublicUserEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PublicUser>;
};

/** Parameters for publishing a live stream. */
export type PublishLiveStreamInput = {
  /** The ID of the object we want to update */
  id: Scalars['ID']['input'];
};

export type PublishLiveStreamPayload = {
  __typename?: 'PublishLiveStreamPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveStreamResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for purchasing random fixed-price slots in a break */
export type PurchaseRandomSpotInput = {
  /** The amount of account funds to apply to the checkout by the user, in cents */
  appliedAccountFundsAmount?: InputMaybe<Scalars['Int']['input']>;
  /** It represent applied fancash balance applied at the time of checkout in cents by user */
  appliedFancashAmount?: InputMaybe<Scalars['Int']['input']>;
  /** If true, apply the user's account funds to the purchase */
  applyAccountFunds?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, apply the user's entire fancash balance to the purchase */
  applyFancashBalance?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, apply the user's entire reward balance to the purchase */
  applyRewardsBalance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique ID for this break */
  breakId: Scalars['UUID']['input'];
  /** Optional IDs of the spots selected for purchase. This field can be empty. */
  breakSpotIdList?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** The payment method to be used for this purchase */
  paymentMethodId: Scalars['UUID']['input'];
  /** The promo code to be used for this purchase */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** The amount of slots requested for purchase */
  quantity: Scalars['Int']['input'];
  /** Unique device identifier (SEON fingerprint) */
  seonIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The shipping address to be used for this purchase */
  shippingAddressId: Scalars['UUID']['input'];
};

export type PurchaseRandomSpotPayload = {
  __typename?: 'PurchaseRandomSpotPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<BreakOrderResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for purchasing a specific fixed-price spot in a break */
export type PurchaseSpotInput = {
  /** The amount of account funds to apply to the checkout by the user, in cents */
  appliedAccountFundsAmount?: InputMaybe<Scalars['Int']['input']>;
  /** It represent applied fancash balance applied at the time of checkout in cents by user */
  appliedFancashAmount?: InputMaybe<Scalars['Int']['input']>;
  /** If true, apply the user's account funds to the purchase */
  applyAccountFunds?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, apply the user's entire fancash balance to the purchase */
  applyFancashBalance?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, apply the user's entire reward balance to the purchase */
  applyRewardsBalance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique ID for this break */
  breakId: Scalars['UUID']['input'];
  /** The ID of a specific spot to be purchased, if this is a random spot purchase, this field should be empty */
  breakSpotIdList: Array<InputMaybe<Scalars['UUID']['input']>>;
  /** The payment method to be used for this purchase */
  paymentMethodId: Scalars['UUID']['input'];
  /** The promo code to be used for this purchase */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** Unique device identifier (SEON fingerprint) */
  seonIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The shipping address to be used for this purchase */
  shippingAddressId: Scalars['UUID']['input'];
};

export type PurchaseSpotPayload = {
  __typename?: 'PurchaseSpotPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<BreakOrder>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for purchasing a spot with client-side payment confirmation. Payment method is selected on the client via Stripe Elements. */
export type PurchaseWithClientConfirmationInput = {
  /** The amount of account funds to apply to the checkout by the user, in cents */
  appliedAccountFundsAmount?: InputMaybe<Scalars['Int']['input']>;
  /** It represent applied fancash balance applied at the time of checkout in cents by user */
  appliedFancashAmount?: InputMaybe<Scalars['Int']['input']>;
  /** If true, apply the user's account funds to the purchase */
  applyAccountFunds?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, apply the user's entire fancash balance to the purchase */
  applyFancashBalance?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, apply the user's entire reward balance to the purchase */
  applyRewardsBalance?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unique ID for this break */
  breakId: Scalars['UUID']['input'];
  /** The ID of a specific spot to be purchased */
  breakSpotIdList: Array<InputMaybe<Scalars['UUID']['input']>>;
  /** The promo code to be used for this purchase */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** Unique device identifier (SEON fingerprint) */
  seonIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** The shipping address to be used for this purchase */
  shippingAddressId: Scalars['UUID']['input'];
};

export type Query = {
  __typename?: 'Query';
  /** Get account funds balance for the authenticated user */
  accountFundsBalance?: Maybe<AccountFundsBalance>;
  /** Get badges for a specific user */
  badges?: Maybe<Array<Maybe<Badge>>>;
  /** Get a single big moment by ID */
  bigMoment?: Maybe<BigMoment>;
  /** Get a list of big moments */
  bigMoments: Array<BigMoment>;
  /** Retrieve a break by id */
  break?: Maybe<Break>;
  breakGameValidBreaks?: Maybe<ValidBreaksResponse>;
  /** Retrieve a list of available breaks */
  breaks: Array<Break>;
  /** Is break valid for creating break game? */
  canCreateBreakGame?: Maybe<Scalars['Boolean']['output']>;
  /** Get a single card */
  card?: Maybe<Card>;
  /** Get a card catalog item by variant_id with optional certification number for enrichment */
  cardCatalogItem?: Maybe<CardCatalogItem>;
  /** Search for variants using text-based vector search */
  cardCatalogSearch?: Maybe<Array<Maybe<CardCatalogItemSearchResult>>>;
  /**
   * Return a list of cards
   * @deprecated Deprecated: cards of a user without pagination is deprecated
   */
  cards?: Maybe<Array<Maybe<Card>>>;
  /** A paginated list of the cards those belong to current user */
  cardsPaginated?: Maybe<CardConnection>;
  /** Retrieve a channel by id */
  channel?: Maybe<Channel>;
  /** Retrieve a list of channels by shop id */
  channels?: Maybe<Array<Maybe<Channel>>>;
  /** Check if a code has been redeemed by a user. */
  checkAccessCode?: Maybe<CodeStatus>;
  /** Get statistics for a checklist */
  checklistStats: ChecklistComprehensiveStats;
  /** Retrieve the checkout pricing breakdown information for pixed price spot purchase. */
  checkoutFixedSpot?: Maybe<CheckoutSpotBreakdownPayload>;
  checkoutListing?: Maybe<CheckoutListingBreakdownPayload>;
  /** Retrieve the checkout pricing breakdown information for random spot purchase */
  checkoutRandomSpot?: Maybe<CheckoutRandomSpotBreakdownPayload>;
  /** Checks if a code (promotion or reward) is valid */
  codeValidate: CodeResult;
  /** Get all Premier auctions which user can choose to list their portfolio items */
  collectAcceptingSubmissionsPremierAuctions?: Maybe<Array<Maybe<CollectPremierAuction>>>;
  /** Get all Weekly auctions which user can choose to list their portfolio items */
  collectAcceptingSubmissionsWeeklyAuctions?: Maybe<Array<Maybe<CollectWeeklyAuction>>>;
  /** Paginated list of auction sales for the seller. */
  collectAccountingMarketplaceAuctionSales: CollectAccountingMarketplaceAuctionSaleConnection;
  /** Paginated list of premier sales for the seller. */
  collectAccountingMarketplacePremierSales: CollectAccountingMarketplacePremierSaleConnection;
  /** Paginated list of recent transactions for the seller. */
  collectAccountingMarketplaceRecentTransactions: CollectAccountingMarketplaceRecentTransactionConnection;
  /** Summary of marketplace accounting information for the seller. */
  collectAccountingMarketplaceSummary: CollectAccountingMarketplaceSummary;
  collectAlgoliaSearch: Array<CollectAlgoliaSearchResponse>;
  /** Returns a distinct list of folders that auction listings belong to */
  collectAuctionListingFolders: CollectListingFolderConnection;
  collectAuctions: Array<Maybe<CollectAuction>>;
  /** Lists all auctions this vault item can be listed in */
  collectAvailableAuctions?: Maybe<CollectAuctionConnection>;
  /** @deprecated Use `checkoutV2` instead */
  collectBoCheckoutListingCreateDraftOrder?: Maybe<CollectBoCheckoutListingCreateDraftOrderResponse>;
  collectBoCheckoutV2DraftIntent?: Maybe<CollectBoV2CheckoutDraftIntentResult>;
  collectBoGetCart?: Maybe<CollectBoCart>;
  collectBoGetCartCount: Scalars['Int']['output'];
  collectBoGetInvoice?: Maybe<CollectBoInvoiceResponse>;
  /** Get listings for the selling page */
  collectBoGetListingsForSellingPage?: Maybe<CollectBoListingsForSellingPageResponse>;
  collectBoGetMySellingListings?: Maybe<CollectBoMySellingListingsResponse>;
  collectBoGetSaleOrdersBySeller?: Maybe<CollectBoOrdersBySellerResponse>;
  /** Returns a distinct list of folders that listings of the current user belong to */
  collectBoListingFolders: CollectListingFolderConnection;
  collectBoListingsAvailableInventory?: Maybe<CollectBoListingsAvailableInventoryResponse>;
  collectBoSearchInvoices?: Maybe<CollectBoSearchInvoicesResponse>;
  collectBoSupportedPaymentMethods: Array<CollectCheckoutV2PaymentMethod>;
  /** Fetch all distinct category hierarchy */
  collectCategoryHierarchy?: Maybe<Array<Maybe<CollectCategoryHierarchy>>>;
  /**
   * Handles card analysis operations using ChatGPT.
   * Accepts a list of card images and an optional prompt for context.
   * Returns match details, a description of the analysis, and a chat response based on the provided prompt.
   */
  collectChatgptResults?: Maybe<CollectChatgptOperationsResult>;
  /** List of Trade Shows that are available for creating an VaultItem checkout */
  collectCheckoutAvailableTradeShows?: Maybe<Array<Maybe<CollectTradeShow>>>;
  collectCheckoutDetails?: Maybe<CollectCheckoutDetails>;
  collectCheckoutV2Details: CollectCheckoutV2Details;
  collectCheckoutV2PaymentSummary: CollectCheckoutV2PaymentSummary;
  collectCountries: Array<Maybe<CollectCountry>>;
  collectCountriesV2?: Maybe<CollectCountriesV2Payload>;
  collectCurrentUserV2?: Maybe<CollectCurrentUser>;
  collectDetailed?: Maybe<CollectDetailed>;
  /** Get FanID auth params */
  collectFanIdAuthParams: CollectFanIdAuthParams;
  /** Get paginated auctions for the bids page where the user has placed bids */
  collectGetAuctionsForBidsPage?: Maybe<CollectAuctionConnection>;
  /** Get paginated auctions for the selling page */
  collectGetAuctionsForSellingPage?: Maybe<CollectAuctionConnection>;
  /** @deprecated Use `collectBoGetCart` instead. This legacy cart will be removed in a future version. */
  collectGetCart?: Maybe<CollectCart>;
  collectGetFanaticsCollectIdentityKey?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use collectGetLatestOffersForChannelsV2 query instead. */
  collectGetLatestOffersForChannels?: Maybe<Array<Maybe<CollectChannelOffer>>>;
  /** Fetches the latest offers for the specific channels cids */
  collectGetLatestOffersForChannelsV2?: Maybe<Array<Maybe<CollectChannelOffer>>>;
  /** @deprecated Use collectGetLatestOffersForChannels query instead. */
  collectGetOfferIdsForChannels?: Maybe<Array<Maybe<CollectChannelOffers>>>;
  collectGetOwnershipTransferIdentity?: Maybe<CollectUser>;
  collectGetOwnershipTransferSummary?: Maybe<CollectOwnershipTransferSummary>;
  collectGetPickUpInPersonSummary?: Maybe<CollectPickUpInPersonSummary>;
  collectGetRedemptionSubmissionSummary?: Maybe<CollectVaultSubmissionSummary>;
  collectGetTradeShowCheckoutSummary?: Maybe<CollectTradeShowCheckoutSummary>;
  collectGetVaultItem?: Maybe<CollectVaultItem>;
  collectGetVaultItemRequest?: Maybe<CollectVaultItemRequest>;
  collectGetVaultItemRequestDetails?: Maybe<CollectVaultItemRequestDetails>;
  collectGetVaultRetrievalSummary?: Maybe<CollectVaultRetrievalSummary>;
  collectGetVaultSubmission?: Maybe<CollectVaultSubmission>;
  collectGetVaultSubmissionByIntegerId?: Maybe<CollectVaultSubmission>;
  collectGetVaultSubmissionRates?: Maybe<CollectVaultSubmissionRates>;
  collectGetVaultSubmissionSummary?: Maybe<CollectVaultSubmissionSummary>;
  collectGlobalAuctions?: Maybe<Array<Maybe<CollectAuction>>>;
  collectGlobalAuctionsLongPolling?: Maybe<Array<Maybe<CollectAuction>>>;
  /**
   * Handles Google search operations using the provided card images.
   * Accepts a list of card images and returns search results related to those images.
   * Each result includes a link, snippet, and title for the corresponding search result.
   */
  collectGoogleResults?: Maybe<Array<Maybe<CollectGoogleResult>>>;
  /** Lists all graders available in the system */
  collectGraders: Array<CollectGrader>;
  /** Fetch all grading services */
  collectGradingServices?: Maybe<Array<Maybe<CollectGradingServices>>>;
  collectHomepageAuctionsCalendar?: Maybe<Array<Maybe<CollectCalendarEvent>>>;
  collectInvoice?: Maybe<CollectInvoice>;
  collectInvoiceV2?: Maybe<CollectInvoice>;
  /** Returns a collectItem object by ID */
  collectItem?: Maybe<CollectItem>;
  /** Fetch parallels for a specific year, brand, and set */
  collectListParallels?: Maybe<Array<Maybe<CollectParallel>>>;
  collectListSavedSearches?: Maybe<CollectSavedSearchConnection>;
  collectListVaultItems: Array<CollectVaultItem>;
  collectListing?: Maybe<CollectListing>;
  /** Returns the fanatics pricing info for a listing */
  collectListingFanaticsPricingInfo?: Maybe<CollectFanaticsPricingInfo>;
  collectListings: Array<Maybe<CollectListing>>;
  collectListingsByIntegerId: Array<Maybe<CollectListing>>;
  collectMonolithicSearch: CollectMonolithicSearchResponse;
  collectMonolithicSearchOptions: CollectMonolithicSearchOptions;
  collectOffer?: Maybe<CollectFixedPriceListingOfferWithHistoryInterface>;
  collectOfferRoom?: Maybe<CollectOfferRoom>;
  collectProduct?: Maybe<CollectProduct>;
  /** Fetch a PSA variant by its certification number. */
  collectPsaResultV2?: Maybe<CollectVariant>;
  collectPublicUserV2?: Maybe<CollectPublicUser>;
  collectReasons?: Maybe<Array<Maybe<CollectReportReason>>>;
  collectRedRookiePlayers?: Maybe<CollectRedRookiePlayerConnection>;
  /** @deprecated Use collectRelatedListings instead */
  collectRelatedListing?: Maybe<Array<Maybe<CollectListing>>>;
  /** Get related listings by vault item ID or search term */
  collectRelatedListings?: Maybe<Array<Maybe<CollectListing>>>;
  /**
   * Deprecated: Use `collect_scan_v3_modern` instead.
   * @deprecated This query is deprecated and will be removed in the next release. Use `collectScanV3Modern` instead.
   */
  collectScanV3?: Maybe<Array<Maybe<CollectVariant>>>;
  collectScanV3Modern?: Maybe<CollectScanVariantPayload>;
  collectSearch: CollectCatalogSearchResult;
  collectSearchKey?: Maybe<Scalars['String']['output']>;
  collectSearchListing: CollectSearchListing;
  collectSearchProduct: CollectSearchProduct;
  collectSearchSellerOptions: Array<CollectOptionValue>;
  collectSearchSetting: CollectSearchSettings;
  collectSellerFeeConfig?: Maybe<Array<Maybe<CollectSellerFeeRate>>>;
  /** Simplified Seller Fees config */
  collectSellerFeeConfigV2?: Maybe<CollectSellerFeeRateV2>;
  collectSessionValid?: Maybe<CollectSession>;
  collectSuggestedSearchTerms: Array<Scalars['String']['output']>;
  collectTopFanAdditions: Array<Maybe<CollectVariant>>;
  collectVariant?: Maybe<CollectVariant>;
  collectVaultCategories: Array<Maybe<CollectVaultCategory>>;
  collectVaultItemFanaticsPricingInfo?: Maybe<CollectFanaticsPricingInfo>;
  collectVaultItemsChecklist?: Maybe<CollectVaultItemsConnection>;
  collectVaultItemsEditHistory?: Maybe<CollectItemEditRequestConnection>;
  collectVaultItemsForRequest?: Maybe<CollectVaultItemsForRequestConnection>;
  /** Returns a distinct list of folders that contain vault items sent to WA/PA (weekly/premier auctions) */
  collectVaultListingFolders: CollectListingFolderConnection;
  collectionsAuthenticators: Array<Scalars['String']['output']>;
  collectionsCategories?: Maybe<CollectionsCategoryConnection>;
  collectionsCustomList?: Maybe<CollectionsCustomList>;
  collectionsCustomLists?: Maybe<CollectionsCustomListConnection>;
  collectionsItem?: Maybe<CollectionsItem>;
  collectionsItems?: Maybe<CollectionsItemConnection>;
  /** List credit purchase transactions */
  creditPurchaseTransactions?: Maybe<CreditPurchaseTransactionConnection>;
  currentBalance: MoneyAmount;
  /** Retrieve the current break (if any) for a live stream. */
  currentBreak?: Maybe<Break>;
  /** Retrieve currently active break game by live stream id */
  currentBreakGame?: Maybe<BreakGameResponse>;
  /** Retrieve the current break spot auction (if any) for a live stream */
  currentBreakSpotAuction?: Maybe<BreakSpotAuction>;
  currentCashBalance: MoneyAmount;
  /** Retrieve the current giveaway (if any) for a live stream */
  currentGiveaway?: Maybe<Giveaway>;
  /** Retrieve the currently authenticated user */
  currentUser?: Maybe<CurrentUser>;
  currentUserId?: Maybe<Scalars['String']['output']>;
  currentUserZendeskWebWidget?: Maybe<CurrentUserZendeskWebWidgetResponse>;
  /** A set of user's data privacy settings */
  dataPrivacySettings?: Maybe<DataPrivacySettings>;
  /** Retrieves debug data for a given live stream */
  debug: Debug;
  /** Check if a user is eligible for debut pack by verifying they haven't received/purchased an instant rip before. */
  debutPackEligible: Scalars['Boolean']['output'];
  /** Retrieve a list of users who are eligible for the debut pack. */
  debutPackEligibleUsers: Array<Maybe<User>>;
  fanAuthParams: AuthParams;
  /** Get fancash balance for the authenticated user */
  fancashBalance?: Maybe<FancashWalletBalance>;
  featureFlags?: Maybe<Array<Maybe<FeatureFlag>>>;
  /** Get a break template by id */
  getBreakTemplate?: Maybe<BreakTemplate>;
  /** Retrieve category hierarchy */
  getCategoryHierarchy: Array<CategoryHierarchyItem>;
  getDebutShow?: Maybe<LiveStream>;
  /** Retrieve grading services */
  getGradingServices: Array<GradingServiceItem>;
  /**
   * Retrieve all items associated to a product
   * @deprecated Use get_items_v4 instead.
   */
  getItems?: Maybe<GetVaultItemsResponse>;
  getItemsInCollection?: Maybe<GetVaultItemsResponse>;
  /**
   * Retrieve all items associated to a product, supports forward pagination
   * @deprecated Use get_items_v4 instead.
   */
  getItemsV2?: Maybe<GetVaultItemsResponse>;
  /**
   * Retrieve all items associated to a product, supports forward and backwards pagination
   * @deprecated Use get_items_v4 instead.
   */
  getItemsV3?: Maybe<GetVaultItemsResponseV2>;
  getItemsV4?: Maybe<GetVaultItemsResponseV2>;
  /** Retrieve a specific listing event by ID */
  getListing: Listing;
  /** Retrieve all listings for a shop */
  getListings: Array<Listing>;
  /** Retrieve a paginated list of livestreams that have a current break associated with the given product */
  getLivestreamByProduct?: Maybe<LiveStreamConnection>;
  getLogoPath?: Maybe<Url>;
  /** Get a Poll by Id */
  getPoll?: Maybe<GetPollResponse>;
  /** Get Polls by LiveStream Id */
  getPolls?: Maybe<GetPollsResponse>;
  /**
   * Retrieve a valid promo code
   * @deprecated Use `codeValidate` instead
   */
  getPromoCode: PromoCode;
  getRepack: Repack;
  /**
   * Retrieve all products associated with a shop that are digital
   * @deprecated This is kept for legacy purposes. Use get_repacks_paginated instead.
   */
  getRepacks: Array<Repack>;
  /** Retrieve products associated with a shop that are digital in a paginated manner */
  getRepacksPaginated?: Maybe<RepackConnection>;
  getRippedPack: RippedPack;
  /** Retrieve the full path to logo for given profile type. */
  getUploadLogoUrl?: Maybe<Url>;
  /** Refresh a FanID token */
  getUserToken: TokenPair;
  /** Retrieve a live stream id by live stream's name */
  getVaultItems?: Maybe<GetVaultItemsResponse>;
  /** Get the health of a given entity */
  healthCheck?: Maybe<HealthCheckPayload>;
  /** Retrieve the home feed for the current user */
  home?: Maybe<Home>;
  /** Fetch the full path of an image which has been uploaded to S3 */
  imageUrl: Scalars['String']['output'];
  /** Introspect a FanID token */
  introspect: IntrospectResult;
  /**
   * Checks if a promo code is valid for the current user and optionally for the current shop
   * @deprecated Use `codeValidate` instead
   */
  isPromoCodeValid: Scalars['Boolean']['output'];
  /** Check whether the current session is alive. */
  isSessionAlive?: Maybe<Scalars['Boolean']['output']>;
  /** Return a specific league based on type */
  league?: Maybe<League>;
  /** Returns a list of league members (ie. teams) for the specified league */
  leagueMembers: Array<LeagueMember>;
  /** Return a list of supported leagues */
  leagues: Array<League>;
  /** List all the break templates, including common templates and shop specific templates, only label and id is available. */
  listBreakTemplates?: Maybe<Array<Maybe<BreakTemplate>>>;
  listDefaultAvatars?: Maybe<Array<Maybe<DefaultAvatar>>>;
  /** Fetch 10 latest live support ticket comments. Comments are ordered by created_at desc. */
  listLiveSupportTicketComments?: Maybe<ListLiveSupportTicketCommentsResponse>;
  /**
   * Retrieve list of live steams by the list of ids.
   * Live streams ordered by starts_at asc
   * 20 items max!
   */
  listLivestreams: Array<Maybe<LiveStream>>;
  /** Retrieve a list of promo codes that can be redeemed by the current user */
  listRedeemablePromoCodes?: Maybe<Array<Maybe<PromoCode>>>;
  /** Fetch 10 latest live support tickets. Tickets are ordered by created_at desc. */
  listShopLiveSupportTickets?: Maybe<ShopLiveSupportTicketsResponse>;
  liveFeaturedBreak?: Maybe<Array<Maybe<Break>>>;
  liveProgressiveBreaks?: Maybe<Array<Maybe<LiveProgressiveBreak>>>;
  /**
   * Retrieve a live stream by id. If no id is provided, then the server will
   * return a "surprise" stream of a stream exists that meets the internal
   * criteria for such a stream. If no stream is found that matches the criteria,
   * then a null value is returned.
   */
  liveStream?: Maybe<LiveStream>;
  /** Retrieve a live stream by access code */
  liveStreamByAccessCode?: Maybe<LiveStream>;
  /** Retrieve a live stream id by live stream's name */
  liveStreamByName?: Maybe<LiveStream>;
  /** @deprecated For generic recommendations, use live_stream_recommendation. for raids, use corresponding field in the live_stream object. null in stream_id will be deprecated */
  liveStreamRaid: LiveStreamRaid;
  /** Retrieves the generic recommendation for the stream */
  liveStreamRecommendation: LiveStream;
  /** Retrieves the generic recommendation for the stream with forced raid flag */
  liveStreamRecommendationV2: LiveStreamRecommendationResult;
  /** Retrieve a list of live streams */
  liveStreams?: Maybe<LiveStreamConnection>;
  liveStreamsByLeague?: Maybe<Array<LiveStreamCard>>;
  liveStreamsByProductSlug?: Maybe<LiveStreamConnection>;
  /** Get Live-specific wallet information for the authenticated user */
  liveUserWallet?: Maybe<UserWallet>;
  /** Retrieve list of manufacturers */
  manufacturers: Array<Manufacturer>;
  /**
   * Returns break spots available for direct purchase according to user sort and filters preference
   *   - only `sort` or `filters` parameter (or both) that is set to `null` will be reset and for anohter parameter value will be fetched from user preference if not provided or updated if provided
   *   - only that parameter(s) that has value provided and will updated and for another parameter the value from user preferences will be used if any. So if `sort` is received but `filters` are not provided - then `sort` user preference will be updated and for filters we will fetch the value if any
   *   - `filters` are always updated as a whole object, there is no way to update or reset only one filter value with retaining others
   */
  marketplace?: Maybe<Marketplace>;
  marketplaceFilterLeagueMembers?: Maybe<FormModalSelectManyStrings>;
  marketplaceFilterLeagues?: Maybe<FormFieldModalSelectOneString>;
  marketplaceFilterManufacturers?: Maybe<FormModalSelectManyStrings>;
  marketplaceFilterProducts?: Maybe<FormModalSelectManyStrings>;
  /**
   * Returns all options and values available for sort and filters form along with all options selected by user or loaded from users marketplace preferences
   *   - if no parameters provided - fetch user marketplace preference and set form options from user preference
   *   - if any of the paramters provided (`sort` or `filters` or both) then existing user marketplace preference is completely ignored and only provided paramter(s) is user
   *   - if any of the parameters is set to `null` then
   *   - `filters` are always updated as a whole object, there is no way to update or reset only one filter value with retaining others
   */
  marketplaceSortAndFilter?: Maybe<MarketplaceSortAndFilterPage>;
  paginatedSingleLiveStreams?: Maybe<LiveStreamCardConnection>;
  /** Retrieve payment method options available to the user based on their country */
  paymentMethodOptions: PaymentMethodOptions;
  /** Retrieve preference options available to the user */
  preferenceOptions: PreferenceOptions;
  productDetailFeedback?: Maybe<Array<Maybe<CollectProductDetailFeedback>>>;
  /** List all products */
  products?: Maybe<ProductConnection>;
  promoCodeLeaderBoard?: Maybe<LeaderBoardPromoResponse>;
  /** Retrieve a user by id */
  publicUser?: Maybe<PublicUser>;
  /** Retrieve a user by username */
  publicUserByUsername?: Maybe<PublicUser>;
  /** Retrieve a list of recommended shops for the current user */
  recommendedShops: Array<Shop>;
  referralCode: ReferralCode;
  /** @deprecated Use referralCodeForShopV2 instead */
  referralCodeForShop: ShopReferralCode;
  referralCodeForShopV2?: Maybe<ShopReferralCode>;
  /** @deprecated Use referralCodeForUserV2 instead */
  referralCodeForUser: ReferralCode;
  referralCodeForUserV2?: Maybe<ReferralCode>;
  /** @deprecated Use referralCodeShopV2 instead */
  referralCodeShop: ShopReferralCode;
  referralCodeShopV2?: Maybe<ShopReferralCode>;
  /** Get restricted users by livestream */
  restrictedUsersByLivestream?: Maybe<Array<Maybe<LivestreamRestrictedUser>>>;
  /** List rewards in the currently authenticated user's wallet */
  rewards?: Maybe<RewardConnection>;
  /** Search for shops, live streams, or staffers */
  search?: Maybe<SearchResult>;
  /**
   * Search products by name
   * @deprecated Use searchProductsPaginated instead
   */
  searchProducts: Array<Product>;
  /** Search products by name, paginated */
  searchProductsPaginated?: Maybe<ProductConnection>;
  /** Search unlisted repacks by name, paginated */
  searchShopProducts?: Maybe<ProductConnection>;
  shippingProfiles?: Maybe<Array<ShippingProfile>>;
  /** Retrieve a shop by id or slug */
  shop?: Maybe<Shop>;
  shopAnalyticsReportDownload?: Maybe<ShopAnalyticsReportDownload>;
  shopAnalyticsReports?: Maybe<ShopAnalyticsReports>;
  shopBreakSearch?: Maybe<ShopBreakSearchItemConnection>;
  /** List all products which are in the shop's inventory */
  shopInventory?: Maybe<InventoryProductConnection>;
  /**
   * Query for the history of all stream data in a shop. The range is inclusive.
   * Possible combinations:
   * 1. shop id with last 1 day with hourly aggregation across all streams
   * 2. shop id with last 7 days with daily aggregation across all streams
   * 3. shop id with last 30 days with daily aggregation across all streams
   */
  shopMetricsHistory?: Maybe<Array<Maybe<LiveStreamMetricsDated>>>;
  /** The shop summary level metrics, with a date range */
  shopMetricsSummary: ShopMetricsSummaryResponse;
  shopReferralAnalytics: ReferralAnalytics;
  /** Retrieve all shops */
  shops: Array<Shop>;
  /**
   * Retrieve a live stream by id. If no id is provided, then the server will
   * return a "surprise" stream of a stream exists that meets the internal
   * criteria for such a stream. If no stream is found that matches the criteria,
   * then a null value is returned. Must be staff.
   */
  staffLiveStream?: Maybe<LiveStream>;
  /** Suggests a username based on the given email address */
  suggestUsernames?: Maybe<SuggestedUsernames>;
  toppsHomepage: ToppsHomepage;
  toppsProductDetailsPage: ToppsProductDetailsPage;
  /** List transactions in the currently authenticated user's wallet */
  transactions?: Maybe<WalletTransactionConnection>;
  /**
   * Aggregate transactions in the currently authenticated user's wallet.
   *
   * Currently returns the sum.
   */
  transactionsAggregate: MoneyAmount;
  unifiedUser?: Maybe<UnifiedUser>;
  /** Get user ban status */
  userBanStatus?: Maybe<UserBanStatus>;
  /** Checks if a username is taken */
  usernameTaken: Scalars['Boolean']['output'];
  usersAutocomplete?: Maybe<UsersAutocompleteResponse>;
  verifyAccessCode?: Maybe<AccessCode>;
};


export type QueryBadgesArgs = {
  userId: Scalars['UUID']['input'];
};


export type QueryBigMomentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryBigMomentsArgs = {
  livestreamUrl?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBreakArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryBreakGameValidBreaksArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type QueryBreaksArgs = {
  hasSlotsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  pricingType?: InputMaybe<BreakPricingType>;
  selectionType?: InputMaybe<BreakSelectionType>;
};


export type QueryCanCreateBreakGameArgs = {
  breakId: Scalars['UUID']['input'];
};


export type QueryCardArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCardCatalogItemArgs = {
  certNumber?: InputMaybe<Scalars['String']['input']>;
  variantId: Scalars['UUID']['input'];
};


export type QueryCardCatalogSearchArgs = {
  input: CardCatalogSearchInput;
};


export type QueryCardsArgs = {
  term: Scalars['String']['input'];
};


export type QueryCardsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  condition: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<CardSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryChannelArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryChannelsArgs = {
  shopId: Scalars['UUID']['input'];
};


export type QueryCheckAccessCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryChecklistStatsArgs = {
  checklistId: Scalars['UUID']['input'];
};


export type QueryCheckoutFixedSpotArgs = {
  input: CheckoutFixedSpotQueriesInput;
};


export type QueryCheckoutListingArgs = {
  input: ListingPurchaseInput;
};


export type QueryCheckoutRandomSpotArgs = {
  input: CheckoutRandomSpotQueriesInput;
};


export type QueryCodeValidateArgs = {
  code: Scalars['String']['input'];
  codeType: Array<InputMaybe<CodeType>>;
  shopId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCollectAccountingMarketplaceAuctionSalesArgs = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryCollectAccountingMarketplacePremierSalesArgs = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryCollectAccountingMarketplaceRecentTransactionsArgs = {
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryCollectAlgoliaSearchArgs = {
  requests: Array<InputMaybe<CollectAlgoliaSearchRequest>>;
  strategy?: InputMaybe<CollectAlgoliaSearchStrategy>;
};


export type QueryCollectAuctionListingFoldersArgs = {
  listingStatus?: InputMaybe<Array<InputMaybe<CollectListingStatusFilter>>>;
  listingType: CollectListingType;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryCollectAuctionsArgs = {
  auctionId: Array<InputMaybe<CollectAuctionIdInput>>;
};


export type QueryCollectAvailableAuctionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type: CollectAuctionType;
  vaultItemId: Scalars['UUID']['input'];
};


export type QueryCollectBoCheckoutListingCreateDraftOrderArgs = {
  listingId: Scalars['UUID']['input'];
  quantity: Scalars['Int']['input'];
  shipToAddress: CollectBoShippingAddressInput;
  shippingOptionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollectBoCheckoutV2DraftIntentArgs = {
  accountFundsToBeApplied?: InputMaybe<Scalars['Int']['input']>;
  cryptoBalanceToBeApplied?: InputMaybe<Scalars['Int']['input']>;
  fancashBalanceToBeApplied?: InputMaybe<Scalars['Int']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  listings: Array<InputMaybe<CollectBoCheckoutOneShopInput>>;
  paymentMethodToBeUsed?: InputMaybe<CollectBoPaymentMethod>;
  rewardBalanceToBeApplied?: InputMaybe<Scalars['Int']['input']>;
  stripePaymentMethodId?: InputMaybe<Scalars['String']['input']>;
  walletBalanceToBeApplied?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectBoGetInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};


export type QueryCollectBoGetListingsForSellingPageArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyeAppealGrades?: InputMaybe<Array<InputMaybe<CollectEyeAppealGrade>>>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  gradingServices?: InputMaybe<Array<InputMaybe<GradingService>>>;
  pageNumber?: InputMaybe<Scalars['NonNegativeInteger']['input']>;
  pageSize?: InputMaybe<Scalars['NonNegativeInteger']['input']>;
  pricesRange?: InputMaybe<CollectListingPricesRangeFilter>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<CollectBoListingsForSellingPageSortDirection>;
  sortField?: InputMaybe<CollectBoListingsForSellingPageSortField>;
  status?: InputMaybe<CollectBoListingFilterStatus>;
  yearsRange?: InputMaybe<CollectListingYearsRangeFilter>;
};


export type QueryCollectBoGetMySellingListingsArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyeAppealGrades?: InputMaybe<Array<InputMaybe<CollectEyeAppealGrade>>>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  gradingServices?: InputMaybe<Array<InputMaybe<GradingService>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pricesRange?: InputMaybe<CollectListingPricesRangeFilter>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sellType?: InputMaybe<CollectBoSellType>;
  sortDirection?: InputMaybe<CollectBoMySellingListingsSortDirection>;
  sortField?: InputMaybe<CollectBoMySellingListingsSortField>;
  status?: InputMaybe<Array<InputMaybe<CollectBoListingFilterStatus>>>;
  yearsRange?: InputMaybe<CollectListingYearsRangeFilter>;
};


export type QueryCollectBoGetSaleOrdersBySellerArgs = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eyeAppealGrades?: InputMaybe<Array<InputMaybe<CollectEyeAppealGrade>>>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  fulfilmentStatus?: InputMaybe<CollectBoFulfilmentStatus>;
  gradingServices?: InputMaybe<Array<InputMaybe<GradingService>>>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  pricesRange?: InputMaybe<CollectListingPricesRangeFilter>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sellType?: InputMaybe<CollectBoSellType>;
  sortDirection?: InputMaybe<CollectBoOrdersSortDirection>;
  sortField?: InputMaybe<CollectBoOrdersSortField>;
  useProSeller?: InputMaybe<Scalars['Boolean']['input']>;
  yearsRange?: InputMaybe<CollectListingYearsRangeFilter>;
};


export type QueryCollectBoListingFoldersArgs = {
  listingStatus?: InputMaybe<Array<InputMaybe<CollectBoListingFilterStatus>>>;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryCollectBoListingsAvailableInventoryArgs = {
  listingIds: Array<Scalars['UUID']['input']>;
};


export type QueryCollectBoSearchInvoicesArgs = {
  nextPageCursor?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  paymentMethodFilter?: InputMaybe<Array<InputMaybe<CollectBoPaymentMethod>>>;
  searchStatusFilter?: InputMaybe<Array<InputMaybe<CollectBoInvoiceSearchStatus>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<CollectBoSearchInvoicesSortDirection>;
  sortField?: InputMaybe<CollectBoSearchInvoicesSortField>;
  sourceFilter?: InputMaybe<CollectBoInvoiceSource>;
};


export type QueryCollectChatgptResultsArgs = {
  items: Array<CollectSearchItemsInput>;
  prompt?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollectCheckoutDetailsArgs = {
  input: CollectCheckoutDetailsInput;
};


export type QueryCollectCheckoutV2DetailsArgs = {
  cart?: InputMaybe<CollectCheckoutV2DetailsCartInput>;
  invoice?: InputMaybe<CollectCheckoutV2DetailsInvoiceInput>;
  vaultListing?: InputMaybe<CollectCheckoutV2DetailsVaultListingInput>;
};


export type QueryCollectCheckoutV2PaymentSummaryArgs = {
  cart?: InputMaybe<CollectCheckoutV2PaymentSummaryCartInput>;
  invoice?: InputMaybe<CollectCheckoutV2PaymentSummaryInvoiceInput>;
};


export type QueryCollectDetailedArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCollectGetAuctionsForBidsPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: CollectAuctionsForBidsPageInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectGetAuctionsForSellingPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: CollectAuctionsForSellingPageInput;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectGetFanaticsCollectIdentityKeyArgs = {
  userId: Scalars['String']['input'];
};


export type QueryCollectGetLatestOffersForChannelsArgs = {
  channelIds: Array<Scalars['String']['input']>;
};


export type QueryCollectGetLatestOffersForChannelsV2Args = {
  channelCids: Array<Scalars['String']['input']>;
};


export type QueryCollectGetOfferIdsForChannelsArgs = {
  channelIds: Array<Scalars['String']['input']>;
};


export type QueryCollectGetOwnershipTransferIdentityArgs = {
  transferRecipientIdentity: Scalars['String']['input'];
};


export type QueryCollectGetOwnershipTransferSummaryArgs = {
  input: CollectCreateOwnershipTransferInput;
};


export type QueryCollectGetPickUpInPersonSummaryArgs = {
  input: CollectCreatePickUpInPersonInput;
};


export type QueryCollectGetRedemptionSubmissionSummaryArgs = {
  input: CollectCreateRedemptionSubmissionInput;
};


export type QueryCollectGetTradeShowCheckoutSummaryArgs = {
  input: CollectCreateTradeShowCheckoutInput;
};


export type QueryCollectGetVaultItemArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCollectGetVaultItemRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCollectGetVaultItemRequestDetailsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCollectGetVaultRetrievalSummaryArgs = {
  input: CollectCreateVaultRetrievalInput;
};


export type QueryCollectGetVaultSubmissionArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCollectGetVaultSubmissionByIntegerIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCollectGetVaultSubmissionSummaryArgs = {
  input: CollectCreateVaultSubmissionInput;
};


export type QueryCollectGlobalAuctionsLongPollingArgs = {
  input?: InputMaybe<CollectAuctionIdListInput>;
};


export type QueryCollectGoogleResultsArgs = {
  items: Array<CollectSearchItemsInput>;
};


export type QueryCollectInvoiceArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCollectInvoiceV2Args = {
  input: CollectInvoiceInput;
};


export type QueryCollectItemArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCollectListParallelsArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  set: Scalars['String']['input'];
  variantId?: InputMaybe<Scalars['UUID']['input']>;
  year: Scalars['String']['input'];
};


export type QueryCollectListSavedSearchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectListVaultItemsArgs = {
  ids: Array<Scalars['UUID']['input']>;
};


export type QueryCollectListingArgs = {
  id: Scalars['UUID']['input'];
  type: CollectListingType;
};


export type QueryCollectListingFanaticsPricingInfoArgs = {
  id: Scalars['UUID']['input'];
  type: CollectListingType;
};


export type QueryCollectListingsArgs = {
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  isSold?: InputMaybe<Scalars['Boolean']['input']>;
  listingIds: Array<InputMaybe<CollectListingIdInput>>;
};


export type QueryCollectListingsByIntegerIdArgs = {
  listingIds: Array<InputMaybe<CollectListingIntegerIdInput>>;
};


export type QueryCollectMonolithicSearchArgs = {
  auction?: InputMaybe<Array<Scalars['UUID']['input']>>;
  authenticator?: InputMaybe<Array<CollectMonolithicSearchSettingAuthenticatorValue>>;
  category?: InputMaybe<Array<Array<CollectMonolithicSearchCategoryFilter>>>;
  collection?: InputMaybe<Array<Scalars['Int']['input']>>;
  eyeAppealGrade?: InputMaybe<Array<CollectMonolithicSearchSettingEyeAppealGrade>>;
  listingType: Array<CollectListingType>;
  page: Scalars['Int']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  priceRange?: InputMaybe<CollectMonolithicSearchPriceRange>;
  yearRange?: InputMaybe<CollectMonolithicSearchYearRange>;
};


export type QueryCollectMonolithicSearchOptionsArgs = {
  listingType: CollectListingType;
};


export type QueryCollectOfferArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  integerId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectOfferRoomArgs = {
  listingType?: InputMaybe<CollectListingType>;
  listingUuid: Scalars['UUID']['input'];
  offerUuid: Scalars['UUID']['input'];
};


export type QueryCollectProductArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCollectPsaResultV2Args = {
  certNumber: Scalars['String']['input'];
};


export type QueryCollectPublicUserV2Args = {
  id: Scalars['UUID']['input'];
};


export type QueryCollectRedRookiePlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectRelatedListingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  vaultItemId: Scalars['UUID']['input'];
};


export type QueryCollectRelatedListingsArgs = {
  input: CollectRelatedListingsInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectScanV3Args = {
  captureType?: InputMaybe<CollectScanCaptureType>;
  imgKey: Scalars['String']['input'];
  topK?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectScanV3ModernArgs = {
  captureType?: InputMaybe<CollectScanCaptureType>;
  imgKey: Scalars['String']['input'];
  opaqueData?: InputMaybe<Scalars['String']['input']>;
  topK?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectSearchArgs = {
  filterOpts?: InputMaybe<CollectListingFilterOpts>;
  listingFilters?: InputMaybe<CollectListingFilters>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  searchType?: InputMaybe<CollectSearchType>;
  sortBy?: InputMaybe<CollectSearchSortBy>;
};


export type QueryCollectSearchListingArgs = {
  indexName: CollectSearchListingIndexName;
  params: CollectSearchParamsInput;
  prebuiltFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryCollectSearchProductArgs = {
  params: CollectSearchParamsInput;
};


export type QueryCollectSearchSettingArgs = {
  proBuyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CollectSearchType>;
};


export type QueryCollectTopFanAdditionsArgs = {
  amount?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectVariantArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCollectVaultItemFanaticsPricingInfoArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCollectVaultItemsChecklistArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  checklistId: Scalars['UUID']['input'];
  filterListable?: InputMaybe<Scalars['Boolean']['input']>;
  filterListed?: InputMaybe<Scalars['Boolean']['input']>;
  filterProtoItemUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  filterStatus?: InputMaybe<CollectVaultStatus>;
  filterVaultItemGroupId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  grade?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  gradingServiceIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  itemType?: InputMaybe<RepackItemType>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  origins?: InputMaybe<Array<InputMaybe<CollectVaultItemOriginType>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CollectVaultSortBy>;
  state?: InputMaybe<CollectVaultItemState>;
  vaultSubmission?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryCollectVaultItemsEditHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectVaultItemsForRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  available?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids: Array<InputMaybe<Scalars['UUID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  requestType: CollectVaultItemsForRequestInputType;
};


export type QueryCollectVaultListingFoldersArgs = {
  listingStatus?: InputMaybe<Array<InputMaybe<CollectListingStatusFilter>>>;
  listingType: CollectListingType;
  pageNumber: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
};


export type QueryCollectionsCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectionsCustomListArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCollectionsCustomListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCollectionsItemArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryCollectionsItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<CollectionsItemsFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCreditPurchaseTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCurrentBreakArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type QueryCurrentBreakGameArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type QueryCurrentBreakSpotAuctionArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type QueryCurrentGiveawayArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type QueryDebugArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type QueryDebutPackEligibleArgs = {
  livestreamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};


export type QueryDebutPackEligibleUsersArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type QueryFeatureFlagsArgs = {
  input: FeatureFlagsInput;
};


export type QueryGetBreakTemplateArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetCategoryHierarchyArgs = {
  shopId: Scalars['UUID']['input'];
};


export type QueryGetGradingServicesArgs = {
  shopId: Scalars['UUID']['input'];
};


export type QueryGetItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['Int']['input']>;
  filterListable?: InputMaybe<Scalars['Boolean']['input']>;
  filterListed?: InputMaybe<Scalars['Boolean']['input']>;
  filterVaultItemGroupId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['UUID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<CollectVaultSortBy>;
  state?: InputMaybe<CollectVaultItemStateArg>;
  type?: InputMaybe<ItemType>;
  vaultSubmission?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetItemsInCollectionArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};


export type QueryGetItemsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['Int']['input']>;
  filterListable?: InputMaybe<Scalars['Boolean']['input']>;
  filterListed?: InputMaybe<Scalars['Boolean']['input']>;
  filterVaultItemGroupId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['UUID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortByValues?: InputMaybe<SortByValues>;
  state?: InputMaybe<CollectVaultItemStateArg>;
  type?: InputMaybe<ItemType>;
  vaultSubmission?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetItemsV3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['Int']['input']>;
  filterListable?: InputMaybe<Scalars['Boolean']['input']>;
  filterListed?: InputMaybe<Scalars['Boolean']['input']>;
  filterVaultItemGroupId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  itemIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['UUID']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortByValues?: InputMaybe<SortByValues>;
  state?: InputMaybe<CollectVaultItemStateArg>;
  type?: InputMaybe<ItemType>;
  vaultSubmission?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGetItemsV4Args = {
  input: GetItemsV4Input;
};


export type QueryGetListingArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGetListingsArgs = {
  shopId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetLivestreamByProductArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['UUID']['input'];
};


export type QueryGetLogoPathArgs = {
  id: Scalars['UUID']['input'];
  type: ProfileType;
};


export type QueryGetPollArgs = {
  input: PollGetInput;
};


export type QueryGetPollsArgs = {
  input: PollsGetInput;
};


export type QueryGetPromoCodeArgs = {
  promoCode: Scalars['String']['input'];
  shopId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryGetRepackArgs = {
  input: GetRepackInput;
};


export type QueryGetRepacksArgs = {
  input?: InputMaybe<GetRepacksInput>;
};


export type QueryGetRepacksPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input?: InputMaybe<GetRepacksInputV2>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRippedPackArgs = {
  input: GetRippedPackInput;
};


export type QueryGetUploadLogoUrlArgs = {
  fileName: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  type: ProfileType;
};


export type QueryGetUserTokenArgs = {
  code: Scalars['String']['input'];
};


export type QueryGetVaultItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['Int']['input']>;
  filterListable?: InputMaybe<Scalars['Boolean']['input']>;
  filterListed?: InputMaybe<Scalars['Boolean']['input']>;
  filterProtoItemUuid?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  filterVaultItemGroupId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortByV2?: InputMaybe<VaultSortBy>;
  state?: InputMaybe<CollectVaultItemStateArg>;
  vaultSubmission?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryHealthCheckArgs = {
  input: HealthCheckInput;
};


export type QueryImageUrlArgs = {
  fileName: Scalars['String']['input'];
};


export type QueryIntrospectArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIsPromoCodeValidArgs = {
  promoCode: Scalars['String']['input'];
  shopId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryIsSessionAliveArgs = {
  applicationClientId: Scalars['String']['input'];
};


export type QueryLeagueArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<LeagueTypes>;
};


export type QueryLeagueMembersArgs = {
  leagueId: Scalars['UUID']['input'];
};


export type QueryLeaguesArgs = {
  referenced?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryListBreakTemplatesArgs = {
  breakTemplateChecklistOnly?: InputMaybe<Scalars['Boolean']['input']>;
  shopId: Scalars['UUID']['input'];
};


export type QueryListLiveSupportTicketCommentsArgs = {
  ticketId: Scalars['Int']['input'];
};


export type QueryListLivestreamsArgs = {
  idList: Array<Scalars['UUID']['input']>;
};


export type QueryListRedeemablePromoCodesArgs = {
  shopId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryListShopLiveSupportTicketsArgs = {
  shopId: Scalars['UUID']['input'];
  statusFilter?: InputMaybe<TicketStatus>;
};


export type QueryLiveProgressiveBreaksArgs = {
  input?: InputMaybe<LiveProgressiveBreaksInput>;
};


export type QueryLiveStreamArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryLiveStreamByAccessCodeArgs = {
  accessCode: Scalars['String']['input'];
};


export type QueryLiveStreamByNameArgs = {
  name: Scalars['String']['input'];
};


export type QueryLiveStreamRaidArgs = {
  currentLiveStreamId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QueryLiveStreamRecommendationArgs = {
  currentLiveStreamId: Scalars['UUID']['input'];
};


export type QueryLiveStreamRecommendationV2Args = {
  currentLiveStreamId: Scalars['UUID']['input'];
};


export type QueryLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBreakWithSlotsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  leagueId?: InputMaybe<Scalars['UUID']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
  startsAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startsBefore?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<LiveStreamStatus>;
};


export type QueryLiveStreamsByLeagueArgs = {
  leagueId?: InputMaybe<Scalars['UUID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLiveStreamsByProductSlugArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productSlug: Scalars['String']['input'];
};


export type QueryMarketplaceArgs = {
  filters?: InputMaybe<MarketplaceFilters>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceFilterLeagueMembersArgs = {
  filters?: InputMaybe<Array<InputMaybe<FormFieldModalFilter>>>;
  selected?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMarketplaceFilterLeaguesArgs = {
  selected?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMarketplaceFilterManufacturersArgs = {
  selected?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMarketplaceFilterProductsArgs = {
  filters?: InputMaybe<Array<InputMaybe<FormFieldModalFilter>>>;
  selected?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryMarketplaceSortAndFilterArgs = {
  filters?: InputMaybe<MarketplaceFilters>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaginatedSingleLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductDetailFeedbackArgs = {
  typeId: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ProductSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryPublicUserArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPublicUserByUsernameArgs = {
  username: Scalars['String']['input'];
};


export type QueryRecommendedShopsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReferralCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryReferralCodeForShopArgs = {
  slug: Scalars['String']['input'];
};


export type QueryReferralCodeForShopV2Args = {
  slug: Scalars['String']['input'];
};


export type QueryReferralCodeShopArgs = {
  code: Scalars['String']['input'];
};


export type QueryReferralCodeShopV2Args = {
  code: Scalars['String']['input'];
};


export type QueryRestrictedUsersByLivestreamArgs = {
  livestreamId: Scalars['UUID']['input'];
};


export type QueryRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchProductsArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchProductsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productType?: InputMaybe<ProductTypeV2>;
  query: Scalars['String']['input'];
};


export type QuerySearchShopProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isDigital?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productType?: InputMaybe<ProductTypeV2>;
  query: Scalars['String']['input'];
};


export type QueryShippingProfilesArgs = {
  input: ShopInput;
};


export type QueryShopArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryShopAnalyticsReportDownloadArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryShopAnalyticsReportsArgs = {
  shopId: Scalars['UUID']['input'];
};


export type QueryShopBreakSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  leagueFilter?: InputMaybe<Array<InputMaybe<LeagueTypes>>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  shopFilter?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  sortBy?: InputMaybe<ShopBreakSearchSortKey>;
};


export type QueryShopInventoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ProductFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  input: ShopInventoryInput;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<ProductSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
};


export type QueryShopMetricsHistoryArgs = {
  input: ShopMetricsHistoryInput;
};


export type QueryShopMetricsSummaryArgs = {
  input: ShopMetricsSummaryInput;
};


export type QueryShopReferralAnalyticsArgs = {
  input: ReferralAnalyticsFilterInput;
};


export type QueryStaffLiveStreamArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySuggestUsernamesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  email: Scalars['String']['input'];
};


export type QueryToppsProductDetailsPageArgs = {
  pageUid: Scalars['String']['input'];
};


export type QueryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionsAggregateArgs = {
  creditOrDebit?: InputMaybe<CreditDebit>;
  transactionTypes?: InputMaybe<Array<InputMaybe<WalletTransactionType>>>;
};


export type QueryUserBanStatusArgs = {
  livestreamId: Scalars['UUID']['input'];
};


export type QueryUsernameTakenArgs = {
  username: Scalars['String']['input'];
};


export type QueryUsersAutocompleteArgs = {
  searchString: Scalars['String']['input'];
};


export type QueryVerifyAccessCodeArgs = {
  code: Scalars['String']['input'];
};

export type QuickCreateBreakInput = {
  /** The scanned barcode of the product to be sold */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** Cost basis of the listing */
  costInCents?: InputMaybe<Scalars['Int']['input']>;
  leagueId?: InputMaybe<Scalars['UUID']['input']>;
  /** The livestream to associated the break with. Later this can be nullable */
  liveStreamId?: InputMaybe<Scalars['UUID']['input']>;
  /** Listing price */
  priceInCents: Scalars['Int']['input'];
  /** Shipping profile */
  shippingProfileId?: InputMaybe<Scalars['UUID']['input']>;
  /** The shop that the break should be created in */
  shopId: Scalars['UUID']['input'];
  /** Client listing title override */
  titleOverride?: InputMaybe<Scalars['String']['input']>;
};

export type QuickCreateBreakPayload = {
  __typename?: 'QuickCreateBreakPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<QuickCreateBreakResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type QuickCreateBreakResponse = {
  __typename?: 'QuickCreateBreakResponse';
  break?: Maybe<Break>;
};

export type Rail = {
  id: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  railType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type RailConnection = {
  __typename?: 'RailConnection';
  edges?: Maybe<Array<Maybe<RailEdge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RailEdge = {
  __typename?: 'RailEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Rail>;
};

/** The randomization event status of a live stream */
export type Randomization = {
  __typename?: 'Randomization';
  breakSpots: Array<BreakSpot>;
  randomizationResult?: Maybe<Scalars['String']['output']>;
  randomizationType?: Maybe<RandomizationType>;
};

/** The randomization event status of a live stream */
export type RandomizationResult = {
  __typename?: 'RandomizationResult';
  breakSpots: Array<BreakSpot>;
  liveStreamId: Scalars['UUID']['output'];
  randomizationId: Scalars['UUID']['output'];
  randomizationResult: Scalars['UUID']['output'];
  randomizationStatus?: Maybe<RandomizationStatus>;
  randomizationType?: Maybe<RandomizationType>;
};

/** The randomization status */
export enum RandomizationStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS'
}

/** The type of a randomization event of a live stream */
export enum RandomizationType {
  SelectSpots = 'SELECT_SPOTS'
}

/** Input object for randomizing break spots */
export type RandomizeBreakSpotsInput = {
  breakId: Scalars['UUID']['input'];
};

export type RandomizeBreakSpotsPayload = {
  __typename?: 'RandomizeBreakSpotsPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<RandomizeBreakSpotsResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type RandomizeBreakSpotsResponse = {
  __typename?: 'RandomizeBreakSpotsResponse';
  break?: Maybe<Break>;
};

/** Parameters for randomizing a live stream spots. */
export type RandomizeLiveStreamSpotsInput = {
  /** The ID of the object we want to update */
  id: Scalars['ID']['input'];
  selectSpotIds: Array<Scalars['ID']['input']>;
  type: RandomizationType;
};

export type RandomizeLiveStreamSpotsPayload = {
  __typename?: 'RandomizeLiveStreamSpotsPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveStreamSpotsRandomizationResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export enum RangeOptions {
  AllTime = 'ALL_TIME'
}

/** The types of an entity */
export enum ReceiptType {
  Auction = 'AUCTION',
  Giveaway = 'GIVEAWAY'
}

export type ReceiveCsvExportResponse = {
  __typename?: 'ReceiveCsvExportResponse';
  /** Error message if the export failed, null on success */
  error?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

/** The Shop's referral analytics */
export type ReferralAnalytics = {
  __typename?: 'ReferralAnalytics';
  /** The count of users referred by a shop */
  friendsCount: Scalars['Int']['output'];
  /** The total earning made so far by shop through referrals */
  totalEarnings: MoneyAmount;
};

/** Input object for filtering referral analytics */
export type ReferralAnalyticsFilterInput = {
  /** filter used to request referral analytics in a specific days range */
  range: RangeOptions;
  /** UUID of Shop */
  shopId: Scalars['UUID']['input'];
};

/** A code issued by a user which they can use to refer others to the platform */
export type ReferralCode = {
  __typename?: 'ReferralCode';
  /** The amount the referee and referrer will receive once the referral is complete (in cents) */
  amount: MoneyAmount;
  /** The current cap for the referral */
  cap: Scalars['Int']['output'];
  /** The referral code */
  code: Scalars['String']['output'];
  /** The sharable url for the referral */
  url: Scalars['String']['output'];
  /** The user that issued the referral code */
  user: User;
};

/** The type of response to serve for apply referral code mutation */
export type ReferralCodeResponse = {
  __typename?: 'ReferralCodeResponse';
  /** Denotes the success or failure of a mutation */
  status: Scalars['String']['output'];
};

export type ReferralCodeResponsePayload = {
  __typename?: 'ReferralCodeResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ReferralCodeResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** A refund object */
export type Refund = {
  __typename?: 'Refund';
  /** The break order associated with the refund */
  breakOrder?: Maybe<BreakOrder>;
  /** The reason for the refund failure, if any */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** Notes related to the refund */
  notes?: Maybe<Scalars['String']['output']>;
  /** The reason for the refund */
  reason?: Maybe<RefundReason>;
  /** The amount refunded, in cents */
  refundAmountInCents?: Maybe<Scalars['Int']['output']>;
  /** The unique ID of the refund */
  refundId: Scalars['String']['output'];
  /** The status of the refund */
  status?: Maybe<Scalars['String']['output']>;
  /** The transaction code associated with the refund */
  transactionCode?: Maybe<Scalars['String']['output']>;
};

/** Reason for refunding a break spot */
export enum RefundReason {
  /** Refund due to a duplicate purchase */
  Duplicate = 'DUPLICATE',
  /** Refund requested by the customer */
  RequestedByCustomer = 'REQUESTED_BY_CUSTOMER'
}

/** Parameters for refunding a spot in a break */
export type RefundSpotInput = {
  /** The ID of the break spot to be refunded */
  breakSpotId: Scalars['UUID']['input'];
  /** Notes related to the reason the break spot is refunded */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The reason the break spot is refunded */
  refundReason: RefundReason;
};

export type RefundSpotPayload = {
  __typename?: 'RefundSpotPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<RefundSpotResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The response from refunding a spot in a break */
export type RefundSpotResponse = {
  __typename?: 'RefundSpotResponse';
  /** The spot that was refunded */
  breakSpot: BreakSpot;
  /** The refund object */
  refund: Refund;
  /** The user who was refunded */
  user: UpdatedUser;
};

export type RemoveItemsFromChecklistInput = {
  checklistId: Scalars['UUID']['input'];
  itemIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type RemoveItemsFromChecklistPayload = {
  __typename?: 'RemoveItemsFromChecklistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Repack>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** A repack object */
export type Repack = {
  __typename?: 'Repack';
  /**
   * Boolean wether or not the checklist is a child
   * @deprecated Repack allocation is deprecated
   */
  allocatedRepack?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The number of items not yet in a break
   * @deprecated Please use availablePackCount instead
   */
  availableItemCount: Scalars['Int']['output'];
  /** The number of pack not yet added in a break */
  availablePackCount: Scalars['Int']['output'];
  /** The average value of the repack in cents */
  averageValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The number of base items in the repack */
  baseCount?: Maybe<Scalars['Int']['output']>;
  /** The high value of the base range in cents */
  baseRangeHighInCents?: Maybe<Scalars['Int']['output']>;
  /** The low value of the base range in cents */
  baseRangeLowInCents?: Maybe<Scalars['Int']['output']>;
  /** The break template associated with this checklist */
  breakTemplate?: Maybe<BreakTemplate>;
  /** The categories of the repack */
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ceiling value of the repack in cents */
  ceilingValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The number of chase items in the repack */
  chaseCount?: Maybe<Scalars['Int']['output']>;
  /** The high value of the chase range in cents */
  chaseRangeHighInCents?: Maybe<Scalars['Int']['output']>;
  /** The low value of the chase range in cents */
  chaseRangeLowInCents?: Maybe<Scalars['Int']['output']>;
  /** The hexadecimal color of the checklist */
  color?: Maybe<Scalars['String']['output']>;
  /** The description of the repack */
  description?: Maybe<Scalars['String']['output']>;
  /** The floor value of the repack in cents */
  floorValueInCents?: Maybe<Scalars['Int']['output']>;
  /** The number of grail items in the repack */
  grailCount?: Maybe<Scalars['Int']['output']>;
  /** The high value of the grail range in cents */
  grailRangeHighInCents?: Maybe<Scalars['Int']['output']>;
  /** The low value of the grail range in cents */
  grailRangeLowInCents?: Maybe<Scalars['Int']['output']>;
  /** Whether the repack has instant credit */
  hasInstantCredit: Scalars['Boolean']['output'];
  /** The datetime when the repack was hidden */
  hiddenAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the repack */
  id: Scalars['ID']['output'];
  /** The internal title of the repack */
  internalTitle?: Maybe<Scalars['String']['output']>;
  /** Whether the repack is dynamic */
  isDynamic?: Maybe<Scalars['Boolean']['output']>;
  /** The MSRP of the repack in cents */
  msrpInCents?: Maybe<Scalars['Int']['output']>;
  /** The texture category of the repack */
  packTextureCategory?: Maybe<PackTextureCategory>;
  /** The tier of the repack */
  packTier?: Maybe<Scalars['Int']['output']>;
  /** Product */
  product?: Maybe<Product>;
  /** The product id of the repack */
  productId: Scalars['UUID']['output'];
  /** The repack configuration */
  repackConfiguration?: Maybe<RepackConfiguration>;
  /** The datetime when the repack was sealed */
  sealedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the repack is a starter pack */
  starterPack: Scalars['Boolean']['output'];
  /** The status of the repack */
  status: RepackStatus;
  /**
   * The texture url for the checklist
   * @deprecated Use product.image_paths instead
   */
  textureUrl?: Maybe<Scalars['String']['output']>;
  /** The title of the repack */
  title: Scalars['String']['output'];
  /** The total number of items in a repack */
  totalItemCount: Scalars['Int']['output'];
  /** The total number of packs in a repack */
  totalPackCount: Scalars['Int']['output'];
  /** The type of the checklist (regular, dynamic, wax) */
  type?: Maybe<RepackType>;
  /** The variant field of the repack */
  variant: RepackVariant;
  /** The email address of the vault source user for dynamic checklists */
  vaultSourceEmail?: Maybe<Scalars['String']['output']>;
  /** The vault tenant ID used to source items for dynamic checklists */
  vaultSourceTenantId?: Maybe<Scalars['UUID']['output']>;
};

export type RepackConfiguration = {
  __typename?: 'RepackConfiguration';
  /** Tolerance for average value deviation */
  avgValueTolerance?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of base cards required */
  baseMinCount?: Maybe<Scalars['Int']['output']>;
  /** Tolerance for base odds deviation */
  baseOddsTolerance?: Maybe<Scalars['Int']['output']>;
  /** Target odds percentage for base cards */
  baseTargetOdds?: Maybe<Scalars['Float']['output']>;
  /** Tolerance for ceiling value deviation */
  ceilingValueTolerance?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of chase cards required */
  chaseMinCount?: Maybe<Scalars['Int']['output']>;
  /** Tolerance for chase odds deviation */
  chaseOddsTolerance?: Maybe<Scalars['Int']['output']>;
  /** Target odds percentage for chase cards */
  chaseTargetOdds?: Maybe<Scalars['Float']['output']>;
  /** Tolerance for floor value deviation */
  floorValueTolerance?: Maybe<Scalars['Int']['output']>;
  /** Minimum number of grail cards required */
  grailMinCount?: Maybe<Scalars['Int']['output']>;
  /** Tolerance for grail odds deviation */
  grailOddsTolerance?: Maybe<Scalars['Int']['output']>;
  /** Target odds percentage for grail cards */
  grailTargetOdds?: Maybe<Scalars['Float']['output']>;
  /** The number of items per pack */
  perPack?: Maybe<Scalars['Int']['output']>;
};

/** Input for configuring the checklist */
export type RepackConfigurationInput = {
  /** Tolerance for average value deviation */
  avgValueTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of base cards required */
  baseMinCount?: InputMaybe<Scalars['Int']['input']>;
  /** Tolerance for base odds deviation */
  baseOddsTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Target odds percentage for base cards */
  baseTargetOdds?: InputMaybe<Scalars['Float']['input']>;
  /** Tolerance for ceiling value deviation */
  ceilingValueTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of chase cards required */
  chaseMinCount?: InputMaybe<Scalars['Int']['input']>;
  /** Tolerance for chase odds deviation */
  chaseOddsTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Target odds percentage for chase cards */
  chaseTargetOdds?: InputMaybe<Scalars['Float']['input']>;
  /** Tolerance for floor value deviation */
  floorValueTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of grail cards required */
  grailMinCount?: InputMaybe<Scalars['Int']['input']>;
  /** Tolerance for grail odds deviation */
  grailOddsTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Target odds percentage for grail cards */
  grailTargetOdds?: InputMaybe<Scalars['Float']['input']>;
  /** Configure the number of items per pack */
  perPack: Scalars['Int']['input'];
};

export type RepackConnection = {
  __typename?: 'RepackConnection';
  edges?: Maybe<Array<Maybe<RepackEdge>>>;
  pageInfo: PageInfo;
};

export type RepackEdge = {
  __typename?: 'RepackEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Repack>;
};

/** The payload to create each item */
export type RepackItemInput = {
  /** The break template spot ID to assign to this item */
  breakTemplateSpotId?: InputMaybe<Scalars['UUID']['input']>;
  /** Whether the item has buyback enabled */
  buybackPopulationEnabled: Scalars['Boolean']['input'];
  /** The proto item UUID of the item */
  protoItemUuid: Scalars['UUID']['input'];
  /** The title of the item */
  title: Scalars['String']['input'];
  /** An item to include in the repack */
  type?: InputMaybe<RepackItemType>;
  /** The vault ID of the item */
  vaultId: Scalars['UUID']['input'];
};

/** Reveal state of a repack item */
export enum RepackItemRevealState {
  /** The item has been completed */
  Complete = 'COMPLETE',
  /** The item is ready to be revealed */
  Ready = 'READY',
  /** The item is shrouded and not visible */
  Shrouded = 'SHROUDED',
  /** The item is visible */
  Visible = 'VISIBLE'
}

/** Enum for the status of the item */
export enum RepackItemStatus {
  /** Base card */
  Base = 'BASE',
  /** Chase card */
  Chase = 'CHASE',
  /** Grail card */
  Grail = 'GRAIL'
}

/** Enum for the status of the item */
export enum RepackItemType {
  /** Base card */
  Base = 'BASE',
  /** Chase card */
  Chase = 'CHASE',
  /** Grail card */
  Grail = 'GRAIL'
}

/** The status of a repack */
export enum RepackStatus {
  /** The repack is awaiting refill */
  AwaitingRefill = 'AWAITING_REFILL',
  /** The repack is decommissioned */
  Decommissioned = 'DECOMMISSIONED',
  /** The repack is in draft status */
  Draft = 'DRAFT',
  /** The repack is ready to seal after pre-checks */
  ReadyToSeal = 'READY_TO_SEAL',
  /** The repack is sealed */
  Sealed = 'SEALED',
  /** The repack is sealing failed */
  SealingFailed = 'SEALING_FAILED',
  /** The repack is sealing in progress */
  SealingInProgress = 'SEALING_IN_PROGRESS',
  /** The repack is sold out */
  SoldOut = 'SOLD_OUT'
}

export enum RepackType {
  /** Break template repack */
  BreakTemplate = 'BREAK_TEMPLATE',
  /** Dynamic repack */
  Dynamic = 'DYNAMIC',
  /** Regular repack */
  Regular = 'REGULAR',
  /** Wax repack */
  Wax = 'WAX'
}

/** The variant of the repack (standard, gold) */
export enum RepackVariant {
  Gold = 'GOLD',
  Standard = 'STANDARD'
}

/** The status of Shop analytics custom csv report */
export enum ReportStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

/** The type of a Shop Analytics Report */
export enum ReportType {
  Revenue = 'REVENUE',
  Transaction = 'TRANSACTION'
}

/** Parameters for requesting a custom csv export */
export type RequestAnalyticsCsvExportInput = {
  endsAt: Scalars['DateTime']['input'];
  liveStreamId?: InputMaybe<Scalars['UUID']['input']>;
  reportType: ReportType;
  shopId: Scalars['UUID']['input'];
  startsAt: Scalars['DateTime']['input'];
};

/** Parameters for requesting a csv export */
export type RequestCsvExportInput = {
  shopId: Scalars['UUID']['input'];
};

export type RequestCsvExportPayload = {
  __typename?: 'RequestCsvExportPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<RequestCsvExportResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type RequestCsvExportResponse = {
  __typename?: 'RequestCsvExportResponse';
  taskId: Scalars['UUID']['output'];
};

export type RequestReferralsCsvExportPayload = {
  __typename?: 'RequestReferralsCsvExportPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<RequestCsvExportResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type RequestShopAnalyticsCustomReportCsvExportPayload = {
  __typename?: 'RequestShopAnalyticsCustomReportCsvExportPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<RequestCsvExportResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for resetting current user's password */
export type ResetPasswordInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type ResetPasswordPayload = {
  __typename?: 'ResetPasswordPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<TokenPair>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type RestrictUserInput = {
  /** The last messages that triggered the restriction */
  lastMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The ID of the live stream */
  liveStreamId: Scalars['UUID']['input'];
  /** The reasons for the restriction */
  reasons?: InputMaybe<Array<InputMaybe<RestrictionReason>>>;
  /** The ID of the user to restrict */
  restrictedUserId: Scalars['UUID']['input'];
};

export type RestrictUserPayload = {
  __typename?: 'RestrictUserPayload';
  result?: Maybe<RestrictUserResult>;
};

export type RestrictUserResult = {
  __typename?: 'RestrictUserResult';
  /** Message indicating the result of the restriction attempt */
  message: Scalars['String']['output'];
  /** Whether the restriction operation was successful */
  success: Scalars['Boolean']['output'];
};

/** Reasons for restricting a user in chat */
export enum RestrictionReason {
  /** Harassment or bullying */
  Harassment = 'HARASSMENT',
  /** Hate speech or discrimination */
  HateSpeech = 'HATE_SPEECH',
  /** Promoting illegal activities */
  IllegalActivities = 'ILLEGAL_ACTIVITIES',
  /** Impersonation or misleading identity */
  Impersonation = 'IMPERSONATION',
  /** Inappropriate language or content */
  Inappropriate = 'INAPPROPRIATE',
  /** Other violation of community guidelines */
  OtherViolation = 'OTHER_VIOLATION',
  /** Sharing personal information */
  PersonalInfo = 'PERSONAL_INFO',
  /** Spam or excessive messaging */
  Spam = 'SPAM',
  /** Violating platform terms of use */
  TosViolation = 'TOS_VIOLATION'
}

export type Result = {
  __typename?: 'Result';
  message?: Maybe<Scalars['String']['output']>;
};

export type RevealInfo = {
  __typename?: 'RevealInfo';
  /** Details of the shop that sold the pack containing this revealed card */
  shop?: Maybe<Shop>;
  /** Details of the user that won the card */
  user?: Maybe<PublicUser>;
};

export type RevealInput = {
  /** The ID of the break spot to be revealed */
  breakSpotId: Scalars['UUID']['input'];
};

export type RevealItemInput = {
  /** The item ID of the item to be revealed */
  itemId: Scalars['UUID']['input'];
};

export type RevealSpotPayload = {
  __typename?: 'RevealSpotPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<BreakSpot>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export enum RevealStatus {
  /** Return all cards regardless of their reveal status (default). */
  All = 'ALL',
  /** Return only cards that are still available for future pulls. */
  Available = 'AVAILABLE',
  /** Return only cards that have been revealed in previous pack openings. */
  Revealed = 'REVEALED'
}

/** A reward in a user's wallet, representing credits that can be applied to purchases with their types and states */
export type Reward = {
  __typename?: 'Reward';
  /** The current balance of the reward */
  balance: MoneyAmount;
  /** A unique identifier for the reward. In the case of a referral reward, it represents the advocate's slug or username. Otherwise, it is a unique code used to add credit to the wallet. */
  code: Scalars['String']['output'];
  /** The date and time at which the reward will expire */
  expiryDate: Scalars['DateTime']['output'];
  /** The current status of the reward */
  status: RewardStatus;
  /** The type of the reward */
  type: RewardType;
};

/** A code issued by Fanatics Live which can be redeemed for credit in a customer's wallet */
export type RewardCode = {
  __typename?: 'RewardCode';
  /** The reward code */
  code: Scalars['String']['output'];
  /** The monetary value of the code */
  value: MoneyAmount;
};

export type RewardConnection = {
  __typename?: 'RewardConnection';
  balanceExpires?: Maybe<MoneyAmount>;
  edges?: Maybe<Array<Maybe<RewardEdge>>>;
  pageInfo: PageInfo;
};

export type RewardEdge = {
  __typename?: 'RewardEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Reward>;
};

export type RewardResponse = {
  __typename?: 'RewardResponse';
  custom?: Maybe<Custom>;
  giveaway?: Maybe<Giveaway>;
};

export type RewardResponsePayload = {
  __typename?: 'RewardResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<RewardResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export enum RewardStatus {
  /** The reward has been fully consumed and applied to a purchase. */
  Applied = 'APPLIED',
  /** The reward is available for use in a purchase, as it has not been fully consumed and has not passed its expiry date. */
  Available = 'AVAILABLE',
  /** The reward has expired and is no longer valid for use, as it has passed its expiry date. */
  Expired = 'EXPIRED'
}

export enum RewardType {
  /** The reward is of the type referral */
  Referral = 'REFERRAL',
  /** The reward is of the type reward_code */
  RewardCode = 'REWARD_CODE'
}

export type RippedPack = {
  __typename?: 'RippedPack';
  breakSpot: BreakSpot;
  repack: Repack;
};

export type RotateCardInput = {
  /** Whether to flip the card */
  flip: Scalars['Boolean']['input'];
  /** The ID of the live stream */
  liveStreamId: Scalars['UUID']['input'];
  /** The orientation of the card to rotate */
  orientation?: InputMaybe<CardOrientation>;
  /** Whether the card is zoomed */
  zoom: Scalars['Boolean']['input'];
};

export type RotateCardPayload = {
  __typename?: 'RotateCardPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<RotateCardResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type RotateCardResponse = {
  __typename?: 'RotateCardResponse';
  /** The status of the card rotation */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Search result */
export type SearchResult = {
  __typename?: 'SearchResult';
  /** List of channels */
  channels?: Maybe<ChannelsSection>;
  /** List of live streams */
  liveStreams?: Maybe<LiveStreamsSection>;
  /** List of popular searches */
  popularSearches?: Maybe<PopularSearchesSection>;
  /** List of users */
  users?: Maybe<UsersSection>;
};

export enum SearchSectionType {
  /** A section with channels */
  Channels = 'CHANNELS',
  /** A section with live streams */
  LiveStreams = 'LIVE_STREAMS',
  /** A section with popular searches */
  PopularSearches = 'POPULAR_SEARCHES',
  /** A section with users */
  Users = 'USERS'
}

export enum SectionDisplayType {
  /** Display items in a grid layout */
  Grid = 'GRID',
  /** Display items in a horizontal rail layout */
  Rail = 'RAIL'
}

export type SectionV2 = {
  displayType: SectionDisplayType;
  id: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  sectionType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SectionV2Connection = {
  __typename?: 'SectionV2Connection';
  edges?: Maybe<Array<Maybe<SectionV2Edge>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SectionV2Edge = {
  __typename?: 'SectionV2Edge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<SectionV2>;
};

export type SeenFlyoutCount = {
  __typename?: 'SeenFlyoutCount';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  value: Scalars['Int']['output'];
};

export type SeenFlyoutCountInput = {
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** How many times the flyout has been shown and when that count expires */
  value: Scalars['Int']['input'];
};

/** Input for SEON login fraud check (web platform only) */
export type SeonLoginFraudCheckInput = {
  /** SEON device fingerprint identifier */
  seonIdentifier: Scalars['String']['input'];
};

export type SeonLoginFraudCheckPayload = {
  __typename?: 'SeonLoginFraudCheckPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<SeonLoginFraudCheckResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type SeonLoginFraudCheckResponse = {
  __typename?: 'SeonLoginFraudCheckResponse';
  success: Scalars['Boolean']['output'];
};

/** Input for SEON register fraud check (web platform only) */
export type SeonRegisterFraudCheckInput = {
  /** SEON device fingerprint identifier */
  seonIdentifier: Scalars['String']['input'];
};

export type SeonRegisterFraudCheckPayload = {
  __typename?: 'SeonRegisterFraudCheckPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<SeonRegisterFraudCheckResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type SeonRegisterFraudCheckResponse = {
  __typename?: 'SeonRegisterFraudCheckResponse';
  success: Scalars['Boolean']['output'];
};

/** Set onboarding as completed */
export type SetAccountFlagsInput = {
  /** True if the user finished onboarding process. Only true is allowed */
  onboardingComplete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SetAccountFlagsPayload = {
  __typename?: 'SetAccountFlagsPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<UpdatedUser>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type SetBuybackPopulationEnabledInput = {
  checklistPoolItemId: Scalars['UUID']['input'];
  enabled: Scalars['Boolean']['input'];
};

export type SetBuybackPopulationEnabledPayload = {
  __typename?: 'SetBuybackPopulationEnabledPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ZeroChecklistPoolItem>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for setting the current break in a live stream. */
export type SetCurrentBreakInput = {
  /** The ID of the break we want to set as current */
  breakId: Scalars['ID']['input'];
  /** The ID of the object we want to update */
  liveStreamId: Scalars['ID']['input'];
};

export type SetCurrentBreakPayload = {
  __typename?: 'SetCurrentBreakPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveStreamResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type SetStreamingProviderInput = {
  liveStreamId: Scalars['UUID']['input'];
  streamingProvider: StreamingProvider;
};

export type ShadowBanInput = {
  /** The last messages that triggered the restriction */
  lastMessages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The ID of the live stream */
  liveStreamId: Scalars['UUID']['input'];
  /** The ID of the user to restrict */
  mutedUserId: Scalars['UUID']['input'];
  /** The reasons for the restriction */
  reasons?: InputMaybe<Array<InputMaybe<RestrictionReason>>>;
};

export type ShadowBanPayload = {
  __typename?: 'ShadowBanPayload';
  result?: Maybe<ShadowBanResult>;
};

export type ShadowBanResult = {
  __typename?: 'ShadowBanResult';
  /** Message indicating the result of the restriction attempt */
  message: Scalars['String']['output'];
  /** Whether the restriction operation was successful */
  success: Scalars['Boolean']['output'];
};

export type ShippingProfile = {
  __typename?: 'ShippingProfile';
  address?: Maybe<Address>;
  carrier?: Maybe<Carrier>;
  dimensions?: Maybe<Dimensions>;
  fixedRate?: Maybe<MoneyAmount>;
  fixedRateLocal?: Maybe<MoneyAmount>;
  id: Scalars['UUID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  mailingName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  weight?: Maybe<Weight>;
};

/** Information about a shop */
export type Shop = {
  __typename?: 'Shop';
  /**
   * Paginated list of live streams which contain all live and upcoming live streams from the
   * specified shop
   */
  availableLiveStreams?: Maybe<LiveStreamConnection>;
  /** The shop's channels */
  channels: Array<Channel>;
  /**
   * Paginated list of live streams which contain all completed live streams that has been broadcast
   * from the specified shop
   * @deprecated This query was used to list streams with replays, not completed ones.
   * Therefore, use the `liveStreamsWithReplays` instead
   */
  completedLiveStreams?: Maybe<LiveStreamConnection>;
  /**
   * The shop's country
   * @deprecated Use countryV2 instead
   */
  country: Scalars['String']['output'];
  /** The shop's country */
  countryV2: Country;
  /** The shop's currency */
  currency: Scalars['String']['output'];
  /** The shop's description */
  description?: Maybe<Scalars['String']['output']>;
  /** The total number of users who follow a shop */
  followerCount: Scalars['Int']['output'];
  /**
   * The users who follow a shop
   * @deprecated This field is deprecated and will be removed in future versions, use subscribers instead.
   */
  followers: Array<PublicUser>;
  /** The shop's unique ID */
  id: Scalars['UUID']['output'];
  /** Whether the current user is following the shop */
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  /** Link to external websites and platforms */
  links: Links;
  /**
   * The shop's live streams
   * @deprecated Field has been replaced
   */
  liveStreams?: Maybe<LiveStreamConnection>;
  /**
   * Paginated list of live streams which contain all live streams with replays that has been broadcast
   * from the specified shop
   */
  liveStreamsWithReplays?: Maybe<LiveStreamConnection>;
  /** The url to the shop's logo */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The shop's name */
  name: Scalars['String']['output'];
  /** Shop overall score, percent */
  scoreOverallPercent?: Maybe<Scalars['Int']['output']>;
  /** Shop overall score percentile, top or bottom, formatted as a string */
  scoreOverallPercentile?: Maybe<Scalars['String']['output']>;
  /** The shop's slug */
  slug: Scalars['String']['output'];
  /** The shop's staffers */
  staffers?: Maybe<Array<Maybe<Staffer>>>;
  /** The users who follow a shop, paginated */
  subscribers?: Maybe<PublicUserConnection>;
};


/** Information about a shop */
export type ShopAvailableLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deepSearchQuery?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
  startsAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startsBefore?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<LiveStreamStatus>;
  statuses?: InputMaybe<Array<InputMaybe<LiveStreamStatus>>>;
};


/** Information about a shop */
export type ShopCompletedLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deepSearchQuery?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
  startsAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startsBefore?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Information about a shop */
export type ShopLiveStreamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deepSearchQuery?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
  startsAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startsBefore?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<LiveStreamStatus>;
};


/** Information about a shop */
export type ShopLiveStreamsWithReplaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deepSearchQuery?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<LiveStreamSortKey>;
  sortDirection?: InputMaybe<SortDirection>;
  startsAfter?: InputMaybe<Scalars['DateTime']['input']>;
  startsBefore?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Information about a shop */
export type ShopSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Parameters for requesting a shop analytics custom csv report */
export type ShopAnalyticsCustomReportCreateInput = {
  duration?: InputMaybe<ShopAnalyticsDurationInput>;
  liveStreamId?: InputMaybe<Scalars['UUID']['input']>;
  reportType: ReportType;
  shopId: Scalars['UUID']['input'];
  startsAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShopAnalyticsCustomReportCreatePayload = {
  __typename?: 'ShopAnalyticsCustomReportCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ShopAnalyticsCustomReportCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type ShopAnalyticsCustomReportCreateResponse = {
  __typename?: 'ShopAnalyticsCustomReportCreateResponse';
  shopAnalyticsReportId: Scalars['UUID']['output'];
};

export type ShopAnalyticsDurationInput = {
  measurement: DurationMeasurement;
  units: Scalars['Int']['input'];
};

export type ShopAnalyticsReport = {
  __typename?: 'ShopAnalyticsReport';
  date: Scalars['Date']['output'];
  duration: Duration;
  id: Scalars['UUID']['output'];
  shop: Shop;
};

export type ShopAnalyticsReportConnection = {
  __typename?: 'ShopAnalyticsReportConnection';
  edges?: Maybe<Array<Maybe<ShopAnalyticsReportEdge>>>;
  pageInfo: PageInfo;
};

export type ShopAnalyticsReportDownload = {
  __typename?: 'ShopAnalyticsReportDownload';
  url: Scalars['String']['output'];
};

export type ShopAnalyticsReportEdge = {
  __typename?: 'ShopAnalyticsReportEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ShopAnalyticsReport>;
};

export type ShopAnalyticsReportStatusResponse = {
  __typename?: 'ShopAnalyticsReportStatusResponse';
  status: ReportStatus;
};

export type ShopAnalyticsReports = {
  __typename?: 'ShopAnalyticsReports';
  metadata: PaginatedMetadata;
  records?: Maybe<ShopAnalyticsReportConnection>;
};


export type ShopAnalyticsReportsRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ShopBreakSearchItem = {
  __typename?: 'ShopBreakSearchItem';
  break?: Maybe<Break>;
};

export type ShopBreakSearchItemConnection = {
  __typename?: 'ShopBreakSearchItemConnection';
  edges?: Maybe<Array<Maybe<ShopBreakSearchItemEdge>>>;
  pageInfo: PageInfo;
};

export type ShopBreakSearchItemEdge = {
  __typename?: 'ShopBreakSearchItemEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ShopBreakSearchItem>;
};

export enum ShopBreakSearchSortKey {
  MostRecent = 'MOST_RECENT',
  PriceHighToLow = 'PRICE_HIGH_TO_LOW',
  PriceLowToHigh = 'PRICE_LOW_TO_HIGH'
}

export type ShopInput = {
  shopId: Scalars['UUID']['input'];
};

/** A shop inventory */
export type ShopInventory = {
  __typename?: 'ShopInventory';
  /** The Break the shop product is associated to */
  breakId?: Maybe<Scalars['UUID']['output']>;
  /** The ID of the shop product */
  id: Scalars['UUID']['output'];
  /** When the shop product was added */
  insertedAt: Scalars['DateTime']['output'];
  /** The Product id of the shop product */
  product: Product;
  /** The Shop ID of the shop product */
  shopId: Scalars['UUID']['output'];
};

export type ShopInventoryInput = {
  shopId: Scalars['UUID']['input'];
};

export type ShopLiveSupportTicketsResponse = {
  __typename?: 'ShopLiveSupportTicketsResponse';
  liveSupportTickets: Array<Maybe<LiveSupportTicket>>;
};

export type ShopMetricsHistoryInput = {
  range: LiveStreamMetricAggWindow;
  shopId: Scalars['UUID']['input'];
};

export type ShopMetricsSummaryInput = {
  range: LiveStreamMetricAggWindow;
  shopId: Scalars['UUID']['input'];
};

export type ShopMetricsSummaryResponse = {
  __typename?: 'ShopMetricsSummaryResponse';
  gmvDisplay?: Maybe<Scalars['String']['output']>;
  gmvInCents?: Maybe<Scalars['Int']['output']>;
  netRevenueDisplay?: Maybe<Scalars['String']['output']>;
  netRevenueInCents?: Maybe<Scalars['Int']['output']>;
  range?: Maybe<LiveStreamMetricAggWindow>;
  topBuyers?: Maybe<Array<Maybe<TopBuyer>>>;
};

export type ShopProductCreatePayload = {
  __typename?: 'ShopProductCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ShopProductCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response object for shop product creation */
export type ShopProductCreateResponse = {
  __typename?: 'ShopProductCreateResponse';
  inventory: Array<Maybe<ShopInventory>>;
};

/** A code belonging to a shop which can be used to refer users to the platform */
export type ShopReferralCode = {
  __typename?: 'ShopReferralCode';
  /** The amount the referee and referrer will receive once the referral is complete (in cents) */
  amount: MoneyAmount;
  /** The referral code */
  code: Scalars['String']['output'];
  /** The shop the referral code belongs to */
  shop: Shop;
  /** The amount the referee needs to spend to redeem the referral code */
  spendingThresholdAmount: MoneyAmount;
};

export type ShutoffDynamicChecklistPayload = {
  __typename?: 'ShutoffDynamicChecklistPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<ShutoffDynamicChecklistResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response for shutting off a dynamic checklist */
export type ShutoffDynamicChecklistResponse = {
  __typename?: 'ShutoffDynamicChecklistResponse';
  /** The updated checklist (now in awaiting_refill status) */
  checklist?: Maybe<Repack>;
  /** ID of the created tracking record */
  constraintFailureId?: Maybe<Scalars['UUID']['output']>;
  /** Status message */
  message?: Maybe<Scalars['String']['output']>;
};

export enum SortByValues {
  /** Sort by highest value first */
  HighestValue = 'HIGHEST_VALUE',
  /** Sort by item type ascending */
  ItemTypeAsc = 'ITEM_TYPE_ASC',
  /** Sort by item type descending */
  ItemTypeDesc = 'ITEM_TYPE_DESC',
  /** Sort by lowest value first */
  LowestValue = 'LOWEST_VALUE',
  /** Sort by recently added items */
  RecentlyAdded = 'RECENTLY_ADDED',
  /** Sort by title ascending */
  TitleAsc = 'TITLE_ASC',
  /** Sort by title descending */
  TitleDesc = 'TITLE_DESC'
}

/** The sorting direction for a sorted list */
export enum SortDirection {
  /** Sort ascending */
  Asc = 'ASC',
  /** Sort descending */
  Desc = 'DESC'
}

export type Staffer = {
  __typename?: 'Staffer';
  /** The color to be used for the staffer's avatar */
  avatarColor?: Maybe<AvatarColor>;
  /** The image url to be used for the staffer's avatar */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The staffer's biography */
  biography?: Maybe<Scalars['String']['output']>;
  /** The staffer's unique ID */
  id: Scalars['UUID']['output'];
  /** Whether the current user is following this staffer */
  isFollowed?: Maybe<Scalars['Boolean']['output']>;
  /** The staffer's username */
  username: Scalars['String']['output'];
};

/** Staffer settings the user has set up */
export type StafferSettings = {
  __typename?: 'StafferSettings';
  /** Facebook streaming key */
  streamKeyFb?: Maybe<Scalars['String']['output']>;
  /** Instagram streaming key */
  streamKeyInstagram?: Maybe<Scalars['String']['output']>;
  /** Tiktok streaming key */
  streamKeyTiktok?: Maybe<Scalars['String']['output']>;
  /** Twitch streaming key */
  streamKeyTwitch?: Maybe<Scalars['String']['output']>;
  /** Youtube streaming key */
  streamKeyYoutube?: Maybe<Scalars['String']['output']>;
};

export type StafferSettingsInput = {
  /** Facebook streaming key */
  streamKeyFb?: InputMaybe<Scalars['String']['input']>;
  /** Instagram streaming key */
  streamKeyInstagram?: InputMaybe<Scalars['String']['input']>;
  /** Tiktok streaming key */
  streamKeyTiktok?: InputMaybe<Scalars['String']['input']>;
  /** Twitch streaming key */
  streamKeyTwitch?: InputMaybe<Scalars['String']['input']>;
  /** Youtube streaming key */
  streamKeyYoutube?: InputMaybe<Scalars['String']['input']>;
};

export type StartAuctionInput = {
  breakSpotId: Scalars['UUID']['input'];
  extendedBiddingRefillThresholdInSeconds?: InputMaybe<Scalars['Int']['input']>;
  initialDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  refillThresholdInSeconds?: InputMaybe<Scalars['Int']['input']>;
};

export type StartAuctionPayload = {
  __typename?: 'StartAuctionPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<StartAuctionResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type StartAuctionResponse = {
  __typename?: 'StartAuctionResponse';
  breakSpotAuction?: Maybe<BreakSpotAuction>;
};

export type StartIvsRecordingInput = {
  liveStreamId: Scalars['UUID']['input'];
};

export type StartLivekitRecordingInput = {
  liveStreamId: Scalars['UUID']['input'];
};

export type StartOneUpAuctionForFixedPriceSpotInput = {
  breakSpotId: Scalars['UUID']['input'];
  extendedBiddingRefillThresholdInSeconds?: InputMaybe<Scalars['Int']['input']>;
  initialDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  isExtendedBiddingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  startingBidInCents: Scalars['Int']['input'];
};

export type StartOneUpAuctionForFixedPriceSpotPayload = {
  __typename?: 'StartOneUpAuctionForFixedPriceSpotPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<StartAuctionResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type StartOneUpAuctionInput = {
  auctionSpotTitle: Scalars['String']['input'];
  breakType?: InputMaybe<BreakType>;
  extendedBiddingRefillThresholdInSeconds?: InputMaybe<Scalars['Int']['input']>;
  initialDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  isExtendedBiddingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  leagueId?: InputMaybe<Scalars['UUID']['input']>;
  liveStreamId: Scalars['UUID']['input'];
  productType?: InputMaybe<Scalars['String']['input']>;
  startingBidInCents: Scalars['Int']['input'];
};

export type StartOneUpAuctionPayload = {
  __typename?: 'StartOneUpAuctionPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<StartAuctionResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type StartStreamInput = {
  liveStreamId: Scalars['UUID']['input'];
  liveStreamSessionId: Scalars['String']['input'];
};

/** Status of a poll */
export enum Status {
  Created = 'CREATED',
  PollCompleted = 'POLL_COMPLETED',
  Started = 'STARTED',
  VotingClosed = 'VOTING_CLOSED'
}

export type StopStreamInput = {
  liveStreamId: Scalars['UUID']['input'];
};

/** Tokens of started IVS stream */
export type StreamTokens = {
  __typename?: 'StreamTokens';
  /** IVS security token */
  securityToken?: Maybe<Scalars['String']['output']>;
  /** IVS streaming token */
  streamingToken?: Maybe<Scalars['String']['output']>;
  /** IVS viewing token */
  viewingToken?: Maybe<Scalars['String']['output']>;
};

export type StreamTokensPayload = {
  __typename?: 'StreamTokensPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<StreamTokens>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export enum StreamingProvider {
  Ivs = 'IVS',
  Livekit = 'LIVEKIT'
}

export type SubBreakInput = {
  /** The break's break mechanic threshold in cents */
  breakMechanicThresholdInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The break's break mechanic type */
  breakMechanicType?: InputMaybe<BreakMechanicType>;
  /** The break's break products */
  breakProductsConfig?: InputMaybe<Array<InputMaybe<BreakProductsInput>>>;
  /** The break's spots and the corresponding pricing. This list is only needed for PYT set price. */
  breakSpots?: InputMaybe<Array<InputMaybe<BreakSpotInput>>>;
  /** The break template ID of the break */
  breakTemplateId: Scalars['UUID']['input'];
  /** If the break is auction, this field enables extended bidding */
  extendedBiddingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** If the break is auction, this field sets the extended bidding refill threshold in seconds */
  extendedBiddingRefillThresholdInSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Indicates this is a child break */
  isChild?: InputMaybe<Scalars['Boolean']['input']>;
  /** The live stream ID of the break */
  liveStreamId: Scalars['UUID']['input'];
  /** If the break is auction, this field sets the minimum bid amount */
  minimumBidAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  parentBreakId: Scalars['UUID']['input'];
  parentBreakSpots?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** The break's pricing type */
  pricingType: BreakPricingType;
  /** The price for random set price break */
  randomSetPriceInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The break's selection type */
  selectionType: BreakSelectionType;
  /** The unique identifier of a shipping profile ID belonging to the shop to be used with a given break */
  shippingProfileId?: InputMaybe<Scalars['UUID']['input']>;
  /** The shop ID the break belongs to */
  shopId?: InputMaybe<Scalars['UUID']['input']>;
  /** The title of the break */
  title: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Receive break updates */
  break?: Maybe<Break>;
  breakGameValidBreaks?: Maybe<ValidBreaksResponse>;
  /**
   * Receive updates for slot auctions on a break
   * @deprecated This subscription is being replaced by breakSpotAuction, please use that instead
   */
  breakSlotAuction?: Maybe<BreakSlotAuction>;
  /** Receive updates for spot auctions on a break */
  breakSpotAuction?: Maybe<BreakSpotAuction>;
  /** Receive updates for changes on a break spot in a live stream */
  breakSpotChanged?: Maybe<BreakSpotChangedPayload>;
  collectAuctionListingUpdates?: Maybe<CollectAuctionAndListingsDelta>;
  collectAuctionUpdates?: Maybe<CollectAuction>;
  collectListingUpdates?: Maybe<CollectListingDelta>;
  /** Receive updates for the current break in a live stream */
  currentBreakChanged?: Maybe<CurrentBreakChangedPayload>;
  /** Receive updates for the current break game in a livestream */
  currentBreakGame?: Maybe<BreakGameResponse>;
  /** Receive updates for the current break spot auction in a live stream */
  currentBreakSpotAuction?: Maybe<BreakSpotAuction>;
  /** Receive updates for the current giveaway in a live stream */
  giveaway?: Maybe<Giveaway>;
  /** Receive updates for live streams */
  liveStream?: Maybe<LiveStream>;
  /** Receives latest events on a livestream */
  liveStreamEvent?: Maybe<LiveStreamEventResponse>;
  /** Receive updates for the number of viewers in a live stream */
  liveStreamViewers: Scalars['Int']['output'];
  /** Receive updates for the viewers counter details in a live stream */
  liveStreamViewersCounterDetails: LiveStreamViewersCounterDetailsPayload;
  ping?: Maybe<PingResponse>;
  /** Receive updates for the currently active poll in a livestream */
  poll?: Maybe<Poll>;
  /** Receive updates for live streams spots randomization results */
  randomizationResult?: Maybe<RandomizationResult>;
  /** Receive link to CSV export of shop analytics values */
  receiveCsvExport?: Maybe<ReceiveCsvExportResponse>;
  /** Receive the status of Shop analytics custom CSV report */
  shopAnalyticsReportStatus?: Maybe<ShopAnalyticsReportStatusResponse>;
  /** Receives latest events on a user */
  userEvent?: Maybe<UserEventResponse>;
};


export type SubscriptionBreakArgs = {
  breakId: Scalars['UUID']['input'];
};


export type SubscriptionBreakGameValidBreaksArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type SubscriptionBreakSlotAuctionArgs = {
  breakId: Scalars['UUID']['input'];
};


export type SubscriptionBreakSpotAuctionArgs = {
  breakId: Scalars['UUID']['input'];
};


export type SubscriptionBreakSpotChangedArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type SubscriptionCollectAuctionListingUpdatesArgs = {
  auctionIds: Array<InputMaybe<CollectAuctionIdInput>>;
};


export type SubscriptionCollectAuctionUpdatesArgs = {
  auctionIds: Array<InputMaybe<CollectAuctionIdInput>>;
};


export type SubscriptionCollectListingUpdatesArgs = {
  listingIds: Array<InputMaybe<CollectListingIdInput>>;
};


export type SubscriptionCurrentBreakChangedArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type SubscriptionCurrentBreakGameArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type SubscriptionCurrentBreakSpotAuctionArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type SubscriptionGiveawayArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type SubscriptionLiveStreamArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type SubscriptionLiveStreamEventArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type SubscriptionLiveStreamViewersArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type SubscriptionLiveStreamViewersCounterDetailsArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type SubscriptionPingArgs = {
  pingId: Scalars['UUID']['input'];
};


export type SubscriptionPollArgs = {
  liveStreamId: Scalars['UUID']['input'];
};


export type SubscriptionRandomizationResultArgs = {
  randomizationId: Scalars['UUID']['input'];
};


export type SubscriptionReceiveCsvExportArgs = {
  taskId: Scalars['UUID']['input'];
};


export type SubscriptionShopAnalyticsReportStatusArgs = {
  shopAnalyticsReportId: Scalars['UUID']['input'];
};

export type SuggestedUsernames = {
  __typename?: 'SuggestedUsernames';
  usernames: Array<Scalars['String']['output']>;
};

export type SwipeCardInput = {
  /** Index of the swipe event */
  index: Scalars['Int']['input'];
  /** The ID of the live stream */
  liveStreamId: Scalars['UUID']['input'];
  /** Percentage of the card */
  percentage: Scalars['Float']['input'];
};

export type SwipeCardPayload = {
  __typename?: 'SwipeCardPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<SwipeCardResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type SwipeCardResponse = {
  __typename?: 'SwipeCardResponse';
  /** The status of the card swipe */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SyncBadgeUsersToStreamInput = {
  /** Badge name to sync users for */
  badgeName: BadgeName;
};

export type SyncBadgeUsersToStreamPayload = {
  __typename?: 'SyncBadgeUsersToStreamPayload';
  /** Whether the sync job was successfully enqueued */
  jobEnqueued: Scalars['Boolean']['output'];
};

/** The tax line item */
export type TaxLine = {
  __typename?: 'TaxLine';
  /** The tax line item description */
  description?: Maybe<Scalars['String']['output']>;
  /** The tax rate regarding that line item */
  rate?: Maybe<Scalars['String']['output']>;
  /** The calculated tax value */
  taxCalculated?: Maybe<Scalars['Float']['output']>;
  /** The tax name */
  taxName?: Maybe<Scalars['String']['output']>;
};

export type TicketCommentCreateInput = {
  /** Comment text between 1 and 4096 characters */
  body: Scalars['String']['input'];
  /** Live support ticket id */
  ticketId: Scalars['Int']['input'];
};

export enum TicketStatus {
  /** Staff is working on the ticket */
  Open = 'OPEN',
  /** The ticket has been solved */
  Solved = 'SOLVED'
}

export type TicketStatusUpdateInput = {
  /** New ticket status */
  newStatus: TicketStatus;
  /** Live support ticket id */
  ticketId: Scalars['Int']['input'];
};

/** DEPRECATED: Tips feature is deprecated and non functional right now */
export type TipCreateInput = {
  /** The amount in cents that we want to tip */
  amountInCents: Scalars['Int']['input'];
  /** The livestream id */
  liveStreamId: Scalars['UUID']['input'];
};

export type TipCreatePayload = {
  __typename?: 'TipCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<BreakOrder>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Input object for toggling extended bidding */
export type ToggleExtendedBiddingInput = {
  breakId: Scalars['UUID']['input'];
};

export type ToggleExtendedBiddingPayload = {
  __typename?: 'ToggleExtendedBiddingPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<UpdateBreakResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** A pair of tokens that can be used together to authenticate with the application. */
export type TokenPair = {
  __typename?: 'TokenPair';
  /** Token with a short expiry that can be used to gain access to the application. */
  accessToken: Scalars['String']['output'];
  /** Token with a long expiry that can only be used to get a new access token. */
  refreshToken: Scalars['String']['output'];
};

/** Top buyers for the target entity */
export type TopBuyer = {
  __typename?: 'TopBuyer';
  /** The subtotal amount in cents, in human readable format */
  gmvDisplay?: Maybe<Scalars['String']['output']>;
  /** The subtotal amount in cents */
  gmvInCents?: Maybe<Scalars['Int']['output']>;
  /** The number of streams that the buyer has made a purchase in */
  numberOfStreamsPurchasedInShop?: Maybe<Scalars['Int']['output']>;
  /** The total number of orders made by the buyer */
  totalNumberOfOrders?: Maybe<Scalars['Int']['output']>;
  /** The total amount spent by the buyer in a human readable format */
  totalSpentInShopDisplay?: Maybe<Scalars['String']['output']>;
  /** The total amount spent by the buyer */
  totalSpentInShopInCents?: Maybe<Scalars['Int']['output']>;
  /** The buyer's identity */
  user?: Maybe<User>;
};

export enum ToppsCountdownType {
  Countdown = 'COUNTDOWN',
  Day = 'DAY',
  Disabled = 'DISABLED',
  Month = 'MONTH'
}

export type ToppsFeaturedItem = {
  __typename?: 'ToppsFeaturedItem';
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  /** @deprecated Use launchDateV2 instead. */
  launchDate: Scalars['DateTime']['output'];
  launchDateV2?: Maybe<Scalars['DateTime']['output']>;
  pillLabel?: Maybe<Scalars['String']['output']>;
  price?: Maybe<MoneyAmount>;
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export enum ToppsHeroLayout {
  Carousel = 'CAROUSEL',
  Single = 'SINGLE'
}

export type ToppsHeroModule = {
  __typename?: 'ToppsHeroModule';
  ctaLabel?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  items: Array<ToppsProduct>;
  layout: ToppsHeroLayout;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ToppsHomepage = {
  __typename?: 'ToppsHomepage';
  /** @deprecated Use modules hero module instead. */
  featured: Array<ToppsFeaturedItem>;
  /** @deprecated Use modules product lists instead. */
  items: Array<ToppsHomepageItem>;
  /** Configurable content modules (hero banners and product lists) for the homepage */
  modules: Array<ToppsHomepageModule>;
};


export type ToppsHomepageItemsArgs = {
  status?: InputMaybe<Array<ToppsItemStatus>>;
};

export type ToppsHomepageItem = {
  __typename?: 'ToppsHomepageItem';
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  launchDate: Scalars['DateTime']['output'];
  pillLabel?: Maybe<Scalars['String']['output']>;
  price?: Maybe<MoneyAmount>;
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type ToppsHomepageModule = ToppsHeroModule | ToppsProductModule;

export enum ToppsItemStatus {
  AvailableNow = 'AVAILABLE_NOW',
  Upcoming = 'UPCOMING'
}

export type ToppsProduct = {
  __typename?: 'ToppsProduct';
  /** Product category (e.g., basketball, baseball, mma) */
  category?: Maybe<Scalars['String']['output']>;
  /** Type of countdown to display for the product */
  countdownType?: Maybe<ToppsCountdownType>;
  id: Scalars['String']['output'];
  image: Scalars['String']['output'];
  /** Whether the product is just dropped and we need to display a pill label */
  isJustDropped?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the product has a pre-order and we need to display a pill label */
  isPreOrder?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the product is selling fast and we need to display a pill label */
  isSellingFast?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use launchDateV2 instead. */
  launchDate: Scalars['DateTime']['output'];
  launchDateV2?: Maybe<Scalars['DateTime']['output']>;
  listingId?: Maybe<Scalars['String']['output']>;
  pillLabel?: Maybe<Scalars['String']['output']>;
  price?: Maybe<MoneyAmount>;
  /** Remaining quantity available for purchase */
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  shopId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ToppsProductChasingItem = {
  __typename?: 'ToppsProductChasingItem';
  image: Scalars['String']['output'];
  /** URL to additional information about this chase card or item */
  readMore?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ToppsProductDetailsPage = {
  __typename?: 'ToppsProductDetailsPage';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  brandDescription?: Maybe<Scalars['String']['output']>;
  /** Product category (e.g., basketball, baseball, mma) */
  category?: Maybe<Scalars['String']['output']>;
  /** Featured chase cards or rare items that collectors are pursuing */
  chasing: Array<ToppsProductChasingItem>;
  /** URL to product checklist PDF */
  checklistUrl?: Maybe<Scalars['String']['output']>;
  /** Type of countdown to display for the product */
  countdownType?: Maybe<ToppsCountdownType>;
  /** @deprecated Images moved to product level. */
  images: Array<Scalars['String']['output']>;
  isPreOrder: Scalars['Boolean']['output'];
  isSellingFast: Scalars['Boolean']['output'];
  isSoldOut: Scalars['Boolean']['output'];
  /** @deprecated Use launchDateV2 instead. */
  launchDate: Scalars['DateTime']['output'];
  launchDateV2?: Maybe<Scalars['DateTime']['output']>;
  /** URL to product odds PDF */
  oddsUrl?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the product details page */
  pageUid: Scalars['String']['output'];
  /** @deprecated Use productsV2 instead. */
  products: Array<ToppsProductListing>;
  /** Products with their available listings */
  productsV2: Array<ToppsProductWithListings>;
  releaseDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Subtitle moved to product level. */
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ToppsProductListing = {
  __typename?: 'ToppsProductListing';
  /** @deprecated Description moved to product level. */
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  images: Array<Scalars['String']['output']>;
  /** @deprecated Overview moved to product level. */
  overview?: Maybe<Scalars['String']['output']>;
  price?: Maybe<MoneyAmount>;
  /** Remaining quantity available for purchase */
  quantityAvailable?: Maybe<Scalars['Int']['output']>;
  shopId: Scalars['String']['output'];
  /** Product specifications (e.g., size, weight, material) */
  specs: Array<ToppsProductSpec>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ToppsProductModule = {
  __typename?: 'ToppsProductModule';
  ctaLabel?: Maybe<Scalars['String']['output']>;
  ctaLink?: Maybe<Scalars['String']['output']>;
  displayStyle: ToppsProductModuleDisplayStyle;
  id: Scalars['String']['output'];
  items: Array<ToppsProduct>;
  status?: Maybe<ToppsItemStatus>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum ToppsProductModuleDisplayStyle {
  Countdown = 'COUNTDOWN',
  Grid = 'GRID',
  List = 'LIST'
}

export type ToppsProductSpec = {
  __typename?: 'ToppsProductSpec';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Product with listings */
export type ToppsProductWithListings = {
  __typename?: 'ToppsProductWithListings';
  /** URL to product checklist */
  checklistUrl?: Maybe<Scalars['String']['output']>;
  /** Detailed product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the Back Office product */
  id: Scalars['String']['output'];
  /** Product images */
  images: Array<Scalars['String']['output']>;
  /** Available listings for this product */
  listings: Array<ToppsProductListing>;
  /** URL to product odds PDF */
  oddsUrl?: Maybe<Scalars['String']['output']>;
  /** Product overview */
  overview?: Maybe<Scalars['String']['output']>;
  /** Shopify product ID */
  shopifyId: Scalars['String']['output'];
  /** Product subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Product title */
  title: Scalars['String']['output'];
};

export type TrackAuctionEventInput = {
  auctionId: Scalars['UUID']['input'];
  breakId: Scalars['UUID']['input'];
  eventName: Scalars['String']['input'];
  liveStreamId: Scalars['UUID']['input'];
};

export type TrackAuctionEventPayload = {
  __typename?: 'TrackAuctionEventPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<TrackAuctionEventResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Response from the trackAuctionEvent mutation */
export type TrackAuctionEventResponse = {
  __typename?: 'TrackAuctionEventResponse';
  /** Status of track auction event */
  success: Scalars['Boolean']['output'];
};

export type TrackEventInput = {
  data: Scalars['Json']['input'];
  eventType: Scalars['String']['input'];
};

export type TrackEventPayload = {
  __typename?: 'TrackEventPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<TrackEventResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** The response from trackEvent mutation */
export type TrackEventResponse = {
  __typename?: 'TrackEventResponse';
  status: Scalars['String']['output'];
};

/** Shippo transaction */
export type Transaction = {
  __typename?: 'Transaction';
  breakOrders?: Maybe<BreakOrderConnection>;
  /** Carrier-specific information */
  carrier?: Maybe<Carrier>;
  /** Dimensions of the whole package */
  dimensions?: Maybe<Dimensions>;
  id: Scalars['UUID']['output'];
  /** Shippo label url */
  labelUrl?: Maybe<Scalars['String']['output']>;
  /** Package protection settings */
  packageProtection?: Maybe<PackageProtection>;
  /** Ship from address */
  shipFrom?: Maybe<Address>;
  /** Ship to address */
  shipTo?: Maybe<Address>;
  /** Flagged or not flagged */
  status?: Maybe<TransactionStatus>;
  /** Username of the buyer */
  username?: Maybe<Scalars['String']['output']>;
  /** Weight of the whole package in transaction */
  weight?: Maybe<Weight>;
};


/** Shippo transaction */
export type TransactionBreakOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TransactionConnection = {
  __typename?: 'TransactionConnection';
  edges?: Maybe<Array<Maybe<TransactionEdge>>>;
  pageInfo: PageInfo;
};

export type TransactionEdge = {
  __typename?: 'TransactionEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Transaction>;
};

export enum TransactionStatus {
  Flagged = 'FLAGGED',
  Ready = 'READY'
}

export type TransferVaultItemsInput = {
  email: Scalars['String']['input'];
  fanId: Scalars['String']['input'];
  itemsIds: Array<InputMaybe<Scalars['String']['input']>>;
  sellerTenantId: Scalars['String']['input'];
  transferType: VaultItemsTransferType;
};

export type TransferVaultItemsPayload = {
  __typename?: 'TransferVaultItemsPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<TransferVaultItemsResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type TransferVaultItemsResponse = {
  __typename?: 'TransferVaultItemsResponse';
  message: Scalars['String']['output'];
  oldUuidToNewUuidMap: Scalars['Json']['output'];
  status: Scalars['Int']['output'];
};

/** Detailed error information */
export type TrogonRpcError = {
  __typename?: 'TrogonRpcError';
  /** Error code */
  code: Scalars['Int']['output'];
  /** Error code value */
  codeString?: Maybe<Scalars['String']['output']>;
  /** Error details */
  details?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Error domain */
  domain?: Maybe<Scalars['String']['output']>;
  /** Error message */
  message: Scalars['String']['output'];
  /** Error metadata */
  metadata?: Maybe<Scalars['Json']['output']>;
  /** Raw status */
  rawStatus?: Maybe<Scalars['Int']['output']>;
  /** Error reason */
  reason?: Maybe<Scalars['String']['output']>;
  /** Wrapped Errors */
  wrappedErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Input object for unassigning a spot */
export type UnassignSpotInput = {
  breakSpotId: Scalars['UUID']['input'];
};

export type UnassignSpotPayload = {
  __typename?: 'UnassignSpotPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<UnassignSpotResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type UnassignSpotResponse = {
  __typename?: 'UnassignSpotResponse';
  breakSpot?: Maybe<BreakSpot>;
};

/** Parameters for removing a shop-scoped auction ban */
export type UnbanAuctionInput = {
  liveStreamId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type UnbanAuctionPayload = {
  __typename?: 'UnbanAuctionPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<AuctionBanResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type UnfollowLiveStreamCreatePayload = {
  __typename?: 'UnfollowLiveStreamCreatePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<FollowLiveStreamCreateResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** A field to check for the unified phone status. */
export type UnifiedPhoneStatus = {
  __typename?: 'UnifiedPhoneStatus';
  /** The Collect phone number. */
  collectPhoneNumber?: Maybe<CollectPhone>;
  /** Whether the user phone numbers have a conflict. */
  hasConflict?: Maybe<Scalars['Boolean']['output']>;
  /** The Live phone number. */
  livePhoneNumber?: Maybe<CollectPhone>;
};

export type UnifiedUser = {
  __typename?: 'UnifiedUser';
  /** A list of addresses associated with the authenticated user (supports non-US addresses with an empty state) */
  addresses: Array<AddressV2>;
  /** The user's avatar color. */
  avatarColor?: Maybe<Scalars['String']['output']>;
  /** The user's avatar url. */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The user's badges */
  badges?: Maybe<Array<Maybe<Badge>>>;
  /** The user's biography. */
  biography?: Maybe<Scalars['String']['output']>;
  /** The user's chat token. */
  chatToken?: Maybe<Scalars['String']['output']>;
  /** The user's Collect-specific attributes. */
  collectAttributes?: Maybe<CollectUserAttributes>;
  /** The user's country */
  country: Scalars['String']['output'];
  /** The user's currency */
  currency: Scalars['String']['output'];
  /** The user's email address */
  email?: Maybe<CollectEmail>;
  /** The user's first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Indicates if user is frozen or not */
  frozen: Scalars['Boolean']['output'];
  /** The datetime the user was created. This is the earlier of the user's Live or Collect account creation date. */
  insertedAt: Scalars['DateTime']['output'];
  kycStatus?: Maybe<CollectKycStatus>;
  /** The user's last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The user's Live-specific attributes. */
  liveAttributes?: Maybe<LiveUserAttributes>;
  /** The user's client‑side metadata blob */
  metadata: UserMetadata;
  /** The user's phone number. */
  phone?: Maybe<CollectPhone>;
  /** The user's FanID tenant ID. */
  tenantId: Scalars['UUID']['output'];
  unifiedPhoneStatus?: Maybe<UnifiedPhoneStatus>;
  /** The user's username. */
  username?: Maybe<Scalars['String']['output']>;
  /** The datetime when the user's username will be editable again, or false if it cannot be edited. */
  usernameEditableAfter?: Maybe<Scalars['DateTime']['output']>;
  /** The datetime the user's username was last updated. */
  usernameUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User specific Ship To address in vault submissions */
  vaultSubmissionAddress: CollectAddress;
  /** The user's wallet information */
  wallet?: Maybe<UserWallet>;
};


export type UnifiedUserAddressesArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};

/** Input object for updating a break */
export type UpdateBreakInput = {
  /** The id of the break */
  breakId: Scalars['UUID']['input'];
  /** If the break is auction, this field sets the minimum bid amount */
  minimumBidAmountInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The new title of the break */
  title: Scalars['String']['input'];
};

/** Input object for uprating a break mechanics */
export type UpdateBreakMechanicInput = {
  breakId: Scalars['UUID']['input'];
  /** The break's break mechanic threshold in cents */
  breakMechanicThresholdInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The break's break mechanic type */
  breakMechanicType?: InputMaybe<BreakMechanicType>;
};

export type UpdateBreakMechanicPayload = {
  __typename?: 'UpdateBreakMechanicPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<UpdateBreakResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type UpdateBreakPayload = {
  __typename?: 'UpdateBreakPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<UpdateBreakResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type UpdateBreakResponse = {
  __typename?: 'UpdateBreakResponse';
  break?: Maybe<Break>;
};

/** Parameters for updating a live stream. */
export type UpdateLiveStreamInput = {
  /** The ID of the channel where the livestream will be broadcasted. */
  channelId: Scalars['ID']['input'];
  /** The URL of the cover image for the livestream. */
  coverImage: Scalars['String']['input'];
  /** The ID of the object we want to update */
  id: Scalars['ID']['input'];
  /** The name of the livestream. */
  name: Scalars['String']['input'];
  /** The starting time of the livestream in UTC. */
  startsAt: Scalars['DateTime']['input'];
};

export type UpdateLiveStreamPayload = {
  __typename?: 'UpdateLiveStreamPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<LiveStreamResult>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Parameters for updating path to logo for given profile type. */
export type UpdateLogoPathInput = {
  /** The unique ID of profile. */
  id: Scalars['UUID']['input'];
  /** The image file name. */
  logoPath: Scalars['String']['input'];
  /** Profile type. */
  type: ProfileType;
};

export type UpdateLogoPathPayload = {
  __typename?: 'UpdateLogoPathPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Result>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type UpdateRepackConfigurationInput = {
  /** Tolerance for average value deviation */
  avgValueTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of base cards required */
  baseMinCount?: InputMaybe<Scalars['Int']['input']>;
  /** Tolerance for base odds deviation */
  baseOddsTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Target odds percentage for base cards */
  baseTargetOdds?: InputMaybe<Scalars['Float']['input']>;
  /** Tolerance for ceiling value deviation */
  ceilingValueTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of chase cards required */
  chaseMinCount?: InputMaybe<Scalars['Int']['input']>;
  /** Tolerance for chase odds deviation */
  chaseOddsTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Target odds percentage for chase cards */
  chaseTargetOdds?: InputMaybe<Scalars['Float']['input']>;
  /** Tolerance for floor value deviation */
  floorValueTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum number of grail cards required */
  grailMinCount?: InputMaybe<Scalars['Int']['input']>;
  /** Tolerance for grail odds deviation */
  grailOddsTolerance?: InputMaybe<Scalars['Int']['input']>;
  /** Target odds percentage for grail cards */
  grailTargetOdds?: InputMaybe<Scalars['Float']['input']>;
  /** The number of items per pack in a checklist */
  perPack: Scalars['Int']['input'];
  /** ID of the checklist */
  repackId: Scalars['UUID']['input'];
};

export type UpdateRepackConfigurationPayload = {
  __typename?: 'UpdateRepackConfigurationPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<UpdateRepackConfigurationResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type UpdateRepackConfigurationResponse = {
  __typename?: 'UpdateRepackConfigurationResponse';
  /** The status of the repack configuration update */
  success?: Maybe<Scalars['String']['output']>;
};

/** Input for updating an existing repack */
export type UpdateRepackInput = {
  /** The average value in cents */
  averageValueInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The break template ID to associate with this checklist */
  breakTemplateId?: InputMaybe<Scalars['UUID']['input']>;
  /** The ceiling value in cents */
  ceilingValueInCents?: InputMaybe<Scalars['Int']['input']>;
  /** The hexadecimal color of the checklist */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Updated description of the checklist */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The floor value in cents */
  floorValueInCents?: InputMaybe<Scalars['Int']['input']>;
  /** List of items to include */
  items: Array<RepackItemInput>;
  /** The MSRP of the checklist in cents */
  msrpInCents?: InputMaybe<Scalars['Int']['input']>;
  /** Pack texture category */
  packTextureCategory?: InputMaybe<PackTextureCategory>;
  /** Pack tier (1-4) */
  packTier?: InputMaybe<Scalars['Int']['input']>;
  /** Configuration of repack */
  repackConfiguration?: InputMaybe<RepackConfigurationInput>;
  /** ID of the checklist */
  repackId: Scalars['UUID']['input'];
  /** The path of the checklist */
  repackUrl?: InputMaybe<Scalars['String']['input']>;
  /** Updated status of the checklist */
  status: RepackStatus;
  /** The path of the pack texture */
  textureUrl?: InputMaybe<Scalars['String']['input']>;
  /** Updated title of the checklist */
  title?: InputMaybe<Scalars['String']['input']>;
  /** The variant of this checklist, can hold values (standard, gold) */
  variant?: InputMaybe<RepackVariant>;
  /** Vault tenant ID to source items from for dynamic checklists */
  vaultSourceTenantId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateRepackPayload = {
  __typename?: 'UpdateRepackPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Repack>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Input object for updating spot price */
export type UpdateSpotPriceInput = {
  breakSpotId: Scalars['UUID']['input'];
  newPriceInCents: Scalars['Int']['input'];
};

export type UpdateSpotPricePayload = {
  __typename?: 'UpdateSpotPricePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<UpdateSpotPriceResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type UpdateSpotPriceResponse = {
  __typename?: 'UpdateSpotPriceResponse';
  breakSpot?: Maybe<BreakSpot>;
};

export type UpdateUserMetadataInput = {
  /** Container for any whitelisted metadata keys */
  metadata: UserMetadataInput;
};

/** Input for updating user preferred countries */
export type UpdateUserPreferredCountriesInput = {
  /** Countries which the user prefers to see in-app content for (ISO alpha-2) */
  preferredCountries: Array<Scalars['String']['input']>;
};

/** Input for updating user preferred countries */
export type UpdateUserPreferredCountriesInputV2 = {
  /** Countries which the user prefers to see in-app content for (ISO alpha-2) */
  preferredCountries: Array<Country>;
};

export type UpdateWalletPreferencesPayload = {
  __typename?: 'UpdateWalletPreferencesPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type UpdatedBreakPayload = {
  __typename?: 'UpdatedBreakPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<Break>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** A base user representation to return from updates. Query user to retrieve full data after updates. */
export type UpdatedUser = {
  __typename?: 'UpdatedUser';
  /** The user's id */
  id: Scalars['UUID']['output'];
};

export type Url = {
  __typename?: 'Url';
  fullPath?: Maybe<Scalars['String']['output']>;
};

/** A user who is issuing or following referrals */
export type User = {
  __typename?: 'User';
  /** The user avatar url */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** The user id */
  id: Scalars['UUID']['output'];
  /** The user username */
  username: Scalars['String']['output'];
};

/** User auction ban payload */
export type UserAuctionBanPayload = {
  __typename?: 'UserAuctionBanPayload';
  /** When the ban expires */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Unique identifier for the ban (shop_id) */
  id: Scalars['String']['output'];
  /** Whether the user is currently banned */
  isBanned: Scalars['Boolean']['output'];
  /** ID of the livestream where the ban applies */
  livestreamId: Scalars['UUID']['output'];
  /** ID of the banned user */
  userId: Scalars['UUID']['output'];
};

/** User's ban status */
export type UserBanStatus = {
  __typename?: 'UserBanStatus';
  /** Auction ban information for the user */
  auctionBan?: Maybe<UserAuctionBanPayload>;
};

export type UserChannels = {
  __typename?: 'UserChannels';
  /** All of the user's channels */
  allItems?: Maybe<Array<Avatar>>;
  /** The user's top channels */
  items?: Maybe<Array<Avatar>>;
};

export type UserCounts = {
  __typename?: 'UserCounts';
  foundUserCount?: Maybe<Scalars['Int']['output']>;
  notFoundUserCount?: Maybe<Scalars['Int']['output']>;
  totalUserCount?: Maybe<Scalars['Int']['output']>;
};

export type UserEventPayload = PaymentRequiresActionClosedPayload | PaymentRequiresActionPayload | UserAuctionBanPayload;

export type UserEventResponse = {
  __typename?: 'UserEventResponse';
  payload?: Maybe<UserEventPayload>;
  type?: Maybe<UserEventType>;
};

export enum UserEventType {
  AuctionBanStatusChanged = 'AUCTION_BAN_STATUS_CHANGED',
  PaymentRequiresAction = 'PAYMENT_REQUIRES_ACTION',
  PaymentRequiresActionClosed = 'PAYMENT_REQUIRES_ACTION_CLOSED'
}

/** Parameters for following/unfollowing a user */
export type UserFollowInput = {
  /** The user to follow/unfollow */
  userId: Scalars['UUID']['input'];
};

export type UserLiveStreams = {
  __typename?: 'UserLiveStreams';
  /** All of the user's live streams */
  allItems?: Maybe<Array<LiveStreamCard>>;
  /** The user's top live streams */
  items?: Maybe<Array<LiveStreamCard>>;
};

export type UserMetadata = {
  __typename?: 'UserMetadata';
  /**
   * User badges
   * @deprecated Use badgesV2 instead which returns a non-null list intead of null
   */
  badges?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** User badges */
  badgesV2: Array<Maybe<Scalars['String']['output']>>;
  /** How many times the user has seen the flyout count */
  seenFlyoutCount?: Maybe<SeenFlyoutCount>;
  /** Timestamp when the user saw the wallet preference notice */
  seenWalletPreferenceNoticeAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UserMetadataInput = {
  seenFlyoutCount?: InputMaybe<SeenFlyoutCountInput>;
  seenWalletPreferenceNoticeAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum UserRole {
  /** A staffer user */
  Staffer = 'STAFFER',
  /** A regular user */
  User = 'USER'
}

/** User Staffer info */
export type UserStaffer = {
  __typename?: 'UserStaffer';
  isShopAdmin: Scalars['Boolean']['output'];
  shop: Shop;
};

/** Information needed to setup payments in Stripe for a user */
export type UserStripeInformation = {
  __typename?: 'UserStripeInformation';
  /** The user's ephemeral key generated by Stripe */
  ephemeralKey?: Maybe<Scalars['String']['output']>;
  /** The user's customer ID in Stripe for GB */
  gbStripeCustomerId: Scalars['String']['output'];
  /** The user's customer ID in Stripe */
  stripeCustomerId: Scalars['String']['output'];
  /** The client secret associated with the setup intent */
  stripeSetupIntentSecret: Scalars['String']['output'];
};

/** Complete wallet information for unified user */
export type UserWallet = {
  __typename?: 'UserWallet';
  /** Individual wallet accounts */
  accounts: WalletAccounts;
  /**
   * Wallet preferences - DEPRECATED: Use default_contribution field in each account instead
   * @deprecated Use default_contribution field in each account (account_funds, fancash, rewards) instead
   */
  preferences: WalletPreferences;
  /** Wallet summary totals */
  summary: WalletSummary;
};

export type UsersAutocompleteResponse = {
  __typename?: 'UsersAutocompleteResponse';
  users: Array<User>;
};

/** A section with users */
export type UsersSection = {
  __typename?: 'UsersSection';
  allItems?: Maybe<Array<Avatar>>;
  items?: Maybe<Array<Avatar>>;
  sectionType: SearchSectionType;
};

export type ValidBreaksResponse = {
  __typename?: 'ValidBreaksResponse';
  breaks?: Maybe<Array<Maybe<Break>>>;
};

/**
 * Validation messages are returned when mutation input does not meet the requirements.
 *   While client-side validation is highly recommended to provide the best User Experience,
 *   All inputs will always be validated server-side.
 *
 *   Some examples of validations are:
 *
 *   * Username must be at least 10 characters
 *   * Email field does not contain an email address
 *   * Birth Date is required
 *
 *   While GraphQL has support for required values, mutation data fields are always
 *   set to optional in our API. This allows 'required field' messages
 *   to be returned in the same manner as other validations. The only exceptions
 *   are id fields, which may be required to perform updates or deletes.
 */
export type ValidationMessage = {
  __typename?: 'ValidationMessage';
  /** A unique error code for the type of validation used. */
  code: Scalars['String']['output'];
  /**
   * The input field that the error applies to. The field can be used to
   * identify which field the error message should be displayed next to in the
   * presentation layer.
   *
   * If there are multiple errors to display for a field, multiple validation
   * messages will be in the result.
   *
   * This field may be null in cases where an error cannot be applied to a specific field.
   */
  field?: Maybe<Scalars['String']['output']>;
  /**
   * A friendly error message, appropriate for display to the end user.
   *
   * The message is interpolated to include the appropriate variables.
   *
   * Example: `Username must be at least 10 characters`
   *
   * This message may change without notice, so we do not recommend you match against the text.
   * Instead, use the *code* field for matching.
   */
  message?: Maybe<Scalars['String']['output']>;
  /** A list of substitutions to be applied to a validation message template */
  options?: Maybe<Array<Maybe<ValidationOption>>>;
  /**
   * A template used to generate the error message, with placeholders for option substitution.
   *
   * Example: `Username must be at least {count} characters`
   *
   * This message may change without notice, so we do not recommend you match against the text.
   * Instead, use the *code* field for matching.
   */
  template?: Maybe<Scalars['String']['output']>;
};

export type ValidationOption = {
  __typename?: 'ValidationOption';
  /** The name of a variable to be substituted in a validation message template */
  key: Scalars['String']['output'];
  /** The value of a variable to be substituted in a validation message template */
  value: Scalars['String']['output'];
};

/** Vault item category type */
export enum VaultCategoryType {
  /** Coins Currency */
  CoinsCurrency = 'COINS_CURRENCY',
  /** Comics */
  Comics = 'COMICS',
  /** Other */
  Other = 'OTHER',
  /** Sports Cards */
  SportsCards = 'SPORTS_CARDS',
  /** Trading Card Games */
  TradingCardGames = 'TRADING_CARD_GAMES',
  /** Video Games */
  VideoGames = 'VIDEO_GAMES',
  /** Wax */
  Wax = 'WAX'
}

export type VaultItem = {
  __typename?: 'VaultItem';
  /** Appraisal value */
  appraisalValue?: Maybe<MoneyAmount>;
  /** Auction url */
  auctionUrl?: Maybe<Scalars['String']['output']>;
  /** The break template spot assigned to this item via checklist_item_spot_templates */
  breakTemplateSpot?: Maybe<BreakTemplateSpot>;
  /** Buy now url */
  buyNowUrl?: Maybe<Scalars['String']['output']>;
  /** Buyback value */
  buybackValue?: Maybe<MoneyAmount>;
  /** The time when the buyback window ends */
  buybackWindowEndsAt?: Maybe<Scalars['DateTime']['output']>;
  /** Card grade */
  cardGrade?: Maybe<VaultItemCardGrade>;
  /** Card ladder value */
  cardLadderValue?: Maybe<MoneyAmount>;
  /** Card value */
  cardValue?: Maybe<MoneyAmount>;
  /** Category */
  category?: Maybe<VaultItemCategory>;
  /** Grade Cert */
  gradeCert?: Maybe<Scalars['String']['output']>;
  /** grading service */
  gradingService?: Maybe<VaultItemGradingService>;
  /** Id */
  id: Scalars['String']['output'];
  /** Metadata for each image */
  imageMetadata?: Maybe<Array<Maybe<ImageMetadata>>>;
  /** Images */
  images: Array<Maybe<Scalars['String']['output']>>;
  /** Metadata for each image */
  imagesV2: Array<Scalars['String']['output']>;
  /** Date insterted into db */
  insertedAt: Scalars['DateTime']['output'];
  /** Instant rip completed at */
  instantRipCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Insured value */
  insuredValue?: Maybe<MoneyAmount>;
  /**
   * Item ID
   * @deprecated Use `itemIdV2` instead
   */
  itemId?: Maybe<Scalars['UUID']['output']>;
  /** Item ID */
  itemIdV2: Scalars['UUID']['output'];
  /**
   * Item status
   * @deprecated This object is deprecated.
   */
  itemStatus?: Maybe<RepackItemStatus>;
  /**
   * Type of repack item (base, chase, grail)
   * @deprecated Use `itemTypeV2` instead
   */
  itemType?: Maybe<RepackItemType>;
  /** Type of repack item (base, chase, grail) */
  itemTypeV2: RepackItemType;
  /** Market value */
  marketValue?: Maybe<MoneyAmount>;
  /** Premier url */
  premierUrl?: Maybe<Scalars['String']['output']>;
  /** Proto item uuid */
  protoItemUuid: Scalars['String']['output'];
  revealInfo?: Maybe<RevealInfo>;
  revealOrder?: Maybe<Scalars['Int']['output']>;
  /**
   * Current reveal state of this item
   * @deprecated Use `revealStateV2` instead
   */
  revealState?: Maybe<RepackItemRevealState>;
  /** Current reveal state of this item */
  revealStateV2: RepackItemRevealState;
  /** Rotation value for the item */
  rotation?: Maybe<Scalars['Int']['output']>;
  /** Serial */
  serial?: Maybe<Scalars['String']['output']>;
  /** Subtitle */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Title */
  title: Scalars['String']['output'];
};

/** Vault item grading service */
export type VaultItemCardGrade = {
  __typename?: 'VaultItemCardGrade';
  /** Grade */
  grade?: Maybe<Scalars['Float']['output']>;
  /** Population */
  population?: Maybe<Scalars['Int']['output']>;
};

/** Vault item category */
export type VaultItemCategory = {
  __typename?: 'VaultItemCategory';
  /**
   * Category type (deprecated in favour of `CategoryTypeV2`)
   * @deprecated This field is now deprecated. Use `CategoryTypeV2` instead.
   */
  categoryType: CollectVaultCategoryTypeDeprecated;
  /** Category type */
  categoryTypeV2: VaultCategoryType;
  /** Id */
  id: Scalars['Int']['output'];
  /** Name */
  name: Scalars['String']['output'];
};

/** Get vault items response */
export type VaultItemEdge = {
  __typename?: 'VaultItemEdge';
  /** Pagination Cursor */
  cursor: Scalars['String']['output'];
  /** Vault item */
  node: VaultItem;
};

/** Vault item grading service */
export type VaultItemGradingService = {
  __typename?: 'VaultItemGradingService';
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
  /** Name */
  name?: Maybe<Scalars['String']['output']>;
};

/** The instant rip state of a vault item */
export type VaultItemInstantRipState = {
  __typename?: 'VaultItemInstantRipState';
  buybackCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  buybackWindowEndsAt?: Maybe<Scalars['DateTime']['output']>;
  instantRipCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  itemId: Scalars['UUID']['output'];
  itemType: RepackItemType;
  revealState: RepackItemRevealState;
  shop?: Maybe<Shop>;
  user?: Maybe<PublicUser>;
};

export enum VaultItemsTransferType {
  Buyback = 'BUYBACK',
  ToSeller = 'TO_SELLER',
  ToUser = 'TO_USER'
}

/** Vault sort by */
export enum VaultSortBy {
  /** Highest value */
  HighestValue = 'HIGHEST_VALUE',
  /** Lowest value */
  LowestValue = 'LOWEST_VALUE',
  /** Recently added */
  RecentlyAdded = 'RECENTLY_ADDED',
  /** Title asc */
  TitleAsc = 'TITLE_ASC',
  /** Title desc */
  TitleDesc = 'TITLE_DESC'
}

/** The recording of a live stream to be played back at a later date */
export type VideoOnDemand = {
  __typename?: 'VideoOnDemand';
  /**
   * The length (in milliseconds) of a stream recording
   * @deprecated The duration could be null, it is returned as 0 to avoid breaking changes,
   * since it is a non-nullable field and would break API contracts.
   * Use `durationV2` instead.
   */
  duration: Scalars['Int']['output'];
  /** The length (in milliseconds) of a stream recording */
  durationV2?: Maybe<Scalars['Int']['output']>;
  /** The format of the video content provided in the playback URL */
  format: VideoOnDemandFormat;
  /** The URL provided to the client to render the video content */
  playbackUrl: Scalars['String']['output'];
  /** The source of the video content provided in the playback URL */
  source: VideoOnDemandSource;
};

/** The streaming video format of a content link for a live streams video-on-demand (VOD) */
export enum VideoOnDemandFormat {
  Hls = 'HLS'
}

export enum VideoOnDemandSource {
  AwsInteractiveVideoService = 'AWS_INTERACTIVE_VIDEO_SERVICE',
  AwsMediaConvert = 'AWS_MEDIA_CONVERT',
  Livekit = 'LIVEKIT'
}

export type VoteCastInput = {
  /** The list of ids or id to cast vote in a poll */
  optionIds: Array<InputMaybe<Scalars['UUID']['input']>>;
  /** The UUID of a poll */
  pollId: Scalars['UUID']['input'];
};

/** The type of response to serve for cast vote mutation */
export type VoteCastResponse = {
  __typename?: 'VoteCastResponse';
  /** Denotes the success or failure of a mutation */
  status: Scalars['String']['output'];
};

export type VoteCastResponsePayload = {
  __typename?: 'VoteCastResponsePayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<VoteCastResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** Account funds information for unified user wallet */
export type WalletAccountFunds = {
  __typename?: 'WalletAccountFunds';
  /** Default contribution preference for this account */
  defaultContribution: WalletPreferenceStatus;
  /** Account funds headline information */
  headline: MoneyAmount;
  /** Account visibility status */
  visibility: WalletAccountVisibility;
  /** Reason for visibility restriction if applicable */
  visibilityReason?: Maybe<WalletAccountVisibilityReason>;
};

/** Visibility status options for wallet accounts */
export enum WalletAccountVisibility {
  /** Account is disabled and cannot be used */
  Disabled = 'DISABLED',
  /** Account is hidden from view */
  Hidden = 'HIDDEN',
  /** Account is visible and can be used */
  Visible = 'VISIBLE'
}

/** Reasons for wallet account visibility restrictions */
export enum WalletAccountVisibilityReason {
  /** Account not supported for GB users */
  NotSupportedForGbUser = 'NOT_SUPPORTED_FOR_GB_USER'
}

/** Wallet accounts container for unified user */
export type WalletAccounts = {
  __typename?: 'WalletAccounts';
  /** Account funds information */
  accountFunds: WalletAccountFunds;
  /** FanCash information */
  fancash: WalletFancash;
  /** Rewards information */
  rewards: WalletRewards;
};

/** Default contribution preferences for wallet */
export type WalletDefaultContributions = {
  __typename?: 'WalletDefaultContributions';
  /** Account funds contribution preference */
  accountFunds: WalletPreferenceStatus;
  /** FanCash contribution preference */
  fancash: WalletPreferenceStatus;
  /** Rewards contribution preference */
  rewards: WalletPreferenceStatus;
};

/** Input for updating wallet default contributions */
export type WalletDefaultContributionsInput = {
  /** Account funds contribution preference */
  accountFunds: WalletPreferenceStatus;
  /** FanCash contribution preference */
  fancash: WalletPreferenceStatus;
  /** Rewards contribution preference */
  rewards: WalletPreferenceStatus;
};

/** FanCash information for unified user wallet */
export type WalletFancash = {
  __typename?: 'WalletFancash';
  /** Default contribution preference for this account */
  defaultContribution: WalletPreferenceStatus;
  /** FanCash headline information */
  headline: MoneyAmount;
  /** Account visibility status */
  visibility: WalletAccountVisibility;
  /** Reason for visibility restriction if applicable */
  visibilityReason?: Maybe<WalletAccountVisibilityReason>;
};

/** Status for wallet preference contributions */
export enum WalletPreferenceStatus {
  /** The contribution type is disabled */
  Off = 'OFF',
  /** The contribution type is enabled */
  On = 'ON'
}

/** Wallet preferences configuration */
export type WalletPreferences = {
  __typename?: 'WalletPreferences';
  /** Default contributions settings */
  defaultContributions: WalletDefaultContributions;
};

/** Rewards information for unified user wallet */
export type WalletRewards = {
  __typename?: 'WalletRewards';
  /** Default contribution preference for this account */
  defaultContribution: WalletPreferenceStatus;
  /** Rewards headline information */
  headline: MoneyAmount;
  /** Account visibility status */
  visibility: WalletAccountVisibility;
  /** Reason for visibility restriction if applicable */
  visibilityReason?: Maybe<WalletAccountVisibilityReason>;
};

/** Information about a wallet balance and its contributions to the checkout */
export type WalletSourceBreakdown = {
  __typename?: 'WalletSourceBreakdown';
  /** When toggled on, the amount applied to be used in the wallet */
  applied?: Maybe<MoneyAmount>;
  /** The available amount in the wallet */
  available?: Maybe<MoneyAmount>;
  /** The remaining amount in the wallet after using the applied amount */
  remaining?: Maybe<MoneyAmount>;
};

/** Wallet summary for unified user */
export type WalletSummary = {
  __typename?: 'WalletSummary';
  /** Summary headline information */
  headline: MoneyAmount;
};

/** A transaction in a user's wallet */
export type WalletTransaction = {
  __typename?: 'WalletTransaction';
  /** The amount of the transaction */
  amount: MoneyAmount;
  /** Is the transaction a credit or debit */
  creditOrDebit: CreditDebit;
  /** The time at which the transaction was created (UTC) */
  date: Scalars['DateTime']['output'];
  /** The description of the transaction */
  description: Scalars['String']['output'];
  /** Metadata associated with the transaction */
  metadata: Metadata;
  /** The status of the transaction */
  status: WalletTransactionStatus;
  /** The type of transaction */
  type: WalletTransactionType;
};

export type WalletTransactionConnection = {
  __typename?: 'WalletTransactionConnection';
  edges?: Maybe<Array<Maybe<WalletTransactionEdge>>>;
  pageInfo: PageInfo;
};

export type WalletTransactionEdge = {
  __typename?: 'WalletTransactionEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<WalletTransaction>;
};

export enum WalletTransactionStatus {
  /** The transaction is pending */
  Pending = 'PENDING',
  /** The transaction is settled */
  Settled = 'SETTLED'
}

export enum WalletTransactionType {
  /** The transaction is related to a buyback */
  Buyback = 'BUYBACK',
  /** The transaction is related to a crypto deposit */
  CashDeposit = 'CASH_DEPOSIT',
  /** The transaction is related to a platform fee (for crypto deposit) */
  DepositFee = 'DEPOSIT_FEE',
  /** The transaction is related to expired credit */
  Expired = 'EXPIRED',
  /** The transaction is related to a manual adjustment */
  ManualAdjustment = 'MANUAL_ADJUSTMENT',
  /** The transaction is related to a purchase */
  Purchase = 'PURCHASE',
  /** The transaction is related to a referral */
  Referral = 'REFERRAL',
  /** The transaction is related to a refund */
  Refund = 'REFUND',
  /** The transaction is related to a reward */
  Reward = 'REWARD'
}

export type WalletsAmounts = {
  __typename?: 'WalletsAmounts';
  /** The account funds wallet information */
  accountFunds?: Maybe<WalletSourceBreakdown>;
  /** The fancash wallet information */
  fancash?: Maybe<WalletSourceBreakdown>;
  /** The rewards wallet information */
  rewards?: Maybe<WalletSourceBreakdown>;
};

/** Input for a wax treatment */
export type WaxTreatmentInput = {
  /** Average number of cards per pack for this treatment */
  averageCardsPerPack: Scalars['Decimal']['input'];
  /** Folder path for the treatment */
  folder: Scalars['String']['input'];
  /** Name of the treatment */
  name: Scalars['String']['input'];
  /** Order in which this treatment is revealed */
  revealOrder: Scalars['Int']['input'];
};

/** Weight in imperial metrics */
export type Weight = {
  __typename?: 'Weight';
  ounce: Scalars['Float']['output'];
  pound: Scalars['Int']['output'];
};

/** WHIP details */
export type WhipDetails = {
  __typename?: 'WhipDetails';
  /** The whip token */
  whipKey?: Maybe<Scalars['String']['output']>;
  /** The WHIP URL */
  whipUrl?: Maybe<Scalars['String']['output']>;
};

export type WhipPayload = {
  __typename?: 'WhipPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<WhipDetails>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

export type WhiteElephantBreakInput = {
  /** Live stream id */
  liveStreamId: Scalars['UUID']['input'];
  /** Repack id */
  repackId: Scalars['UUID']['input'];
};

export type WhiteElephantBreakPayload = {
  __typename?: 'WhiteElephantBreakPayload';
  /** A list of failed validations. May be blank or null if mutation succeeded. */
  messages?: Maybe<Array<Maybe<ValidationMessage>>>;
  /** The object created/updated/deleted by the mutation. May be null if mutation failed. */
  result?: Maybe<BreakGameResponse>;
  /** Indicates if the mutation completed successfully or not. */
  successful: Scalars['Boolean']['output'];
};

/** A checklist pool item */
export type ZeroChecklistPoolItem = {
  __typename?: 'ZeroChecklistPoolItem';
  buybackPopulationEnabled: Scalars['Boolean']['output'];
  buybackValueInCents?: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  insertedAt: Scalars['DateTime']['output'];
  isBuyback: Scalars['Boolean']['output'];
  originalPoolItemId?: Maybe<Scalars['UUID']['output']>;
  poolType: Scalars['String']['output'];
  protoItemUuid?: Maybe<Scalars['UUID']['output']>;
  reservedAt?: Maybe<Scalars['DateTime']['output']>;
  reservedUntil?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: RepackItemType;
  updatedAt: Scalars['DateTime']['output'];
  valueInCents?: Maybe<Scalars['Int']['output']>;
  vaultId?: Maybe<Scalars['UUID']['output']>;
};

export type WebAddAddressMutationMutationVariables = Exact<{
  input: AddressCreateInputV2;
}>;


export type WebAddAddressMutationMutation = { __typename?: 'Mutation', addressCreateV2?: { __typename?: 'AddressChangePayloadV2', successful: boolean, result?: { __typename?: 'AddressV2', id: any } | null, messages?: Array<{ __typename?: 'ValidationMessage', message?: string | null, code: string, field?: string | null } | null> | null } | null };

export type WebDeleteAddressMutationMutationVariables = Exact<{
  input: AddressDeleteInput;
}>;


export type WebDeleteAddressMutationMutation = { __typename?: 'Mutation', addressDelete?: { __typename?: 'AddressChangePayload', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', message?: string | null, code: string, field?: string | null } | null> | null } | null };

export type WebLogoutMutationMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
  refreshToken: Scalars['String']['input'];
  terminateSession?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type WebLogoutMutationMutation = { __typename?: 'Mutation', collectLogout?: boolean | null };

export type WebMarkOfferNotificationAsViewedCcMutationMutationVariables = Exact<{
  input: CollectMarkOfferNotificationAsViewedInput;
}>;


export type WebMarkOfferNotificationAsViewedCcMutationMutation = { __typename?: 'Mutation', collectMarkOfferNotificationAsViewed?: { __typename?: 'CollectMarkOfferNotificationAsViewedPayload', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', field?: string | null, message?: string | null, code: string } | null> | null } | null };

export type WebResendPhoneVerificationCodeMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type WebResendPhoneVerificationCodeMutationMutation = { __typename?: 'Mutation', collectResendPhoneVerificationCode?: { __typename?: 'CollectResendPhoneVerificationCodePayload', successful: boolean, result?: boolean | null, messages?: Array<{ __typename?: 'ValidationMessage', field?: string | null, message?: string | null, code: string } | null> | null } | null };

export type WebResendWelcomeEmailCcMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type WebResendWelcomeEmailCcMutationMutation = { __typename?: 'Mutation', collectResendWelcomeEmail?: { __typename?: 'CollectResendWelcomeEmailPayload', successful: boolean, result?: boolean | null, messages?: Array<{ __typename?: 'ValidationMessage', field?: string | null, message?: string | null, code: string } | null> | null } | null };

export type WebResolvePhoneConflictMutationMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type WebResolvePhoneConflictMutationMutation = { __typename?: 'Mutation', collectResolvePhoneConflict?: { __typename?: 'CollectResolvePhoneConflict', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', message?: string | null, code: string } | null> | null } | null };

export type WebUpdateProfileNameMutationMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;


export type WebUpdateProfileNameMutationMutation = { __typename?: 'Mutation', collectUpdateProfileName?: { __typename?: 'CollectUpdateProfileName', successful: boolean, result?: boolean | null, messages?: Array<{ __typename?: 'ValidationMessage', message?: string | null, code: string, field?: string | null } | null> | null } | null };

export type WebUpdateUserDefaultAddressMutationMutationVariables = Exact<{
  input: AccountUpdateInput;
}>;


export type WebUpdateUserDefaultAddressMutationMutation = { __typename?: 'Mutation', accountUpdate?: { __typename?: 'AccountUpdatePayload', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', message?: string | null, code: string } | null> | null } | null };

export type WebUpdateUserPhoneMutationMutationVariables = Exact<{
  phone: Scalars['String']['input'];
}>;


export type WebUpdateUserPhoneMutationMutation = { __typename?: 'Mutation', collectUpdateUserPhone?: { __typename?: 'CollectUpdateUserPhone', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', message?: string | null, code: string } | null> | null } | null };

export type CollectVerifyPhoneMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type CollectVerifyPhoneMutation = { __typename?: 'Mutation', collectVerifyPhone?: { __typename?: 'CollectVerifyPhonePayload', successful: boolean, messages?: Array<{ __typename?: 'ValidationMessage', message?: string | null, code: string, field?: string | null } | null> | null } | null };

export type WebCurrentUserV2CcQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type WebCurrentUserV2CcQueryQuery = { __typename?: 'Query', collectCurrentUserV2?: { __typename?: 'CollectCurrentUser', tenantId: any, firstName?: string | null, lastName?: string | null, collectPendingInvoicesCount?: number | null, collectPremierAuctionApproved?: boolean | null, kycStatus?: CollectKycStatus | null, email?: { __typename?: 'CollectEmail', address?: string | null, verified?: boolean | null } | null, phone?: { __typename?: 'CollectPhone', number?: string | null, status?: CollectPhoneStatus | null } | null } | null };

export type WebStripeKeyCcQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type WebStripeKeyCcQueryQuery = { __typename?: 'Query', collectCurrentUserV2?: { __typename?: 'CollectCurrentUser', stripePublishableKey: string, tenantId: any } | null };

export type WebGetUnifiedUserQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type WebGetUnifiedUserQueryQuery = { __typename?: 'Query', unifiedUser?: { __typename?: 'UnifiedUser', kycStatus?: CollectKycStatus | null, tenantId: any, frozen: boolean, firstName?: string | null, lastName?: string | null, username?: string | null, usernameUpdatedAt?: any | null, usernameEditableAfter?: any | null, country: string, currency: string, chatToken?: string | null, insertedAt: any, phone?: { __typename?: 'CollectPhone', number?: string | null, status?: CollectPhoneStatus | null } | null, unifiedPhoneStatus?: { __typename?: 'UnifiedPhoneStatus', hasConflict?: boolean | null, livePhoneNumber?: { __typename?: 'CollectPhone', number?: string | null, status?: CollectPhoneStatus | null } | null, collectPhoneNumber?: { __typename?: 'CollectPhone', number?: string | null, status?: CollectPhoneStatus | null } | null } | null, addresses: Array<{ __typename?: 'AddressV2', name: string, line1: string, line2?: string | null, city: string, state?: string | null, postalCode: string, country?: string | null, phone?: string | null, company?: string | null, id: any, countryV2: Country }>, email?: { __typename?: 'CollectEmail', address?: string | null, verified?: boolean | null } | null, vaultSubmissionAddress: { __typename?: 'CollectAddress', addressLine1: string, addressLine2?: string | null, city: string, country: string, name: string, state?: string | null, zip: string }, liveAttributes?: { __typename?: 'LiveUserAttributes', id?: any | null, brazeExternalId: any } | null } | null };

export type WebUserOffersStatusCcQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type WebUserOffersStatusCcQueryQuery = { __typename?: 'Query', collectCurrentUserV2?: { __typename?: 'CollectCurrentUser', tenantId: any, collectWaitingOffersCount?: number | null, hasNewOffersFromSellers?: boolean | null, hasNewOffersFromBidders?: boolean | null, accountFunds?: { __typename?: 'CollectAccountFunds', usableFunds?: { __typename?: 'Money', amountInCents: number, currency: any } | null } | null, collectBoInvoiceSummary?: { __typename?: 'CollectBoInvoiceSummary', overdueInvoiceCount?: number | null, pendingInvoiceCount?: number | null } | null } | null, currentBalance: { __typename?: 'MoneyAmount', amount: number, currency: string }, fancashBalance?: { __typename?: 'FancashWalletBalance', balance: { __typename?: 'MoneyAmount', amount: number, currency: string } } | null };

export type MoneyFragment = { __typename?: 'Money', amountInCents: number, currency: any };

export type PaymentMethodsFragment = { __typename?: 'CollectCurrentUser', collectPaymentMethods?: Array<{ __typename?: 'CollectPaymentMethodBank', isDefault?: boolean | null, id: string, bank?: { __typename?: 'CollectPaymentMethodBankDetails', lastFour: string, name: string } | null } | { __typename?: 'CollectPaymentMethodCard', isDefault?: boolean | null, id: string, card?: { __typename?: 'CollectPaymentMethodCardDetails', brand: string, expirationMonth: number, expirationYear: number, lastFour: string } | null } | { __typename?: 'CollectPaymentMethodOther', id: string, isDefault?: boolean | null } | null> | null };

export type WebGetWalletDataCcQueryQueryVariables = Exact<{
  enableFancash: Scalars['Boolean']['input'];
  enableRewards: Scalars['Boolean']['input'];
}>;


export type WebGetWalletDataCcQueryQuery = { __typename?: 'Query', collectCurrentUserV2?: { __typename?: 'CollectCurrentUser', tenantId: any, accountFunds?: { __typename?: 'CollectAccountFunds', usableFunds?: { __typename?: 'Money', amountInCents: number, currency: any } | null } | null, collectPaymentMethods?: Array<{ __typename?: 'CollectPaymentMethodBank', isDefault?: boolean | null, id: string, bank?: { __typename?: 'CollectPaymentMethodBankDetails', lastFour: string, name: string } | null } | { __typename?: 'CollectPaymentMethodCard', isDefault?: boolean | null, id: string, card?: { __typename?: 'CollectPaymentMethodCardDetails', brand: string, expirationMonth: number, expirationYear: number, lastFour: string } | null } | { __typename?: 'CollectPaymentMethodOther', id: string, isDefault?: boolean | null } | null> | null } | null, currentBalance?: { __typename?: 'MoneyAmount', amount: number, currency: string, amountDisplay: string }, fancashBalance?: { __typename?: 'FancashWalletBalance', balance: { __typename?: 'MoneyAmount', amount: number, currency: string, amountDisplay: string } } | null };

export type WebCurrentUserV2PendingOffersCcQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type WebCurrentUserV2PendingOffersCcQueryQuery = { __typename?: 'Query', collectCurrentUserV2?: { __typename?: 'CollectCurrentUser', tenantId: any, collectPendingOffers?: { __typename?: 'CollectPendingOffer', offersForSeller?: Array<{ __typename?: 'CollectOfferData', offerId?: any | null, listingId?: any | null, listingTitle?: string | null, showNotification?: boolean | null } | null> | null, counterOffersForSeller?: Array<{ __typename?: 'CollectOfferData', offerId?: any | null, listingId?: any | null, listingTitle?: string | null, showNotification?: boolean | null } | null> | null, counterOffersForBuyer?: Array<{ __typename?: 'CollectOfferData', offerId?: any | null, listingId?: any | null, listingTitle?: string | null, showNotification?: boolean | null } | null> | null } | null } | null };

export type OfferDataFragment = { __typename?: 'CollectOfferData', offerId?: any | null, listingId?: any | null, listingTitle?: string | null, showNotification?: boolean | null };

export const MoneyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]} as unknown as DocumentNode<MoneyFragment, unknown>;
export const PaymentMethodsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethods"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectCurrentUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectPaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectPaymentMethodCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expirationMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expirationYear"}},{"kind":"Field","name":{"kind":"Name","value":"lastFour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectPaymentMethodBank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastFour"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectPaymentMethodOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]}}]} as unknown as DocumentNode<PaymentMethodsFragment, unknown>;
export const OfferDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectOfferData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerId"}},{"kind":"Field","name":{"kind":"Name","value":"listingId"}},{"kind":"Field","name":{"kind":"Name","value":"listingTitle"}},{"kind":"Field","name":{"kind":"Name","value":"showNotification"}}]}}]} as unknown as DocumentNode<OfferDataFragment, unknown>;
export const WebAddAddressMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"webAddAddressMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressCreateInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressCreateV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"result"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}}]}}]} as unknown as DocumentNode<WebAddAddressMutationMutation, WebAddAddressMutationMutationVariables>;
export const WebDeleteAddressMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"webDeleteAddressMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressDeleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}}]}}]} as unknown as DocumentNode<WebDeleteAddressMutationMutation, WebDeleteAddressMutationMutationVariables>;
export const WebLogoutMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"webLogoutMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"terminateSession"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectLogout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"refreshToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refreshToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"terminateSession"},"value":{"kind":"Variable","name":{"kind":"Name","value":"terminateSession"}}}]}]}}]} as unknown as DocumentNode<WebLogoutMutationMutation, WebLogoutMutationMutationVariables>;
export const WebMarkOfferNotificationAsViewedCcMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"webMarkOfferNotificationAsViewedCCMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollectMarkOfferNotificationAsViewedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectMarkOfferNotificationAsViewed"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<WebMarkOfferNotificationAsViewedCcMutationMutation, WebMarkOfferNotificationAsViewedCcMutationMutationVariables>;
export const WebResendPhoneVerificationCodeMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"webResendPhoneVerificationCodeMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectResendPhoneVerificationCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<WebResendPhoneVerificationCodeMutationMutation, WebResendPhoneVerificationCodeMutationMutationVariables>;
export const WebResendWelcomeEmailCcMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"webResendWelcomeEmailCCMutation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectResendWelcomeEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<WebResendWelcomeEmailCcMutationMutation, WebResendWelcomeEmailCcMutationMutationVariables>;
export const WebResolvePhoneConflictMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"webResolvePhoneConflictMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectResolvePhoneConflict"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<WebResolvePhoneConflictMutationMutation, WebResolvePhoneConflictMutationMutationVariables>;
export const WebUpdateProfileNameMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"webUpdateProfileNameMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectUpdateProfileName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firstName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstName"}}},{"kind":"Argument","name":{"kind":"Name","value":"lastName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}},{"kind":"Field","name":{"kind":"Name","value":"result"}}]}}]}}]} as unknown as DocumentNode<WebUpdateProfileNameMutationMutation, WebUpdateProfileNameMutationMutationVariables>;
export const WebUpdateUserDefaultAddressMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"webUpdateUserDefaultAddressMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<WebUpdateUserDefaultAddressMutationMutation, WebUpdateUserDefaultAddressMutationMutationVariables>;
export const WebUpdateUserPhoneMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"webUpdateUserPhoneMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phone"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectUpdateUserPhone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phone"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<WebUpdateUserPhoneMutationMutation, WebUpdateUserPhoneMutationMutationVariables>;
export const CollectVerifyPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"collectVerifyPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectVerifyPhone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"successful"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"field"}}]}}]}}]}}]} as unknown as DocumentNode<CollectVerifyPhoneMutation, CollectVerifyPhoneMutationVariables>;
export const WebCurrentUserV2CcQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"webCurrentUserV2CCQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectCurrentUserV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectPendingInvoicesCount"}},{"kind":"Field","name":{"kind":"Name","value":"collectPremierAuctionApproved"}},{"kind":"Field","name":{"kind":"Name","value":"kycStatus"}}]}}]}}]} as unknown as DocumentNode<WebCurrentUserV2CcQueryQuery, WebCurrentUserV2CcQueryQueryVariables>;
export const WebStripeKeyCcQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"webStripeKeyCCQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectCurrentUserV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stripePublishableKey"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}}]}}]}}]} as unknown as DocumentNode<WebStripeKeyCcQueryQuery, WebStripeKeyCcQueryQueryVariables>;
export const WebGetUnifiedUserQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"webGetUnifiedUserQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unifiedUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kycStatus"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"frozen"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unifiedPhoneStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasConflict"}},{"kind":"Field","name":{"kind":"Name","value":"livePhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectPhoneNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"usernameUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"usernameEditableAfter"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"company"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"countryV2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chatToken"}},{"kind":"Field","name":{"kind":"Name","value":"email"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vaultSubmissionAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liveAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brazeExternalId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"insertedAt"}}]}}]}}]} as unknown as DocumentNode<WebGetUnifiedUserQueryQuery, WebGetUnifiedUserQueryQueryVariables>;
export const WebUserOffersStatusCcQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"webUserOffersStatusCCQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectCurrentUserV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"accountFunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usableFunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectBoInvoiceSummary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overdueInvoiceCount"}},{"kind":"Field","name":{"kind":"Name","value":"pendingInvoiceCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collectWaitingOffersCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasNewOffersFromSellers"}},{"kind":"Field","name":{"kind":"Name","value":"hasNewOffersFromBidders"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fancashBalance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]} as unknown as DocumentNode<WebUserOffersStatusCcQueryQuery, WebUserOffersStatusCcQueryQueryVariables>;
export const WebGetWalletDataCcQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"webGetWalletDataCCQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enableFancash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enableRewards"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectCurrentUserV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PaymentMethods"}},{"kind":"Field","name":{"kind":"Name","value":"accountFunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usableFunds"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Money"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentBalance"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enableRewards"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amountDisplay"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fancashBalance"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enableFancash"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"balance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"amountDisplay"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PaymentMethods"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectCurrentUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectPaymentMethods"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectPaymentMethodCard"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"expirationMonth"}},{"kind":"Field","name":{"kind":"Name","value":"expirationYear"}},{"kind":"Field","name":{"kind":"Name","value":"lastFour"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectPaymentMethodBank"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bank"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastFour"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectPaymentMethodOther"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Money"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Money"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amountInCents"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]} as unknown as DocumentNode<WebGetWalletDataCcQueryQuery, WebGetWalletDataCcQueryQueryVariables>;
export const WebCurrentUserV2PendingOffersCcQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"webCurrentUserV2PendingOffersCCQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collectCurrentUserV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"collectPendingOffers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offersForSeller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"counterOffersForSeller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferData"}}]}},{"kind":"Field","name":{"kind":"Name","value":"counterOffersForBuyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfferData"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OfferData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CollectOfferData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerId"}},{"kind":"Field","name":{"kind":"Name","value":"listingId"}},{"kind":"Field","name":{"kind":"Name","value":"listingTitle"}},{"kind":"Field","name":{"kind":"Name","value":"showNotification"}}]}}]} as unknown as DocumentNode<WebCurrentUserV2PendingOffersCcQueryQuery, WebCurrentUserV2PendingOffersCcQueryQueryVariables>;